const OOBError = function() {};
class DataMap {
  constructor(title, description, xSize, ySize) {
    this.title = title;
    this.description = !description ? '' : description;
    this.xSize = xSize;
    this.ySize = ySize;
    this.a = [];
  }
}

class DataMapNumeric extends DataMap {
  constructor(title, desc, units, da, xs, ys, defaultValue, xo, yo, xrs, yrs) {
    super(title, desc, xs, ys);
    this.units = units;
    this.a = da;
    this.defaultValue = defaultValue;
    this.xOffset = 0;
    this.yOffset = 0;
    this.valueModFunction = null;

    if (typeof xo !== 'undefined') {
      this.xOffset = xo;
    }
    if (typeof yo !== 'undefined') {
      this.yOffset = yo;
    }
    this.xRealSize = typeof xrs === 'undefined' ? xs : xrs;
    this.yRealSize = typeof yrs === 'undefined' ? ys : yrs;
    if (
      this.xRealSize + this.xOffset > this.xSize ||
      this.yRealSize + this.yOffset > this.ySize
    ) {
      throw new Error(
        'xRealSize or yRealSize too big for specified x or y offset.',
      );
    }
  }

  setValueModFunction(func) {
    this.valueModFunction = func;
  }

  getData(x, y) {
    let args = [];
    let l5;
    let i = 2;
    while (i < arguments.length) {
      args.push(arguments[i]);
      i++;
    }
    if (y < 0 || y > this.ySize - 1 || x < 0 || x > this.xSize - 1) {
      throw new OOBError(); // todo
    } else {
      if (this.yOffset > 0) {
        y -= this.yOffset;
      }
      if (this.xOffset > 0) {
        x -= this.xOffset;
      }
      if (y < 0 || y > this.yRealSize - 1 || x < 0 || x > this.xRealSize - 1) {
        l5 = this.defaultValue;
      } else {
        if (typeof this.a[y] !== 'undefined') {
          l5 = this.a[y][x];
        }
        if (typeof l5 === 'undefined') {
          l5 = this.defaultValue;
        }
      }
      if (this.valueModFunction) {
        args.unshift(l5);
        return this.valueModFunction.apply(this, args);
      }
      return l5;
    }
  }

  getHighLow() {
    let max = this.a[0][0];
    let min = this.a[0][0];

    for (let i = 0; i < this.a.length; i++) {
      for (let j = 0; j < this.a[i].length; j++) {
        if (this.a[i][j] > max) {
          max = this.a[i][j];
        } else if (this.a[i][j] < min) {
          min = this.a[i][j];
        }
      }
    }

    if (typeof this.defaultValue !== 'undefined') {
      if (this.defaultValue > max) {
        max = this.defaultValue;
      }
      if (this.defaultValue < min) {
        min = this.defaultValue;
      }
    }

    return [max, min];
  }
}

class DataMapCodedValue extends DataMapNumeric {
  constructor(
    title,
    desc,
    da,
    dictionary,
    xs,
    ys,
    defaultValue,
    xo,
    yo,
    xrs,
    yrs,
  ) {
    super(title, desc, null, da, xs, ys, defaultValue, xo, yo, xrs, yrs);

    this.d = dictionary;
    this.valueModFunction = function(val) {
      return typeof this.d[val] === 'undefined'
        ? this.defaultValue
        : this.d[val];
    };
  }

  getDataIndex(x, y) {
    let valueModFunction = this.valueModFunction;
    this.valueModFunction = null;
    let result = this.getData(x, y);
    this.valueModFunction = valueModFunction;
    return result;
  }
}

const dataMaps = {};

let a = [];
let b = [];
let d = [];

b[94] = 57;
b[95] = 14;
b[96] = 59;
b[97] = 73;
b[98] = 67;
b[99] = 68;
a[174] = b;
b = [];
b[93] = 54;
b[94] = 23;
b[95] = 74;
b[96] = 16;
b[97] = 69;
b[98] = 70;
b[99] = 68;
a[173] = b;
b = [];
b[93] = 13;
b[94] = 75;
b[95] = 25;
b[96] = 65;
b[97] = 72;
b[98] = 71;
b[99] = 68;
a[172] = b;
b = [];
b[91] = 58;
b[92] = b[98] = 15;
b[93] = 19;
b[94] = 76;
b[95] = 21;
b[96] = 61;
b[97] = 56;
b[99] = 59;
a[171] = b;
b = [];
b[90] = b[96] = 55;
b[91] = b[97] = 22;
b[92] = b[98] = 24;
b[93] = b[99] = 17;
b[94] = 20;
b[95] = 63;
a[170] = b;
b = [];
b[90] = b[96] = 12;
b[91] = b[97] = 28;
b[92] = b[98] = 26;
b[93] = 27;
b[94] = 64;
b[95] = 60;
b[99] = 53;
a[169] = b;
b = [];
b[91] = b[97] = 18;
b[92] = 27;
b[93] = 62;
b[94] = 55;
b[95] = 15;
b[96] = 19;
b[98] = 53;
a[168] = b;
b = [];
b[91] = 66;
b[92] = 64;
b[93] = 55;
b[94] = 22;
b[95] = 24;
b[96] = 17;
b[97] = b[98] = 68;
a[167] = b;
b = [];
b[91] = b[97] = 68;
b[92] = 66;
b[93] = 12;
b[94] = 28;
b[95] = 26;
b[96] = 53;
a[166] = b;
b = [];
b[92] = b[96] = b[97] = 68;
b[93] = 77;
b[94] = 18;
b[95] = 53;
a[165] = b;
b = [];
b[222] = 3;
b[223] = b[224] = b[225] = 4;
b[226] = 8;
a[120] = b;
b = [];
b[226] = 39;
a[119] = b;
b = [];
b[222] = 3;
b[223] = b[224] = b[225] = 4;
b[226] = 7;
b[253] = 42;
a[118] = b;
b = [];
b[226] = 38;
b[252] = 43;
b[253] = 41;
a[117] = b;
b = [];
b[222] = 3;
b[223] = b[224] = b[225] = 4;
b[226] = 6;
b[227] = b[231] = 78;
b[228] = 9;
b[229] = 10;
b[230] = 11;
b[232] = 1;
b[253] = 40;
a[116] = b;
b = [];
b[226] = 38;
a[115] = b;
b = [];
b[222] = 3;
b[223] = b[224] = b[225] = 4;
b[226] = 2;
a[114] = b;
b = [];
b[226] = 39;
a[113] = b;
b = [];
b[222] = 3;
b[223] = b[224] = b[225] = 4;
b[226] = 5;
a[112] = b;
b = [];
b[230] = 31;
b[231] = 44;
b[232] = 29;
a[94] = b;
b = [];
b[230] = 32;
b[231] = 45;
b[232] = 30;
a[93] = b;
b = [];
b[230] = 32;
b[231] = 46;
b[232] = 29;
a[92] = b;
b = [];
b[230] = 47;
b[231] = 48;
b[232] = 30;
a[91] = b;
b = [];
b[230] = 35;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 36;
b[238] = 37;
a[84] = b;
b = [];
b[230] = 49;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 33;
b[238] = 34;
a[83] = b;
a[82] = b;
a[81] = b;
a[80] = b;
a[79] = b;
a[78] = b;
a[77] = b;
a[76] = b;
a[75] = b;
b = [];
b[230] = 51;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 50;
b[238] = 52;
a[74] = b;
b = [];

d[0] = 'background';
d[1] =
  "a solid, ceramic, septic field  pipe  6\" in diameter is found at a depth of 2'; it rests on silty sand; the pipe runs from the W limit of this excavation for a distance of 5' to the E before disappearing into the concrete foundation of the Self-Lume building; the surrounding soil is primarily sand with some silt and gravel";
d[2] =
  "a perforated, ceramic, septic field drain pipe 6\" in diameter is found at a depth of 2'; it rests on a bed of 1/2' gravel that is 3' deep and 4' wide; the pipe and gravel-filled trench runs down the exact center of this excavation with the pipe and trench extending half-way across this excavation from the W to the E ending in the exact center of this excavation; at this point the pipe becomes solid ceramic resting now on a silty sand and turns 90 degreesto the N;there is also another exactly similar solid pipe running N-S through the entire excavation and running parallel to the other solid pipe from the center of the excavation to the N edge of the excavation where both pipes leave; the surrounding soil is primarily sand with some silt and gravel";
d[3] =
  "a perforated, ceramic, septic field drain pipe 6\" in diameter is found at a depth of 2'; it rests on a bed of 1/2' gravel that is 3' deep and 4' wide; the pipe and gravel-filled trench ends in the exact center of this excavation with the pipe and trench extending to the E; the surrounding soil is primarily sand with some silt and gravel";
d[4] =
  "a perforated, ceramic, septic field drain pipe 6\" in diameter is found at a depth of 2'; it rests on a bed of 1/2' gravel that is 3' deep and 4' wide; the pipe and gravel-filled trench runs down the exact center of this excavation with the pipe and trench extending to the W & E; the surrounding soil is primarily sand with some silt and gravel";
d[5] =
  "a perforated, ceramic, septic field drain pipe 6\" in diameter is found at a depth of 2'; it rests on a bed of 1/2' gravel that is 3' deep and 4' wide; the pipe and gravel-filled trench runs down the exact center of this excavation with the pipe and trench extending from the W to the E ending in the exact center of this excavation; at this point the pipe becomes solid ceramic resting now on a silty sand and turns 90 degreesto the N; the surrounding soil is primarily sand with some silt and gravel";
d[6] =
  "in the exact center of this excavation is a concrete,septic field distribution box 3' deep, 3' wide and 4' long with the 4' axis running E-W; the top of this box is 1' below the surface and contains a  circular steel lid 2\" in diameter; removal of the lid reveals 1\" of very fine dark muck in 1/4' of water; 2 solid, ceramic septic field pipes 6\" in diameter enter the box from the S and from the N; a single solid septic field pipe 6\" in diameter enters the box from the E and leaves the box to the W; the pipes and box rest on silty sand; ";
d[7] =
  "a perforated, ceramic, septic field drain pipe 6\" in diameter is found at a depth of 2'; it rests on a bed of 1/2' gravel that is 3' deep and 4' wide; the pipe and gravel-filled trench runs down the exact center of this excavation with the pipe and trench extending half-way across this excavation from the W to the E ending in the exact center of this excavation; at this point the pipe becomes solid ceramic resting now on a silty sand and turns 90 degreesto the S;there is also another exactly similar solid pipe running N-S through the entire excavation and running parallel to the other solid pipe from the center of the excavation to the S edge of the excavation where both pipes leave; the surrounding soil is primarily sand with some silt and gravel";
d[8] =
  "a perforated, ceramic, septic field drain pipe 6\" in diameter is found at a depth of 2'; it rests on a bed of 1/2' gravel that is 3' deep and 4' wide; the pipe and gravel-filled trench runs down the exact center of this excavation with the pipe and trench extending from the W to the E ending in the exact center of this excavation; at this point the pipe becomes solid ceramic resting now on a silty sand and turns 90 degreesto the S; the surrounding soil is primarily sand with some silt and gravel";
d[9] =
  "a solid, ceramic, septic field  pipe  6\" in diameter is found at a depth of 2'; it rests on silty sand; the pipe runs from the W limit of this excavation to the E for 5' before entering the W end of a large, concrete septic tank; the septic tank is 5' deep and 6' wide with 5' of its length uncovered in this excavation; the surrounding soil is primarily sand with some silt and gravel";
d[10] =
  "a section of a large concrete septic tank is uncovered here; the septic tank is 5' deep, 6' wide, and runs the full length of the excavation (10') exiting to the W & E; the top of the tank is 1' below the surface; there are two, circular septic tank risers that rise up to just below the soil surface; the two risers are 2' in diameter with the circles just tangent to the edge of this excavation, one at the W end and one at the E end; removal of the steel lids on top of these risers allowed cleaning of the septic tank in the past; inspection today reveals about 2' of water still in the tank with over 2' of sludge at the E end of the tank thinning to 6' at the W end; a sample of the sludge taken with a bucket reveals considerable broken glass & small rusty metal pieces within an organic sludge";
d[11] =
  "a solid, ceramic, septic field  pipe  6\" in diameter is found at a depth of 2'; it rests on silty sand; the pipe runs from the E limit of this excavation to the W for 5' before entering the E end of a large, concrete septic tank; the septic tank is 5' deep and 6' wide with 5' of its length uncovered in this excavation; the surrounding soil is primarily sand with some silt and gravel";
d[12] =
  'In the exact center of this excavation is the westernmost corner of a UST for gasoline; about 1/2 of the 11\' diameter, circular end of this UST (whose flat surfaces faces SW) is exposed in this excavation and it disappears into the SE corner of the pit wall; the NW facing side of the tank begins at the center of this excavation and disappears into the NE corner of the pit wall;the top of this UST is about 3\' below the asphalt surface; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary;';
d[13] =
  "In the exact center of this excavation is the westernmost corner of a UST for gasoline; about 1/2 of the 11' diameter, circular end of this UST (whose flat surfaces faces SW) is exposed in this excavation and it disappears into the SE corner of the pit wall; the NW facing side of the tank begins at the center of this excavation and disappears into the NE corner of the pit wall;the top of this UST is about 3' below the asphalt surface; the excavation has penetrated  3\" of asphalt and 3\" of 3/4\" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3' the soil is all sand and gravelly sand; at a depth of about 8' the pore space in the sand is saturated with gasoline; clearly this UST is leaking gasoline; further excavation and removal of this LUST and contaminated sand is required;";
d[14] =
  "In the exact center of this excavation is the northernmost corner of a UST for gasoline; about 1/2 of the 11' diameter, circular end of this UST (whose flat surfaces faces NE) is exposed in this excavation and it disappears into the SE corner of the pit wall; the NW facing side of the tank begins at the center of this excavation and disappears into the SW corner of the pit wall;the top of this UST is about 3' below the asphalt surface; the excavation has penetrated  3\" of asphalt and 3\" of 3/4\" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3' the soil is all sand and gravelly sand; at a depth of about 6' the pore space in the sand is saturated with gasoline; the N corner of this UST (at the exact center of this excavation) is severely corroded and the seam between the end of the UST cylinder and the wall here is oozing gasoline; clearly when this tank is 1/2 or more full it is leaking gasoline; further excavation and removal of this LUST and contaminated sand is required;";
d[15] =
  'In the exact center of this excavation is the northernmost corner of a UST for gasoline; about 1/2 of the 11\' diameter, circular end of this UST (whose flat surfaces faces NE) is exposed in this excavation and it disappears into the SE corner of the pit wall; the NW facing side of the tank begins at the center of this excavation and disappears into the SW corner of the pit wall; the top of this UST is about 3\' below the asphalt surface; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3\' the soil is all sand and gravelly sand;  no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[16] =
  'In the exact center of this excavation is the easternmost corner of a UST for gasoline; about 1/2 of the 11\' diameter, circular end of this UST (whose flat surfaces faces NE) is exposed in this excavation and it disappears into the NW corner of the pit wall; the SE facing side of the tank begins at the center of this excavation and disappears into the SW corner of the pit wall;the top of this UST is about 3\' below the asphalt surface; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed; in the NW corner of this excavation the pore space in the sand is saturated with gasoline at a depth of about 6\'; this depth increases to about 8\' in the SE corner; clearly this UST is leaking gasoline; further excavation and removal of this LUST and contaminated sand is required;';
d[17] =
  'In the exact center of this excavation is the easternmost corner of a UST for gasoline; about 1/2 of the 11\' diameter, circular end of this UST (whose flat surfaces faces NE) is exposed in this excavation and it disappears into the NW corner of the pit wall; the SE facing side of the tank begins at the center of this excavation and disappears into the SW corner of the pit wall; the top of this UST is about 3\' below the asphalt surface; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[18] =
  'In the exact center of this excavation is the southernmost corner of a UST for gasoline; about 1/2 of the 11\' diameter, circular end of this UST (whose flat surfaces faces SW) is exposed in this excavation and it disappears into the NW corner of the pit wall; the SE facing side of the tank begins at the center of this excavation and disappears into the NE corner of the pit wall;the top of this UST is about 3\' below the asphalt surface; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3\' the soil is all sand and gravelly sand; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary;';
d[19] =
  'In the far SW corner as well of this pit a 11\' diameter strip (about 5" wide) of the NE facing end of a UST is exposed; also, in the far NE corner as well of this pit a 11\' diameter strip (about 5" wide) of the SW facing end of a UST is exposed; the UST is about 3\' below the asphalt surface; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed; in the NE quadrant of this excavation the pore space in the sand is saturated with gasoline below 9\'; this depth increases to 10\' in the SW quadrant; clearly a UST is leaking; further excavation and inspection for this LUST and removal of the contaminated sand is required; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[20] =
  'The excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3\' the soil is all sand and gravelly sand; in the SE half of this pit the excavation also broke through the concrete pier on which the fuel pumps sit; in the N half of this excavation the pore space in the sand is saturated with gasoline below 9\'; this depth increases to 10\' in the S half; clearly a UST is leaking; further excavation and inspection for this LUST and removal of the contaminated sand is required;  ';
d[21] =
  'In the far NW corner of this pit a small (10" x 5") section of the SE facing wall of a UST is exposed;the UST appears to run to the NE and SW;   the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3\' the soil is all sand and gravelly sand; in the SE half of this pit the excavation also broke through the concrete pier on which the fuel pumps sit; below 8\' the pore space in the sand is saturated with gasoline; clearly this UST leaking; further excavation and removal of this LUST and contaminated sand is required; ';
d[22] =
  'In the exact center of this excavation is the NW facing wall of a UST for gasoline; the wall extends to the NE and SW disappearing into the NE and SW corners of this excavation; the top of this UST is about 3\' below the asphalt surface and can be seen only in the far SE corner of the excavation; a 2" diameter pipe  extends NW for about 11\' from the top of the UST in the SE corner to the NW corner; this pipe is about 1\' below the surface of the asphalt and clearly is the feed line for the fuel pumps; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3\' the soil is all sand and gravelly sand; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[23] =
  "In the exact center of this excavation is the NW facing wall of a UST for gasoline; the wall extends to the NE and SW disappearing into the NE and SW corners of this excavation; the top of this UST is about 3' below the asphalt surface and can be seen only in the far SE corner of the excavation; a 2\" diameter pipe  extends NW for about 11' from the top of the UST in the SE corner to the NW corner; this pipe is about 1' below the surface of the asphalt and clearly is the feed line for the fuel pumps; the excavation has penetrated  3\" of asphalt and 3\" of 3/4\" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3' the soil is all sand and gravelly sand; in the NE corner of this excavation the pore space in the sand is saturated with gasoline at a depth of about 7'; this depth increases to about 8' in the SW corner; clearly this UST is leaking gasoline; further excavation and removal of this LUST and contaminated sand is required;";
d[24] =
  'This excavation is completely filled by and centered over a UST that runs NE-SW; the walls of the UST are exposed in the NW and SE corners of this excavation and show that the diameter of this UST is about 11\'; the excavation penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt, sand, and gravelly sand; the top of the UST is about 3\' below the asphalt surface; in the exact center of this excavation there is a 3" pipe rising out of the UST which extends to the surface and is capped there; this is the refueling port for the UST; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[25] =
  "In the exact center of this excavation is the SE facing wall of a UST for gasoline; the wall extends to the NE and SW disappearing into the NE and SW corners of this excavation; the top of this UST is about 3' below the asphalt surface and can be seen only in the far NW corner of the excavation; the excavation has penetrated  3\" of asphalt and 3\" of 3/4\" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3' the soil is all sand and gravelly sand; in the NE corner of this excavation the pore space in the sand is saturated with gasoline at a depth of about 7'; this depth increases to about 8' in the SW corner; clearly this UST is leaking gasoline; further excavation and removal of this LUST and contaminated sand is required;";
d[26] =
  "In the exact center of this excavation is the SE facing wall of a UST for gasoline; the wall extends to the NE and SW disappearing into the NE and SW corners of this excavation; the top of this UST is about 3' below the asphalt surface and can be seen only in the far NW corner of the excavation; the excavation has penetrated  3\" of asphalt and 3\" of 3/4\" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3' the soil is all sand and gravelly sand; in the NE corner of this excavation the pore space in the sand is saturated with gasoline at a depth of about 7'; this depth increases to about 8' in the SW corner; clearly this UST is leaking gasoline; further excavation and removal of this LUST and contaminated sand is required;";
d[27] =
  'In the far NW corner of this pit a small (10" x 5") section of the SE facing wall of a UST is exposed;the UST appears to run to the NE and SW;   the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3\' the soil is all sand and gravelly sand; in the SE half of this pit the excavation also broke through the concrete pier on which the fuel pumps sit; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary;';
d[28] =
  'This excavation is completely filled by and centered over a UST that runs NE-SW; the walls of the UST are exposed in the NW and SE corners of this excavation and show that the diameter of this UST is about 11\'; the excavation penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt, sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[29] =
  "In the exact center of this excavation is the NE edge of a UST used for diesel fuel; the flat, circular end of this tank is 5' in diameter and extends from the center of this excavation to the W ending at the exact edge of the pit; the UST is 3' deep, and occupies the entire SW quadrant of this excavation; the UST sits on a 1' bed of 3/4\" gravel and extends further to the S; the surrounding soil consists of  3\" of aspahalt over 3\" of 3/4\" gravel covering about 3' of loess which covers gravelly sand below; there is no evidence of leakage from this UST into the surrounding soil nor is there any evidence of corrosion of the tank itself; at the top of this tank at the extreme S end of this pit is a 3' riser (a 3\" pipe rising from the tank to the surface of the asphalt) used to refill the tank; just W and next to this pipe is another smaller diameter pipe which rises up for 2' and then extends to the W and presumably runs to feed the fuel tank;";
d[30] =
  "In the exact center of this excavation is the SE edge of a UST used for diesel fuel; the flat, circular end of this tank is 5' in diameter and extends from the center of this excavation to the W ending at the exact edge of the pit; the UST is 3' deep, and occupies the entire NW quadrant of this excavation; the UST sits on a 1' bed of 3/4\" gravel and extends further to the N; the surrounding soil consists of  3\" of asphalt over 3\" of 3/4\" gravel covering about 3' of loess which covers gravelly sand below; there is no evidence of leakage from this UST into the surrounding soil nor is there any evidence of corrosion of the tank itself; at the top of this tank at the extreme N end of this pit is a 3' riser (a 3\" pipe rising from the tank to the surface of the asphalt) used to refill the tank; just W and next to this pipe is another smaller diameter pipe which rises up for 2' and then extends to the W and presumably runs to feed the fuel tank;";
d[31] =
  'In the exact center of this excavation is the NW corner of a 30\' long (N to S) and 10\' wide (E to W) concrete pier that is 10" high; the entire SE quadrant of this excavation consists of this concrete pier which extends 3" below the surrounding asphalt and sits on a 3" layer of 3/4" gravel which in turn overlies about 3\' of loess which covers gravelly sand below; the rest of the excavation consists of  3" of asphalt over 3" of 3/4" gravel covering about 3\' of loess which covers gravelly sand below; ';
d[32] =
  'In the exact center of this excavation is the W edge of a 30\' long (N to S) and 10\' wide (E to W) concrete pier that is 10" high; the entire W side of this excavation consists of this concrete pier which extends 3" below the surrounding asphalt and sits on a 3" layer of 3/4" gravel which in turn overlies about 3\' of loess which covers gravelly sand below; the rest of the excavation consists of  3" of asphalt over 3" of 3/4" gravel covering about 3\' of loess which covers gravelly sand below; ';
d[33] =
  "All the quadrants of this excavation consist entirely of a landfill which extends to depths of 6-8'; beneath the landfill is gravelly sand; the landfill itself consists entirely of construction debris - cinder block, metal flashing, tar paper, paper coffee cups and plastic & aluminum soda containers, empty bags of cement and mortar, broken glass, miscellaneous pieces of pipe, etc., all commingled with gravelly sand.";
d[34] =
  "The NE and SE quadrants of this excavation consists of about 3' of loess which covers gravelly sand below; the NW & SW quadrants consist entirely of a landfill which extends to depths of 6-8'; beneath the landfill is gravelly sand; the landfill itself consists entirely of construction debris - cinder block, metal flashing, tar paper, paper coffee cups and plastic & aluminum soda containers, empty bags of cement and mortar, broken glass, miscellaneous pieces of pipe, etc., all commingled with gravelly sand";
d[35] =
  'The NE, NW, and SW quadrants of this excavation consists of about 3\' of loess which covers gravelly sand below; in the NE and NW quadrants this soil structure is overlain by  3" of asphalt over 3" of 3/4" gravel; the entire SE quadrant consists of a landfill which extends to depths of 6-8\'; beneath the landfill is gravelly sand; the landfill itself consists entirely of construction debris - cinder block, metal flashing, tar paper, paper coffee cups and plastic & aluminum soda containers, empty bags of cement and mortar, broken glass, miscellaneous pieces of pipe, etc., all commingled with gravelly sand';
d[36] =
  'The NE & NW quadrants of this excavation consists of about 3\' of loess which covers gravelly sand below; in the NE and NW quadrants this soil structure is overlain by  3" of asphalt over 3" of 3/4" gravel; the SE & SW quadrants consist entirely of a landfill which extends to depths of 6-8\'; beneath the landfill is gravelly sand; the landfill itself consists entirely of construction debris - cinder block, metal flashing, tar paper, paper coffee cups and plastic & aluminum soda containers, empty bags of cement and mortar, broken glass, miscellaneous pieces of pipe, etc., all commingled with gravelly sand';
d[37] =
  'The NE, NW, and SE quadrants of this excavation consists of about 3\' of loess which covers gravelly sand below; in the NE and NW quadrants this soil structure is overlain by  3" of asphalt over 3" of 3/4" gravel; the entire SW quadrant consists of a landfill which extends to depths of 6-8\'; beneath the landfill is gravelly sand; the landfill itself consists entirely of construction debris - cinder block, metal flashing, tar paper, paper coffee cups and plastic & aluminum soda containers, empty bags of cement and mortar, broken glass, miscellaneous pieces of pipe, etc., all commingled with gravelly sand';
d[38] =
  'two solid, ceramic, septic field  pipes each 6" in diameter are found at a depth of 2\'; they rest on silty sand; the pipes runs down the exact center of this excavation with the pipes extending to the N & S; the surrounding soil is primarily sand with some silt and gravel';
d[39] =
  'a solid, ceramic, septic field  pipe  6" in diameter is found at a depth of 2\'; it rests on silty sand; the pipe runs down the exact center of this excavation with the pipe extending to the N & S; the surrounding soil is primarily sand with some silt and gravel';
d[40] =
  "excavation reveals the S end of a UST for oil;the end of the tank is exactly at the center of this excavation with 5' of tank visible extending to the N; the tank is circular & 4' in diameter; the top of the tank is 2' below the surface and sits on a 1' bed of coarse 2\" gravel; the surrounding soil consists of about 6\" of 3/4\" gravel and then about 3' of loess which covers gravelly sand below; close inspection does not show that any part of this tank is corroded or leaking; there is no evidence of any oil contamination within the gravel or adjacent soil;";
d[41] =
  'excavation reveals a UST for oil;the tank extends the full length of this excavation disappearing to the N & S; the tank is circular & 4\' in diameter; the top of the tank is 2\' below the surface and sits on a 1\' bed of coarse 2" gravel;at the exact center of this excavation there is a 3" pipe leaving the top of the tank and extending to the W disappearing into the loess and probably connecting to the oil refilling pipe at the base of the Self-Lume factory wall; the surrounding soil consists of about 6" of 3/4" gravel covering about 3\' of loess which covers gravelly sand below; close inspection does not show that any part of this tank is corroded or leaking; there is no evidence of any oil contamination within the gravel or adjacent soil;';
d[42] =
  "excavation reveals the N end of a UST for oil;the end of the tank is exactly at the center of this excavation with 5' of tank visible extending to the S; the tank is circular & 4' in diameter; the top of the tank is 2' below the surface and sits on a 1' bed of coarse 2\" gravel; the surrounding soil consists of about 6\" of 3/4\" gravel covering about 3' of loess which covers gravelly sand below; close inspection does not show that any part of this tank is corroded or leaking; there is no evidence of any oil contamination within the gravel or adjacent soil;";
d[43] =
  'excavation can only procede to the E of the Self-Lume factory foundation; excavation reveals that the oil refilling pipe visible at the base of the wall extends to a depth of about 2\' and then turns E running for 5\' until it disappears into the loess;the pipe is 3" in diameter; there is no evidence of a leaking or corroded pipe or oil in the soil; the surrounding soil consists of 6" of 3/4" gravel covering about 3\' of loess which covers gravelly sand below;';
d[44] =
  'In the exact center of this excavation is the NE corner of a 30\' long (N to S) and 10\' wide (E to W) concrete pier that is 10" high; the entire SW quadrant of this excavation consists of this concrete pier which extends 3" below the surrounding asphalt and sits on a 3" layer of 3/4" gravel which in turn overlies about 3\' of loess which covers gravelly sand below;the rest of the excavation consists of  3" of asphalt over 3" of 3/4" gravel covering about 3\' of loess which covers gravelly sand below; beginning at the extreme S end of the excavation and running N along the E wall of this excavation is the NW corner and a  5\' section (actually edge) of the W side of a UST used for diesel fuel; because the tank is cylindrical this 5\' section is barely visible at a depth of about 5 1/2\' below the surface; also, running E-W completely across the extreme S end of this excavation is a 2" diameter pipe; the pipe ends and bends upward in the SW corner of this excavation; this pipe feeds the fuel pump immediately above; there is no evidence of leakage from this UST or pipe into the surrounding soil nor is there any evidence of corrosion of the tank or pipe; ';
d[45] =
  'In the exact center of this excavation is the E edge of a 30\' long (N to S) and 10\' wide (E to W) concrete pier that is 10" high; the entire W side of this excavation consists of this concrete pier which extends 3" below the surrounding asphalt and sits on a 3" layer of 3/4" gravel which in turn overlies about 3\' of loess which covers gravelly sand below;the rest of the excavation consists of  3" of asphalt over 3" of 3/4" gravel covering about 3\' of loess which covers gravelly sand below; beginning at the extreme N end of the excavation and running S along the E wall of this excavation is the SW corner and a  5\' section (actually edge) of the W side of a UST used for diesel fuel; because the tank is cylindrical this 5\' section is barely visible at a depth of about 5 1/2\' below the surface; also, running E-W completely across the extreme N end of this excavation is a 2" diameter pipe; the pipe ends and bends upward in the NW corner of this excavation; this pipe feeds the fuel pump immediately above; there is no evidence of leakage from this UST or pipe into the surrounding soil nor is there any evidence of corrosion of the tank or pipe; ';
d[46] =
  'In the exact center of this excavation is the E edge of a 30\' long (N to S) and 10\' wide (E to W) concrete pier that is 10" high; the entire W side of this excavation consists of this concrete pier which extends 3" below the surrounding asphalt and sits on a 3" layer of 3/4" gravel which in turn overlies about 3\' of loess which covers gravelly sand below;the rest of the excavation consists of  3" of asphalt over 3" of 3/4" gravel covering about 3\' of loess which covers gravelly sand below; beginning at the extreme S end of the excavation and running N along the E wall of this excavation is the NW corner and a  5\' section (actually edge) of the W side of a UST used for diesel fuel; because the tank is cylindrical this 5\' section is barely visible at a depth of about 5 1/2\' below the surface; also, running E-W completely across the extreme S end of this excavation is a 2" diameter pipe; the pipe ends and bends upward in the SW corner of this excavation; this pipe feeds the fuel pump immediately above; there is no evidence of leakage from this UST or pipe into the surrounding soil nor is there any evidence of corrosion of the tank or pipe; ';
d[47] =
  'In the exact center of this excavation is the SW corner of a 30\' long (N to S) and 10\' wide (E to W) concrete pier that is 10" high; the entire NE quadrant of this excavation consists of this concrete pier which extends 3" below the surrounding asphalt and sits on a 3" layer of 3/4" gravel which in turn overlies about 3\' of loess which covers gravelly sand below; the rest of the excavation consists of  3" of asphalt over 3" of 3/4" gravel covering about 3\' of loess which covers gravelly sand below; ';
d[48] =
  'In the exact center of this excavation is the SE corner of a 30\' long (N to S) and 10\' wide (E to W) concrete pier that is 10" high; the entire NW quadrant of this excavation consists of this concrete pier which extends 3" below the surrounding asphalt and sits on a 3" layer of 3/4" gravel which in turn overlies about 3\' of loess which covers gravelly sand below;the rest of the excavation consists of  3" of asphalt over 3" of 3/4" gravel covering about 3\' of loess which covers gravelly sand below; beginning at the extreme N end of the excavation and running S along the E wall of this excavation is the SW corner and a  5\' section (actually edge) of the W side of a UST used for diesel fuel; because the tank is cylindrical this 5\' section is barely visible at a depth of about 5 1/2\' below the surface; also, running E-W completely across the extreme N end of this excavation is a 2" diameter pipe; the pipe ends and bends upward in the NW corner of this excavation; this pipe feeds the fuel pump immediately above; there is no evidence of leakage from this UST or pipe into the surrounding soil nor is there any evidence of corrosion of the tank or pipe; ';
d[49] =
  "The NW and SW quadrants of this excavation consists of about 3' of loess which covers gravelly sand below; the NE & SE quadrants consist entirely of a landfill which extends to depths of 6-8'; beneath the landfill is gravelly sand; the landfill itself consists entirely of construction debris - cinder block, metal flashing, tar paper, paper coffee cups and plastic & aluminum soda containers, empty bags of cement and mortar, broken glass, miscellaneous pieces of pipe, etc., all commingled with gravelly sand";
d[50] =
  "The SE & SW quadrants of this excavation consists of about 3' of loess which covers gravelly sand below; the NE & NW quadrants consist entirely of a landfill which extends to depths of 6-8'; beneath the landfill is gravelly sand; the landfill itself consists entirely of construction debris - cinder block, metal flashing, tar paper, paper coffee cups and plastic & aluminum soda containers, empty bags of cement and mortar, broken glass, miscellaneous pieces of pipe, etc., all commingled with gravelly sand";
d[51] =
  "The SE, SW, and NW quadrants of this excavation consists of about 3' of loess which covers gravelly sand below; the entire NE quadrant consists of a landfill which extends to depths of 6-8'; beneath the landfill is gravelly sand; the landfill itself consists entirely of construction debris - cinder block, metal flashing, tar paper, paper coffee cups and plastic & aluminum soda containers, empty bags of cement and mortar, broken glass, miscellaneous pieces of pipe, etc., all commingled with gravelly sand";
d[52] =
  "The SE, SW, and NE quadrants of this excavation consists of about 3' of loess which covers gravelly sand below; the entire NW quadrant consists of a landfill which extends to depths of 6-8'; beneath the landfill is gravelly sand; the landfill itself consists entirely of construction debris - cinder block, metal flashing, tar paper, paper coffee cups and plastic & aluminum soda containers, empty bags of cement and mortar, broken glass, miscellaneous pieces of pipe, etc., all commingled with gravelly sand";
d[53] =
  'In the far NW corner of this pit a small (10" x 5") section of the SE facing wall of a UST is exposed;the UST appears to run to the NE and SW;   the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3\' the soil is all sand and gravelly sand; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary;';
d[54] =
  'In the far SE corner of this pit a small (10" x 5") section of the NW facing wall of a UST is exposed;the UST appears to run to the NE and SW;  the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; in the NW half of this pit excavation also broke through the concrete pier on which the fuel pumps sit; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed; in the SE quadrant of this excavation the pore space in the sand is saturated with gasoline below 7\'; this stauration gradually disappears toward the NW corner of this excavation; clearly this UST which extends to the SW is leaking; further excavation and removal of this LUST and contaminated sand is required; ';
d[55] =
  'In the far SE corner of this pit a small (10" x 5") section of the NW facing wall of a UST is exposed;the UST appears to run to the NE and SW;  the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; in the NW half of this pit excavation also broke through the concrete pier on which the fuel pumps sit; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[56] =
  'In the far SE corner of this pit a small (10" x 5") section of the NW facing wall of a UST is exposed;the UST appears to run to the NE and SW; there is a 2" pipe exposed in the far SW corner of this excavation at a depth of about 1\'; this pipe runs NW-SE and connects the UST to the fuel pumps; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; the excavation also broke through the E corner of the concrete pier on which the fuel pumps sit; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed; in the NW quadrant of this excavation the pore space in the sand is saturated with gasoline below 9\'; this saturation depth gradually increases to 10\' toward the SE corner of this excavation; clearly there is a UST which is leaking; further excavation and inspection for this LUST and removal of  the contaminated sand is required; ';
d[57] =
  'In the far SE corner of this pit a small (10" x 5") section of the NW facing wall of a UST is exposed;the UST appears to run to the NE and SW; there is a 2" pipe exposed in the far SW corner of this excavation at a depth of about 1\'; this pipe runs NW-SE and connects the UST to the fuel pumps; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; the excavation also broke through the E corner of the concrete pier on which the fuel pumps sit; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed; in the SE quadrant of this excavation the pore space in the sand is saturated with gasoline below 6\'; this saturation gradually disappears toward the NW corner of this excavation; clearly this UST which extends to the SW is leaking; further excavation and removal of this LUST and contaminated sand is required; ';
d[58] =
  'In the far SE corner of this pit a small (10" x 5") section of the NW facing wall of a UST is exposed;the UST appears to run to the NE and SW; there is a 2" pipe exposed in the far SW corner of this excavation at a depth of about 1\'; this pipe runs NW-SE and connects the UST to the fuel pumps; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary;  ';
d[59] =
  'In the far SW corner of this pit a 11\' diameter strip (about 5" wide) of the NE facing end of a UST is exposed; the UST is about 3\' below the asphalt surface; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed;  no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[60] =
  'The excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; in the NW half of this pit excavation also broke through the concrete pier on which the fuel pumps sit; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[61] =
  'This excavation has penetrated  10" of concrete and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the concrete and gravel had been removed; below 3\' the soil is all sand and gravelly sand; the concrete is the pier on which the fuel pumps sit; a fuel pump had to be removed for this excavation; beneath this fuel pump in the exact center of this excavation is a 2" diameter pipe which extends to the SE leaving the pit 1\' below the  surface in the SE corner; in the NW quadrant the pore space in the sand is saturated with gasoline below 9\'; this depth increases to 10\' in the SE quadrant; clearly a UST is leaking; further excavation and inspection for this LUST and removal of the contaminated sand is required; ';
d[62] =
  'This excavation has penetrated  10" of concrete and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the concrete and gravel had been removed; below 3\' the soil is all sand and gravelly sand; the concrete is the pier on which the fuel pumps sit; a fuel pump had to be removed for this excavation; beneath this fuel pump in the exact center of this excavation is a 2" diameter pipe which extends to the SE leaving the pit 1\' below the surface in the SE corner; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary;';
d[63] =
  'This excavation has penetrated  10" of concrete and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the concrete and gravel had been removed; below 3\' the soil is all sand and gravelly sand; the concrete is the pier on which the fuel pumps sit; a fuel pump had to be removed for this excavation; in the N half of this excavation the pore space in the sand is saturated with gasoline below 9\'; this depth increases to 10\' in the S half; clearly a UST is leaking; further excavation and inspection for this LUST and removal of the contaminated sand is required; ';
d[64] =
  'This excavation has penetrated  10" of concrete and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the concrete and gravel had been removed; below 3\' the soil is all sand and gravelly sand; the concrete is the pier on which the fuel pumps sit; a fuel pump had to be removed for this excavation; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary;';
d[65] =
  'This excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3\' the soil is all sand and gravelly sand; the excavation also broke through the concrete pier on which the fuel pumps sit; in the NW quadrant the pore space in the sand is saturated with gasoline below 8\'; this depth increases to 9\' in the SE quadrant; clearly a UST is leaking; further excavation and inspection for this LUST and removal of the contaminated sand is required; ';
d[66] =
  'This excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3\' the soil is all sand and gravelly sand; the excavation also broke through the concrete pier on which the fuel pumps sit; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[67] =
  'This excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt, gravel, and silt had been removed; in the SW quadrant of this excavation the pore space in the sand is saturated with gasoline at the bottom of this pit (at and below 10\'); this stauration gradually disappears toward the NE corner of this excavation; clearly a nearby UST must be leaking; further excavation and inspection for this LUST as well as removal of the contaminated sand in this pit is required;  ';
d[68] =
  'This excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt, gravel, and silt had been removed; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary; ';
d[69] =
  'This excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt, gravel, and silt had been removed; in the SW quadrant of this excavation the pore space in the sand is saturated with gasoline at a depth of 9\'; this saturation gradually disappears toward the NE corner of this excavation; clearly a nearby UST must be leaking; further excavation and inspection for this LUST as well as removal of the contaminated sand in this pit is required;  ';
d[70] =
  'This excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt, gravel, and silt had been removed; in the  SW quadrant of this excavation the pore space in the sand is saturated with gasoline at the bottom of this pit (at and below 10\'); this stauration gradually disappears toward the NE corner of this excavation; clearly a nearby UST must be leaking; further excavation and inspection for this LUST as well as removal of the contaminated sand in this pit is required;  ';
d[71] =
  'This excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt, gravel, and silt had been removed; in the  NW & SW quadrants of this excavation the pore space in the sand is saturated with gasoline at the bottom of this pit (at and below 10\'); this stauration gradually disappears toward the NE & SE corners of this excavation; clearly a nearby UST must be leaking; further excavation and inspection for this LUST as well as removal of the contaminated sand in this pit is required;  ';
d[72] =
  'This excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt, gravel, and silt had been removed; in the NW quadrant of this excavation the pore space in the sand is saturated with gasoline at a depth of 9\'; this depth of saturation gradually increases toward the SE corner of this excavation; clearly a nearby UST must be leaking; further excavation and inspection for this LUST as well as removal of the contaminated sand in this pit is required;  ';
d[73] =
  'This excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt, gravel, and silt had been removed; in the SW quadrant of this excavation the pore space in the sand is saturated with gasoline below 9\'; this stauration gradually disappears toward the NE corner of this excavation; clearly a nearby UST must be leaking; further excavation and in spection for this LUST as well as removal of the contaminated sand in this pit is required;  ';
d[74] =
  'This excavation is completely filled by and centered over a UST that runs NE-SW; the walls of the UST are exposed in the NW and SE corners of this excavation and show that the diameter of this UST is about 11\'; the excavation penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt, sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and soil had been removed; the top of the UST is about 3\' below the asphalt surface; in the exact center of this excavation there is a 3" pipe rising out of the UST which extends to the surface and is capped there; this is the refueling port for the UST; the strong smell of gasoline and some sand saturated with gasoline removed from the NW and SE corners of this excavation indicate that this UST is leaking gasoline; further excavation and inspection of this UST and possible removal of this LUST and contaminated sand is required;';
d[75] =
  'This excavation is completely filled by and centered over a UST that runs NE-SW; the walls of the UST are exposed in the NW and SE corners of this excavation and show that the diameter of this UST is about 11\'; the excavation penetrated  3" of asphalt and 3" of 3/4" gravel before encountering a mixture of silt, sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and soil had been removed; the top of the UST is about 3\' below the asphalt surface; there is a 2" pipe exposed in the far NE corner of this excavation at a depth of about 1\'; this pipe runs NW-SE and connects the UST to the fuel pumps;the strong smell of gasoline and some sand saturated with gasoline removed from the NW and SE corners of this excavation indicate that this UST is leaking gasoline; further excavation and inspection of this UST and possible removal of this LUST and contaminated sand is required;';
d[76] =
  "In the exact center of this excavation is the southernmost corner of a UST for gasoline; about 1/2 of the 11' diameter, circular end of this UST (whose flat surfaces faces SW) is exposed in this excavation and it disappears into the NW corner of the pit wall; the SE facing side of the tank begins at the center of this excavation and disappears into the NE corner of the pit wall;the top of this UST is about 3' below the asphalt surface; the excavation has penetrated  3\" of asphalt and 3\" of 3/4\" gravel before encountering a a mixture of silt (loess), sand, and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and gravel had been removed; below 3' the soil is all sand and gravelly sand; at a depth of about 8' the pore space in the sand is saturated with gasoline; clearly this UST is leaking gasoline; further excavation and removal of this LUST and contaminated sand is required;";
d[77] =
  'In the far NE corner as well of this pit a 11\' diameter strip (about 5" wide) of the SW facing end of a UST is exposed; the UST is about 3\' below the asphalt surface; the excavation has penetrated  3" of asphalt and 3" of 3/4" gravel before encountering about 6" of silt (loess) which covers sand and gravelly sand; there was a pervasive smell of gasoline right from the beginning of this excavation after the asphalt and silt had been removed; no gasoline is present, however, in the soil in this pit; it is a distinct possibility that a nearby UST is leaking; further excavation and inspection for a LUST is necessary;';
d[78] =
  'a solid, ceramic, septic field  pipe  6" in diameter is found at a depth of 2\'; it rests on silty sand; the pipe runs from the E to the W of the entire excavation; the surrounding soil is primarily sand with some silt and gravel';

dataMaps.exca = new DataMapCodedValue(
  'Excavation',
  'Excavation',
  a,
  d,
  320,
  200,
  0,
);

a = [];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0.08,
  0.13,
  0.14,
  0.09,
  0.09,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0.07,
  0.14,
  0.18,
  0.27,
  0.32,
  0.36,
  0.36,
  0.2,
  0.12,
  0.01,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0.04,
  0.17,
  0.27,
  0.32,
  0.41,
  0.5,
  0.63,
  0.63,
  0.35,
  0.28,
  0.13,
  0.1,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0.03,
  0.11,
  0.26,
  0.38,
  0.43,
  0.57,
  0.73,
  0.82,
  0.82,
  0.59,
  0.46,
  0.27,
  0.2,
  0.08,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0.09,
  0.19,
  0.35,
  0.5,
  0.57,
  0.71,
  0.91,
  1.01,
  0.99,
  0.81,
  0.64,
  0.4,
  0.31,
  0.17,
  0.03,
  0,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0.04,
  0.15,
  0.27,
  0.5,
  0.68,
  0.75,
  0.89,
  1.05,
  1.14,
  1.08,
  1,
  0.83,
  0.56,
  0.42,
  0.26,
  0.11,
  0,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0.08,
  0.21,
  0.35,
  0.6,
  0.76,
  0.84,
  0.96,
  1.05,
  1.14,
  1.1,
  1.03,
  0.91,
  0.64,
  0.52,
  0.36,
  0.2,
  0.01,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0.05,
  0.16,
  0.29,
  0.43,
  0.67,
  0.83,
  0.91,
  1.01,
  1.08,
  1.13,
  1.1,
  1.05,
  0.96,
  0.71,
  0.6,
  0.45,
  0.3,
  0.08,
  0.01,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0.01,
  0.15,
  0.24,
  0.38,
  0.51,
  0.74,
  0.88,
  0.97,
  1.04,
  1.07,
  1.12,
  1.1,
  1.05,
  1.01,
  0.8,
  0.7,
  0.54,
  0.39,
  0.14,
  0.07,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0.07,
  0.25,
  0.32,
  0.46,
  0.62,
  0.83,
  0.94,
  1.01,
  1.06,
  1.08,
  1.1,
  1.09,
  1.07,
  1.04,
  0.9,
  0.78,
  0.61,
  0.44,
  0.21,
  0.1,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0.01,
  0.11,
  0.3,
  0.38,
  0.52,
  0.65,
  0.86,
  0.97,
  1.01,
  1.06,
  1.08,
  1.1,
  1.1,
  1.08,
  1.05,
  0.95,
  0.82,
  0.65,
  0.49,
  0.24,
  0.12,
  0.01,
  0,
  0,
];
a[49] = [
  0,
  0,
  0.05,
  0.15,
  0.33,
  0.44,
  0.58,
  0.71,
  0.91,
  1,
  1.03,
  1.07,
  1.09,
  1.1,
  1.1,
  1.08,
  1.05,
  0.96,
  0.83,
  0.68,
  0.52,
  0.26,
  0.12,
  0.01,
  0,
  0,
];
a[48] = [
  0,
  0,
  0.07,
  0.18,
  0.36,
  0.49,
  0.62,
  0.76,
  0.96,
  1.02,
  1.05,
  1.08,
  1.1,
  1.09,
  1.09,
  1.07,
  1.04,
  0.94,
  0.83,
  0.71,
  0.54,
  0.27,
  0.12,
  0.01,
  0,
  0,
];
a[47] = [
  0,
  0,
  0.08,
  0.2,
  0.4,
  0.52,
  0.67,
  0.8,
  0.97,
  1.03,
  1.07,
  1.09,
  1.09,
  1.08,
  1.08,
  1.05,
  1,
  0.9,
  0.82,
  0.69,
  0.55,
  0.3,
  0.14,
  0.02,
  0,
  0,
];
a[46] = [
  0,
  0,
  0.07,
  0.2,
  0.4,
  0.53,
  0.67,
  0.8,
  0.96,
  1.03,
  1.06,
  1.08,
  1.09,
  1.08,
  1.07,
  1.04,
  1,
  0.89,
  0.81,
  0.69,
  0.55,
  0.32,
  0.17,
  0.03,
  0,
  0,
];
a[45] = [
  0,
  0,
  0.07,
  0.2,
  0.41,
  0.55,
  0.69,
  0.81,
  0.96,
  1.02,
  1.06,
  1.08,
  1.09,
  1.07,
  1.06,
  1.03,
  0.98,
  0.87,
  0.79,
  0.68,
  0.56,
  0.35,
  0.19,
  0.03,
  0,
  0,
];
a[44] = [
  0,
  0,
  0.1,
  0.22,
  0.43,
  0.57,
  0.7,
  0.82,
  0.96,
  1.02,
  1.06,
  1.08,
  1.08,
  1.07,
  1.05,
  1.01,
  0.96,
  0.86,
  0.78,
  0.67,
  0.56,
  0.37,
  0.2,
  0.06,
  0,
  0,
];
a[43] = [
  0,
  0,
  0.12,
  0.26,
  0.48,
  0.6,
  0.74,
  0.87,
  0.99,
  1.04,
  1.06,
  1.08,
  1.08,
  1.06,
  1.04,
  1,
  0.94,
  0.85,
  0.76,
  0.66,
  0.55,
  0.36,
  0.22,
  0.09,
  0,
  0,
];
a[42] = [
  0,
  0,
  0.12,
  0.26,
  0.49,
  0.62,
  0.76,
  0.87,
  1,
  1.05,
  1.06,
  1.08,
  1.08,
  1.06,
  1.03,
  1,
  0.94,
  0.85,
  0.76,
  0.66,
  0.55,
  0.37,
  0.24,
  0.11,
  0.02,
  0,
];
a[41] = [
  0,
  0,
  0.13,
  0.28,
  0.51,
  0.65,
  0.79,
  0.91,
  1.02,
  1.06,
  1.07,
  1.08,
  1.08,
  1.05,
  1.03,
  1,
  0.95,
  0.86,
  0.78,
  0.68,
  0.57,
  0.38,
  0.26,
  0.15,
  0.05,
  0,
];
a[40] = [
  0,
  0.04,
  0.17,
  0.31,
  0.53,
  0.68,
  0.82,
  0.92,
  1.03,
  1.06,
  1.07,
  1.08,
  1.07,
  1.05,
  1.03,
  1,
  0.96,
  0.87,
  0.79,
  0.69,
  0.59,
  0.4,
  0.3,
  0.19,
  0.09,
  0,
];
a[39] = [
  0,
  0.08,
  0.2,
  0.35,
  0.55,
  0.68,
  0.82,
  0.92,
  1.02,
  1.05,
  1.07,
  1.07,
  1.07,
  1.05,
  1.04,
  1.01,
  0.97,
  0.88,
  0.81,
  0.7,
  0.59,
  0.41,
  0.32,
  0.2,
  0.09,
  0,
];
a[38] = [
  0,
  0.1,
  0.21,
  0.35,
  0.54,
  0.67,
  0.79,
  0.88,
  0.99,
  1.04,
  1.06,
  1.07,
  1.07,
  1.06,
  1.05,
  1.03,
  1,
  0.92,
  0.85,
  0.74,
  0.63,
  0.45,
  0.34,
  0.23,
  0.13,
  0,
];
a[37] = [
  0,
  0.08,
  0.21,
  0.34,
  0.54,
  0.66,
  0.77,
  0.87,
  0.98,
  1.03,
  1.05,
  1.06,
  1.07,
  1.06,
  1.05,
  1.04,
  1.02,
  0.96,
  0.87,
  0.75,
  0.64,
  0.46,
  0.35,
  0.24,
  0.14,
  0.01,
];
a[36] = [
  0.02,
  0.08,
  0.21,
  0.34,
  0.53,
  0.65,
  0.77,
  0.86,
  0.98,
  1.03,
  1.05,
  1.06,
  1.06,
  1.05,
  1.05,
  1.04,
  1.02,
  0.96,
  0.87,
  0.75,
  0.64,
  0.46,
  0.35,
  0.24,
  0.14,
  0.01,
];
a[35] = [
  0.03,
  0.12,
  0.22,
  0.35,
  0.53,
  0.64,
  0.77,
  0.86,
  0.98,
  1.02,
  1.04,
  1.05,
  1.05,
  1.03,
  1.03,
  1.03,
  1.01,
  0.93,
  0.86,
  0.74,
  0.63,
  0.46,
  0.35,
  0.24,
  0.14,
  0.01,
];
a[34] = [
  0.06,
  0.14,
  0.24,
  0.35,
  0.52,
  0.63,
  0.74,
  0.83,
  0.97,
  1.01,
  1.03,
  1.04,
  1.04,
  1.03,
  1.03,
  1.02,
  0.99,
  0.91,
  0.83,
  0.73,
  0.62,
  0.45,
  0.34,
  0.23,
  0.13,
  0,
];
a[33] = [
  0.06,
  0.15,
  0.25,
  0.35,
  0.51,
  0.61,
  0.72,
  0.81,
  0.94,
  0.99,
  1.01,
  1.03,
  1.04,
  1.04,
  1.03,
  1.02,
  0.99,
  0.9,
  0.81,
  0.7,
  0.6,
  0.44,
  0.33,
  0.22,
  0.11,
  0,
];
a[32] = [
  0.06,
  0.15,
  0.24,
  0.34,
  0.49,
  0.59,
  0.69,
  0.78,
  0.91,
  0.97,
  0.99,
  1.02,
  1.03,
  1.03,
  1.03,
  1.02,
  0.99,
  0.89,
  0.8,
  0.7,
  0.59,
  0.43,
  0.32,
  0.2,
  0.08,
  0,
];
a[31] = [
  0.06,
  0.13,
  0.22,
  0.32,
  0.48,
  0.57,
  0.67,
  0.76,
  0.89,
  0.95,
  0.98,
  1.01,
  1.03,
  1.03,
  1.02,
  1.01,
  0.98,
  0.87,
  0.79,
  0.68,
  0.58,
  0.41,
  0.31,
  0.2,
  0.06,
  0,
];
a[30] = [
  0.04,
  0.11,
  0.2,
  0.3,
  0.45,
  0.55,
  0.65,
  0.74,
  0.86,
  0.93,
  0.98,
  1.01,
  1.02,
  1.01,
  1.01,
  0.99,
  0.94,
  0.83,
  0.76,
  0.64,
  0.54,
  0.38,
  0.28,
  0.17,
  0.06,
  0,
];
a[29] = [
  0.02,
  0.08,
  0.17,
  0.27,
  0.42,
  0.52,
  0.62,
  0.71,
  0.84,
  0.92,
  0.98,
  1,
  1.01,
  1.01,
  1,
  0.97,
  0.93,
  0.81,
  0.74,
  0.64,
  0.54,
  0.37,
  0.27,
  0.17,
  0.06,
  0,
];
a[28] = [
  0,
  0.06,
  0.14,
  0.24,
  0.4,
  0.49,
  0.59,
  0.68,
  0.82,
  0.91,
  0.95,
  0.99,
  1.01,
  1,
  0.99,
  0.96,
  0.9,
  0.79,
  0.71,
  0.62,
  0.52,
  0.35,
  0.26,
  0.16,
  0.06,
  0,
];
a[27] = [
  0,
  0.02,
  0.11,
  0.21,
  0.38,
  0.46,
  0.56,
  0.65,
  0.8,
  0.88,
  0.92,
  0.97,
  0.99,
  1,
  0.98,
  0.94,
  0.88,
  0.76,
  0.69,
  0.59,
  0.49,
  0.33,
  0.24,
  0.14,
  0.06,
  0,
];
a[26] = [
  0,
  0,
  0.11,
  0.21,
  0.36,
  0.44,
  0.55,
  0.65,
  0.78,
  0.86,
  0.9,
  0.95,
  0.99,
  0.98,
  0.96,
  0.92,
  0.86,
  0.74,
  0.67,
  0.57,
  0.47,
  0.32,
  0.22,
  0.13,
  0.05,
  0,
];
a[25] = [
  0,
  0,
  0.09,
  0.19,
  0.34,
  0.42,
  0.51,
  0.6,
  0.73,
  0.82,
  0.86,
  0.92,
  0.96,
  0.95,
  0.93,
  0.89,
  0.83,
  0.71,
  0.64,
  0.55,
  0.45,
  0.29,
  0.2,
  0.1,
  0.03,
  0,
];
a[24] = [
  0,
  0,
  0.09,
  0.19,
  0.34,
  0.41,
  0.49,
  0.57,
  0.71,
  0.79,
  0.83,
  0.89,
  0.93,
  0.92,
  0.9,
  0.86,
  0.81,
  0.69,
  0.62,
  0.52,
  0.43,
  0.27,
  0.18,
  0.1,
  0.02,
  0,
];
a[23] = [
  0,
  0.02,
  0.11,
  0.21,
  0.35,
  0.38,
  0.47,
  0.56,
  0.68,
  0.76,
  0.8,
  0.86,
  0.9,
  0.9,
  0.88,
  0.83,
  0.78,
  0.66,
  0.59,
  0.5,
  0.4,
  0.25,
  0.17,
  0.09,
  0.02,
  0,
];
a[22] = [
  0,
  0.01,
  0.09,
  0.25,
  0.38,
  0.39,
  0.47,
  0.56,
  0.67,
  0.74,
  0.78,
  0.83,
  0.87,
  0.87,
  0.85,
  0.8,
  0.75,
  0.63,
  0.56,
  0.47,
  0.37,
  0.23,
  0.15,
  0.07,
  0,
  0,
];
a[21] = [
  0,
  0.01,
  0.08,
  0.26,
  0.39,
  0.42,
  0.48,
  0.54,
  0.64,
  0.71,
  0.75,
  0.8,
  0.83,
  0.82,
  0.81,
  0.77,
  0.72,
  0.59,
  0.53,
  0.43,
  0.34,
  0.18,
  0.12,
  0.05,
  0,
  0,
];
a[20] = [
  0,
  0.03,
  0.13,
  0.22,
  0.36,
  0.4,
  0.46,
  0.52,
  0.62,
  0.68,
  0.72,
  0.77,
  0.8,
  0.8,
  0.78,
  0.74,
  0.69,
  0.56,
  0.49,
  0.4,
  0.31,
  0.14,
  0.08,
  0.01,
  0,
  0,
];
a[19] = [
  0,
  0.05,
  0.12,
  0.2,
  0.33,
  0.37,
  0.43,
  0.49,
  0.59,
  0.66,
  0.69,
  0.74,
  0.77,
  0.77,
  0.76,
  0.72,
  0.66,
  0.53,
  0.46,
  0.37,
  0.27,
  0.11,
  0.04,
  0,
  0,
  0,
];
a[18] = [
  0,
  0.04,
  0.11,
  0.18,
  0.3,
  0.33,
  0.4,
  0.47,
  0.57,
  0.63,
  0.66,
  0.71,
  0.74,
  0.75,
  0.73,
  0.69,
  0.63,
  0.5,
  0.43,
  0.33,
  0.24,
  0.09,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0.02,
  0.07,
  0.13,
  0.24,
  0.3,
  0.36,
  0.42,
  0.52,
  0.59,
  0.63,
  0.68,
  0.71,
  0.71,
  0.7,
  0.66,
  0.59,
  0.45,
  0.4,
  0.31,
  0.22,
  0.08,
  0.01,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0.04,
  0.1,
  0.21,
  0.26,
  0.32,
  0.38,
  0.49,
  0.56,
  0.6,
  0.65,
  0.69,
  0.68,
  0.67,
  0.61,
  0.55,
  0.42,
  0.36,
  0.28,
  0.2,
  0.08,
  0.01,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0.02,
  0.07,
  0.17,
  0.21,
  0.28,
  0.34,
  0.45,
  0.52,
  0.56,
  0.61,
  0.65,
  0.63,
  0.62,
  0.56,
  0.49,
  0.38,
  0.33,
  0.25,
  0.18,
  0.07,
  0.01,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0.03,
  0.13,
  0.17,
  0.23,
  0.3,
  0.41,
  0.48,
  0.51,
  0.57,
  0.6,
  0.59,
  0.57,
  0.51,
  0.45,
  0.34,
  0.29,
  0.23,
  0.16,
  0.06,
  0.01,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0.04,
  0.1,
  0.18,
  0.25,
  0.35,
  0.41,
  0.46,
  0.52,
  0.55,
  0.54,
  0.51,
  0.47,
  0.41,
  0.3,
  0.27,
  0.2,
  0.14,
  0.05,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0.08,
  0.15,
  0.21,
  0.31,
  0.38,
  0.42,
  0.48,
  0.51,
  0.5,
  0.48,
  0.43,
  0.38,
  0.28,
  0.24,
  0.18,
  0.12,
  0.03,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0.01,
  0.08,
  0.14,
  0.19,
  0.29,
  0.35,
  0.38,
  0.44,
  0.48,
  0.47,
  0.44,
  0.4,
  0.35,
  0.25,
  0.21,
  0.15,
  0.1,
  0.01,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0.01,
  0.07,
  0.12,
  0.17,
  0.26,
  0.32,
  0.35,
  0.4,
  0.44,
  0.43,
  0.41,
  0.37,
  0.32,
  0.22,
  0.17,
  0.12,
  0.07,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0.01,
  0.05,
  0.1,
  0.15,
  0.24,
  0.29,
  0.32,
  0.36,
  0.39,
  0.4,
  0.38,
  0.33,
  0.29,
  0.19,
  0.14,
  0.08,
  0.02,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0.02,
  0.07,
  0.12,
  0.2,
  0.25,
  0.29,
  0.33,
  0.37,
  0.36,
  0.34,
  0.3,
  0.26,
  0.16,
  0.1,
  0.02,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0.04,
  0.09,
  0.17,
  0.22,
  0.25,
  0.3,
  0.33,
  0.32,
  0.31,
  0.27,
  0.23,
  0.13,
  0.09,
  0.02,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0.02,
  0.05,
  0.13,
  0.18,
  0.21,
  0.26,
  0.29,
  0.29,
  0.28,
  0.23,
  0.19,
  0.11,
  0.07,
  0.01,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0.02,
  0.09,
  0.15,
  0.17,
  0.22,
  0.26,
  0.26,
  0.25,
  0.2,
  0.16,
  0.09,
  0.04,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0.02,
  0.09,
  0.13,
  0.19,
  0.21,
  0.21,
  0.19,
  0.15,
  0.11,
  0.03,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0.06,
  0.1,
  0.15,
  0.18,
  0.17,
  0.16,
  0.11,
  0.06,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0.04,
  0.08,
  0.12,
  0.14,
  0.12,
  0.12,
  0.06,
  0.01,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0.02,
  0.04,
  0.04,
  0.1,
  0.04,
  0.04,
  0.02,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.floatgas = new DataMapNumeric(
  'Floating Gas',
  'Floating Gas Thickness',
  'ft',
  a,
  320,
  200,
  0,
  80,
  114,
  26,
  61,
);

a = [];
b = [];
b[94] = 16;
b[95] = 19;
a[174] = b;
b = [];
b[95] = 17;
b[96] = 20;
b[93] = 22;
b[94] = 23;
a[173] = b;
b = [];
b[92] = 15;
b[94] = 24;
b[95] = 25;
b[93] = 26;
a[172] = b;
b = [];
b[91] = b[98] = 16;
b[93] = 18;
b[92] = b[99] = 19;
b[94] = 21;
a[171] = b;
b = [];
b[92] = b[99] = 17;
b[93] = b[100] = 20;
b[90] = b[97] = 22;
b[91] = b[98] = 23;
a[170] = b;
b = [];
b[89] = b[96] = 15;
b[91] = b[98] = 24;
b[92] = b[99] = 25;
b[90] = b[97] = 26;
a[169] = b;
b = [];
b[94] = 16;
b[90] = b[97] = 18;
b[95] = 19;
b[91] = b[98] = 21;
a[168] = b;
b = [];
b[95] = 17;
b[96] = 20;
b[93] = 22;
b[94] = 23;
a[167] = b;
b = [];
b[92] = 15;
b[94] = 24;
b[95] = 25;
b[93] = 26;
a[166] = b;
b = [];
b[93] = 18;
b[94] = 21;
a[165] = b;
b = [];
b[221] = 3;
b[222] = b[224] = b[225] = 4;
b[225] = 7;
b[226] = 14;
a[120] = b;
b = [];
b[221] = 3;
b[222] = b[224] = b[225] = 4;
b[225] = 7;
b[226] = 14;
b[253] = 64;
b[252] = 65;
a[118] = b;
b = [];
b[253] = 68;
b[252] = 69;
a[117] = b;
b = [];
b[221] = 3;
b[222] = b[224] = b[225] = 4;
b[225] = 6;
b[226] = 8;
b[227] = 9;
b[228] = 10;
b[229] = 11;
b[230] = 12;
b[231] = 0;
b[253] = 66;
b[252] = 67;
a[116] = b;
b = [];
b[221] = 3;
b[222] = b[224] = b[225] = 4;
b[225] = 5;
b[226] = 13;
a[114] = b;
b = [];
b[221] = 3;
b[222] = b[224] = b[225] = 4;
b[225] = 5;
b[226] = 13;
a[112] = b;
b = [];
b[231] = 27;
b[232] = 29;
a[94] = b;
b = [];
b[231] = 28;
b[232] = 30;
a[93] = b;
b = [];
b[231] = 27;
b[232] = 29;
a[92] = b;
b = [];
b[231] = 28;
b[232] = 30;
a[91] = b;
b = [];
b[230] = 61;
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 62;
b[237] = 63;
a[84] = b;
b = [];
b[230] = 58;
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 59;
b[237] = 60;
a[83] = b;
b = [];
b[230] = 55;
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 56;
b[237] = 57;
a[82] = b;
b = [];
b[230] = 52;
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 53;
b[237] = 54;
a[81] = b;
b = [];
b[230] = 49;
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 50;
b[237] = 51;
a[80] = b;
b = [];
b[230] = 31;
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 32;
b[237] = 33;
a[79] = b;
b = [];
b[230] = 43;
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 44;
b[237] = 45;
a[78] = b;
b = [];
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 39;
b[230] = 41;
b[237] = 42;
a[77] = b;
b = [];
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 36;
b[230] = 38;
b[237] = 40;
a[76] = b;
b = [];
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 34;
b[230] = 35;
b[237] = 37;
a[75] = b;
b = [];
b[230] = 46;
b[231] = b[233] = b[234] = b[235] = b[236] = b[237] = 47;
b[237] = 48;
a[74] = b;
b = [];
d = [];
d[0] =
  "ground surface is flat and at an elevation of 837'; 10' section of pipe running E-W centered on transect; pipe is 6-10\" in diameter; pipe ends at east end of transect and enters foundation of factory building; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width of trench undetermined; trench fill is unknown; recommend excavation for clarification.";
d[1] =
  "ground surface is flat and at an elevation of 837'; at extreme eastern end of transect there is a longitudinal section of pipe 1/2' in length; it runs E-W centered on transect; pipe is 6-10\" in diameter; pipe likely continues to the east; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width of trench undetermined; trench fill is unknown; recommend excavation for clarification and further GPR study along this and adjacent transects.";
d[2] = 'background';
d[3] =
  "ground surface is flat and at an elevation of 837'; 10' section of pipe running E-W centered on transect; pipe is 6-10\" in diameter; pipe ends at west end of transect; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width of trench undetermined; trench fill is unknown; recommend excavation for clarification";
d[4] =
  "ground surface is flat and at an elevation of 837'; 10' section of pipe running E-W centered on transect; pipe is 6-10\" in diameter; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width of trench undetermined; trench fill is unknown; recommend excavation for clarification";
d[5] =
  "ground surface is flat and at an elevation of 837'; 10' section of pipe running E-W centered on transect; pipe is 6-10\" in diameter; pipe ends at east end of transect and bends 90 degrees to the north; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width of trench undetermined; trench fill is unknown; recommend excavation for clarification";
d[6] =
  "ground surface is flat and at an elevation of 837'; 8' section of pipe running E-W centered on transect; pipe is 6-10\" in diameter; pipe ends at east end of transect and enters a large object 3' in depth;the object is at a depth of 1' and is possibly a small tank; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width and composition of object is unknown; only 2' of the length of the object can be seen and there is probably more to the east; width of trench undetermined; trench fill is unknown; recommend excavation for clarification; possible septic field.";
d[7] =
  "ground surface is flat and at an elevation of 837'; 10' section of pipe running E-W centered on transect; pipe is 6-10\" in diameter; pipe ends at east end of transect and bends 90 degrees to the south; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width of trench undetermined; trench fill is unknown; recommend excavation for clarification";
d[8] =
  "ground surface is flat and at an elevation of 837'; 8' section of pipe running E-W centered on transect; pipe is 6-10\" in diameter; pipe ends at west end of transect and enters an object 3' in depth; the object is at a depth of 1' and is possibly a small tank; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width and composition of object is unknown; only 2' of the length of the object can be seen and there is probably more to the west; width of trench undetermined; trench fill is unknown; recommend excavation for clarification; possible septic field.";
d[9] =
  "ground surface is flat and at an elevation of 837'; 9' section of pipe running E-W centered on transect; pipe is 6-10\" in diameter; pipe ends at east end of transect and enters a large, object 5' in depth; large object is at a depth of 1' and is possibly a tank; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width and composition of object is unknown; only 1' of the length of the object can be seen and there is probably more to the east; trench walls and bottom and the sides and bottom of the large object are nearly contiguous; width of pipe trench undetermined; trench fill is unknown; recommend excavation for clarification; possible septic field.";
d[10] =
  "ground surface is flat and at an elevation of 837'; there is a 10' section of a large object, possibly a tank; the object is at a depth of 1';  width and composition of object is unknown; the object probably extends both to the east and west; centered exactly halfway along this transect is an object just beneath the surface  and 2' long; the configuration suggests this is a septic tank riser and port; trench walls and bottom and the sides and bottom of the object are nearly contiguous; recommend excavation for clarification; recomend further GPR study to locate probable septic field.";
d[11] =
  "ground surface is flat and at an elevation of 837'; there is a 10' section of a large object, possibly a tank; the object is at a depth of 1';  width and composition of object is unknown; the object probably extends both to the east and west; centered exactly halway along this transect is an object 2'  long; the configuration suggets this to be a septic tank riser and port; trench walls and bottom and the sides and bottom of the object are nearly contiguous; recommend excavation for clarification; recommend further GPR study to locate likely septic field.";
d[12] =
  "ground surface is flat and at an elevation of 837'; 9' section of pipe running E-W centered on transect; pipe is 6-10\" in diameter; pipe ends at west end of transect and and enters a large, object 5' in depth; large object is at a depth of 1' and is possibly a tank; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width and composition of object is unknown; only 1' of the length of the object can be seen and there is probably more to the west; trench walls and bottom and the sides and bottom of the large object are nearly contiguous; width of pipe trench undetermined; trench fill is unknown; recommend excavation for clarification; possible septic field.";
d[13] =
  "ground surface is flat and at an elevation of 837'; at extreme western end of transect there is a longitudinal section of pipe 1/2' in length; it runs E-W centered on transect; pipe is 6-10\" in diameter; the pipe appears to turn 90 degrees north and continue in that direction; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width of trench undetermined; trench fill is unknown; recommend excavation for clarification and further GPR study along this and adjacent transects.";
d[14] =
  "ground surface is flat and at an elevation of 837'; at extreme western end of transect there is a longitudinal section of pipe 1/2' in length; it runs E-W centered on transect; pipe is 6-10\" in diameter; the pipe appears to turn 90 degrees to the south and continue in this direction; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width of trench undetermined; trench fill is unknown; recommend excavation for clarification and further GPR study along this and adjacent transects.";
d[15] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the easternmost edge of this GPR image is the W pointing corner of a UST; the UST is about 5 feet in diameter';
d[16] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the easternmost edge of this GPR image is the N pointing corner of a UST; the UST is about 5 feet in diameter';
d[17] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this is a UST extending from the westernmost part of this image to the easternmost part where the E pointing corner of the UST is located; the UST is about 5 feet in diameter';
d[18] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the easternmost edge of this GPR image is the S pointing corner of a UST; the UST is about 5 feet in diameter';
d[19] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the westernmost edge of this GPR image is the N pointing corner of a UST; the UST is about 5 feet in diameter';
d[20] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the westernmost edge of this GPR image is the E pointing corner of a UST; the UST is about 5 feet in diameter';
d[21] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the westernmost edge of this GPR image is the S pointing corner of a UST; the UST is about 5 feet in diameter';
d[22] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the easternmost edge of this GPR image is the side of a UST which runs NE-SW; the UST is about 5 feet in diameter';
d[23] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this is a UST extending from the easternmost part of this image to the westernmost part where the side of a UST which runs NE-SW is located; the UST is about 5 feet in diameter';
d[24] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this is a UST extending from the westernmost part of this image to the easternmost part where the side of a UST which runs NE-SW is located; the UST is about 5 feet in diameter';
d[25] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the westernmost edge of this GPR image is the side of a UST which runs NE-SW; the UST is about 5 feet in diameter';
d[26] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this is a UST extending from the easternmost part of this image to the westernmost part where the W pointing corner of the UST is located; the UST is about 5 feet in diameter';
d[27] =
  'there is a surface layer about 6" thick of asphalt and gravel; 3 feet below the surface there is the N end of a presumed UST; the W corner of this end is 5 feet from the W side of this transect and the E corner of the UST is at the E end of this transect; the UST is, thus, 5 feet wide; it is also 5 feet deep (extending to a depth of 8 feet)';
d[28] =
  'there is a surface layer about 6" thick of asphalt and gravel; 3 feet below the surface there is the S end of a presumed UST; the W corner of this end is 5 feet from the W side of this transect and the E corner of the UST is at the E end of this transect; the UST is, thus, 5 feet wide; it is also 5 feet deep (extending to a depth of 8 feet)';
d[29] =
  'there is a surface layer about 6" thick of asphalt and gravel; 3 feet below the surface there is the NE corner of a presumed UST; the NE corner of this UST is at the extreme W end of this transect';
d[30] =
  'there is a surface layer about 6" thick of asphalt and gravel; 3 feet below the surface there is the SE corner of a presumed UST; the SE corner of this UST is at the extreme W end of this transect';
d[31] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at E end of this transect';
d[32] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet';
d[33] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at W end of this transect';
d[34] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet';
d[35] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at E end of this transect';
d[36] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet';
d[37] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at W end of this transect';
d[38] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at E end of this transect';
d[39] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet';
d[40] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at W end of this transect';
d[41] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at E end of this transect';
d[42] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at W end of this transect';
d[43] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at E end of this transect';
d[44] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet';
d[45] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at W end of this transect';
d[46] =
  'edge of trench running E-W; trench wall is 8-9 feet deep; trench wall begins at edge of asphalt; along E side of this transect the trench wall makes a ninety degree turn to the N here';
d[47] =
  'edge of trench running E-W; trench wall is 8-9 feet deep; trench wall begins at edge of asphalt';
d[48] =
  'edge of trench running E-W; trench wall is 8-9 feet deep; trench wall begins at edge of asphalt; along W side of this transect the trench wall makes a ninety degree turn to the N here';
d[49] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at E end of this transect';
d[50] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet';
d[51] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at W end of this transect';
d[52] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at E end of this transect';
d[53] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet';
d[54] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at W end of this transect';
d[55] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at E end of this transect';
d[56] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet';
d[57] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at W end of this transect';
d[58] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at E end of this transect';
d[59] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet';
d[60] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall at W end of this transect';
d[61] =
  'edge of trench running E-W; trench wall is 8-9 feet deep; trench wall begins at edge of asphalt; along E side of this transect the trench wall makes a ninety degree turn to the S here';
d[62] =
  'edge of trench running E-W; trench wall is 8-9 feet deep; trench wall begins at edge of asphalt';
d[63] =
  'edge of trench running E-W; trench wall is 8-9 feet deep; trench wall begins at edge of asphalt; along W side of this transect the trench wall makes a ninety degree turn to the S here';
d[64] =
  'there is a surface layer about 4" thick of gravel; 3 feet below the surface there is the N end of a presumed UST; the NE corner of this end is 2 feet from the W side of this transect; the UST is also 4 feet deep (extending to a depth of 7 feet)';
d[65] =
  'there is a surface layer about 4" thick of gravel; 3 feet below the surface there is the N end of a presumed UST; the NW corner of this end is 2 feet from the E side of this transect; the UST is also 4 feet deep (extending to a depth of 7 feet)';
d[66] =
  'there is a surface layer about 4" thick of gravel; 3 feet below the surface there is the S end of a presumed UST; the SE corner of this end is 2 feet from the W side of this transect; the UST is also 4 feet deep (extending to a depth of 7 feet)';
d[67] =
  'there is a surface layer about 4" thick of gravel; 3 feet below the surface there is the S end of a presumed UST; the SW corner of this end is 2 feet from the E side of this transect; the UST is also 4 feet deep (extending to a depth of 7 feet)';
d[68] =
  'there is a surface layer about 4" thick of gravel; 3 feet below the surface there is the W side of a presumed UST; the W side of this UST is 2 feet from the E side of this transect; the UST is also 4 feet deep (extending to a depth of 7 feet)';
d[69] =
  'there is a surface layer about 4" thick of gravel; 3 feet below the surface there is the W side of a presumed UST; the W side of this UST is 2 feet from the E side of this transect; the UST is also 4 feet deep (extending to a depth of 7 feet); there is also a continuous signal from the W to E side of this transect which is about 2\' below the surface and consists of two pipes one for refueling the UST because it lines up exactly with the refilling pipe at the surface next to the Self-Lume factory wall, the other leading under and into the boiler room of the building';

dataMaps.gpr_h = new DataMapCodedValue(
  'GPR Horizontal',
  'Ground-Penetrating Radar East-West',
  a,
  d,
  320,
  200,
  2,
);

a = [];
b = [];
b[95] = 14;
a[174] = b;
b = [];
b[96] = 11;
b[95] = 17;
b[94] = 20;
a[173] = b;
b = [];
b[93] = 13;
b[96] = 18;
b[94] = 21;
b[95] = 22;
a[172] = b;
b = [];
b[92] = b[98] = 14;
b[94] = 15;
b[93] = 16;
b[95] = 23;
a[171] = b;
b = [];
b[93] = b[99] = 11;
b[92] = b[98] = 17;
b[94] = 19;
b[91] = b[97] = 20;
a[170] = b;
b = [];
b[90] = b[96] = 13;
b[93] = b[99] = 18;
b[91] = b[97] = 21;
b[92] = b[98] = 22;
a[169] = b;
b = [];
b[95] = 14;
b[91] = b[97] = 15;
b[90] = b[96] = 16;
b[92] = b[98] = 23;
a[168] = b;
b = [];
b[96] = 11;
b[95] = 17;
b[91] = b[97] = 19;
b[94] = 20;
a[167] = b;
b = [];
b[93] = 13;
b[96] = 18;
b[94] = 21;
b[95] = 22;
a[166] = b;
b = [];
b[94] = 15;
b[93] = 16;
b[95] = 23;
a[165] = b;
b = [];
b[94] = 19;
a[164] = b;
b = [];
b[221] = b[222] = b[223] = b[224] = b[225] = 4;
b[226] = 6;
a[120] = b;
b = [];
b[221] = b[222] = b[223] = b[224] = b[225] = 3;
b[226] = 5;
a[119] = b;
b = [];
b[221] = b[222] = b[223] = b[224] = b[225] = 4;
b[226] = 6;
b[253] = 41;
a[118] = b;
b = [];
b[221] = b[222] = b[223] = b[224] = b[225] = 3;
b[226] = 5;
b[253] = 38;
a[117] = b;
b = [];
b[221] = b[222] = b[223] = b[224] = b[225] = b[227] = b[231] = 4;
b[226] = 7;
b[228] = b[229] = b[230] = 9;
b[232] = 0;
b[253] = 39;
a[116] = b;
b = [];
b[221] = b[222] = b[223] = b[224] = b[225] = b[227] = b[231] = 3;
b[226] = 8;
b[228] = b[229] = b[230] = 10;
b[232] = 12;
b[253] = 40;
a[115] = b;
b = [];
b[221] = b[222] = b[223] = b[224] = b[225] = 4;
b[226] = 6;
a[114] = b;
b = [];
b[221] = b[222] = b[223] = b[224] = b[225] = 3;
b[226] = 5;
a[113] = b;
b = [];
b[221] = b[222] = b[223] = b[224] = b[225] = 4;
b[226] = 6;
a[112] = b;
b = [];
b[221] = b[222] = b[223] = b[224] = b[225] = 3;
b[226] = 5;
a[111] = b;
b = [];
b[232] = 35;
a[94] = b;
b = [];
b[232] = 24;
b[231] = 37;
a[93] = b;
b = [];
b[232] = 34;
a[92] = b;
b = [];
b[232] = 24;
b[231] = 37;
a[91] = b;
b = [];
b[232] = 36;
a[90] = b;
b = [];
b[230] = 25;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 29;
b[238] = 32;
a[83] = b;
b = [];
b[230] = 27;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 28;
b[238] = 31;
a[82] = b;
b = [];
b[230] = 27;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 28;
b[238] = 31;
a[81] = b;
b = [];
b[230] = 27;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 28;
b[238] = 31;
a[80] = b;
b = [];
b[230] = 27;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 28;
b[238] = 31;
a[79] = b;
b = [];
b[230] = 27;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 28;
b[238] = 31;
a[78] = b;
b = [];
b[230] = 27;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 28;
b[238] = 31;
a[77] = b;
b = [];
b[230] = 27;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 28;
b[238] = 31;
a[76] = b;
b = [];
b[230] = 27;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 28;
b[238] = 31;
a[75] = b;
b = [];
b[230] = 26;
b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 30;
b[238] = 33;
a[74] = b;
b = [];
d = [];
d[0] =
  "ground surface is flat and at an elevation of 837'; this transect runs right along the edge of the foundation wall of the abandoned factory; at the extreme south end of transect there is a cross-section of pipe running E-W which likely enters the building; the pipe is 6-10\" in diameter; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; the trench wall runs E-W and is 2' N of the pipe; trench fill is unknown;  recommend excavation for clarification.";
d[1] = 'background';
d[2] = 'background';
d[3] =
  "ground surface is flat and at an elevation of 837'; at the extreme north end of transect there is a cross-section of pipe running E-W; the pipe is 6-10\" in diameter; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; the trench wall runs E-W and is 2' S of the pipe; trench fill is unknown; recommend excavation for clarification.\t";
d[4] =
  "ground surface is flat and at an elevation of 837'; at the extreme south end of transect there is a cross-section of pipe running E-W; the pipe is 6-10\" in diameter; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; the trench wall runs E-W and is 2' N of the pipe; trench fill is unknown; recommend excavation for clarification.\t";
d[5] =
  "ground surface is flat and at an elevation of 837'; a 10' section of pipe running N-S is centered on transect; pipe is 6-10\" in diameter; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width of trench undetermined; trench fill is unknown; another pipe appears to connect to this from the west at the extreme northern end of this transect; recommend excavation for clarification.";
d[6] =
  "ground surface is flat and at an elevation of 837'; a 10' section of pipe running N-S is centered on transect; pipe is 6-10\" in diameter; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width of trench undetermined; trench fill is unknown; another pipe appears to connect to this from the west at the extreme southern end of this transect; recommend excavation for clarification.\t";
d[7] =
  "ground surface is flat and at an elevation of 837'; an 8 1/2' section of pipe running N-S is centered on transect; pipe is 6-10\" in diameter; pipe ends at southern end of transect and enters a large object 3' in depth;the object is at a depth of 1' and is possibly a small tank; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width and composition of object is unknown; only 1 1/2' of the length of the object can be seen and there is probably more to the south; width of trench undetermined; trench fill is unknown; recommend excavation for clarification; possible septic field.\t";
d[8] =
  "ground surface is flat and at an elevation of 837'; an 8 1/2' section of pipe running N-S is centered on transect; pipe is 6-10\" in diameter; pipe ends at northern end of transect and enters a large object 3' in depth;the object is at a depth of 1' and is possibly a small tank; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; width and composition of object is unknown; only 1 1/2' of the length of the object can be seen and there is probably more to the north; width of trench undetermined; trench fill is unknown; recommend excavation for clarification; possible septic field.";
d[9] =
  "ground surface is flat and at an elevation of 837'; at the southern end of the transect there is a large object, possibly a tank; the object is 1' below the surface and has a vertical dimension of 5'; only 3' of the object can be seen in the horizontal and the object continues to the south; the composition of the object is unknown; the object lies in a trench but the trench walls and bottom are nearly contiguous with object; exploratory excavation is recommended.\t";
d[10] =
  "ground surface is flat and at an elevation of 837'; at the northern end of the transect there is a large object, possibly a tank; the object is 1' below the surface and has a vertical dimension of 5'; only 3' of the object can be seen in the horizontal and the object continues to the north; the composition of the object is unknown; the object lies in a trench but the trench walls and bottom are nearly contiguous with object; exploratory excavation is recommended.";
d[11] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the southernmost edge of this GPR image is the E pointing corner of a UST; the UST is about 5 feet in diameter.';
d[12] =
  "ground surface is flat and at an elevation of 837';this transect runs right along he edge of the foundation wall of the abandoned factory; at the extreme north end of transect there is a cross-section of pipe running E-W which likely enters the building; the pipe is 6-10\" in diameter; pipe composition is unknown; pipe is at a depth of 2' in trench 5' deep; the trench wall runs E-W and is 2' S of the pipe; trench fill is unknown; recommend excavation for clarification.";
d[13] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the southernmost edge of this GPR image is the W pointing corner of a UST; the UST is about 5 feet in diameter.\t';
d[14] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the southernmost edge of this GPR image is the N pointing corner of a UST; the UST is about 5 feet in diameter.';
d[15] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this is a UST extending from the northernmost part of this image to the southernmost part where the corner of a UST which faces S is located; the UST is about 5 feet in diameter';
d[16] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the northernmost edge of this GPR image is the W pointing corner of a UST; the UST is about 5 feet in diameter.\t';
d[17] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this is a UST extending from the southernmost part of this image to the northernmost part where the N pointing corner of the UST is located; the UST is about 5 feet in diameter';
d[18] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the northernmost edge of this GPR image is the E pointing corner of a UST; the UST is about 5 feet in diameter.';
d[19] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the northernmost edge of this GPR image is the S pointing corner of a UST; the UST is about 5 feet in diameter.';
d[20] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the southernmost edge of this GPR image is the side of a UST which runs NE-SW; the UST is about 5 feet in diameter.';
d[21] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this is a UST extending from the southernmost part of this image to the northernmost part where the side of a UST which runs NE-SW is located; the UST is about 5 feet in diameter\t';
d[22] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this is a UST extending from the northernmost part of this image to the southernmost part where the side of a UST which runs NE-SW is located; the UST is about 5 feet in diameter';
d[23] =
  'there is a surface layer about 6" thick of concrete and gravel; 2 feet below this at the northernmost edge of this GPR image is the side of a UST which runs NE-SW; the UST is about 5 feet in diameter.\t';
d[24] =
  'there is a surface layer about 6" thick of asphalt and gravel; 3 feet below the surface and extending the entire length of this transect is the E side of a UST whose N and S ends are at the beginning and end of this transect; the UST is, therefore, 10\' long.';
d[25] =
  'edge of trench running N-S; trench wall is 8-9 feet deep; trench wall begins at edge of asphalt.\t';
d[26] =
  'edge of trench running N-S; trench wall is 8-9 feet deep; trench wall makes a ninety degree turn here to the E.\t';
d[27] = 'edge of trench running N-S; trench wall is 8-9 feet deep.\t';
d[28] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet.\t';
d[29] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall extends E-W along the edge of the asphalt.\t';
d[30] =
  'numerous and diverse reflections and scatterings typical of landfill debris; debris extends to a depth of 8-9 feet; trench wall extends E-W along the southernmost edge of the transect.\t';
d[31] = 'edge of trench running N-S; trench wall is 8-9 feet deep.\t';
d[32] =
  'edge of trench running N-S; trench wall is 8-9 feet deep; trench wall begins at edge of asphalt.';
d[33] =
  'edge of trench running N-S; trench wall is 8-9 feet deep; trench wall makes a ninety degree turn here to the W.';
d[34] =
  'there is a surface layer about 6" thick of asphalt and gravel; 3 feet below the surface there is the SE corner of a presumed UST; the SE corner of this UST is at the extreme N end of this transect; also, 3 feet below the surface there is the NE corner of another UST; the NE corner of this UST is at the extreme S end of this transect.';
d[35] =
  'there is a surface layer about 6" thick of asphalt and gravel; 3 feet below the surface there is the NE corner of a presumed UST; the NE corner of this UST is at the extreme S end of this transect.';
d[36] =
  'there is a surface layer about 6" thick of asphalt and gravel; 3 feet below the surface there is the SE corner of a presumed UST; the SE corner of this UST is at the extreme N end of this transect';
d[37] =
  'This transect is right at the edge of the concrete pier on which the diesel fuel pumps sit; there is a surface layer about 6" thick of asphalt and gravel; exactly in the middle of this transect is the cross-section of a pipe about 2" in diameter.';
d[38] =
  'there is a surface layer about 4" thick of gravel; 3 feet below the surface and at the N end of this transect there is the N end of a presumed UST; the UST is also 4 feet deep (extending to a depth of 7 feet); the UST extends the full length of this transect.';
d[39] =
  'there is a surface layer about 4" thick of gravel; 3 feet below the surface and at the S end of this transect there is the S end of a presumed UST; the UST is also 4 feet deep (extending to a depth of 7 feet); the UST extends the full length of this transect.';
d[40] =
  'there is a surface layer about 4" thick of gravel; 3 feet below the surface and at the N end of this transect there is the S end of a presumed UST;  the UST is also 4 feet deep (extending to a depth of 7 feet).';
d[41] =
  'there is a surface layer about 4" thick of gravel; 3 feet below the surface and at the S end of this transect there is the N end of a presumed UST;  the UST is also 4 feet deep (extending to a depth of 7 feet)';

dataMaps.gpr_v = new DataMapCodedValue(
  'GPR Vertical',
  'Ground-Penetrating Radar North-South',
  a,
  d,
  320,
  200,
  2,
);

a = [];
a[199] = [
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[198] = [
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[197] = [
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[196] = [
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[195] = [
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[194] = [
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[193] = [
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[192] = [
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[191] = [
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[190] = [
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[189] = [
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[188] = [
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[187] = [
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[186] = [
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[185] = [
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[184] = [
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[183] = [
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[182] = [
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[181] = [
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[180] = [
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[179] = [
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[178] = [
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[177] = [
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[176] = [
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[175] = [
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[174] = [
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[173] = [
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[172] = [
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[171] = [
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[170] = [
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[169] = [
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[168] = [
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[167] = [
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[166] = [
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[165] = [
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[164] = [
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[163] = [
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[162] = [
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[161] = [
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[160] = [
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[159] = [
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[158] = [
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[157] = [
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[156] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[155] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[154] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[153] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[152] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[151] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[150] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[149] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
];
a[148] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[147] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
];
a[146] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[145] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[144] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[143] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[142] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[141] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[140] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[139] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[138] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[137] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[136] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[135] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[134] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[133] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[132] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[131] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[130] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[129] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  3.9,
  3.9,
];
a[128] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[127] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  3.9,
  3.9,
];
a[126] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[125] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  3.9,
  3.9,
];
a[124] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[123] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[122] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[121] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[120] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[119] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
];
a[118] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[117] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
];
a[116] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[115] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
];
a[114] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[113] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[112] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[111] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[110] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[109] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  4,
  4,
  3.9,
  3.9,
];
a[108] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[107] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  4,
  4,
  3.9,
  3.9,
];
a[106] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[105] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
];
a[104] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[103] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[102] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[101] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[100] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[99] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
];
a[98] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
];
a[97] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[96] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
];
a[95] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[94] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
];
a[93] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
  3.9,
];
a[92] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[91] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[90] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[89] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[88] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[87] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[86] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[85] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[84] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[83] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[82] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[81] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[80] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[79] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  3.9,
];
a[78] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[77] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[76] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[75] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[74] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[73] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[72] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[71] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[70] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[69] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[68] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[67] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[66] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[65] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[64] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[63] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[62] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[61] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
  4,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
  4,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
  4,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
  4,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
  4,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  4,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2.1,
  2.1,
  2.1,
  2.1,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.2,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.3,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.4,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.5,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.6,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.7,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.8,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  2.9,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.1,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.2,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.3,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.4,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.5,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.6,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.7,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.8,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
  3.9,
];

dataMaps.loess = new DataMapNumeric(
  'Loess',
  'Loess Depth',
  'ft',
  a,
  320,
  200,
  0,
  85,
  0,
  235,
  200,
);

a = [];
b = [];
b[94] = 1;
a[173] = b;
b = [];
b[93] = 5;
b[94] = 7;
b[95] = 2;
a[172] = b;
b = [];
b[92] = 4;
b[93] = 7;
b[94] = 6;
a[171] = b;
b = [];
b[91] = 1;
b[93] = 3;
b[97] = 1;
a[170] = b;
b = [];
b[90] = b[96] = 5;
b[91] = b[97] = 7;
b[92] = b[98] = 2;
a[169] = b;
b = [];
b[89] = b[95] = 4;
b[90] = b[96] = 7;
b[91] = b[97] = 6;
a[168] = b;
b = [];
b[90] = 3;
b[94] = 1;
b[96] = 3;
a[167] = b;
b = [];
b[93] = 5;
b[94] = 7;
b[95] = 2;
a[166] = b;
b = [];
b[92] = 4;
b[93] = 7;
b[94] = 6;
a[165] = b;
b = [];
b[93] = 3;
a[164] = b;
b = [];
b[252] = 11;
a[117] = b;
b = [];
b[252] = 12;
a[116] = b;
b = [];
b[226] = 9;
b[229] = 10;
b[252] = 13;
a[115] = b;
b = [];
b[231] = 14;
b[232] = 17;
a[93] = b;
b = [];
b[231] = 15;
b[232] = 16;
a[92] = b;
b = [];
b[231] = 14;
b[232] = 17;
a[91] = b;
b = [];
b[230] = b[231] = b[232] = b[233] = b[234] = b[235] = b[236] = b[237] = 8;
a[83] = b;
a[82] = b;
a[81] = b;
a[80] = b;
a[79] = b;
a[78] = b;
a[77] = b;
a[76] = b;
a[75] = b;
a[74] = b;
b = [];
d = [];
d[0] = 'background';
d[1] =
  'There was a strong ferrous signal in the Southern half of the area, strongest along the South edge.';
d[2] =
  'There was a strong ferrous signal in the Western half of the area, strongest along the West edge.';
d[3] =
  'There was a strong ferrous signal in the Northern half of the area, strongest along the North edge.';
d[4] =
  'There was a strong ferrous signal in the Eastern half of the area, strongest along the East edge.';
d[5] =
  'Within the SE half of the area there was a strong ferrous signal, and a slight signal was found running from the center to the NW corner.';
d[6] = 'Within the NW half of the area there was a strong ferrous signal.';
d[7] = 'There was a strong ferrous signal throughout the entire area.';
d[8] =
  'Diverse ferrous signals mixed with non-ferrous signals (copper and aluminum especially) typical of landfill debris.';
d[9] = 'There was a ferrous signal in the direct center of this area.';
d[10] =
  'There were strong ferrous signals at the E and W ends of the horizontal transect bisecting this area.';
d[11] =
  'There was a strong ferrous signal found in the SE quadrant of this area.';
d[12] =
  'There was a strong ferrous signal occupying the entire Eastern half of this area.';
d[13] =
  'There was a strong ferrous signal found in the NE quadrant of this area.';
d[14] =
  'There was a strong ferrous signal occupying the entire Eastern half of this area, and a slight signal was found running from the center to the West edge.';
d[15] =
  'There were slight but definite ferrous signals in the Eastern portions of the North and South edges of this area.';
d[16] =
  'There were slight but definite ferrous signals in the NW and SW corners of this area.';
d[17] =
  'There was a slight but definite ferrous signal all along the W edge of this area.';

dataMaps.mmd = new DataMapCodedValue(
  'MMD',
  'Magnetometry / Metal Detection',
  a,
  d,
  320,
  200,
  0,
);

a = [];
a[58] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[57] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 60, 60, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  80,
  1200,
  930,
  1300,
  50,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1700,
  4700,
  7400,
  7400,
  1000,
  200,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  30,
  1700,
  7600,
  10400,
  10100,
  2000,
  670,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  10,
  210,
  3000,
  8500,
  10400,
  10100,
  2600,
  1400,
  290,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  90,
  600,
  4700,
  9600,
  10300,
  10100,
  5300,
  3000,
  1100,
  10,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  50,
  120,
  390,
  910,
  1800,
  6500,
  9100,
  10200,
  10000,
  6100,
  3300,
  1600,
  600,
  90,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  120,
  310,
  790,
  1500,
  2800,
  6700,
  8900,
  10000,
  9900,
  6100,
  3500,
  1600,
  600,
  150,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  150,
  480,
  1100,
  2100,
  3600,
  6900,
  8600,
  9500,
  9100,
  6000,
  3500,
  1600,
  600,
  150,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  140,
  500,
  1200,
  2500,
  4100,
  7000,
  8600,
  9300,
  8700,
  6200,
  4000,
  2200,
  770,
  270,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  110,
  440,
  1000,
  2600,
  4200,
  7100,
  8600,
  9400,
  8700,
  6200,
  4500,
  2700,
  1200,
  270,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  90,
  430,
  1100,
  2500,
  4300,
  7000,
  8300,
  9200,
  8900,
  6600,
  5000,
  3500,
  2100,
  960,
  70,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  30,
  70,
  420,
  840,
  1600,
  2900,
  4500,
  6900,
  7800,
  8600,
  8300,
  6600,
  5200,
  3800,
  2600,
  1500,
  320,
  70,
  0,
  0,
];
a[44] = [
  0,
  30,
  110,
  230,
  730,
  1100,
  2000,
  3300,
  4600,
  6700,
  7600,
  8100,
  8000,
  6600,
  5300,
  4000,
  2900,
  1900,
  560,
  70,
  0,
  0,
];
a[43] = [
  0,
  60,
  160,
  330,
  900,
  1500,
  2400,
  3500,
  4600,
  6500,
  7300,
  8000,
  7800,
  6500,
  5300,
  4100,
  3100,
  2100,
  770,
  350,
  50,
  0,
];
a[42] = [
  10,
  90,
  210,
  420,
  980,
  1600,
  2500,
  3500,
  4600,
  6400,
  6900,
  7700,
  7400,
  6300,
  5300,
  4100,
  3100,
  2100,
  940,
  600,
  220,
  0,
];
a[41] = [
  20,
  70,
  170,
  350,
  870,
  1300,
  2200,
  3200,
  4100,
  5900,
  6400,
  6800,
  6800,
  5800,
  5100,
  4000,
  3100,
  2200,
  1200,
  710,
  350,
  60,
];
a[40] = [
  0,
  40,
  120,
  250,
  720,
  1000,
  1900,
  2900,
  3900,
  5600,
  6000,
  6500,
  6400,
  5400,
  4700,
  3800,
  3000,
  2200,
  1200,
  710,
  370,
  90,
];
a[39] = [
  0,
  10,
  70,
  160,
  580,
  980,
  1800,
  2700,
  3600,
  5200,
  5700,
  6200,
  6100,
  5000,
  4200,
  3500,
  2700,
  2000,
  1100,
  710,
  370,
  90,
];
a[38] = [
  0,
  0,
  20,
  90,
  570,
  1100,
  1800,
  2600,
  3400,
  4900,
  5300,
  5800,
  5600,
  4400,
  3700,
  2900,
  2200,
  1600,
  920,
  630,
  330,
  90,
];
a[37] = [
  0,
  0,
  0,
  70,
  570,
  1100,
  1800,
  2600,
  3400,
  4400,
  4700,
  5100,
  5000,
  3800,
  3300,
  2400,
  1700,
  1200,
  710,
  490,
  250,
  50,
];
a[36] = [
  0,
  0,
  30,
  150,
  570,
  990,
  1500,
  2100,
  2800,
  3900,
  4200,
  4300,
  4100,
  3200,
  2600,
  1600,
  1000,
  750,
  390,
  270,
  120,
  0,
];
a[35] = [
  0,
  0,
  60,
  200,
  540,
  830,
  1200,
  1800,
  2500,
  3600,
  3900,
  4100,
  3900,
  2900,
  2100,
  1100,
  820,
  550,
  230,
  150,
  30,
  0,
];
a[34] = [
  0,
  0,
  60,
  170,
  480,
  670,
  1000,
  1500,
  2200,
  3400,
  3600,
  4000,
  3700,
  2700,
  1900,
  1100,
  700,
  430,
  110,
  50,
  0,
  0,
];
a[33] = [
  0,
  0,
  50,
  170,
  430,
  620,
  950,
  1500,
  2200,
  3100,
  3500,
  3700,
  3400,
  2400,
  1800,
  1100,
  640,
  320,
  30,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  10,
  90,
  330,
  560,
  910,
  1300,
  1800,
  2700,
  2800,
  2900,
  2800,
  2000,
  1600,
  1000,
  570,
  230,
  10,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  40,
  270,
  480,
  810,
  1100,
  1600,
  2300,
  2500,
  2500,
  2400,
  1700,
  1200,
  860,
  500,
  250,
  30,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  10,
  180,
  390,
  700,
  1000,
  1300,
  2000,
  2200,
  2200,
  2100,
  1500,
  1000,
  720,
  460,
  260,
  60,
  10,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  10,
  130,
  350,
  600,
  870,
  1200,
  1800,
  1900,
  2100,
  2000,
  1300,
  990,
  680,
  440,
  270,
  80,
  10,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  20,
  160,
  340,
  550,
  780,
  1000,
  1500,
  1700,
  1800,
  1600,
  1100,
  920,
  650,
  430,
  270,
  80,
  30,
  0,
  0,
];
a[27] = [
  0,
  0,
  10,
  50,
  170,
  300,
  450,
  620,
  820,
  1200,
  1200,
  1200,
  1200,
  890,
  760,
  590,
  400,
  260,
  100,
  40,
  10,
  0,
];
a[26] = [
  0,
  0,
  20,
  60,
  160,
  250,
  380,
  540,
  720,
  1000,
  1100,
  1100,
  980,
  750,
  640,
  490,
  350,
  240,
  100,
  40,
  10,
  0,
];
a[25] = [
  0,
  10,
  20,
  50,
  140,
  200,
  320,
  460,
  630,
  950,
  1000,
  1000,
  880,
  650,
  540,
  390,
  270,
  180,
  80,
  40,
  10,
  0,
];
a[24] = [
  0,
  0,
  10,
  30,
  100,
  150,
  250,
  380,
  540,
  860,
  930,
  910,
  800,
  570,
  440,
  300,
  190,
  120,
  60,
  30,
  10,
  0,
];
a[23] = [
  0,
  0,
  10,
  20,
  70,
  90,
  160,
  320,
  530,
  790,
  840,
  840,
  720,
  500,
  360,
  210,
  130,
  80,
  30,
  20,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  10,
  30,
  50,
  90,
  240,
  400,
  670,
  740,
  720,
  630,
  400,
  280,
  120,
  70,
  40,
  10,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  20,
  50,
  120,
  220,
  350,
  600,
  660,
  640,
  550,
  350,
  240,
  120,
  60,
  30,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  20,
  50,
  110,
  180,
  280,
  530,
  570,
  570,
  470,
  290,
  210,
  120,
  60,
  20,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  20,
  40,
  80,
  140,
  230,
  440,
  490,
  490,
  380,
  230,
  160,
  90,
  50,
  10,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  10,
  30,
  60,
  100,
  150,
  350,
  400,
  410,
  300,
  150,
  120,
  70,
  30,
  10,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  10,
  30,
  50,
  80,
  220,
  290,
  290,
  210,
  80,
  60,
  40,
  20,
  10,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  20,
  30,
  50,
  160,
  210,
  210,
  140,
  70,
  40,
  30,
  10,
  10,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  10,
  20,
  40,
  90,
  130,
  130,
  90,
  50,
  30,
  20,
  10,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  10,
  20,
  40,
  70,
  80,
  90,
  70,
  40,
  20,
  10,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  10,
  30,
  60,
  70,
  70,
  60,
  30,
  10,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  10,
  20,
  50,
  60,
  60,
  50,
  20,
  10,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  10,
  40,
  50,
  50,
  40,
  20,
  10,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  10,
  30,
  40,
  40,
  30,
  10,
  10,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  10,
  20,
  20,
  20,
  20,
  10,
  10,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 10, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[7] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[6] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[5] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[4] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[3] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.sgsa = new DataMapNumeric(
  'SGSA',
  'Soil Gas Sampling and Analysis',
  'ppm',
  a,
  320,
  200,
  0,
  82,
  115,
  22,
  59,
);

a = [];
a[199] = [
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716,
  716,
  715.5,
  715,
  715,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710,
  709.5,
  709.5,
  709,
  708.5,
  708,
  707.5,
  707.5,
  707,
  706.5,
  706,
  705.5,
  705.5,
  705,
  704,
  703.5,
  703,
  701.5,
  701,
  700,
  699.5,
  699,
  698.5,
  698,
  697,
  696.5,
  696,
  695.5,
  695,
  694.5,
  693.5,
  693.5,
  692.5,
  692,
  691.5,
  691,
  690.5,
  690.5,
  689.5,
  689.5,
  688.5,
  688.5,
  688,
  687.5,
  687.5,
  686.5,
  686.5,
  686,
  685.5,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681,
  680.5,
  680.5,
  679.5,
  679,
  678.5,
  678,
  677.5,
  676.5,
  676.5,
  676,
  675,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670.5,
  670,
  669.5,
  669,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664.5,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
];
a[198] = [
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  716.5,
  716.5,
  716,
  716,
  715.5,
  715.5,
  715,
  714.5,
  714,
  714,
  713.5,
  713,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710.5,
  710,
  709.5,
  709,
  708.5,
  708,
  708,
  707.5,
  707,
  706.5,
  706,
  706,
  705,
  705,
  704.5,
  703.5,
  703,
  702,
  701,
  700.5,
  700,
  699.5,
  699,
  698,
  697.5,
  696.5,
  696,
  696,
  695,
  694.5,
  694,
  693.5,
  693,
  692,
  691.5,
  691.5,
  690.5,
  690.5,
  690,
  689,
  689,
  688.5,
  688,
  687.5,
  687,
  687,
  686.5,
  686,
  686,
  685.5,
  685,
  684.5,
  684,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  672,
  671,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
];
a[197] = [
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  716.5,
  716.5,
  716,
  716,
  715.5,
  715.5,
  715,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710,
  709.5,
  709,
  709,
  708.5,
  708,
  707.5,
  707,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  702,
  701.5,
  701,
  700.5,
  699.5,
  699,
  698.5,
  697.5,
  697,
  696.5,
  696,
  695.5,
  694.5,
  694,
  693.5,
  693,
  692.5,
  692,
  691.5,
  691,
  690.5,
  690,
  689.5,
  689,
  688.5,
  688,
  687.5,
  687.5,
  687,
  686.5,
  686,
  685.5,
  685.5,
  685,
  684.5,
  684,
  684,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677,
  677,
  676,
  675.5,
  675.5,
  674.5,
  674,
  674,
  673,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669.5,
  669,
  668.5,
  668,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
];
a[196] = [
  718.5,
  718.5,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717,
  717,
  716.5,
  716.5,
  716,
  716,
  715.5,
  715.5,
  715,
  714.5,
  714,
  713.5,
  713.5,
  713,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710,
  710,
  709.5,
  709,
  708.5,
  708,
  707.5,
  707,
  706.5,
  706.5,
  706,
  705,
  705,
  704,
  704,
  703.5,
  702,
  701.5,
  701,
  700,
  700,
  699,
  698.5,
  698,
  697,
  696.5,
  696,
  695.5,
  695,
  694,
  693.5,
  693,
  692.5,
  692,
  691,
  691,
  690.5,
  689.5,
  689.5,
  689,
  688,
  688,
  687.5,
  687,
  686.5,
  686,
  686,
  685.5,
  685,
  684.5,
  684,
  684,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678,
  677.5,
  677.5,
  676.5,
  676.5,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673.5,
  672.5,
  672.5,
  671.5,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664.5,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
];
a[195] = [
  718.5,
  718.5,
  718.5,
  719,
  719,
  719,
  719,
  719,
  719,
  719,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  716.5,
  716,
  716,
  716,
  715.5,
  715,
  715,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712,
  712,
  711.5,
  710.5,
  710.5,
  710,
  709.5,
  709,
  708.5,
  708,
  707.5,
  707,
  707,
  706,
  706,
  705.5,
  705,
  704.5,
  703.5,
  703.5,
  703,
  701.5,
  701.5,
  700.5,
  700,
  699.5,
  698.5,
  698,
  697.5,
  696.5,
  696.5,
  695.5,
  695,
  694.5,
  693.5,
  693.5,
  693,
  692,
  691.5,
  691,
  690.5,
  690,
  689.5,
  689,
  688.5,
  688,
  687.5,
  687,
  686.5,
  686,
  685.5,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  679,
  678.5,
  677.5,
  677,
  677,
  676,
  676,
  675,
  674.5,
  674.5,
  673.5,
  673,
  673,
  672,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
];
a[194] = [
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717,
  717,
  716.5,
  716.5,
  716,
  716,
  715.5,
  715,
  715,
  714.5,
  714,
  713.5,
  713,
  713,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710,
  709.5,
  709,
  708.5,
  708,
  707.5,
  707,
  706.5,
  706.5,
  705.5,
  705.5,
  705,
  704.5,
  704,
  703,
  702,
  702,
  701,
  700.5,
  700,
  699.5,
  699,
  698,
  697.5,
  697,
  696,
  695.5,
  695,
  694.5,
  694,
  693,
  692.5,
  692,
  691.5,
  691,
  690.5,
  690,
  689.5,
  688.5,
  688.5,
  688,
  687,
  687,
  686,
  686,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677,
  676.5,
  676.5,
  675.5,
  675.5,
  674.5,
  674,
  674,
  673,
  672.5,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656,
  656,
  656,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
];
a[193] = [
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  716.5,
  716.5,
  716,
  715.5,
  715.5,
  715,
  714.5,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710,
  710,
  709,
  709,
  708.5,
  707.5,
  707.5,
  706.5,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  702,
  701.5,
  701.5,
  700.5,
  700,
  699.5,
  698.5,
  698.5,
  697.5,
  697,
  696.5,
  695.5,
  695.5,
  694.5,
  694,
  693.5,
  692.5,
  692.5,
  691.5,
  691,
  690.5,
  690,
  689.5,
  689,
  688,
  688,
  687.5,
  686.5,
  686.5,
  685.5,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678,
  678,
  677.5,
  676.5,
  676,
  676,
  675,
  675,
  674,
  673.5,
  673.5,
  672.5,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  670,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
];
a[192] = [
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717,
  717,
  716.5,
  716.5,
  716,
  716,
  715.5,
  715.5,
  714.5,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712.5,
  712,
  711,
  711,
  710.5,
  710,
  709.5,
  708.5,
  708.5,
  708,
  707.5,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  701.5,
  701,
  701,
  700,
  699.5,
  699,
  698,
  698,
  697,
  696.5,
  696,
  695,
  695,
  694,
  693.5,
  693,
  692,
  692,
  691.5,
  690.5,
  690,
  689.5,
  689,
  688.5,
  688,
  687.5,
  687,
  686.5,
  686,
  685,
  685,
  684.5,
  684,
  684,
  683,
  682.5,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  677,
  676,
  676,
  675.5,
  674.5,
  674.5,
  673.5,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  666.5,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
];
a[191] = [
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  716.5,
  716.5,
  716,
  715.5,
  715.5,
  715,
  714.5,
  714,
  714,
  713.5,
  713,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710,
  709.5,
  709,
  708.5,
  708,
  707.5,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701,
  700.5,
  700,
  699.5,
  699,
  698.5,
  697.5,
  697,
  696.5,
  696,
  695.5,
  694.5,
  694,
  693.5,
  693,
  692.5,
  691.5,
  691,
  690.5,
  690,
  689.5,
  688.5,
  688.5,
  688,
  687,
  687,
  686.5,
  685.5,
  685.5,
  684.5,
  684,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681.5,
  680.5,
  680.5,
  679.5,
  679.5,
  679,
  678,
  678,
  677,
  676.5,
  676.5,
  675.5,
  675,
  675,
  674,
  674,
  673,
  672.5,
  672.5,
  671.5,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  667,
  666,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
];
a[190] = [
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  716.5,
  716.5,
  716,
  716,
  715.5,
  715,
  715,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710,
  709.5,
  709,
  708.5,
  708,
  707.5,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701.5,
  700.5,
  700,
  699.5,
  699,
  698.5,
  698,
  697,
  697,
  696,
  695.5,
  695,
  694,
  693.5,
  693,
  692.5,
  692,
  691,
  691,
  690,
  689.5,
  689,
  688,
  688,
  687.5,
  686.5,
  686.5,
  686,
  685,
  685,
  684,
  683.5,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681.5,
  681,
  680,
  680,
  679,
  678.5,
  678.5,
  677.5,
  677,
  676.5,
  676,
  676,
  675,
  674.5,
  674.5,
  673.5,
  673.5,
  672.5,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  670,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
];
a[189] = [
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  716.5,
  716.5,
  716,
  715.5,
  715.5,
  715,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712.5,
  711.5,
  711.5,
  711,
  710,
  709.5,
  709,
  708.5,
  708,
  707.5,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701,
  700.5,
  700,
  699.5,
  699,
  698.5,
  698,
  697,
  696.5,
  696,
  695,
  695,
  694,
  693.5,
  693,
  692,
  691.5,
  691,
  690.5,
  690,
  689.5,
  689,
  688.5,
  687.5,
  687,
  686.5,
  686,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  682.5,
  682,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  673,
  672,
  671.5,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
];
a[188] = [
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716,
  715.5,
  715,
  715,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712,
  711.5,
  711,
  710.5,
  709.5,
  709.5,
  709,
  708,
  708,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701.5,
  700.5,
  700.5,
  699.5,
  699,
  698.5,
  697.5,
  697.5,
  697,
  696,
  695.5,
  694.5,
  694.5,
  693.5,
  693,
  692.5,
  691.5,
  691,
  691,
  690,
  689.5,
  689,
  688,
  688,
  687,
  686.5,
  686.5,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673.5,
  672.5,
  672.5,
  671.5,
  671,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664.5,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
];
a[187] = [
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718.5,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  716.5,
  716.5,
  716,
  715.5,
  715.5,
  715,
  714.5,
  714,
  713.5,
  713,
  713,
  712,
  711.5,
  711,
  710.5,
  710,
  709.5,
  709,
  708.5,
  708,
  707.5,
  706.5,
  706.5,
  706,
  705,
  705,
  704,
  703.5,
  703,
  702,
  701.5,
  701,
  700,
  700,
  699,
  698.5,
  698,
  697,
  697,
  696.5,
  695.5,
  695,
  694,
  694,
  693,
  692.5,
  692,
  691,
  690.5,
  690.5,
  689.5,
  689,
  688.5,
  688,
  687.5,
  686.5,
  686,
  686,
  685,
  684.5,
  684,
  683.5,
  683,
  682.5,
  682,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  673,
  672,
  672,
  671,
  671,
  670.5,
  670,
  669.5,
  669.5,
  668.5,
  668.5,
  668,
  667.5,
  667.5,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
];
a[186] = [
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716,
  715.5,
  715.5,
  714.5,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712,
  711.5,
  710.5,
  710,
  709.5,
  709,
  708.5,
  708,
  707.5,
  707,
  706,
  706,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701,
  701,
  700,
  699.5,
  699,
  698.5,
  698,
  697.5,
  696.5,
  696,
  695.5,
  694.5,
  694.5,
  693.5,
  693,
  692.5,
  691.5,
  691.5,
  690.5,
  690,
  689.5,
  688.5,
  688.5,
  688,
  687,
  686.5,
  686,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678.5,
  677.5,
  677.5,
  676.5,
  676,
  676,
  675,
  675,
  674,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  670,
  669,
  669,
  668.5,
  668,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665,
  665,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  662.5,
  662.5,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
];
a[185] = [
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716,
  716,
  715.5,
  715,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712,
  711.5,
  711,
  710,
  710,
  709.5,
  708.5,
  708,
  707.5,
  707,
  706.5,
  705.5,
  705.5,
  705,
  704,
  703.5,
  703,
  702,
  701.5,
  700.5,
  700.5,
  700,
  699,
  698.5,
  697.5,
  697,
  697,
  696,
  695.5,
  695,
  694,
  694,
  693,
  692.5,
  692,
  691,
  691,
  690,
  689.5,
  689,
  688,
  688,
  687.5,
  686.5,
  686,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  682,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  678,
  677,
  677,
  676,
  675.5,
  675.5,
  674.5,
  674,
  673.5,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  665.5,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  657,
  657.5,
  657.5,
  658,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
];
a[184] = [
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  715.5,
  715,
  714.5,
  714,
  713.5,
  712.5,
  712.5,
  712,
  711,
  710.5,
  710,
  709.5,
  709,
  708,
  708,
  707,
  706.5,
  706,
  705,
  705,
  704.5,
  703.5,
  703.5,
  702,
  701.5,
  701,
  700,
  700,
  699.5,
  698.5,
  698,
  697,
  696.5,
  696.5,
  695.5,
  695,
  694.5,
  693.5,
  693.5,
  692.5,
  692,
  691.5,
  690.5,
  690.5,
  689.5,
  689,
  688.5,
  687.5,
  687.5,
  687,
  686,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  677.5,
  676.5,
  676.5,
  675.5,
  675,
  675,
  674,
  673.5,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670.5,
  669.5,
  669,
  669,
  668.5,
  668,
  668,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  663.5,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
];
a[183] = [
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  715.5,
  715.5,
  715,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712,
  711.5,
  710.5,
  710.5,
  709.5,
  709,
  708.5,
  707.5,
  707,
  706.5,
  706,
  705.5,
  704.5,
  704.5,
  704,
  703,
  702,
  701.5,
  701,
  700.5,
  699.5,
  699,
  698.5,
  698,
  697.5,
  696.5,
  696,
  695.5,
  694.5,
  694.5,
  693.5,
  693,
  692.5,
  691.5,
  691.5,
  690.5,
  690,
  689.5,
  688.5,
  688,
  688,
  687,
  686.5,
  686,
  685.5,
  685,
  684,
  683.5,
  683.5,
  682.5,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680.5,
  679.5,
  679.5,
  678.5,
  678,
  678,
  677,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  672,
  671,
  670.5,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  664.5,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
];
a[182] = [
  718,
  718,
  718,
  718,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  715.5,
  715.5,
  715,
  714.5,
  714.5,
  713.5,
  713,
  713,
  712,
  711.5,
  711,
  710.5,
  710,
  709,
  708.5,
  708,
  707,
  707,
  706,
  705.5,
  705,
  704,
  704,
  703.5,
  702,
  701.5,
  700.5,
  700.5,
  700,
  699,
  698.5,
  698,
  697,
  697,
  696,
  695.5,
  695,
  694,
  694,
  693,
  692.5,
  692,
  691,
  691,
  690,
  689.5,
  689,
  688,
  687.5,
  687,
  686.5,
  686,
  685.5,
  684.5,
  684.5,
  683.5,
  683,
  683,
  682,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  679,
  678,
  677.5,
  677.5,
  676.5,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671.5,
  670.5,
  670,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
];
a[181] = [
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  715.5,
  715.5,
  715,
  715,
  714.5,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712,
  711.5,
  710.5,
  710,
  709.5,
  708.5,
  708,
  707.5,
  706.5,
  706,
  705.5,
  705,
  704.5,
  703.5,
  703.5,
  702,
  701.5,
  701,
  700,
  699.5,
  699,
  698.5,
  698,
  697.5,
  696.5,
  696,
  695.5,
  694.5,
  694,
  693.5,
  693,
  692.5,
  691.5,
  691,
  690.5,
  690,
  689.5,
  688.5,
  688,
  687.5,
  687,
  686.5,
  685.5,
  685.5,
  684.5,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  679.5,
  679.5,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  673,
  672,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669.5,
  668.5,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666,
  666,
  666,
  666,
  666,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
];
a[180] = [
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  715.5,
  715.5,
  715.5,
  715,
  715,
  714.5,
  714,
  713.5,
  713,
  712.5,
  712,
  711.5,
  711,
  710.5,
  709.5,
  709,
  708.5,
  708,
  707,
  706,
  706,
  705,
  704.5,
  704,
  703,
  703,
  702,
  701,
  700.5,
  699.5,
  699,
  698.5,
  698,
  697.5,
  697,
  696,
  695.5,
  694.5,
  694,
  693.5,
  693,
  692.5,
  692,
  691,
  690.5,
  689.5,
  689.5,
  689,
  688,
  687.5,
  686.5,
  686,
  686,
  685,
  685,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680,
  680,
  679,
  678.5,
  678.5,
  677.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672.5,
  671.5,
  671,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
];
a[179] = [
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  715.5,
  715.5,
  715.5,
  715,
  715,
  714.5,
  714.5,
  714,
  713.5,
  713.5,
  712.5,
  712.5,
  712,
  711,
  710.5,
  710,
  709.5,
  709,
  708,
  707.5,
  706.5,
  705.5,
  705.5,
  705,
  704,
  703.5,
  703,
  702,
  701.5,
  700.5,
  700,
  699,
  698.5,
  698,
  697.5,
  697,
  696.5,
  695.5,
  695,
  694,
  693.5,
  693,
  692.5,
  692,
  691.5,
  690.5,
  690,
  689,
  689,
  688.5,
  687.5,
  687,
  686,
  685.5,
  685.5,
  684.5,
  684.5,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  681,
  680.5,
  679.5,
  679.5,
  678.5,
  678,
  678,
  677,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  672,
  671,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
];
a[178] = [
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  716,
  715.5,
  715.5,
  715.5,
  715,
  715,
  714.5,
  714.5,
  714,
  714,
  713.5,
  713,
  713,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710,
  709,
  708.5,
  707.5,
  707,
  706.5,
  705.5,
  705,
  704.5,
  703.5,
  703,
  702,
  701.5,
  700.5,
  700,
  699.5,
  698.5,
  698,
  697.5,
  696.5,
  696,
  695.5,
  694.5,
  694.5,
  693.5,
  693,
  692.5,
  691.5,
  691,
  690.5,
  689.5,
  689.5,
  688.5,
  688,
  687.5,
  686.5,
  686.5,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  682,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  675,
  674,
  674,
  673.5,
  672.5,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  667,
  666,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663.5,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
];
a[177] = [
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  716,
  715.5,
  715.5,
  715.5,
  715.5,
  715,
  715,
  714.5,
  714.5,
  714.5,
  714,
  713.5,
  713.5,
  713,
  712.5,
  712,
  711.5,
  711.5,
  710.5,
  710,
  709.5,
  708.5,
  708,
  707.5,
  706.5,
  706,
  705,
  704.5,
  704,
  703,
  703,
  701.5,
  701,
  700.5,
  699.5,
  699,
  698,
  697.5,
  697,
  696,
  695.5,
  695,
  694,
  694,
  692.5,
  692,
  692,
  691,
  690.5,
  690,
  689,
  688.5,
  688,
  687.5,
  687,
  686,
  685.5,
  685,
  684.5,
  684,
  683,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674.5,
  673.5,
  673.5,
  673,
  672,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
];
a[176] = [
  717,
  717,
  717,
  717,
  717,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  716,
  716,
  715.5,
  715.5,
  715.5,
  715,
  715,
  715,
  714.5,
  714.5,
  714,
  714,
  713.5,
  713.5,
  713,
  712.5,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710,
  709.5,
  708.5,
  708,
  707,
  706.5,
  705.5,
  705,
  704.5,
  703.5,
  703,
  702,
  701,
  700.5,
  700,
  699,
  698.5,
  697.5,
  697,
  696.5,
  695.5,
  695,
  694.5,
  694,
  693,
  692.5,
  692,
  691.5,
  690.5,
  690,
  689.5,
  689,
  688,
  687.5,
  687,
  686.5,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
];
a[175] = [
  717,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  716,
  716,
  715.5,
  715.5,
  715.5,
  715,
  715,
  715,
  715,
  714.5,
  714.5,
  714,
  714,
  713.5,
  713.5,
  713,
  713,
  712.5,
  712,
  712,
  711.5,
  711,
  710.5,
  710,
  709.5,
  709,
  708,
  707.5,
  706.5,
  706,
  705.5,
  704.5,
  704,
  703.5,
  702,
  701.5,
  700.5,
  700,
  699,
  698.5,
  698,
  697,
  696,
  696,
  695,
  694.5,
  693.5,
  693,
  692.5,
  691.5,
  691,
  690.5,
  689.5,
  689,
  688.5,
  687.5,
  687.5,
  686.5,
  686,
  685.5,
  684.5,
  684.5,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  681,
  680,
  679.5,
  679.5,
  678.5,
  678.5,
  678,
  677,
  677,
  676,
  675.5,
  675.5,
  674.5,
  674.5,
  673.5,
  673,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
];
a[174] = [
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  716,
  716,
  715.5,
  715.5,
  715.5,
  715.5,
  715,
  715,
  715,
  714.5,
  714.5,
  714.5,
  714,
  714,
  713.5,
  713.5,
  713,
  713,
  712.5,
  712.5,
  712,
  711.5,
  711,
  710.5,
  710.5,
  709.5,
  709,
  708.5,
  708,
  707.5,
  706.5,
  706,
  705,
  704.5,
  703.5,
  703,
  701.5,
  701,
  700,
  699.5,
  699,
  698,
  697.5,
  696,
  695.5,
  695,
  694,
  694,
  693,
  692,
  692,
  691,
  690.5,
  690,
  689,
  688.5,
  688,
  687,
  687,
  686,
  685.5,
  685,
  684,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  680.5,
  680.5,
  679.5,
  679,
  679,
  678,
  678,
  677.5,
  676.5,
  676.5,
  675.5,
  675,
  675,
  674,
  674,
  673,
  672.5,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  667,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
];
a[173] = [
  716.5,
  716.5,
  716.5,
  716,
  716,
  716,
  716,
  716,
  715.5,
  715.5,
  715.5,
  715.5,
  715,
  715,
  715,
  715,
  714.5,
  714.5,
  714,
  714,
  714,
  713.5,
  713.5,
  713,
  713,
  713,
  712.5,
  712,
  712,
  711.5,
  711,
  710.5,
  710.5,
  710,
  709.5,
  709,
  708.5,
  707.5,
  707,
  706,
  705.5,
  705,
  704,
  703.5,
  702,
  701,
  700.5,
  699.5,
  699,
  698,
  697,
  696.5,
  695.5,
  695,
  694.5,
  693.5,
  693,
  692.5,
  691.5,
  691,
  690,
  689.5,
  689,
  688,
  688,
  687,
  686.5,
  686,
  685,
  684.5,
  684,
  683.5,
  683,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  671,
  670.5,
  669.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662,
  662,
  660.5,
  660.5,
  660.5,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
];
a[172] = [
  716,
  716,
  716,
  716,
  716,
  716,
  715.5,
  715.5,
  715.5,
  715.5,
  715,
  715,
  715,
  715,
  714.5,
  714.5,
  714.5,
  714,
  714,
  714,
  713.5,
  713.5,
  713,
  713,
  712.5,
  712.5,
  712,
  712,
  711.5,
  711,
  711,
  710.5,
  710,
  709.5,
  709,
  708.5,
  708,
  707.5,
  707,
  706,
  705,
  704.5,
  703.5,
  703,
  701.5,
  700.5,
  700,
  699,
  698.5,
  697.5,
  696.5,
  696,
  695,
  694.5,
  694,
  693,
  692.5,
  692,
  691,
  690.5,
  689.5,
  689,
  688.5,
  687.5,
  687,
  686.5,
  685.5,
  685.5,
  684.5,
  684,
  683.5,
  682.5,
  682.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  676.5,
  676.5,
  676,
  675,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670.5,
  670,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  660.5,
  660.5,
  660.5,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
];
a[171] = [
  716,
  716,
  716,
  716,
  715.5,
  715.5,
  715.5,
  715.5,
  715,
  715,
  715,
  715,
  714.5,
  714.5,
  714.5,
  714,
  714,
  714,
  713.5,
  713.5,
  713,
  713,
  713,
  712.5,
  712.5,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710,
  709.5,
  709.5,
  709,
  708.5,
  708,
  707,
  706.5,
  705.5,
  705,
  704.5,
  703,
  702,
  701.5,
  700,
  699.5,
  698.5,
  698,
  697,
  696,
  695.5,
  694.5,
  694,
  693.5,
  692.5,
  692,
  691,
  690.5,
  690,
  689,
  688.5,
  688,
  687,
  686.5,
  686,
  685,
  685,
  684,
  683.5,
  683,
  682,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677,
  677,
  676,
  676,
  675.5,
  674.5,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  660.5,
  660.5,
  660.5,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
];
a[170] = [
  716,
  715.5,
  715.5,
  715.5,
  715.5,
  715.5,
  715,
  715,
  715,
  714.5,
  714.5,
  714.5,
  714.5,
  714,
  714,
  713.5,
  713.5,
  713.5,
  713,
  713,
  712.5,
  712.5,
  712.5,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710,
  709.5,
  709.5,
  709,
  708.5,
  708,
  707.5,
  707,
  706,
  705.5,
  704.5,
  704,
  703,
  701.5,
  701,
  699.5,
  699,
  698,
  697.5,
  696.5,
  695.5,
  695,
  693.5,
  693,
  692.5,
  691.5,
  691,
  690.5,
  689.5,
  689,
  688,
  687.5,
  687,
  686,
  686,
  685,
  684.5,
  684,
  683,
  683,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680.5,
  679.5,
  679.5,
  679,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671.5,
  670.5,
  670,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664,
  663.5,
  663,
  662.5,
  662,
  660.5,
  660.5,
  660.5,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
];
a[169] = [
  715.5,
  715.5,
  715.5,
  715.5,
  715,
  715,
  715,
  715,
  714.5,
  714.5,
  714.5,
  714,
  714,
  714,
  713.5,
  713.5,
  713,
  713,
  713,
  712.5,
  712.5,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710,
  710,
  709.5,
  709,
  709,
  708,
  708,
  707.5,
  706.5,
  706,
  705,
  704.5,
  703.5,
  702,
  701,
  700.5,
  699,
  698.5,
  697.5,
  697,
  696,
  695,
  694.5,
  693,
  692.5,
  692,
  691,
  690.5,
  690,
  689,
  688.5,
  687.5,
  687,
  686.5,
  685.5,
  685,
  684.5,
  683.5,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  680,
  679,
  679,
  678.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  672,
  671,
  671,
  670,
  669.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664,
  663.5,
  663,
  662.5,
  662,
  660.5,
  660.5,
  660.5,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
];
a[168] = [
  715.5,
  715.5,
  715,
  715,
  715,
  715,
  714.5,
  714.5,
  714.5,
  714,
  714,
  714,
  713.5,
  713.5,
  713.5,
  713,
  713,
  712.5,
  712.5,
  712,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710,
  709.5,
  709.5,
  709,
  709,
  708.5,
  708,
  707.5,
  707,
  706.5,
  705.5,
  704.5,
  704,
  703,
  701.5,
  701,
  700,
  699,
  698,
  697,
  696,
  695.5,
  694.5,
  693.5,
  692.5,
  692,
  691.5,
  690.5,
  690,
  689,
  688.5,
  688,
  687,
  686.5,
  686,
  685,
  684.5,
  684,
  683.5,
  683,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664,
  663.5,
  663,
  662.5,
  662,
  660.5,
  660.5,
  660.5,
  659.5,
  659.5,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
];
a[167] = [
  715,
  715,
  715,
  714.5,
  714.5,
  714.5,
  714.5,
  714,
  714,
  714,
  713.5,
  713.5,
  713,
  713,
  713,
  712.5,
  712.5,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710,
  710,
  709.5,
  709.5,
  709,
  709,
  708.5,
  708,
  708,
  707.5,
  707.5,
  707,
  706,
  705.5,
  704.5,
  703.5,
  702,
  701,
  700.5,
  699.5,
  698,
  697.5,
  696,
  695.5,
  694.5,
  693.5,
  693,
  691.5,
  691,
  690.5,
  689.5,
  689,
  688.5,
  687.5,
  687,
  686,
  685.5,
  685,
  684,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678.5,
  677.5,
  677.5,
  677,
  676,
  676,
  675,
  674.5,
  674.5,
  673.5,
  673.5,
  673,
  672,
  672,
  671,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  667.5,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664,
  663.5,
  663,
  662.5,
  662,
  660.5,
  660.5,
  660.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
];
a[166] = [
  714.5,
  714.5,
  714.5,
  714.5,
  714.5,
  714,
  714,
  714,
  713.5,
  713.5,
  713.5,
  713,
  713,
  712.5,
  712.5,
  712,
  712,
  712,
  711.5,
  711.5,
  711,
  710.5,
  710.5,
  710,
  710,
  709.5,
  709.5,
  709,
  709,
  708.5,
  708.5,
  708,
  708,
  707.5,
  707,
  707,
  706.5,
  706,
  705,
  704,
  703,
  702,
  700.5,
  699.5,
  699,
  697.5,
  697,
  695.5,
  695,
  694,
  692.5,
  692,
  691,
  690.5,
  690,
  689,
  688.5,
  687.5,
  686.5,
  686.5,
  685.5,
  684.5,
  684.5,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678,
  678,
  677,
  677,
  676.5,
  675.5,
  675.5,
  674.5,
  674,
  674,
  673,
  673,
  672.5,
  671.5,
  671.5,
  670.5,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667,
  667,
  666.5,
  666,
  666,
  665,
  665,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664,
  663.5,
  663,
  662.5,
  662,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
];
a[165] = [
  714.5,
  714.5,
  714,
  714,
  714,
  713.5,
  713.5,
  713.5,
  713,
  713,
  713,
  712.5,
  712.5,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710,
  710,
  709.5,
  709.5,
  709,
  708.5,
  708.5,
  708,
  708,
  707.5,
  707.5,
  707,
  707,
  706.5,
  706.5,
  706,
  705.5,
  705,
  703.5,
  702,
  701,
  700,
  699,
  698,
  697,
  696,
  694.5,
  694,
  693,
  692,
  691.5,
  690,
  689.5,
  689,
  688,
  687.5,
  686.5,
  686,
  685.5,
  684.5,
  684,
  683.5,
  682.5,
  682.5,
  681.5,
  681.5,
  681.5,
  680.5,
  680.5,
  680,
  679,
  679,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669.5,
  668.5,
  668.5,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664,
  663.5,
  663,
  662.5,
  662,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
];
a[164] = [
  714,
  714,
  714,
  713.5,
  713.5,
  713.5,
  713.5,
  713,
  713,
  712.5,
  712.5,
  712.5,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710,
  710,
  709.5,
  709.5,
  709,
  709,
  708.5,
  708,
  708,
  707.5,
  707.5,
  707,
  707,
  706.5,
  706.5,
  706,
  706,
  705.5,
  704.5,
  704,
  702,
  701.5,
  700.5,
  699,
  698.5,
  697.5,
  696,
  695.5,
  694,
  693.5,
  692.5,
  691,
  690.5,
  689.5,
  688.5,
  688,
  687,
  687,
  686,
  685,
  685,
  684,
  683.5,
  683,
  682,
  682,
  681.5,
  681.5,
  681,
  680,
  680,
  679.5,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664,
  663.5,
  663,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
];
a[163] = [
  714,
  713.5,
  713.5,
  713.5,
  713.5,
  713,
  713,
  713,
  712.5,
  712.5,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710,
  710,
  709.5,
  709,
  709,
  708.5,
  708.5,
  708,
  707.5,
  707.5,
  707,
  707,
  706.5,
  706,
  706,
  705.5,
  705.5,
  705,
  704.5,
  704,
  703.5,
  701.5,
  701,
  700,
  698.5,
  697.5,
  696.5,
  695.5,
  694.5,
  693,
  692.5,
  692,
  690.5,
  690,
  688.5,
  688,
  687.5,
  686.5,
  686,
  685.5,
  684.5,
  684,
  683,
  682.5,
  682.5,
  681.5,
  681.5,
  681.5,
  680.5,
  680.5,
  679.5,
  679.5,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  667.5,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664,
  663.5,
  663,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659,
  659,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
];
a[162] = [
  713.5,
  713.5,
  713,
  713,
  713,
  712.5,
  712.5,
  712.5,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710,
  709.5,
  709.5,
  709,
  709,
  708.5,
  708,
  708,
  707.5,
  707,
  707,
  706.5,
  706,
  706,
  705.5,
  705.5,
  705,
  704.5,
  704.5,
  704,
  703.5,
  702,
  701.5,
  700,
  699.5,
  699,
  697.5,
  697,
  696,
  694.5,
  694,
  692.5,
  692,
  691,
  689.5,
  689,
  687.5,
  687,
  686.5,
  685.5,
  685,
  684.5,
  683.5,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  679,
  678.5,
  678,
  677,
  677,
  676,
  675.5,
  675.5,
  674.5,
  674.5,
  674,
  673,
  673,
  672,
  671.5,
  671.5,
  670.5,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  667,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  665.5,
  665,
  664.5,
  664,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
];
a[161] = [
  713,
  713,
  713,
  712.5,
  712.5,
  712.5,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  711,
  710.5,
  710,
  710,
  709.5,
  709.5,
  709,
  708.5,
  708.5,
  708,
  707.5,
  707.5,
  707,
  706.5,
  706.5,
  706,
  705.5,
  705,
  705,
  704.5,
  704,
  704,
  703.5,
  703,
  702,
  701,
  700.5,
  699.5,
  699,
  698,
  696.5,
  696,
  695,
  693.5,
  693,
  691.5,
  691,
  690,
  689,
  688.5,
  687,
  686,
  686,
  685,
  684.5,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678,
  678,
  677.5,
  676.5,
  676.5,
  675.5,
  675,
  675,
  674,
  674,
  673.5,
  672.5,
  672.5,
  671.5,
  671,
  671,
  670,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  666.5,
  666.5,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  663.5,
  663,
  662.5,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666,
  666.5,
];
a[160] = [
  712.5,
  712.5,
  712.5,
  712.5,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710,
  710,
  709.5,
  709.5,
  709,
  708.5,
  708,
  708,
  707.5,
  707,
  707,
  706.5,
  706,
  705.5,
  705.5,
  705,
  704.5,
  704,
  704,
  703.5,
  703,
  702,
  701.5,
  701,
  700.5,
  700,
  699.5,
  698,
  697.5,
  697,
  695.5,
  695,
  694,
  693,
  692,
  691,
  690,
  689,
  688,
  687.5,
  686,
  685,
  685,
  684,
  683.5,
  683,
  682,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660,
  659.5,
  659.5,
  658.5,
  658.5,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
];
a[159] = [
  712.5,
  712.5,
  712,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710,
  710,
  709.5,
  709,
  709,
  708.5,
  708,
  707.5,
  707.5,
  707,
  706.5,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704.5,
  704,
  703.5,
  703,
  702,
  702,
  701.5,
  701,
  700.5,
  700,
  699,
  698.5,
  697.5,
  697,
  696,
  694.5,
  694,
  693,
  692,
  691.5,
  690,
  689.5,
  688.5,
  687.5,
  686.5,
  685.5,
  684.5,
  684,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  679.5,
  679.5,
  679,
  678,
  677.5,
  677,
  676.5,
  676,
  675,
  675,
  674,
  673.5,
  673.5,
  672.5,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668.5,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
];
a[158] = [
  712,
  712,
  712,
  711.5,
  711.5,
  711,
  711,
  711,
  710.5,
  710.5,
  710,
  709.5,
  709.5,
  709,
  708.5,
  708.5,
  708,
  707.5,
  707,
  707,
  706.5,
  706,
  705.5,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  703,
  702,
  701.5,
  701,
  700.5,
  700,
  699.5,
  699,
  698,
  697.5,
  696.5,
  696,
  695,
  694,
  693.5,
  692.5,
  691,
  690.5,
  689,
  689,
  688,
  686.5,
  686,
  684.5,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680,
  680,
  679,
  679,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  674.5,
  674.5,
  673.5,
  673,
  673,
  672,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669.5,
  668.5,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  659.5,
  659,
  659,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
];
a[157] = [
  711.5,
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710.5,
  710,
  709.5,
  709.5,
  709,
  709,
  708.5,
  708,
  707.5,
  707,
  707,
  706.5,
  706,
  705.5,
  705,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701.5,
  701,
  700.5,
  700,
  699.5,
  699.5,
  698.5,
  698,
  697.5,
  696.5,
  696,
  695,
  694.5,
  694,
  693,
  692,
  691.5,
  690.5,
  689.5,
  688.5,
  688,
  687,
  686,
  685,
  684,
  683.5,
  683,
  682,
  681.5,
  681.5,
  681,
  681,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  676.5,
  676.5,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  671,
  670,
  670,
  669,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665.5,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665,
  664.5,
  664,
  663.5,
  663,
  662,
  661.5,
  661.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
];
a[156] = [
  711.5,
  711.5,
  711,
  711,
  710.5,
  710.5,
  710,
  710,
  709.5,
  709.5,
  709,
  708.5,
  708.5,
  708,
  707.5,
  707,
  706.5,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  703,
  701.5,
  701.5,
  701,
  700.5,
  700,
  699.5,
  699,
  698.5,
  697.5,
  697.5,
  696.5,
  696,
  695.5,
  694.5,
  694,
  693,
  692,
  691.5,
  690.5,
  689.5,
  689,
  687.5,
  687,
  686.5,
  685,
  684.5,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  680.5,
  680.5,
  679.5,
  679,
  678.5,
  677.5,
  677.5,
  677,
  676,
  676,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670.5,
  669.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658.5,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
];
a[155] = [
  711,
  711,
  711,
  710.5,
  710.5,
  710,
  710,
  709.5,
  709,
  709,
  708.5,
  708.5,
  708,
  707.5,
  707,
  707,
  706,
  706,
  705,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701.5,
  701,
  700.5,
  700,
  699.5,
  699,
  698.5,
  698,
  697.5,
  697,
  696.5,
  696,
  695,
  694.5,
  693.5,
  693,
  692.5,
  691,
  690.5,
  690,
  688.5,
  688,
  687,
  686.5,
  685.5,
  684.5,
  684,
  683,
  682,
  682,
  681.5,
  681.5,
  681,
  680,
  679.5,
  679,
  678.5,
  678,
  677,
  677,
  676.5,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  670,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
];
a[154] = [
  710.5,
  710.5,
  710.5,
  710,
  710,
  709.5,
  709.5,
  709,
  708.5,
  708.5,
  708,
  707.5,
  707.5,
  706.5,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701.5,
  701,
  700.5,
  700,
  699.5,
  699,
  698.5,
  698,
  697.5,
  696.5,
  696.5,
  695.5,
  695,
  694.5,
  693.5,
  693,
  692,
  692,
  691,
  690,
  689.5,
  689,
  687.5,
  687,
  686,
  685.5,
  685,
  683.5,
  683,
  682,
  681.5,
  681.5,
  681,
  681,
  680,
  679.5,
  679,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  673.5,
  673.5,
  673,
  672,
  672,
  671,
  670.5,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  662.5,
  662,
  662,
  660.5,
  660.5,
  660.5,
  659.5,
  659,
  658.5,
  658,
  658,
  657.5,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
];
a[153] = [
  710.5,
  710,
  710,
  709.5,
  709.5,
  709,
  709,
  708.5,
  708,
  708,
  707.5,
  707,
  707,
  706,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  701.5,
  701.5,
  701,
  700,
  700,
  699,
  699,
  698,
  697.5,
  697,
  696.5,
  696,
  695.5,
  694.5,
  694,
  693.5,
  692.5,
  692.5,
  691.5,
  691,
  690,
  689,
  688.5,
  688,
  687,
  686.5,
  685.5,
  685,
  684,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  678.5,
  678.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674,
  674,
  673,
  673,
  672.5,
  671.5,
  671.5,
  670.5,
  670,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664.5,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660,
  660,
  659,
  659,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
];
a[152] = [
  710,
  709.5,
  709.5,
  709,
  709,
  708.5,
  708.5,
  708,
  707.5,
  707.5,
  706.5,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701.5,
  701,
  700.5,
  700,
  699,
  699,
  698,
  697.5,
  697,
  696.5,
  696,
  695,
  694.5,
  694,
  693.5,
  693,
  692.5,
  691.5,
  691,
  690,
  689.5,
  689,
  688,
  687.5,
  687,
  686,
  685.5,
  684.5,
  684,
  683,
  682.5,
  682,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678,
  677.5,
  677,
  676.5,
  676,
  675,
  675,
  674.5,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
];
a[151] = [
  709.5,
  709.5,
  709,
  709,
  708.5,
  708,
  708,
  707.5,
  707,
  707,
  706,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701.5,
  701,
  700,
  699.5,
  699,
  698.5,
  698,
  697.5,
  697,
  696.5,
  695.5,
  695,
  694.5,
  694,
  693.5,
  692.5,
  692,
  691.5,
  690.5,
  690,
  689.5,
  689,
  688,
  687,
  687,
  686,
  685,
  684.5,
  683.5,
  683.5,
  682.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679,
  679,
  678.5,
  677.5,
  677,
  676,
  675.5,
  675.5,
  674.5,
  674.5,
  674,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
];
a[150] = [
  709.5,
  709,
  709,
  708.5,
  708,
  707.5,
  707.5,
  707,
  706.5,
  706.5,
  705.5,
  705.5,
  705,
  704.5,
  704,
  703.5,
  702,
  702,
  701,
  701,
  700,
  699.5,
  699,
  698.5,
  697.5,
  697.5,
  696.5,
  696,
  695.5,
  694.5,
  694.5,
  693.5,
  693,
  692.5,
  691.5,
  691,
  690.5,
  690,
  689.5,
  688.5,
  688,
  687.5,
  686.5,
  686,
  685.5,
  684.5,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  678.5,
  678.5,
  678,
  677,
  676.5,
  675.5,
  675,
  675,
  674,
  674,
  673.5,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  663.5,
  663,
  663,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  659,
  658,
  658,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
];
a[149] = [
  709,
  708.5,
  708.5,
  708,
  707.5,
  707,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701.5,
  701,
  700,
  700,
  699,
  698.5,
  698,
  697.5,
  696.5,
  696,
  695.5,
  695,
  694.5,
  693.5,
  693,
  692,
  691.5,
  691,
  690.5,
  690,
  689.5,
  688.5,
  688,
  687.5,
  687,
  686.5,
  685.5,
  685,
  684.5,
  683.5,
  683,
  682,
  681.5,
  681.5,
  681,
  680.5,
  679.5,
  679,
  679,
  678,
  677.5,
  677,
  676,
  676,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669,
  669,
  668,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663,
  662.5,
  662.5,
  661.5,
  661.5,
  660.5,
  660,
  660,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
];
a[148] = [
  708.5,
  708.5,
  708,
  707.5,
  707.5,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701.5,
  700.5,
  700.5,
  699.5,
  699,
  698.5,
  697.5,
  697.5,
  696.5,
  696,
  695.5,
  694.5,
  694,
  693.5,
  692.5,
  692,
  691.5,
  691,
  690.5,
  689.5,
  689,
  688.5,
  687.5,
  687.5,
  686.5,
  686,
  685.5,
  684.5,
  684,
  683.5,
  682.5,
  682.5,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  675.5,
  675.5,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663.5,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
];
a[147] = [
  708.5,
  708,
  707.5,
  707.5,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703.5,
  703,
  702,
  701.5,
  701,
  700.5,
  699.5,
  699,
  698.5,
  698,
  697,
  696.5,
  696,
  695.5,
  694.5,
  694,
  693.5,
  692.5,
  692,
  691.5,
  691,
  690,
  689.5,
  689,
  688.5,
  687.5,
  687,
  686.5,
  686,
  685.5,
  685,
  684,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  679,
  678.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  658,
  657.5,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
];
a[146] = [
  707.5,
  707.5,
  707,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  704,
  703,
  703,
  701.5,
  701,
  700.5,
  700,
  699,
  698.5,
  698,
  697.5,
  697,
  696,
  695.5,
  695,
  694,
  693.5,
  692.5,
  692,
  691.5,
  690.5,
  690,
  689.5,
  688.5,
  688,
  687.5,
  687,
  686.5,
  685.5,
  685.5,
  684.5,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  680.5,
  680.5,
  680,
  679,
  678.5,
  677.5,
  677,
  677,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669,
  669,
  668.5,
  668,
  667.5,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  657.5,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
];
a[145] = [
  707.5,
  707.5,
  707,
  706.5,
  706,
  705.5,
  705,
  704.5,
  703.5,
  703.5,
  702,
  702,
  701,
  700.5,
  700,
  699.5,
  698.5,
  698,
  697,
  697,
  696,
  695,
  695,
  694,
  693,
  693,
  692,
  691.5,
  691,
  690,
  689.5,
  688.5,
  688,
  687.5,
  686.5,
  686,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  682,
  682,
  681.5,
  681.5,
  681,
  680,
  680,
  679,
  678.5,
  678,
  677,
  676.5,
  676.5,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662.5,
  662.5,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
];
a[144] = [
  707,
  707,
  706.5,
  706,
  705.5,
  704.5,
  704.5,
  704,
  703,
  702,
  701.5,
  701,
  700.5,
  699.5,
  699,
  698.5,
  697.5,
  697,
  696,
  695.5,
  695,
  694,
  693.5,
  693,
  692,
  691.5,
  690.5,
  690.5,
  689.5,
  688.5,
  688.5,
  687.5,
  686.5,
  686,
  685.5,
  685,
  684.5,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679,
  679,
  678.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  674.5,
  674.5,
  674,
  673,
  673,
  672,
  671.5,
  671.5,
  670.5,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
];
a[143] = [
  706.5,
  706.5,
  706,
  705.5,
  705,
  704,
  704,
  703.5,
  702,
  701.5,
  700.5,
  700.5,
  699.5,
  698.5,
  698.5,
  697.5,
  696.5,
  696.5,
  695.5,
  695,
  694.5,
  693.5,
  693,
  692.5,
  691.5,
  691,
  690,
  689.5,
  689,
  688,
  687.5,
  686.5,
  686,
  685.5,
  684.5,
  684.5,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  679.5,
  679.5,
  678.5,
  678,
  677.5,
  677,
  676.5,
  675.5,
  675,
  675,
  674,
  674,
  673.5,
  672.5,
  672.5,
  671.5,
  671,
  671,
  670,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
];
a[142] = [
  706.5,
  706,
  705.5,
  705,
  704.5,
  703.5,
  703.5,
  703,
  701.5,
  701,
  700,
  699.5,
  699,
  698,
  698,
  697,
  696,
  695.5,
  694.5,
  694.5,
  693.5,
  692.5,
  692.5,
  691.5,
  690.5,
  690,
  689,
  689,
  688,
  687,
  687,
  686,
  685,
  685,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  680.5,
  680.5,
  680,
  679,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675,
  674.5,
  674.5,
  673.5,
  673.5,
  673,
  672,
  672,
  671,
  670.5,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
];
a[141] = [
  706,
  705.5,
  705,
  704.5,
  704,
  703,
  702,
  701.5,
  700.5,
  700,
  699,
  699,
  698,
  697,
  697,
  696,
  695,
  694.5,
  693.5,
  693.5,
  692.5,
  691.5,
  691,
  690.5,
  689.5,
  689,
  688,
  688,
  687,
  686,
  686,
  685,
  684,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  679,
  678,
  678,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  670,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
];
a[140] = [
  705.5,
  705.5,
  704.5,
  704,
  703.5,
  702,
  701.5,
  701,
  700,
  699.5,
  698.5,
  698,
  697.5,
  696.5,
  696,
  695.5,
  694.5,
  694,
  693,
  692.5,
  692,
  691,
  690.5,
  690,
  688.5,
  688.5,
  687.5,
  687,
  686.5,
  685.5,
  685,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  680.5,
  680.5,
  680,
  679,
  679,
  678.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663.5,
  663,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662,
  663,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
];
a[139] = [
  705,
  704.5,
  704,
  703.5,
  702,
  701,
  700.5,
  700,
  699,
  698.5,
  698,
  697.5,
  696.5,
  695.5,
  695,
  694.5,
  693.5,
  693,
  692,
  691.5,
  691,
  690,
  689.5,
  688.5,
  688,
  687.5,
  686.5,
  686,
  685.5,
  684.5,
  684,
  683,
  682.5,
  682.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  679.5,
  679.5,
  679,
  678,
  678,
  677.5,
  676.5,
  676.5,
  675.5,
  675.5,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672.5,
  671.5,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  669,
  668,
  668,
  667.5,
  667,
  667,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
];
a[138] = [
  704,
  704,
  703,
  702,
  701.5,
  700.5,
  700,
  699.5,
  698.5,
  698,
  697,
  696.5,
  696,
  695,
  694.5,
  694,
  693,
  692.5,
  691,
  691,
  690,
  689,
  688.5,
  688,
  687,
  686.5,
  685.5,
  685.5,
  684.5,
  684,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  681,
  680,
  680,
  679,
  679,
  678.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  672,
  671,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
];
a[137] = [
  703.5,
  703,
  702,
  701.5,
  701,
  700,
  699.5,
  699,
  698,
  697.5,
  696.5,
  696,
  695.5,
  694,
  694,
  693,
  692,
  691.5,
  690.5,
  690,
  689.5,
  688.5,
  688,
  687,
  686,
  686,
  685,
  684.5,
  684,
  683,
  683,
  682,
  681.5,
  681.5,
  681,
  681,
  680.5,
  679.5,
  679.5,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
];
a[136] = [
  702,
  701.5,
  701,
  700.5,
  700,
  699,
  698.5,
  698,
  697,
  696.5,
  695.5,
  695,
  694.5,
  693.5,
  693,
  692,
  691,
  690.5,
  689.5,
  689,
  688.5,
  687.5,
  687,
  686,
  685,
  685,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  678.5,
  678.5,
  677.5,
  677.5,
  677,
  676,
  676,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  672,
  671,
  670.5,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
];
a[135] = [
  701,
  701,
  700.5,
  699.5,
  699,
  698,
  698,
  697,
  696,
  696,
  694.5,
  694.5,
  693.5,
  692.5,
  692,
  691.5,
  690.5,
  690,
  689,
  688.5,
  688,
  686.5,
  686.5,
  685.5,
  684.5,
  684,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  679.5,
  679.5,
  679,
  678,
  678,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671.5,
  670.5,
  670,
  670,
  669.5,
  669,
  669,
  668,
  668,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  660,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  662.5,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
];
a[134] = [
  700.5,
  700,
  699.5,
  699,
  698.5,
  697.5,
  697,
  696.5,
  695.5,
  695,
  694,
  693.5,
  693,
  692,
  691.5,
  691,
  689.5,
  689.5,
  688,
  688,
  687,
  686,
  685.5,
  685,
  684,
  683.5,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679,
  679,
  678.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669.5,
  669,
  668.5,
  668.5,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  658.5,
  658,
  658,
  657.5,
  657,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
];
a[133] = [
  699.5,
  699,
  698.5,
  698,
  697.5,
  696.5,
  696,
  695.5,
  694.5,
  694,
  693,
  692.5,
  692,
  691,
  690.5,
  690,
  689,
  688.5,
  687.5,
  687,
  686,
  685,
  685,
  684,
  683,
  683,
  682,
  681.5,
  681.5,
  681,
  681,
  680,
  679.5,
  679,
  678.5,
  678,
  677.5,
  676.5,
  676.5,
  675.5,
  675.5,
  675,
  674,
  674,
  673.5,
  672.5,
  672.5,
  671.5,
  671.5,
  671,
  670,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
];
a[132] = [
  698.5,
  698.5,
  698,
  697.5,
  696.5,
  696,
  695.5,
  695,
  694,
  693.5,
  692.5,
  692,
  691.5,
  690,
  690,
  689,
  688,
  687.5,
  686.5,
  686.5,
  685.5,
  684.5,
  684,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  679,
  678.5,
  677.5,
  677.5,
  677,
  676,
  676,
  675,
  675,
  674.5,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  671,
  670.5,
  669.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  670,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
];
a[131] = [
  697.5,
  697.5,
  697,
  696.5,
  695.5,
  695,
  694.5,
  694,
  693,
  692.5,
  691.5,
  691,
  690,
  689.5,
  689,
  688,
  687.5,
  686.5,
  686,
  685.5,
  684.5,
  684,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662,
  663,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
];
a[130] = [
  697,
  696.5,
  696,
  695.5,
  695,
  694,
  694,
  693,
  692,
  691.5,
  690.5,
  690.5,
  689.5,
  688.5,
  688,
  687.5,
  686.5,
  686,
  685,
  685,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679,
  679,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  674.5,
  674.5,
  673.5,
  673.5,
  673,
  672,
  672,
  671.5,
  670.5,
  670.5,
  669.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
];
a[129] = [
  696.5,
  696,
  695.5,
  695,
  694.5,
  693.5,
  693,
  692.5,
  691.5,
  691,
  690,
  689.5,
  689,
  688,
  687.5,
  687,
  686,
  685.5,
  684.5,
  684,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  678.5,
  678.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  675,
  674,
  674,
  673,
  673,
  672.5,
  671.5,
  671.5,
  671,
  670,
  670,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674.5,
];
a[128] = [
  695.5,
  695,
  694.5,
  694,
  693.5,
  692.5,
  692,
  691.5,
  690.5,
  690,
  689,
  688.5,
  688,
  687,
  686.5,
  686,
  685,
  684.5,
  683.5,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  679.5,
  679,
  678.5,
  678,
  677.5,
  676.5,
  676,
  676,
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667,
  667,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  665,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
];
a[127] = [
  695,
  694.5,
  694,
  693.5,
  693,
  692,
  691.5,
  691,
  690,
  689.5,
  688.5,
  688,
  687,
  686,
  686,
  685,
  684.5,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680,
  680,
  679,
  678.5,
  678,
  677,
  677,
  676,
  675.5,
  675.5,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667.5,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
];
a[126] = [
  694.5,
  694,
  693.5,
  693,
  692,
  691.5,
  691,
  690,
  689.5,
  689,
  688,
  687.5,
  686.5,
  686,
  685,
  684.5,
  684,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679.5,
  678.5,
  678,
  677.5,
  677,
  676.5,
  676,
  675.5,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  669,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
];
a[125] = [
  693.5,
  693,
  692.5,
  692,
  691.5,
  690.5,
  690,
  689.5,
  688.5,
  688,
  686.5,
  686.5,
  685.5,
  684.5,
  684.5,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679,
  678.5,
  677.5,
  677.5,
  677,
  676,
  675.5,
  674.5,
  674.5,
  674,
  673,
  673,
  672.5,
  671.5,
  671.5,
  670.5,
  670.5,
  670,
  669,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
];
a[124] = [
  692.5,
  692.5,
  692,
  691.5,
  690.5,
  690,
  689.5,
  688.5,
  687.5,
  687.5,
  686,
  685.5,
  685,
  684,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680,
  680,
  679,
  678.5,
  678,
  677,
  677,
  676,
  675.5,
  675,
  674,
  673.5,
  673.5,
  672.5,
  672.5,
  672,
  671,
  671,
  670,
  670,
  669.5,
  668.5,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  663,
  663,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
];
a[123] = [
  692,
  691.5,
  691,
  690.5,
  690,
  689,
  688.5,
  688,
  687,
  686.5,
  685.5,
  685,
  684,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  679.5,
  679,
  678.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  674.5,
  674.5,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
];
a[122] = [
  691.5,
  691,
  690.5,
  690,
  689.5,
  688.5,
  688,
  687.5,
  686.5,
  686,
  685,
  684.5,
  684,
  683,
  682.5,
  682,
  681.5,
  681.5,
  680.5,
  680.5,
  679.5,
  679,
  678.5,
  678,
  677,
  676.5,
  676,
  675.5,
  675,
  674,
  674,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667.5,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
];
a[121] = [
  691,
  690.5,
  690,
  689.5,
  689,
  688,
  687.5,
  687,
  686,
  685.5,
  684.5,
  684,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680,
  680,
  679,
  678.5,
  678,
  677.5,
  676.5,
  676,
  675.5,
  675,
  674.5,
  673.5,
  673.5,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  668,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
];
a[120] = [
  690,
  690,
  689.5,
  688.5,
  688,
  687,
  687,
  686,
  685,
  684.5,
  684,
  683.5,
  682.5,
  681.5,
  681.5,
  681.5,
  681,
  680.5,
  679.5,
  679,
  678.5,
  677.5,
  677,
  676.5,
  676,
  675.5,
  674.5,
  674,
  673.5,
  673,
  672.5,
  671.5,
  671,
  671,
  670,
  670,
  669.5,
  668.5,
  668.5,
  667.5,
  667.5,
  667,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667.5,
  667,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  665,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677,
];
a[119] = [
  689.5,
  689.5,
  689,
  688,
  687.5,
  686.5,
  686.5,
  685.5,
  684.5,
  684,
  683,
  683,
  682,
  681.5,
  681.5,
  681,
  680,
  680,
  679,
  678.5,
  678,
  677,
  676.5,
  676,
  675,
  675,
  674,
  673.5,
  673,
  672.5,
  672,
  671,
  670.5,
  670.5,
  669.5,
  669.5,
  669,
  668,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667.5,
  667,
  667,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  656,
  656,
  656,
  656.5,
  656.5,
  657,
  657.5,
  657.5,
  658,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
];
a[118] = [
  689.5,
  689,
  688.5,
  687.5,
  687,
  686.5,
  686,
  685,
  684.5,
  684,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  678.5,
  678,
  677.5,
  676.5,
  676,
  675.5,
  675,
  674.5,
  673.5,
  673,
  672.5,
  672,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  668,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667,
  667,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656.5,
  656.5,
  657,
  657.5,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
];
a[117] = [
  688.5,
  688,
  687.5,
  687,
  686.5,
  685.5,
  685,
  684.5,
  683.5,
  683,
  682,
  681.5,
  681.5,
  681,
  680.5,
  680,
  679,
  678.5,
  677.5,
  677.5,
  676.5,
  676,
  675.5,
  675,
  674,
  673.5,
  673,
  672.5,
  672,
  671,
  671,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666,
  666,
  666,
  665.5,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  655,
  655.5,
  655.5,
  656,
  656,
  656.5,
  657,
  657.5,
  658,
  658,
  658.5,
  659,
  660,
  660,
  660.5,
  661.5,
  662,
  662,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
];
a[116] = [
  688,
  688,
  687,
  686.5,
  686,
  685,
  684.5,
  684,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  678.5,
  678,
  677,
  677,
  676,
  675.5,
  675,
  674.5,
  673.5,
  673,
  672.5,
  672,
  671.5,
  670.5,
  670.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666.5,
  665.5,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667.5,
  667,
  667,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  655,
  655,
  655,
  655.5,
  656,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  678.5,
];
a[115] = [
  687.5,
  687,
  686.5,
  686,
  685.5,
  684.5,
  684,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  678.5,
  678,
  677.5,
  676.5,
  676,
  675.5,
  674.5,
  674,
  673.5,
  673,
  672.5,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667,
  667,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  666.5,
  666.5,
  666,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655,
  655,
  655,
  654.5,
  654.5,
  654.5,
  655,
  655,
  655.5,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  664,
  664,
  665,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679,
];
a[114] = [
  687,
  686.5,
  686,
  685.5,
  685,
  684,
  683.5,
  683,
  682,
  681.5,
  681.5,
  681,
  680.5,
  679.5,
  679,
  678,
  677.5,
  677,
  676,
  675.5,
  675,
  674,
  673.5,
  673,
  672,
  672,
  671,
  670.5,
  670,
  669.5,
  669,
  668,
  668,
  667.5,
  666.5,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
];
a[113] = [
  686.5,
  686.5,
  685.5,
  685,
  684.5,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  680.5,
  680.5,
  679.5,
  678.5,
  678.5,
  677.5,
  676.5,
  676.5,
  675.5,
  675,
  674.5,
  673.5,
  673,
  672.5,
  671.5,
  671.5,
  670.5,
  670.5,
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  667,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656,
  655.5,
  655.5,
  655.5,
  655,
  654.5,
  654.5,
  654.5,
  654,
  654,
  654,
  654.5,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658.5,
  659,
  659.5,
  660,
  660.5,
  661.5,
  662,
  662.5,
  663.5,
  663.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
];
a[112] = [
  686,
  685.5,
  685,
  684.5,
  683.5,
  683,
  682.5,
  681.5,
  681.5,
  681,
  680,
  679.5,
  679,
  678,
  677.5,
  677,
  676,
  675.5,
  674.5,
  674.5,
  673.5,
  673,
  672.5,
  672,
  671,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667,
  666.5,
  666.5,
  665.5,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666.5,
  666,
  666,
  666,
  666,
  666,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656,
  656,
  656,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654,
  654,
  654,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  658,
  658.5,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662,
  663,
  663.5,
  664,
  665,
  665.5,
  666,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
];
a[111] = [
  685.5,
  685.5,
  684.5,
  684,
  683.5,
  682,
  682,
  681.5,
  681,
  680.5,
  679.5,
  679,
  678.5,
  677.5,
  677,
  676.5,
  675.5,
  675,
  674,
  674,
  673,
  672.5,
  672,
  671.5,
  670.5,
  670,
  669.5,
  669,
  668.5,
  668,
  667.5,
  666.5,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  666.5,
  666,
  666,
  666,
  666,
  666,
  666,
  666,
  665.5,
  665.5,
  665.5,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654,
  654,
  653.5,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657.5,
  658,
  658.5,
  659,
  660,
  660.5,
  661.5,
  662,
  662.5,
  663.5,
  664,
  664.5,
  665.5,
  666,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
];
a[110] = [
  685,
  684.5,
  684,
  683,
  682.5,
  681.5,
  681.5,
  681.5,
  680.5,
  680,
  679,
  678.5,
  677.5,
  677,
  676.5,
  675.5,
  675,
  674.5,
  673.5,
  673,
  672.5,
  671.5,
  671,
  670.5,
  670,
  669.5,
  668.5,
  668.5,
  668,
  667,
  667,
  666,
  665.5,
  665.5,
  664.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666,
  666,
  666,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665,
  665,
  665,
  664.5,
  664.5,
  664,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654,
  654,
  653.5,
  653.5,
  653.5,
  654,
  655,
  655.5,
  656,
  657,
  657.5,
  658.5,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
];
a[109] = [
  684.5,
  684,
  683.5,
  682.5,
  682,
  681.5,
  681.5,
  681,
  680,
  679.5,
  678.5,
  678,
  677,
  676,
  676,
  675,
  674,
  674,
  673,
  672.5,
  672,
  671,
  670.5,
  670,
  669.5,
  669,
  668,
  668,
  667.5,
  666.5,
  666.5,
  665.5,
  665,
  665,
  664.5,
  664,
  663.5,
  663,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665.5,
  665,
  665,
  665,
  665,
  665,
  664.5,
  664.5,
  664.5,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654,
  654,
  653.5,
  654,
  654.5,
  655,
  656,
  656.5,
  657,
  658,
  658.5,
  659,
  660,
  660.5,
  660.5,
  662,
  662.5,
  663,
  664,
  664.5,
  665,
  666,
  666.5,
  667,
  667,
  667.5,
  668,
  668,
  668.5,
  669,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
];
a[108] = [
  684,
  683.5,
  683,
  682,
  681.5,
  681.5,
  681,
  680,
  679,
  679,
  677.5,
  677.5,
  676.5,
  675.5,
  675,
  674.5,
  673.5,
  673,
  672.5,
  672,
  671.5,
  670.5,
  670,
  669.5,
  669,
  668.5,
  667.5,
  667.5,
  667,
  666,
  666,
  665,
  664.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665,
  665,
  665,
  665,
  665,
  665,
  665,
  665,
  665,
  664.5,
  664.5,
  664.5,
  664,
  664,
  664,
  663.5,
  663.5,
  663,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657.5,
  658,
  659,
  659.5,
  660,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
];
a[107] = [
  682.5,
  682.5,
  682,
  681.5,
  681.5,
  680.5,
  680,
  679.5,
  678.5,
  678,
  677,
  676.5,
  676,
  675,
  674.5,
  673.5,
  673,
  672.5,
  671.5,
  671,
  670.5,
  670,
  669.5,
  669,
  668,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  664,
  663.5,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664.5,
  664,
  664,
  664,
  664,
  663.5,
  663.5,
  663.5,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  655,
  655.5,
  656,
  656.5,
  657,
  657,
  658,
  658.5,
  659.5,
  660,
  660.5,
  661.5,
  662,
  662.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666.5,
  666.5,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  670.5,
  671,
  671,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
];
a[106] = [
  682,
  681.5,
  681.5,
  681.5,
  681,
  680,
  679.5,
  679,
  678,
  677.5,
  676.5,
  676,
  675.5,
  674,
  674,
  673,
  672,
  672,
  671,
  670.5,
  670,
  669,
  669,
  668.5,
  667.5,
  667.5,
  666.5,
  666,
  666,
  665,
  665,
  664,
  663.5,
  663.5,
  663,
  662.5,
  662.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  664,
  663.5,
  663.5,
  663.5,
  663,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656.5,
  657,
  657.5,
  657.5,
  658.5,
  659,
  660,
  660.5,
  660.5,
  662,
  662.5,
  663,
  663.5,
  664,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  670,
  670,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
];
a[105] = [
  681.5,
  681.5,
  681.5,
  681,
  680,
  679.5,
  679,
  678,
  677,
  677,
  675.5,
  675.5,
  674.5,
  673.5,
  673.5,
  672.5,
  671.5,
  671.5,
  670.5,
  670,
  669.5,
  668.5,
  668.5,
  668,
  667,
  667,
  666,
  666,
  665.5,
  664.5,
  664.5,
  663.5,
  663.5,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664,
  663.5,
  663.5,
  663.5,
  663.5,
  663.5,
  663,
  663,
  663,
  663,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  657,
  657.5,
  658,
  658,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  667,
  667,
  668,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  671,
  671,
  671,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
];
a[104] = [
  681.5,
  681,
  680.5,
  680,
  679.5,
  678.5,
  678,
  677.5,
  676.5,
  676,
  675,
  674.5,
  674,
  673,
  672.5,
  672,
  671,
  670.5,
  669.5,
  669.5,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  663,
  662.5,
  662.5,
  662.5,
  662,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  658,
  658,
  658.5,
  659,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668.5,
  669,
  669.5,
  669.5,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671,
  671.5,
  671.5,
  672,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
];
a[103] = [
  680.5,
  680.5,
  680,
  679.5,
  678.5,
  677.5,
  677.5,
  676.5,
  676,
  675.5,
  674.5,
  674,
  673.5,
  672.5,
  672,
  671,
  670.5,
  670,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663.5,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  655,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  655,
  655,
  655,
  655,
  655,
  655,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  663,
  663,
  663,
  663,
  663,
  663,
  662.5,
  662.5,
  662.5,
  662.5,
  662.5,
  662,
  662,
  662,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667.5,
  668,
  668.5,
  669,
  669,
  669.5,
  670,
  670,
  670.5,
  670.5,
  671,
  671,
  671.5,
  671.5,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683,
];
a[102] = [
  680,
  679.5,
  679,
  678.5,
  678,
  677,
  676.5,
  676,
  675,
  674.5,
  673.5,
  673,
  672.5,
  671.5,
  671,
  670.5,
  669.5,
  669,
  668,
  668,
  667.5,
  666.5,
  666.5,
  666,
  665,
  665,
  664,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  655,
  655,
  655,
  655,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662.5,
  662.5,
  662.5,
  662.5,
  662,
  662,
  662,
  662,
  662,
  662,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  665,
  665,
  665.5,
  666.5,
  667,
  667,
  668,
  668,
  668.5,
  669,
  669.5,
  670,
  670,
  670.5,
  671,
  671,
  671.5,
  671.5,
  672,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
];
a[101] = [
  679,
  679,
  678.5,
  677.5,
  677,
  676,
  676,
  675.5,
  674.5,
  674,
  673,
  672.5,
  672,
  671,
  670.5,
  670,
  669,
  668.5,
  667.5,
  667.5,
  667,
  666,
  666,
  665.5,
  664.5,
  664.5,
  663.5,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  655,
  655,
  655,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  662,
  661.5,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672,
  672.5,
  672.5,
  673,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
];
a[100] = [
  678.5,
  678,
  677.5,
  677,
  676.5,
  675.5,
  675.5,
  674.5,
  674,
  673.5,
  672.5,
  672,
  671.5,
  670.5,
  670,
  669.5,
  668.5,
  668,
  667,
  666.5,
  666,
  665.5,
  665.5,
  665,
  664,
  664,
  663,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654,
  654,
  654,
  654,
  654,
  654,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  654,
  654,
  654,
  654,
  654,
  654.5,
  654.5,
  654.5,
  654.5,
  655,
  655,
  655,
  655.5,
  655.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  661.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  671.5,
  672,
  672,
  672.5,
  672.5,
  673,
  673,
  673,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
];
a[99] = [
  677.5,
  677.5,
  677,
  676,
  675.5,
  675,
  674.5,
  674,
  673,
  672.5,
  671.5,
  671,
  670.5,
  669.5,
  669,
  668.5,
  667.5,
  667,
  666,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656,
  656,
  656,
  655.5,
  655.5,
  655,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654.5,
  654,
  654,
  654,
  654,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  654,
  654,
  654,
  654,
  654.5,
  654.5,
  654.5,
  655,
  655,
  655.5,
  655.5,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668,
  669,
  669.5,
  670,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672,
  672.5,
  672.5,
  673,
  673,
  673,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
];
a[98] = [
  677,
  676.5,
  676,
  675.5,
  675,
  674,
  674,
  673.5,
  672.5,
  672,
  671,
  670.5,
  670,
  669,
  668.5,
  668,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654,
  654,
  654,
  654,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653,
  653.5,
  653.5,
  653.5,
  653.5,
  654,
  654,
  654,
  654.5,
  654.5,
  654.5,
  655,
  655.5,
  655.5,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668.5,
  668.5,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
];
a[97] = [
  676.5,
  676,
  675.5,
  675,
  674.5,
  674,
  673.5,
  672.5,
  672,
  671.5,
  670.5,
  670,
  669.5,
  668.5,
  668,
  667.5,
  667,
  666,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654,
  654,
  654,
  654,
  653.5,
  653.5,
  653.5,
  653.5,
  653,
  653,
  653,
  653,
  653,
  653,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  653,
  653,
  653,
  653,
  653,
  653.5,
  653.5,
  653.5,
  654,
  654,
  654,
  654.5,
  654.5,
  655,
  655,
  655.5,
  655.5,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  669,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673,
  673.5,
  673.5,
  673.5,
  674,
  674,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
];
a[96] = [
  675.5,
  675.5,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671,
  670.5,
  669.5,
  669.5,
  669,
  668,
  667.5,
  667,
  666,
  665.5,
  664.5,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654,
  654,
  654,
  653.5,
  653.5,
  653.5,
  653.5,
  653,
  653,
  653,
  653,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  653,
  653,
  653,
  653,
  653.5,
  653.5,
  654,
  654,
  654.5,
  654.5,
  655,
  655,
  655.5,
  655.5,
  656,
  656,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  673.5,
  674,
  674,
  674,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
];
a[95] = [
  675,
  674.5,
  674,
  673.5,
  673,
  672.5,
  672,
  671.5,
  670.5,
  670,
  669,
  669,
  668.5,
  667.5,
  667,
  666.5,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654,
  654,
  654,
  653.5,
  653.5,
  653.5,
  653,
  653,
  653,
  653,
  652.5,
  652.5,
  652.5,
  652.5,
  652.5,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652.5,
  652.5,
  652.5,
  653,
  653,
  653,
  653.5,
  653.5,
  654,
  654,
  654.5,
  654.5,
  655,
  655.5,
  655.5,
  656,
  656,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660,
  660,
  660,
  660,
  659.5,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672.5,
  672.5,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686,
  686.5,
];
a[94] = [
  674,
  674,
  673.5,
  673,
  672.5,
  671.5,
  671,
  670.5,
  670,
  669.5,
  668.5,
  668,
  667.5,
  666.5,
  666.5,
  665.5,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654,
  654,
  653.5,
  653.5,
  653.5,
  653,
  653,
  653,
  652.5,
  652.5,
  652.5,
  652.5,
  652,
  652,
  652,
  652,
  652,
  652,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  652,
  652,
  652,
  652,
  652.5,
  652.5,
  652.5,
  653,
  653.5,
  653.5,
  653.5,
  654,
  654.5,
  655,
  655,
  655.5,
  655.5,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659.5,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  668,
  668,
  668.5,
  669,
  669.5,
  670,
  670,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  686.5,
  687,
];
a[93] = [
  673.5,
  673.5,
  673,
  672.5,
  672,
  671,
  670.5,
  670,
  669,
  669,
  668,
  667.5,
  667,
  666,
  666,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657.5,
  657,
  656.5,
  656.5,
  656,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654,
  654,
  654,
  653.5,
  653.5,
  653,
  653,
  653,
  652.5,
  652.5,
  652.5,
  652.5,
  652,
  652,
  652,
  652,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651.5,
  651.5,
  651.5,
  651.5,
  652,
  652,
  652,
  652.5,
  652.5,
  653,
  653,
  653.5,
  654,
  654,
  654.5,
  655,
  655,
  655.5,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  664.5,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  667,
  667,
  667.5,
  668,
  668,
  668.5,
  669,
  669.5,
  670,
  670,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672.5,
  673,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  674.5,
  675,
  675,
  675,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
];
a[92] = [
  673,
  673,
  672.5,
  672,
  671,
  670.5,
  670,
  669.5,
  668.5,
  668.5,
  667.5,
  667,
  666.5,
  665.5,
  665.5,
  665,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  659,
  658.5,
  658,
  657.5,
  657,
  657,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654,
  654,
  653.5,
  653.5,
  653,
  653,
  653,
  652.5,
  652.5,
  652.5,
  652,
  652,
  652,
  652,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651.5,
  651.5,
  651.5,
  652,
  652,
  652.5,
  652.5,
  653,
  653,
  653.5,
  654,
  654,
  654.5,
  655,
  655.5,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  659,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664,
  664.5,
  664.5,
  665,
  665,
  665,
  665.5,
  665.5,
  666,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  669,
  669.5,
  670,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672.5,
  673,
  673,
  673.5,
  673.5,
  674,
  674.5,
  674.5,
  674.5,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
];
a[91] = [
  672.5,
  672,
  671.5,
  671,
  670.5,
  669.5,
  669.5,
  669,
  668,
  667.5,
  667,
  666.5,
  666,
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658.5,
  658,
  657.5,
  657,
  656.5,
  656.5,
  656,
  655.5,
  655.5,
  655,
  655,
  654.5,
  654,
  654,
  654,
  653.5,
  653.5,
  653,
  653,
  652.5,
  652.5,
  652.5,
  652,
  652,
  652,
  651.5,
  651.5,
  651.5,
  651.5,
  651,
  651,
  651,
  651,
  651,
  651,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650,
  650,
  650,
  650,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  651,
  651,
  651,
  651.5,
  651.5,
  652,
  652,
  652.5,
  652.5,
  653,
  653.5,
  654,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  671.5,
  672.5,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
];
a[90] = [
  671.5,
  671.5,
  671,
  670.5,
  670,
  669,
  669,
  668.5,
  667.5,
  667,
  666.5,
  666,
  665.5,
  664.5,
  664.5,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  658,
  657.5,
  657,
  656.5,
  656,
  656,
  655.5,
  655,
  655,
  654.5,
  654.5,
  654,
  654,
  653.5,
  653.5,
  653,
  653,
  652.5,
  652.5,
  652.5,
  652,
  652,
  652,
  651.5,
  651.5,
  651.5,
  651,
  651,
  651,
  651,
  651,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650.5,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650.5,
  650.5,
  650.5,
  651,
  651,
  651,
  651.5,
  652,
  652,
  652.5,
  652.5,
  653,
  653.5,
  654,
  654,
  655,
  655,
  655.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669.5,
  670,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675,
  675.5,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688,
];
a[89] = [
  671,
  671,
  670.5,
  670,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  665.5,
  665.5,
  665,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  657,
  656.5,
  656,
  655.5,
  655.5,
  655,
  654.5,
  654.5,
  654,
  654,
  653.5,
  653.5,
  653,
  653,
  652.5,
  652.5,
  652,
  652,
  652,
  651.5,
  651.5,
  651.5,
  651,
  651,
  651,
  651,
  650.5,
  650.5,
  650.5,
  650.5,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  650,
  650,
  650,
  650,
  650.5,
  650.5,
  651,
  651,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  653.5,
  654,
  654.5,
  655,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658.5,
  658.5,
  658.5,
  658.5,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  666.5,
  667,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668.5,
  669,
  669,
  669.5,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  688.5,
];
a[88] = [
  670.5,
  670.5,
  670,
  669.5,
  669,
  668,
  667.5,
  667,
  666.5,
  666,
  665,
  665,
  664.5,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  657,
  656.5,
  656,
  655.5,
  655,
  655,
  654.5,
  654,
  654,
  653.5,
  653.5,
  653,
  653,
  652.5,
  652.5,
  652,
  652,
  652,
  651.5,
  651.5,
  651.5,
  651,
  651,
  651,
  650.5,
  650.5,
  650.5,
  650.5,
  650,
  650,
  650,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649.5,
  649.5,
  649.5,
  649.5,
  650,
  650,
  650,
  650.5,
  650.5,
  651,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653,
  653.5,
  654,
  654.5,
  655,
  655,
  655,
  655,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662,
  662.5,
  662.5,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  670,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  688.5,
  689,
  689,
];
a[87] = [
  670,
  670,
  669.5,
  669,
  668.5,
  667.5,
  667,
  666.5,
  666,
  665.5,
  664.5,
  664.5,
  664,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  656.5,
  656.5,
  656,
  655.5,
  655.5,
  655,
  654.5,
  654,
  654,
  653.5,
  653.5,
  653,
  653,
  652.5,
  652.5,
  652,
  652,
  651.5,
  651.5,
  651.5,
  651,
  651,
  651,
  650.5,
  650.5,
  650.5,
  650,
  650,
  650,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  648.5,
  648.5,
  648.5,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  649.5,
  649.5,
  650,
  650,
  650.5,
  650.5,
  651,
  651,
  651.5,
  652,
  652.5,
  652.5,
  653,
  653.5,
  654,
  654,
  654.5,
  654.5,
  655,
  655,
  655,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  658,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667,
  667.5,
  667.5,
  668,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  676,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689,
  689.5,
];
a[86] = [
  669.5,
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  656.5,
  656,
  656,
  655.5,
  655,
  654.5,
  654,
  654,
  653.5,
  653,
  653,
  653,
  652.5,
  652,
  652,
  652,
  651.5,
  651.5,
  651,
  651,
  651,
  650.5,
  650.5,
  650.5,
  650,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649,
  649,
  649,
  649,
  649,
  649,
  649,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648,
  648,
  648,
  648,
  648,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  649,
  649,
  649.5,
  649.5,
  650,
  650,
  650.5,
  651,
  651.5,
  651.5,
  652,
  652.5,
  652.5,
  653,
  653.5,
  653.5,
  654,
  654,
  654.5,
  654.5,
  655,
  655,
  655,
  655.5,
  655.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  671,
  671,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  674.5,
  675,
  675.5,
  675.5,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  689.5,
];
a[85] = [
  669,
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  665.5,
  664.5,
  664.5,
  663.5,
  663.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659,
  659,
  658.5,
  658,
  657.5,
  657,
  656.5,
  656,
  655.5,
  655.5,
  655,
  654.5,
  654,
  653.5,
  653.5,
  653,
  653,
  652.5,
  652.5,
  652,
  652,
  651.5,
  651.5,
  651,
  651,
  651,
  650.5,
  650.5,
  650,
  650,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649.5,
  649,
  649,
  649,
  649,
  649,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648.5,
  648.5,
  648.5,
  649,
  649,
  649.5,
  649.5,
  650,
  650,
  650.5,
  651,
  651.5,
  652,
  652,
  652.5,
  653,
  653,
  653.5,
  653.5,
  654,
  654,
  654.5,
  654.5,
  655,
  655,
  655.5,
  655.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676.5,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
];
a[84] = [
  668.5,
  668,
  667.5,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663,
  663,
  662.5,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  656.5,
  656,
  655.5,
  655,
  655,
  654.5,
  654,
  654,
  653.5,
  653,
  653,
  652.5,
  652,
  652,
  651.5,
  651.5,
  651,
  651,
  651,
  650.5,
  650.5,
  650,
  650,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649,
  649,
  649,
  649,
  649,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  648,
  648,
  648,
  648.5,
  648.5,
  649,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651,
  651.5,
  652,
  652.5,
  652.5,
  653,
  653,
  653.5,
  654,
  654,
  654.5,
  654.5,
  655,
  655,
  655.5,
  655.5,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670,
  670.5,
  670.5,
  671,
  671,
  671.5,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  674.5,
  675,
  675.5,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
];
a[83] = [
  667.5,
  667.5,
  667,
  666.5,
  666,
  665,
  665,
  664.5,
  663.5,
  663.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658,
  658,
  657.5,
  656.5,
  656.5,
  656,
  655.5,
  655,
  654.5,
  654.5,
  654,
  653.5,
  653,
  652.5,
  652.5,
  652,
  652,
  651.5,
  651.5,
  651,
  651,
  650.5,
  650.5,
  650,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649,
  649,
  649,
  649,
  648.5,
  648.5,
  648.5,
  648.5,
  648.5,
  648,
  648,
  648,
  648,
  648,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647.5,
  647.5,
  647.5,
  648,
  648,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651,
  651.5,
  652,
  652.5,
  652.5,
  653,
  653,
  653.5,
  654,
  654,
  654.5,
  655,
  655,
  655.5,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657.5,
  657.5,
  657.5,
  657.5,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  668,
  668,
  668.5,
  669,
  669,
  669,
  669.5,
  670,
  670,
  670.5,
  670.5,
  671,
  671,
  671.5,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  674.5,
  675,
  675,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  690.5,
  691,
];
a[82] = [
  667.5,
  667,
  666.5,
  666,
  665.5,
  665,
  664.5,
  664,
  663,
  663,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  656.5,
  656,
  655.5,
  655,
  654.5,
  654,
  654,
  653.5,
  653,
  652.5,
  652.5,
  652,
  652,
  651.5,
  651,
  651,
  650.5,
  650.5,
  650.5,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649,
  649,
  649,
  649,
  648.5,
  648.5,
  648.5,
  648.5,
  648,
  648,
  648,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  647,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651.5,
  652,
  652,
  652.5,
  653,
  653,
  653.5,
  653.5,
  654,
  654.5,
  655,
  655,
  655.5,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  669,
  669,
  669.5,
  669.5,
  670,
  670,
  670.5,
  671,
  671,
  671.5,
  671.5,
  672,
  672,
  672.5,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  674.5,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691,
];
a[81] = [
  666.5,
  666.5,
  666,
  665.5,
  665,
  664,
  664,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657,
  657,
  656.5,
  655.5,
  655.5,
  655,
  654.5,
  654,
  653.5,
  653,
  653,
  652.5,
  652,
  651.5,
  651.5,
  651,
  651,
  650.5,
  650.5,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649,
  649,
  649,
  648.5,
  648.5,
  648.5,
  648.5,
  648,
  648,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653,
  653.5,
  654,
  654.5,
  655,
  655.5,
  655.5,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657,
  657,
  657,
  657,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  656,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667.5,
  668,
  668,
  668.5,
  669,
  669,
  669.5,
  670,
  670,
  670.5,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672,
  672.5,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  674.5,
  675,
  675,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  691.5,
];
a[80] = [
  666,
  666,
  665.5,
  665,
  664.5,
  663.5,
  663.5,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  657.5,
  657.5,
  656.5,
  656.5,
  656,
  655,
  655,
  654.5,
  654,
  653.5,
  653,
  653,
  652.5,
  652,
  651.5,
  651,
  651,
  650.5,
  650.5,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649,
  649,
  649,
  648.5,
  648.5,
  648.5,
  648,
  648,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  650,
  650.5,
  650.5,
  651,
  651.5,
  652,
  652.5,
  652.5,
  653,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  656.5,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  655.5,
  655.5,
  655.5,
  655,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663.5,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  665.5,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  669,
  669,
  669.5,
  670,
  670,
  670.5,
  671,
  671,
  671.5,
  671.5,
  672,
  672,
  672.5,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  691.5,
  692,
  692,
];
a[79] = [
  665.5,
  665.5,
  665,
  664.5,
  664,
  663,
  663,
  662.5,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  656,
  656,
  655.5,
  655,
  654.5,
  654,
  653.5,
  653,
  652.5,
  652.5,
  652,
  651.5,
  651,
  651,
  650.5,
  650.5,
  650,
  650,
  649.5,
  649.5,
  649,
  649,
  649,
  648.5,
  648.5,
  648.5,
  648,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  645,
  645,
  645,
  645,
  645,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651.5,
  652,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  655,
  656,
  656,
  656,
  656,
  656,
  656,
  656,
  656.5,
  656.5,
  656.5,
  656.5,
  656,
  656,
  656,
  656,
  656,
  655.5,
  655.5,
  655,
  655,
  655,
  654.5,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655,
  655.5,
  655.5,
  655.5,
  656,
  656,
  656,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  669,
  669,
  669.5,
  670,
  670,
  670.5,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673,
  673.5,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692,
  692.5,
];
a[78] = [
  665,
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658,
  658,
  657.5,
  656.5,
  656.5,
  655.5,
  655.5,
  655,
  654,
  654,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651.5,
  651,
  650.5,
  650,
  650,
  649.5,
  649.5,
  649,
  649,
  649,
  648.5,
  648.5,
  648,
  648,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  644.5,
  644.5,
  645,
  645.5,
  646,
  646,
  646.5,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649.5,
  650,
  650.5,
  650.5,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  655,
  655,
  655,
  655,
  655,
  655,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655.5,
  655,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  655,
  655,
  655,
  655.5,
  655.5,
  656,
  656,
  656.5,
  656.5,
  657,
  657,
  657.5,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667.5,
  668,
  668,
  668.5,
  669,
  669,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  692.5,
  693,
];
a[77] = [
  664.5,
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  656,
  656,
  655,
  655,
  654.5,
  653.5,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651,
  651,
  650.5,
  650,
  650,
  649.5,
  649.5,
  649,
  649,
  648.5,
  648.5,
  648,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644.5,
  645,
  645.5,
  645.5,
  646,
  646.5,
  647,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  650,
  651,
  651,
  651.5,
  652,
  652.5,
  653,
  653.5,
  653.5,
  654,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  654.5,
  655,
  655,
  655,
  654.5,
  654.5,
  654.5,
  654.5,
  654,
  654,
  654,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  653.5,
  654,
  654,
  654,
  654.5,
  654.5,
  654.5,
  655,
  655,
  655.5,
  655.5,
  656,
  656,
  656.5,
  656.5,
  657,
  657,
  657.5,
  658,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  663.5,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  669.5,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
];
a[76] = [
  664,
  663.5,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  656.5,
  656,
  655.5,
  655,
  654.5,
  654,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651,
  651,
  650.5,
  650,
  649.5,
  649.5,
  649,
  649,
  648.5,
  648.5,
  648,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644.5,
  645,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651.5,
  652,
  652.5,
  652.5,
  653,
  653.5,
  653.5,
  653.5,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  654,
  653.5,
  653.5,
  653.5,
  653,
  653,
  653,
  652.5,
  652.5,
  652.5,
  652.5,
  653,
  653,
  653,
  653,
  653.5,
  653.5,
  654,
  654,
  654.5,
  654.5,
  655,
  655,
  655.5,
  655.5,
  655.5,
  656,
  656.5,
  656.5,
  657,
  657,
  657.5,
  658,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  667,
  667,
  667.5,
  668,
  668.5,
  668.5,
  669,
  669.5,
  670,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693,
  693.5,
  693.5,
];
a[75] = [
  663,
  663,
  662.5,
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  658,
  658,
  657.5,
  656.5,
  656.5,
  656,
  655,
  655,
  654,
  654,
  653.5,
  652.5,
  652.5,
  652,
  651.5,
  651,
  650.5,
  650,
  650,
  649.5,
  649,
  648.5,
  648.5,
  648,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644.5,
  644.5,
  645,
  645.5,
  646,
  646.5,
  646.5,
  647.5,
  647.5,
  648,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651.5,
  651.5,
  652,
  652,
  652.5,
  652.5,
  652.5,
  653,
  653,
  653,
  653,
  653,
  653,
  652.5,
  652.5,
  652.5,
  652.5,
  652,
  652,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  651.5,
  652,
  652,
  652.5,
  652.5,
  652.5,
  653,
  653,
  653.5,
  654,
  654,
  654.5,
  654.5,
  655,
  655.5,
  655.5,
  656,
  656.5,
  656.5,
  657,
  657.5,
  657.5,
  658,
  658.5,
  659,
  659,
  659.5,
  660,
  660.5,
  660.5,
  660.5,
  661.5,
  662,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672,
  672,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  674.5,
  675,
  675.5,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
];
a[74] = [
  662.5,
  662.5,
  662,
  661.5,
  660.5,
  660,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  656.5,
  656,
  655.5,
  654.5,
  654.5,
  653.5,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651,
  650.5,
  650,
  649.5,
  649.5,
  649,
  648.5,
  648.5,
  648,
  648,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  644,
  644,
  644.5,
  645,
  645.5,
  646,
  646,
  647,
  647,
  647.5,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650.5,
  650.5,
  651,
  651.5,
  651.5,
  651.5,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  652,
  651.5,
  651.5,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  651.5,
  651.5,
  652,
  652,
  652.5,
  652.5,
  653,
  653.5,
  653.5,
  654,
  654.5,
  654.5,
  655,
  655.5,
  655.5,
  656,
  656.5,
  656.5,
  657,
  657.5,
  658,
  658,
  658.5,
  659,
  659.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694,
];
a[73] = [
  662,
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  659,
  658,
  658,
  657,
  657,
  656.5,
  655.5,
  655.5,
  655,
  654,
  654,
  653,
  653,
  652.5,
  651.5,
  651.5,
  651,
  650.5,
  650,
  649.5,
  649,
  648.5,
  648,
  648,
  647.5,
  647.5,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  644,
  644,
  644.5,
  645,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650,
  650.5,
  650.5,
  650.5,
  651,
  651,
  651,
  651,
  651,
  651,
  651,
  650.5,
  650.5,
  650.5,
  650,
  650,
  649.5,
  649.5,
  649.5,
  649.5,
  650,
  650,
  650,
  650.5,
  650.5,
  651,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653,
  653.5,
  654,
  654.5,
  655,
  655,
  655.5,
  656,
  656.5,
  656.5,
  657,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  663.5,
  664,
  664.5,
  665,
  665,
  666,
  666,
  666.5,
  667,
  667.5,
  668,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  674.5,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
];
a[72] = [
  661.5,
  660.5,
  660.5,
  660,
  659.5,
  659,
  659,
  658.5,
  657.5,
  657.5,
  656.5,
  656.5,
  656,
  655,
  655,
  654.5,
  653.5,
  653.5,
  652.5,
  652.5,
  652,
  651.5,
  651,
  650.5,
  650,
  649.5,
  649,
  648.5,
  648,
  647.5,
  647.5,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643.5,
  644,
  644,
  644.5,
  645,
  645.5,
  646,
  646,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  649.5,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  650,
  649.5,
  649.5,
  649,
  649,
  648.5,
  648.5,
  649,
  649,
  649.5,
  649.5,
  650,
  650,
  650.5,
  650.5,
  651,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654,
  655,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662,
  663,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  668.5,
  669.5,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  674.5,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
  695,
  695,
];
a[71] = [
  660.5,
  660.5,
  660,
  659.5,
  659.5,
  658.5,
  658.5,
  658,
  657,
  657,
  656,
  656,
  655.5,
  655,
  654.5,
  654,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651,
  650.5,
  650,
  649.5,
  649,
  648.5,
  648.5,
  648,
  647.5,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  643,
  643.5,
  643.5,
  644,
  644.5,
  645,
  645.5,
  645.5,
  646,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  648.5,
  649,
  649,
  649,
  649,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649.5,
  649,
  649,
  649,
  648.5,
  648.5,
  648,
  648,
  648,
  648,
  648.5,
  649,
  649,
  649.5,
  649.5,
  650,
  650.5,
  650.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654,
  655,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  662.5,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665.5,
  665.5,
  666,
  666.5,
  667,
  667.5,
  667.5,
  668,
  668.5,
  669,
  669,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
];
a[70] = [
  660,
  660,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  656.5,
  656.5,
  655.5,
  655.5,
  655,
  654,
  654,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651,
  650.5,
  650,
  649.5,
  649,
  648.5,
  648,
  647.5,
  647.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642.5,
  642.5,
  643,
  643.5,
  644,
  644.5,
  644.5,
  645,
  645.5,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  647.5,
  648,
  648,
  648,
  648,
  648,
  648.5,
  648.5,
  648.5,
  648.5,
  648,
  648,
  648,
  648,
  648,
  647.5,
  647.5,
  647,
  647,
  647,
  647,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  650,
  650,
  651,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  655,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
];
a[69] = [
  659.5,
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  657,
  656,
  656,
  655,
  655,
  654.5,
  654,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651,
  650.5,
  650,
  649.5,
  649.5,
  648.5,
  648.5,
  647.5,
  647.5,
  647,
  646.5,
  646,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642.5,
  643,
  643,
  643.5,
  644,
  644,
  644.5,
  645,
  645,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647,
  647,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647.5,
  647,
  647,
  647,
  646.5,
  646,
  646.5,
  646.5,
  647,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  650,
  651,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  655,
  655,
  655.5,
  656.5,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663,
  664,
  664.5,
  665,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667.5,
  667.5,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
];
a[68] = [
  659.5,
  659,
  658.5,
  658,
  657.5,
  657,
  657,
  656.5,
  656,
  655.5,
  655,
  654.5,
  654,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651,
  651,
  650.5,
  650,
  649.5,
  649,
  648.5,
  648,
  647.5,
  647,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  642,
  642,
  642.5,
  643,
  643.5,
  643.5,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646,
  646.5,
  646.5,
  646.5,
  646.5,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  647,
  646.5,
  646.5,
  646.5,
  646,
  646,
  646,
  646.5,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649.5,
  650,
  650.5,
  651,
  652,
  652.5,
  653,
  653.5,
  654,
  655,
  655,
  655.5,
  656.5,
  657,
  657,
  658,
  658.5,
  659,
  659.5,
  659.5,
  660.5,
  660.5,
  660.5,
  662,
  662,
  663,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668.5,
  668.5,
  669,
  669.5,
  670,
  670,
  670.5,
  671,
  671.5,
  672,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
];
a[67] = [
  658.5,
  658,
  658,
  657.5,
  657,
  656.5,
  656,
  655.5,
  655,
  655,
  654,
  654,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651,
  650.5,
  650.5,
  650,
  649,
  649,
  648.5,
  648,
  647.5,
  647,
  647,
  646.5,
  646,
  645.5,
  645.5,
  645,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642.5,
  642.5,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  650.5,
  651,
  652,
  652.5,
  653,
  653.5,
  654,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666,
  667,
  667,
  667.5,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  670.5,
  671.5,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
];
a[66] = [
  658,
  658,
  657.5,
  657,
  656.5,
  656,
  655.5,
  655.5,
  654.5,
  654.5,
  654,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651,
  651,
  650,
  650,
  649.5,
  649,
  648.5,
  648,
  647.5,
  647.5,
  646.5,
  646.5,
  646,
  645.5,
  645.5,
  645,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641.5,
  641.5,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  644.5,
  645,
  645,
  645,
  645,
  645,
  645,
  645,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  645.5,
  646,
  646,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  650.5,
  651,
  652,
  652.5,
  653,
  653.5,
  654,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659.5,
  660,
  660,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  664,
  665,
  665.5,
  666,
  666.5,
  666.5,
  667,
  667.5,
  667.5,
  668.5,
  669,
  669,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672.5,
  672.5,
  673,
  673.5,
  674,
  674,
  674.5,
  675,
  675,
  675.5,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
];
a[65] = [
  657.5,
  657,
  656.5,
  656.5,
  656,
  655.5,
  655,
  654.5,
  654,
  654,
  653,
  653,
  652.5,
  652,
  651.5,
  651,
  650.5,
  650.5,
  650,
  649.5,
  649,
  648.5,
  648,
  648,
  647.5,
  647,
  646.5,
  646,
  646,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641.5,
  641.5,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644,
  644,
  644,
  644,
  644,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  644.5,
  645,
  645,
  645,
  645,
  645,
  645,
  645.5,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  650.5,
  651,
  652,
  652.5,
  653,
  654,
  654.5,
  655,
  655.5,
  656,
  657,
  657,
  657.5,
  658.5,
  659,
  659.5,
  660,
  660.5,
  661.5,
  661.5,
  662,
  663,
  663.5,
  664,
  664.5,
  664.5,
  665.5,
  665.5,
  666.5,
  666.5,
  667,
  667.5,
  668,
  668,
  669,
  669,
  669.5,
  670,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678,
  678,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697,
];
a[64] = [
  657,
  656.5,
  656.5,
  656,
  655.5,
  655,
  654.5,
  654.5,
  653.5,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651.5,
  651,
  650.5,
  650,
  649.5,
  649,
  648.5,
  648,
  648,
  647.5,
  647,
  646.5,
  646,
  646,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644.5,
  644,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644,
  644,
  644,
  644.5,
  644.5,
  644.5,
  645,
  645,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  650.5,
  651,
  652,
  652.5,
  653,
  654,
  654.5,
  655,
  655.5,
  656,
  657,
  657.5,
  658,
  658.5,
  659,
  660,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668.5,
  668.5,
  669,
  669.5,
  670,
  670.5,
  671,
  671.5,
  671.5,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
];
a[63] = [
  656.5,
  656,
  656,
  655.5,
  655,
  654.5,
  654.5,
  654,
  653,
  653,
  652.5,
  652,
  652,
  651,
  651,
  650.5,
  650,
  649.5,
  649,
  649,
  648.5,
  648,
  647.5,
  647.5,
  646.5,
  646.5,
  646,
  646,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643,
  643,
  643,
  643,
  643,
  643,
  643,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644,
  644.5,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  651,
  651.5,
  652,
  652.5,
  653,
  654,
  654.5,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  659,
  659.5,
  660,
  660.5,
  660.5,
  662,
  662.5,
  662.5,
  663.5,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  667.5,
  668.5,
  668.5,
  669,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672,
  673,
  673,
  673.5,
  674,
  674,
  674.5,
  675,
  675.5,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  697.5,
];
a[62] = [
  656,
  655.5,
  655,
  655,
  654.5,
  654,
  653.5,
  653.5,
  652.5,
  652.5,
  652,
  651.5,
  651.5,
  650.5,
  650.5,
  650,
  649.5,
  649,
  648.5,
  648.5,
  648,
  647.5,
  647,
  647,
  646.5,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  646,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  651,
  651.5,
  652.5,
  653,
  653.5,
  654,
  654.5,
  655.5,
  656,
  656.5,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668,
  669,
  669,
  669.5,
  670,
  670.5,
  671,
  671,
  671.5,
  672,
  672.5,
  672.5,
  673.5,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
];
a[61] = [
  655.5,
  655,
  655,
  654.5,
  654,
  653.5,
  653.5,
  653,
  652.5,
  652,
  651.5,
  651.5,
  651,
  650.5,
  650,
  649.5,
  649,
  649,
  648.5,
  648,
  647.5,
  647,
  647,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  644.5,
  644.5,
  644,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643.5,
  643.5,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  646,
  646,
  647,
  647,
  648,
  648,
  648.5,
  649.5,
  650,
  650.5,
  651,
  651.5,
  652.5,
  653,
  653.5,
  654.5,
  655,
  655.5,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664.5,
  664.5,
  665.5,
  666,
  666,
  667,
  667.5,
  668,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670.5,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675.5,
  676,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
];
a[60] = [
  655,
  654.5,
  654,
  654,
  653.5,
  653,
  652.5,
  652.5,
  652,
  651.5,
  651,
  651,
  650.5,
  650,
  649.5,
  649,
  649,
  648.5,
  648,
  647.5,
  647.5,
  647,
  646.5,
  646.5,
  646,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  642,
  642,
  643,
  643,
  643.5,
  643.5,
  644,
  644.5,
  645,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  650.5,
  651.5,
  652,
  652.5,
  653,
  654,
  654.5,
  655,
  656,
  656.5,
  657,
  658,
  658.5,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662,
  663,
  663.5,
  664,
  664.5,
  665,
  666,
  666.5,
  666.5,
  667.5,
  667.5,
  668,
  668.5,
  669,
  669.5,
  670,
  670,
  671,
  671,
  671.5,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674.5,
  675,
  675,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  679,
  679,
  679,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  698.5,
  698.5,
];
a[59] = [
  654.5,
  654,
  654,
  653.5,
  653,
  652.5,
  652.5,
  652,
  651.5,
  651,
  650.5,
  650.5,
  650,
  649.5,
  649.5,
  649,
  648.5,
  648,
  647.5,
  647.5,
  647,
  646.5,
  646.5,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  643,
  643,
  643.5,
  644,
  644.5,
  645,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  651,
  651.5,
  652,
  653,
  653.5,
  654,
  655,
  655.5,
  656,
  656.5,
  657.5,
  658,
  658.5,
  659,
  660,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664,
  665,
  665.5,
  666,
  666.5,
  667,
  667.5,
  668,
  668.5,
  669,
  669,
  670,
  670.5,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675.5,
  675.5,
  676.5,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
];
a[58] = [
  654,
  654,
  653.5,
  653,
  652.5,
  652,
  652,
  651.5,
  651,
  651,
  650.5,
  650,
  649.5,
  649,
  649,
  648.5,
  648,
  648,
  647.5,
  647,
  647,
  646.5,
  646,
  646,
  645.5,
  645,
  644.5,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641.5,
  641.5,
  642,
  642,
  642.5,
  643,
  643,
  643.5,
  644,
  644.5,
  645,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  650,
  650.5,
  651,
  652,
  652.5,
  653,
  653.5,
  654,
  655,
  655.5,
  656.5,
  657,
  657.5,
  658.5,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663.5,
  664,
  664.5,
  665.5,
  666,
  666.5,
  667,
  667,
  668,
  668.5,
  669,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674,
  675,
  675,
  675.5,
  676,
  676,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699,
  699,
];
a[57] = [
  653.5,
  653,
  653,
  652.5,
  652,
  651.5,
  651.5,
  651,
  650.5,
  650.5,
  650,
  649.5,
  649,
  648.5,
  648.5,
  648,
  647.5,
  647.5,
  647,
  647,
  646.5,
  646,
  646,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642,
  642.5,
  643,
  643,
  643.5,
  644,
  644.5,
  645,
  645.5,
  646,
  646,
  646.5,
  647.5,
  647.5,
  648.5,
  649,
  649.5,
  650,
  650.5,
  651,
  652,
  652.5,
  653.5,
  654,
  654.5,
  655.5,
  656,
  657,
  657.5,
  658,
  658.5,
  659.5,
  660,
  660.5,
  660.5,
  662,
  662.5,
  663,
  664,
  664.5,
  665,
  665.5,
  666,
  667,
  667.5,
  667.5,
  668.5,
  668.5,
  669.5,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  673,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  699.5,
];
a[56] = [
  653,
  653,
  652.5,
  652,
  651.5,
  651,
  651,
  650.5,
  650,
  650,
  649.5,
  649.5,
  649,
  648.5,
  648,
  648,
  647.5,
  647,
  646.5,
  646.5,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642,
  642.5,
  643,
  643,
  643.5,
  644,
  644.5,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650.5,
  651,
  651.5,
  652.5,
  653,
  653.5,
  654,
  655,
  655.5,
  656,
  657,
  657.5,
  658,
  659,
  659.5,
  660,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665,
  666,
  666.5,
  667,
  667.5,
  668,
  668.5,
  669,
  669.5,
  670,
  670.5,
  671,
  671.5,
  671.5,
  672.5,
  672.5,
  673,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
];
a[55] = [
  652.5,
  652.5,
  652,
  651.5,
  651.5,
  651,
  650.5,
  650.5,
  650,
  649.5,
  649.5,
  649,
  648.5,
  648,
  648,
  647.5,
  647,
  647,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  643,
  643.5,
  644,
  644,
  644.5,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  649,
  649.5,
  650,
  650.5,
  651,
  651.5,
  652.5,
  653,
  654,
  654.5,
  655,
  656,
  656.5,
  657.5,
  658,
  658.5,
  659.5,
  660,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667.5,
  668,
  668.5,
  669,
  669.5,
  670,
  670.5,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  673.5,
  673.5,
  674,
  674.5,
  675,
  675.5,
  675.5,
  676,
  676.5,
  677,
  677,
  677.5,
  677.5,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700,
];
a[54] = [
  652,
  652,
  651.5,
  651,
  651,
  650.5,
  650,
  650,
  649.5,
  649,
  648.5,
  648.5,
  648,
  647.5,
  647.5,
  647,
  646.5,
  646.5,
  646,
  646,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642.5,
  642.5,
  643,
  643.5,
  644,
  644.5,
  645,
  645,
  645.5,
  646.5,
  646.5,
  647,
  648,
  648.5,
  649,
  649.5,
  650,
  651,
  651.5,
  652,
  653,
  653.5,
  654.5,
  655,
  655.5,
  656.5,
  657,
  658,
  658.5,
  659,
  660,
  660.5,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664,
  665,
  665.5,
  666,
  666.5,
  667,
  668,
  668.5,
  668.5,
  669.5,
  670,
  670.5,
  671,
  671,
  672,
  672,
  672.5,
  673,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675.5,
  675.5,
  676.5,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
];
a[53] = [
  651.5,
  651.5,
  651,
  651,
  650.5,
  650,
  650,
  649.5,
  649,
  649,
  648.5,
  648,
  648,
  647.5,
  647,
  647,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  643,
  643,
  643.5,
  644,
  644.5,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649.5,
  650,
  650.5,
  651,
  652,
  652.5,
  653,
  653.5,
  654.5,
  655,
  655.5,
  656.5,
  657,
  658,
  658.5,
  659,
  660,
  660.5,
  660.5,
  662,
  662.5,
  663.5,
  664,
  664.5,
  665.5,
  666,
  666,
  667,
  667.5,
  668,
  668.5,
  669,
  670,
  670,
  671,
  671,
  671.5,
  672,
  672.5,
  673,
  673.5,
  674,
  674.5,
  674.5,
  675,
  675.5,
  676,
  676,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678.5,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  700.5,
  700.5,
];
a[52] = [
  651,
  651,
  650.5,
  650.5,
  650,
  649.5,
  649.5,
  649,
  648.5,
  648.5,
  648,
  647.5,
  647.5,
  647,
  646.5,
  646.5,
  646,
  646,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  643,
  643.5,
  643.5,
  644,
  644.5,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648.5,
  649,
  649.5,
  650,
  650.5,
  651.5,
  652,
  652.5,
  653.5,
  654,
  655,
  655.5,
  656,
  657,
  657.5,
  658.5,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662.5,
  663,
  664,
  664.5,
  665,
  665.5,
  666,
  666.5,
  667.5,
  668,
  668.5,
  669,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  673.5,
  674,
  674.5,
  675,
  675,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678,
  678.5,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701,
];
a[51] = [
  650.5,
  650.5,
  650,
  650,
  649.5,
  649,
  649,
  648.5,
  648,
  648,
  647.5,
  647.5,
  647,
  646.5,
  646.5,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643.5,
  644,
  644.5,
  645,
  645.5,
  646,
  646,
  647,
  647.5,
  648,
  648.5,
  649,
  650,
  650.5,
  651,
  652,
  652.5,
  653,
  654,
  654.5,
  655.5,
  656,
  656.5,
  657.5,
  658,
  659,
  659.5,
  660,
  660.5,
  661.5,
  662,
  663,
  663.5,
  664,
  664.5,
  665,
  666,
  666.5,
  667,
  668,
  668.5,
  669,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672,
  672,
  673,
  673.5,
  673.5,
  674.5,
  674.5,
  675,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678.5,
  678.5,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
];
a[50] = [
  650.5,
  650,
  650,
  649.5,
  649,
  649,
  648.5,
  648.5,
  648,
  647.5,
  647,
  647,
  647,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  643,
  643.5,
  643.5,
  644,
  644.5,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  649,
  649.5,
  650,
  650.5,
  651.5,
  652,
  652.5,
  653.5,
  654,
  654.5,
  655.5,
  656.5,
  657,
  658,
  658.5,
  659.5,
  660,
  660.5,
  661.5,
  662,
  662.5,
  663,
  664,
  664.5,
  665,
  665.5,
  666.5,
  667,
  667.5,
  668,
  668.5,
  669.5,
  670,
  670,
  671,
  671.5,
  672,
  672.5,
  672.5,
  673.5,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676,
  676,
  676.5,
  677,
  677,
  677.5,
  678,
  678.5,
  678.5,
  679,
  679.5,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  701.5,
];
a[49] = [
  650,
  649.5,
  649.5,
  649,
  648.5,
  648.5,
  648,
  648,
  647.5,
  647,
  647,
  646.5,
  646.5,
  646,
  646,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  644,
  644,
  645,
  645,
  646,
  646,
  646.5,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650.5,
  651,
  651.5,
  652.5,
  653,
  653.5,
  654.5,
  655,
  656,
  656.5,
  657,
  658,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664,
  665,
  665.5,
  666,
  667,
  667.5,
  668,
  668.5,
  669,
  670,
  670,
  670.5,
  671.5,
  672,
  672.5,
  673,
  673,
  674,
  674,
  674.5,
  675,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677.5,
  677.5,
  678,
  678.5,
  679,
  679,
  679,
  679.5,
  680,
  680,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
];
a[48] = [
  649.5,
  649.5,
  649,
  648.5,
  648.5,
  648,
  648,
  647.5,
  647,
  647,
  646.5,
  646.5,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  643,
  643.5,
  644,
  644,
  644.5,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649.5,
  650,
  651,
  651.5,
  652,
  653,
  653.5,
  654,
  655,
  655.5,
  656.5,
  657,
  657.5,
  658.5,
  659,
  660,
  660.5,
  660.5,
  662,
  662.5,
  663,
  664,
  664.5,
  665.5,
  666,
  666.5,
  667,
  668,
  668,
  669,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672,
  673,
  673,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676,
  676.5,
  676.5,
  677,
  677.5,
  678,
  678,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  702,
  702,
  703,
];
a[47] = [
  649,
  649,
  648.5,
  648.5,
  648,
  647.5,
  647.5,
  647,
  647,
  646.5,
  646,
  646,
  646,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  644,
  644.5,
  644.5,
  645,
  645.5,
  646,
  646.5,
  647,
  648,
  648.5,
  649,
  649.5,
  650,
  651,
  651.5,
  652,
  653,
  654,
  654.5,
  655.5,
  656,
  657,
  657.5,
  658,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664.5,
  665,
  666,
  666.5,
  666.5,
  667.5,
  668,
  668.5,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  673.5,
  674,
  674.5,
  675,
  675,
  676,
  676,
  676.5,
  677,
  677.5,
  678,
  678,
  678.5,
  679,
  679,
  679.5,
  679.5,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
];
a[46] = [
  648.5,
  648.5,
  648,
  648,
  647.5,
  647,
  647,
  646.5,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644.5,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  650,
  650.5,
  651.5,
  652,
  652.5,
  653.5,
  654,
  654.5,
  655.5,
  656.5,
  657.5,
  658,
  658.5,
  659.5,
  660,
  660.5,
  661.5,
  662,
  663,
  663.5,
  664,
  665,
  665.5,
  666.5,
  667,
  667,
  668,
  668.5,
  669,
  670,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  673.5,
  674,
  674.5,
  675,
  675.5,
  675.5,
  676.5,
  676.5,
  677,
  677.5,
  678,
  678,
  678.5,
  678.5,
  679,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
];
a[45] = [
  648.5,
  648,
  648,
  647.5,
  647.5,
  647,
  646.5,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  644.5,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  644,
  644.5,
  644.5,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648.5,
  649,
  649.5,
  650,
  651,
  651.5,
  652.5,
  653,
  654,
  654.5,
  655,
  656,
  656.5,
  657.5,
  658.5,
  659,
  660,
  660.5,
  661.5,
  662,
  662.5,
  663.5,
  664,
  664.5,
  665.5,
  666,
  666.5,
  667.5,
  667.5,
  668.5,
  669,
  669.5,
  670,
  670.5,
  671.5,
  672,
  672,
  673,
  673.5,
  674,
  674.5,
  674.5,
  675.5,
  676,
  676,
  676.5,
  677,
  677.5,
  678,
  678,
  678.5,
  679,
  679,
  679.5,
  680,
  680,
  680.5,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  703.5,
  703.5,
];
a[44] = [
  648,
  647.5,
  647.5,
  647,
  647,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  644,
  644,
  644.5,
  645,
  645,
  646,
  646,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650.5,
  651,
  652,
  652.5,
  653.5,
  654.5,
  655,
  655.5,
  656.5,
  657,
  658,
  659,
  659.5,
  660.5,
  660.5,
  662,
  662.5,
  663,
  664,
  664.5,
  665,
  666,
  666.5,
  667,
  667.5,
  668,
  669,
  669.5,
  670,
  670.5,
  671,
  672,
  672.5,
  672.5,
  673.5,
  674,
  674.5,
  675,
  675,
  676,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  678.5,
  679,
  679.5,
  679.5,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  684,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704,
];
a[43] = [
  647.5,
  647.5,
  647,
  647,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643.5,
  643.5,
  644,
  644.5,
  645,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  649,
  649.5,
  650,
  651,
  651.5,
  652.5,
  653,
  653.5,
  654.5,
  655.5,
  656,
  657,
  657.5,
  658.5,
  659.5,
  660,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664.5,
  665,
  665.5,
  666.5,
  667,
  667.5,
  668,
  668.5,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672.5,
  672.5,
  673,
  674,
  674,
  675,
  675.5,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  678.5,
  679,
  679.5,
  679.5,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704,
  704,
  704,
  704.5,
];
a[42] = [
  647,
  647,
  646.5,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644.5,
  645,
  645.5,
  645.5,
  646,
  646.5,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  651,
  651.5,
  652.5,
  653.5,
  654,
  655,
  655.5,
  656.5,
  657.5,
  658,
  659,
  660,
  660,
  661.5,
  662,
  663,
  663.5,
  664,
  665,
  665.5,
  666,
  667,
  667.5,
  668,
  668.5,
  669,
  670,
  670.5,
  670.5,
  671.5,
  672,
  672.5,
  673,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677,
  677,
  678,
  678,
  678.5,
  679,
  679.5,
  680,
  680,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  704.5,
];
a[41] = [
  646.5,
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649.5,
  650,
  650.5,
  651.5,
  652,
  653,
  653.5,
  654.5,
  655.5,
  656,
  657,
  658,
  658.5,
  659.5,
  660.5,
  660.5,
  662,
  662.5,
  663.5,
  664,
  664.5,
  665.5,
  666,
  666.5,
  667.5,
  668,
  668.5,
  669,
  669.5,
  670.5,
  671,
  671,
  672,
  672.5,
  673,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  678.5,
  679,
  679.5,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705,
];
a[40] = [
  646.5,
  646,
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  644,
  644,
  644,
  644.5,
  645,
  645.5,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649.5,
  650,
  650.5,
  651.5,
  652.5,
  653.5,
  654,
  654.5,
  656,
  656.5,
  657,
  658.5,
  659,
  660,
  660.5,
  661.5,
  662.5,
  663,
  664,
  664.5,
  665,
  666,
  666.5,
  667,
  668,
  668.5,
  669,
  669.5,
  670,
  671,
  671.5,
  671.5,
  672.5,
  673,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678,
  679,
  679,
  679.5,
  680,
  680.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705,
  705,
  705,
  705,
  705,
];
a[39] = [
  646,
  645.5,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  645,
  645,
  645.5,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650.5,
  651,
  652,
  652.5,
  653.5,
  654.5,
  655,
  656,
  657,
  657.5,
  659,
  659.5,
  660.5,
  661.5,
  662,
  663,
  663.5,
  664.5,
  665,
  665.5,
  666.5,
  667,
  667.5,
  668,
  669,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672,
  673,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  678.5,
  679.5,
  679.5,
  680,
  680.5,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  705.5,
  705.5,
  705.5,
  705.5,
  705.5,
];
a[38] = [
  645.5,
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645.5,
  646,
  646,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  650,
  650.5,
  651,
  652,
  653,
  654,
  654.5,
  655.5,
  656.5,
  657.5,
  658,
  659.5,
  660,
  660.5,
  662,
  662.5,
  663.5,
  664,
  665,
  665.5,
  666,
  667,
  667.5,
  668,
  668.5,
  669,
  670,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673.5,
  674,
  674.5,
  675,
  675,
  676,
  676.5,
  677,
  677.5,
  677.5,
  678.5,
  679,
  679,
  679.5,
  680,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706,
  706,
  706,
];
a[37] = [
  645.5,
  645,
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645.5,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647.5,
  648.5,
  649,
  649.5,
  650,
  651,
  651.5,
  652.5,
  653,
  654.5,
  655,
  656,
  657,
  658,
  658.5,
  660,
  660.5,
  661.5,
  662.5,
  663,
  664,
  664.5,
  665.5,
  666,
  666.5,
  667.5,
  668,
  668.5,
  669,
  669.5,
  670.5,
  671,
  671,
  672,
  672.5,
  673,
  674,
  674,
  675,
  675.5,
  675.5,
  676.5,
  677,
  677.5,
  678,
  678,
  679,
  679,
  679.5,
  680,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
];
a[36] = [
  645,
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650.5,
  651,
  651.5,
  652.5,
  653.5,
  654.5,
  655.5,
  656,
  657.5,
  658.5,
  659,
  660.5,
  660.5,
  662.5,
  663,
  663.5,
  664.5,
  665,
  666,
  666.5,
  667,
  668,
  668.5,
  669,
  669.5,
  670,
  671,
  671.5,
  672,
  672.5,
  673,
  673.5,
  674,
  674.5,
  675.5,
  676,
  676,
  677,
  677.5,
  678,
  678.5,
  678.5,
  679.5,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707,
];
a[35] = [
  644.5,
  644.5,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650.5,
  651,
  652,
  653,
  653.5,
  655,
  656,
  656.5,
  658,
  659,
  659.5,
  660.5,
  661.5,
  663,
  663.5,
  664,
  665,
  666,
  666.5,
  667,
  667.5,
  668.5,
  669,
  669.5,
  670,
  670.5,
  671.5,
  672,
  672,
  673,
  673.5,
  674,
  674.5,
  675,
  676,
  676,
  676.5,
  677.5,
  677.5,
  678.5,
  679,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707,
  707,
  707,
  707.5,
  707.5,
];
a[34] = [
  644,
  644,
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  649,
  649.5,
  650,
  650.5,
  651.5,
  652,
  653,
  654,
  655.5,
  656,
  657,
  658.5,
  659.5,
  660,
  661.5,
  662,
  663.5,
  664.5,
  664.5,
  666,
  666.5,
  667,
  667.5,
  668,
  669,
  669.5,
  669.5,
  670.5,
  671,
  672,
  672.5,
  672.5,
  673.5,
  674,
  674,
  675,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  680.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  707.5,
  707.5,
  707.5,
];
a[33] = [
  644,
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642.5,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648.5,
  649,
  649.5,
  650,
  651,
  651.5,
  652,
  653.5,
  654,
  655.5,
  656.5,
  657.5,
  659,
  660,
  660.5,
  662,
  663,
  664.5,
  665,
  665.5,
  666.5,
  667,
  667.5,
  668,
  668.5,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672.5,
  673,
  673,
  674,
  674.5,
  674.5,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708,
  708,
  708,
  708,
  708.5,
];
a[32] = [
  643.5,
  643.5,
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644,
  644.5,
  644.5,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  651,
  651.5,
  652.5,
  653.5,
  654.5,
  656,
  657,
  658,
  659.5,
  660.5,
  661.5,
  663,
  663.5,
  665,
  665.5,
  666,
  667,
  667.5,
  668,
  668.5,
  669,
  670,
  670.5,
  670.5,
  671.5,
  672,
  672.5,
  673,
  673.5,
  674.5,
  675,
  675,
  676,
  676.5,
  677,
  677.5,
  677.5,
  678.5,
  679,
  679.5,
  680,
  680,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  708.5,
  708.5,
  708.5,
  708.5,
];
a[31] = [
  643,
  643,
  642.5,
  642.5,
  642,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650,
  651,
  651.5,
  652.5,
  654,
  655,
  656.5,
  657.5,
  658.5,
  660,
  660.5,
  662,
  663.5,
  664.5,
  665.5,
  666.5,
  666.5,
  667.5,
  668,
  668.5,
  669,
  669.5,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676.5,
  677,
  677.5,
  678,
  678,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  683,
  683.5,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706.5,
  706.5,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709,
  709,
  709,
  709.5,
];
a[30] = [
  642.5,
  642.5,
  642.5,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651.5,
  652.5,
  654,
  655,
  656.5,
  657.5,
  658.5,
  660.5,
  661.5,
  662.5,
  664,
  665,
  666.5,
  667,
  667,
  668,
  668.5,
  669,
  669.5,
  670,
  671,
  671.5,
  671.5,
  672.5,
  673,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677,
  678,
  678.5,
  678.5,
  679.5,
  680,
  680.5,
  681,
  681,
  681.5,
  681.5,
  681.5,
  682.5,
  682.5,
  683,
  683.5,
  684,
  684,
  684.5,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706.5,
  706.5,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709,
  709,
  709.5,
  709.5,
  709.5,
  709.5,
  709.5,
];
a[29] = [
  642.5,
  642.5,
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650,
  650.5,
  650.5,
  651.5,
  652,
  653,
  654.5,
  655.5,
  657,
  658,
  659,
  660.5,
  662,
  663,
  664.5,
  665.5,
  666.5,
  667,
  667.5,
  668.5,
  669,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672,
  673,
  673.5,
  674,
  674.5,
  674.5,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  681,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  684,
  684,
  684.5,
  684.5,
  685,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709,
  709.5,
  709.5,
  709.5,
  709.5,
  710,
  710,
  710,
  710,
];
a[28] = [
  642,
  642,
  641.5,
  641.5,
  641.5,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  644.5,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651,
  651.5,
  652.5,
  653,
  653.5,
  655,
  656,
  657.5,
  658.5,
  659.5,
  660.5,
  662,
  663.5,
  665,
  665.5,
  667,
  667.5,
  668,
  668.5,
  669,
  670,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  673.5,
  674.5,
  675,
  675,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  684,
  684.5,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709,
  709.5,
  709.5,
  709.5,
  710,
  710,
  710,
  710.5,
  710.5,
  710.5,
  710.5,
  710.5,
];
a[27] = [
  641.5,
  641.5,
  641.5,
  641,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651.5,
  652,
  652,
  653,
  653.5,
  654,
  655.5,
  656.5,
  658,
  659,
  660,
  661.5,
  662.5,
  663.5,
  665,
  666,
  667,
  667.5,
  668,
  669,
  669.5,
  670.5,
  671,
  671,
  672,
  672.5,
  673,
  673.5,
  674,
  675,
  675,
  675.5,
  676.5,
  677,
  677,
  678,
  678.5,
  679,
  679.5,
  679.5,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  682.5,
  683.5,
  684,
  684.5,
  685,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710,
  710.5,
  710.5,
  710.5,
  710.5,
  711,
  711,
  711,
  711,
];
a[26] = [
  641.5,
  641.5,
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650.5,
  650.5,
  651,
  651.5,
  652,
  652.5,
  653.5,
  654,
  655,
  656,
  657,
  658.5,
  659.5,
  660.5,
  662,
  663,
  664,
  665.5,
  666,
  667,
  668,
  668.5,
  669.5,
  670,
  670.5,
  671,
  671.5,
  672,
  672.5,
  673,
  674,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  684,
  684.5,
  685,
  685.5,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  710.5,
  711,
  711,
  711,
  711,
  711.5,
  711.5,
  711.5,
];
a[25] = [
  641,
  641,
  640.5,
  640.5,
  640.5,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650.5,
  651,
  651,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654.5,
  655,
  655.5,
  657,
  658,
  659,
  660,
  660.5,
  662.5,
  663.5,
  664,
  665.5,
  666.5,
  667.5,
  668,
  668.5,
  669.5,
  670,
  671,
  671.5,
  672,
  672.5,
  673,
  673.5,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  684,
  684.5,
  685,
  685.5,
  685.5,
  686,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  711.5,
  711.5,
  712,
  712,
  712,
  712,
];
a[24] = [
  641,
  640.5,
  640.5,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650,
  651,
  651,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  655,
  656,
  656.5,
  657.5,
  658.5,
  659.5,
  660.5,
  661.5,
  663,
  663.5,
  664.5,
  666,
  666.5,
  667.5,
  668.5,
  669,
  670,
  670.5,
  671,
  672,
  672,
  673,
  673.5,
  674,
  674.5,
  675,
  676,
  676.5,
  676.5,
  677.5,
  678,
  678,
  679,
  679.5,
  680,
  680.5,
  680.5,
  681.5,
  681.5,
  681.5,
  682,
  682,
  683,
  683.5,
  683.5,
  684,
  684.5,
  685,
  685.5,
  686,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  711.5,
  712,
  712,
  712,
  712.5,
  712.5,
  712.5,
  712.5,
];
a[23] = [
  640.5,
  640,
  640,
  640,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651.5,
  652,
  652,
  653,
  653.5,
  654,
  654.5,
  655,
  656,
  656.5,
  657,
  658.5,
  659,
  660.5,
  660.5,
  662,
  663,
  664,
  665,
  666,
  667,
  668,
  668.5,
  669,
  670,
  670.5,
  671.5,
  672,
  672.5,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680.5,
  680.5,
  681,
  681.5,
  681.5,
  682,
  682,
  682.5,
  683,
  683.5,
  684,
  684.5,
  685,
  685.5,
  685.5,
  686,
  686.5,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712,
  712.5,
  712.5,
  712.5,
  713,
  713,
  713,
  713,
];
a[22] = [
  640,
  640,
  640,
  639.5,
  639.5,
  639,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648,
  648.5,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651.5,
  652,
  652.5,
  652.5,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656.5,
  657,
  657.5,
  659,
  659.5,
  660.5,
  661.5,
  662.5,
  663.5,
  664.5,
  665,
  666.5,
  667,
  668,
  669,
  669.5,
  670.5,
  671,
  672,
  672.5,
  673,
  673.5,
  674,
  674.5,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  682.5,
  683.5,
  684,
  684,
  684.5,
  685,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713,
  713,
  713.5,
  713.5,
  713.5,
];
a[21] = [
  640,
  639.5,
  639.5,
  639.5,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644,
  644.5,
  644.5,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651.5,
  651.5,
  652.5,
  653,
  653,
  654,
  654.5,
  655,
  655.5,
  656,
  657,
  658,
  658,
  659.5,
  660,
  661.5,
  662,
  663,
  664,
  665,
  665.5,
  666.5,
  667.5,
  668.5,
  669,
  670,
  670.5,
  671.5,
  672,
  672.5,
  673,
  674,
  674.5,
  675,
  675.5,
  676,
  677,
  677.5,
  677.5,
  678.5,
  679,
  679,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682.5,
  682.5,
  683,
  683.5,
  684,
  684.5,
  685,
  685,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713,
  713.5,
  713.5,
  713.5,
  714,
  714,
  714,
];
a[20] = [
  639.5,
  639.5,
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650,
  651,
  651,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  655,
  656,
  656.5,
  657,
  658,
  658.5,
  659,
  660,
  660.5,
  662,
  662.5,
  663.5,
  664.5,
  665,
  666,
  667,
  668,
  669,
  669.5,
  670,
  671,
  671.5,
  672.5,
  673,
  673.5,
  674.5,
  675,
  675,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  684,
  684,
  684.5,
  685,
  685.5,
  686,
  686,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  713.5,
  714,
  714,
  714,
  714.5,
  714.5,
  714.5,
];
a[19] = [
  639,
  639,
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  638,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  646,
  646,
  646,
  646.5,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  650,
  650.5,
  650.5,
  651,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656.5,
  657,
  657.5,
  658.5,
  659,
  659.5,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  665,
  665.5,
  666.5,
  667.5,
  668,
  669,
  670,
  670.5,
  671.5,
  672,
  673,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676.5,
  677,
  677.5,
  678,
  678,
  679,
  679.5,
  679.5,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682,
  683,
  683,
  683.5,
  684,
  684.5,
  685,
  685.5,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687,
  687.5,
  688,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  713.5,
  714,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
];
a[18] = [
  639,
  638.5,
  638.5,
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  650,
  650.5,
  650.5,
  651,
  651.5,
  652,
  652.5,
  653,
  653,
  654,
  654,
  654.5,
  655.5,
  656,
  656.5,
  657,
  658,
  658.5,
  659.5,
  660,
  660.5,
  661.5,
  663,
  663.5,
  664,
  665.5,
  666,
  666.5,
  668,
  668.5,
  669.5,
  670,
  670.5,
  671.5,
  672,
  673,
  673.5,
  674,
  675,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  683.5,
  684.5,
  684.5,
  685,
  685.5,
  686,
  686,
  686.5,
  686.5,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
];
a[17] = [
  638.5,
  638.5,
  638,
  638,
  638,
  638,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  644.5,
  645,
  645,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659.5,
  660,
  660.5,
  662,
  662.5,
  663.5,
  664,
  664.5,
  666,
  666.5,
  667,
  668,
  669,
  670,
  670.5,
  671,
  672,
  672.5,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682.5,
  682.5,
  683.5,
  683.5,
  684,
  684.5,
  685,
  685,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  715.5,
  716,
];
a[16] = [
  638,
  638,
  638,
  638,
  637.5,
  637.5,
  637.5,
  637.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644,
  644.5,
  645,
  645,
  645.5,
  645.5,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  650.5,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654,
  655,
  655.5,
  656,
  657,
  657.5,
  658,
  658.5,
  659,
  660,
  660.5,
  660.5,
  662.5,
  663,
  664,
  664.5,
  665,
  666.5,
  667,
  667.5,
  668.5,
  669,
  670,
  671,
  671.5,
  672.5,
  673,
  674,
  674.5,
  674.5,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678.5,
  679,
  679,
  680,
  680.5,
  680.5,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  684,
  684,
  684.5,
  685,
  685.5,
  686,
  686,
  686.5,
  687,
  687,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  713.5,
  714,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  715.5,
  716,
  716,
];
a[15] = [
  638,
  637.5,
  637.5,
  637.5,
  637.5,
  637,
  637,
  637,
  637,
  637,
  637,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651,
  652,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660.5,
  660.5,
  662,
  663,
  663.5,
  664.5,
  665,
  665.5,
  667,
  667.5,
  668,
  669,
  669.5,
  670.5,
  671,
  672,
  672.5,
  673.5,
  674,
  674.5,
  675,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682,
  683,
  683,
  683.5,
  684,
  684.5,
  685,
  685,
  685.5,
  686,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
];
a[14] = [
  637.5,
  637.5,
  637.5,
  637,
  637,
  637,
  637,
  637,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  650.5,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  658,
  658.5,
  659,
  659.5,
  660,
  660.5,
  662,
  662,
  663.5,
  664,
  665,
  665.5,
  666,
  667,
  668,
  668.5,
  669.5,
  670,
  671,
  671.5,
  672,
  673,
  673.5,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677,
  678,
  678.5,
  679,
  679.5,
  679.5,
  680.5,
  681,
  681,
  681.5,
  681.5,
  682,
  682,
  682.5,
  683,
  683.5,
  684,
  684.5,
  684.5,
  685,
  685.5,
  685.5,
  686,
  686.5,
  687,
  687,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  702,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716,
  716,
];
a[13] = [
  637.5,
  637,
  637,
  637,
  637,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651,
  651.5,
  652,
  652.5,
  653,
  653,
  654,
  654.5,
  654.5,
  655.5,
  655.5,
  656.5,
  657,
  657.5,
  658.5,
  659,
  659.5,
  660,
  660.5,
  661.5,
  662.5,
  662.5,
  664,
  664.5,
  665.5,
  666,
  666.5,
  667.5,
  668.5,
  669,
  670,
  670.5,
  671.5,
  672,
  672.5,
  673.5,
  674,
  675,
  675.5,
  675.5,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  682.5,
  683.5,
  683.5,
  684,
  684.5,
  685,
  685.5,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  689,
  689,
  689.5,
  689.5,
  689.5,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
];
a[12] = [
  637,
  637,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  655,
  655,
  656,
  656.5,
  657,
  657.5,
  658,
  659,
  659.5,
  660,
  660.5,
  660.5,
  662,
  663,
  663.5,
  664.5,
  665,
  666,
  666.5,
  667,
  668,
  668.5,
  669.5,
  670.5,
  671,
  672,
  672.5,
  673,
  674,
  674.5,
  675,
  675.5,
  676,
  677,
  677.5,
  677.5,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  684,
  684.5,
  684.5,
  685,
  685.5,
  686,
  686,
  686.5,
  687,
  687,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703,
  703,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715.5,
  715.5,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
];
a[11] = [
  636.5,
  636.5,
  636.5,
  636.5,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  650.5,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654,
  655,
  655.5,
  655.5,
  656.5,
  656.5,
  657.5,
  658,
  658.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662.5,
  663.5,
  663.5,
  665,
  665.5,
  666.5,
  667,
  667.5,
  668.5,
  669,
  669.5,
  670.5,
  671,
  672,
  673,
  673,
  674,
  674.5,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  680,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683,
  683.5,
  684,
  684.5,
  685,
  685,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687.5,
  687.5,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
];
a[10] = [
  636.5,
  636,
  636,
  636,
  636,
  636,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651,
  651.5,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  654.5,
  655.5,
  656,
  656,
  657,
  657.5,
  658,
  658.5,
  659,
  660,
  660.5,
  660.5,
  661.5,
  662,
  663,
  663.5,
  664.5,
  665,
  666,
  667,
  667.5,
  668,
  669,
  669.5,
  670,
  671,
  671.5,
  672.5,
  673,
  673.5,
  674.5,
  675,
  676,
  676.5,
  676.5,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682,
  682.5,
  683,
  683.5,
  684,
  684.5,
  685,
  685,
  685.5,
  686,
  686,
  686.5,
  687,
  687,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
];
a[9] = [
  636,
  636,
  636,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651,
  651.5,
  652,
  652.5,
  652.5,
  653.5,
  653.5,
  654.5,
  654.5,
  655,
  656,
  656,
  656.5,
  657.5,
  657.5,
  658.5,
  659,
  659.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663.5,
  664,
  664.5,
  665.5,
  666.5,
  667,
  668,
  668.5,
  669.5,
  670,
  670.5,
  671.5,
  672,
  673,
  673.5,
  674,
  675,
  675.5,
  676,
  676.5,
  677,
  678,
  678,
  678.5,
  679.5,
  679.5,
  680.5,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  683.5,
  684,
  684.5,
  685,
  685.5,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  691,
  691,
  691.5,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  717,
  717,
  717,
  717,
];
a[8] = [
  636,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  650.5,
  651,
  651.5,
  652,
  652.5,
  653,
  653,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  659,
  659.5,
  659.5,
  660.5,
  660.5,
  662,
  662.5,
  663,
  664,
  664.5,
  665,
  666,
  666.5,
  667.5,
  668.5,
  669,
  670,
  670.5,
  671,
  672,
  672.5,
  673.5,
  674,
  674.5,
  675,
  675.5,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  684,
  684.5,
  684.5,
  685,
  685.5,
  685.5,
  686,
  686.5,
  687,
  687,
  687.5,
  688,
  688,
  688.5,
  689,
  689,
  689,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708.5,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
];
a[7] = [
  635.5,
  635.5,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650.5,
  651,
  651,
  651.5,
  652,
  652,
  653,
  653,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659.5,
  660,
  660.5,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664.5,
  665,
  665.5,
  666.5,
  667,
  668,
  668.5,
  669,
  670,
  671,
  671.5,
  672.5,
  673,
  673.5,
  674.5,
  675,
  675.5,
  676,
  677,
  677,
  677.5,
  678.5,
  678.5,
  679,
  680,
  680,
  681,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  683.5,
  684,
  684.5,
  685,
  685.5,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687.5,
  687.5,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690.5,
  690.5,
  690.5,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712.5,
  712.5,
  713,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
];
a[6] = [
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  650.5,
  651,
  651.5,
  652,
  652.5,
  652.5,
  653,
  653.5,
  654,
  654.5,
  654.5,
  655.5,
  656,
  656,
  657,
  657.5,
  658,
  658.5,
  659,
  660,
  660.5,
  660.5,
  661.5,
  662,
  663,
  663.5,
  664,
  665,
  665.5,
  666,
  667,
  667.5,
  668.5,
  669,
  669.5,
  670.5,
  671,
  671.5,
  672.5,
  673,
  674,
  674.5,
  675,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  684,
  684,
  684.5,
  685,
  685.5,
  686,
  686,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688.5,
  688.5,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
];
a[5] = [
  635,
  635,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  635,
  635,
  635,
  635,
  635,
  635,
  635,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  659,
  659.5,
  660,
  660.5,
  660.5,
  662,
  662.5,
  663,
  663.5,
  664.5,
  665,
  666,
  666.5,
  667.5,
  668,
  669,
  669.5,
  670,
  671,
  671.5,
  672,
  673,
  673.5,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677.5,
  677.5,
  678,
  679,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683,
  683.5,
  684,
  684.5,
  685,
  685,
  685.5,
  686,
  686,
  686.5,
  687,
  687,
  687.5,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709.5,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  714,
  714,
  714,
  714.5,
  714.5,
  714.5,
  715,
  715,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
];
a[4] = [
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  635,
  635,
  635,
  635,
  635,
  635,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  647.5,
  648,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651,
  652,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659.5,
  659.5,
  660.5,
  660.5,
  661.5,
  662.5,
  663,
  663.5,
  664,
  664.5,
  665.5,
  666.5,
  667,
  667.5,
  668.5,
  669,
  670,
  670.5,
  671.5,
  672,
  672.5,
  673.5,
  674,
  675,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  684,
  684,
  684.5,
  685,
  685.5,
  686,
  686,
  686.5,
  687,
  687,
  687.5,
  688,
  688,
  688.5,
  688.5,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  693,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703.5,
  703.5,
  704,
  704,
  704.5,
  704.5,
  704.5,
  705,
  705,
  705,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717.5,
  717.5,
  717.5,
  717.5,
  717,
  717,
];
a[3] = [
  634.5,
  634,
  634,
  634,
  634,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  635,
  635,
  635,
  635,
  635,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647,
  647.5,
  647.5,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660,
  660.5,
  661.5,
  662,
  662.5,
  663.5,
  664,
  664.5,
  665,
  666,
  666.5,
  667,
  668,
  668.5,
  669.5,
  670,
  671,
  672,
  672.5,
  673,
  674,
  674.5,
  675.5,
  676,
  676,
  677,
  677.5,
  678,
  678.5,
  678.5,
  679.5,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  682.5,
  683,
  683.5,
  684,
  684.5,
  684.5,
  685,
  685.5,
  686,
  686,
  686.5,
  687,
  687,
  687.5,
  688,
  688,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703.5,
  703.5,
  703.5,
  704,
  704,
  704.5,
  704.5,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  712,
  712,
  712,
  712.5,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
];
a[2] = [
  634,
  634,
  634,
  634,
  634,
  634,
  634,
  634,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  635,
  635,
  635,
  635,
  635,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  645,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  649,
  649,
  649.5,
  649.5,
  650,
  650.5,
  651,
  651.5,
  651.5,
  652,
  652.5,
  653,
  653.5,
  653.5,
  654,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660,
  660.5,
  661.5,
  662,
  662.5,
  663,
  663.5,
  664.5,
  665,
  665.5,
  666.5,
  667,
  667.5,
  668.5,
  669,
  670,
  670.5,
  671,
  672,
  672.5,
  673.5,
  674.5,
  675,
  675.5,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683.5,
  683.5,
  684.5,
  684.5,
  685,
  685.5,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687.5,
  687.5,
  688,
  688.5,
  688.5,
  689,
  689,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692.5,
  692.5,
  692.5,
  693,
  693,
  693.5,
  694,
  694,
  694.5,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  702,
  703,
  703,
  703,
  703.5,
  703.5,
  704,
  704,
  704.5,
  704.5,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  711.5,
  712,
  712,
  712.5,
  713,
  713,
  713.5,
  713.5,
  714,
  714,
  714.5,
  715,
  715,
  715,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
];
a[1] = [
  633.5,
  633.5,
  633.5,
  634,
  634,
  634,
  634,
  634,
  634.5,
  634.5,
  634.5,
  634.5,
  634.5,
  635,
  635,
  635,
  635,
  635,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  643.5,
  644,
  644,
  644.5,
  644.5,
  644.5,
  645,
  645.5,
  645.5,
  646,
  646,
  646.5,
  646.5,
  647,
  647.5,
  647.5,
  647.5,
  648,
  648.5,
  649,
  649,
  649.5,
  650,
  650,
  650.5,
  651,
  651,
  651.5,
  652,
  652,
  652.5,
  653,
  653.5,
  654,
  654,
  655,
  655.5,
  655.5,
  656.5,
  656.5,
  657.5,
  657.5,
  658,
  659,
  659.5,
  659.5,
  660.5,
  660.5,
  661.5,
  662,
  662.5,
  663.5,
  664,
  665,
  665.5,
  666,
  666.5,
  667.5,
  668,
  669,
  669.5,
  670.5,
  671,
  671.5,
  672.5,
  673,
  673.5,
  674.5,
  675,
  676,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679,
  679.5,
  680,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  681.5,
  682.5,
  682.5,
  683,
  683.5,
  684,
  684.5,
  684.5,
  685,
  685.5,
  686,
  686,
  686.5,
  687,
  687,
  687.5,
  687.5,
  688,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  690.5,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693,
  693.5,
  693.5,
  694,
  694,
  694.5,
  694.5,
  695,
  695,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703.5,
  703.5,
  704,
  704,
  704.5,
  704.5,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710.5,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713.5,
  713.5,
  714,
  714,
  714.5,
  714.5,
  715,
  715.5,
  715.5,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
];
a[0] = [
  633.5,
  633.5,
  633.5,
  633.5,
  634,
  634,
  634,
  634,
  634,
  634.5,
  634.5,
  634.5,
  634.5,
  635,
  635,
  635,
  635,
  635,
  635.5,
  635.5,
  635.5,
  635.5,
  635.5,
  636,
  636,
  636,
  636,
  636.5,
  636.5,
  636.5,
  636.5,
  637,
  637,
  637,
  637,
  637,
  637.5,
  637.5,
  637.5,
  638,
  638,
  638,
  638,
  638,
  638.5,
  638.5,
  638.5,
  639,
  639,
  639,
  639.5,
  639.5,
  639.5,
  639.5,
  640,
  640,
  640,
  640.5,
  640.5,
  640.5,
  641,
  641,
  641,
  641.5,
  641.5,
  641.5,
  642,
  642,
  642.5,
  642.5,
  642.5,
  643,
  643,
  643.5,
  643.5,
  644,
  644,
  644,
  644.5,
  645,
  645,
  645.5,
  645.5,
  645.5,
  646,
  646,
  646.5,
  647,
  647,
  647.5,
  648,
  648,
  648.5,
  648.5,
  649,
  649.5,
  649.5,
  650,
  650,
  650.5,
  651,
  651.5,
  652,
  652,
  652.5,
  653,
  653.5,
  654,
  654.5,
  654.5,
  655,
  655.5,
  656,
  656.5,
  657,
  657.5,
  658,
  658.5,
  659,
  659.5,
  660,
  660.5,
  660.5,
  662,
  662.5,
  663,
  664,
  664.5,
  665,
  665.5,
  666,
  667,
  667.5,
  668,
  669,
  669.5,
  670.5,
  671,
  672,
  672.5,
  673.5,
  674,
  675,
  675.5,
  676.5,
  676.5,
  677,
  677.5,
  678,
  678.5,
  679,
  679.5,
  680,
  680.5,
  680.5,
  681,
  681.5,
  681.5,
  681.5,
  682,
  682.5,
  683,
  683,
  683.5,
  684,
  684.5,
  685,
  685,
  685.5,
  686,
  686.5,
  686.5,
  687,
  687.5,
  687.5,
  688,
  688,
  688.5,
  689,
  689,
  689.5,
  689.5,
  690,
  690,
  690.5,
  691,
  691,
  691.5,
  691.5,
  692,
  692,
  692.5,
  692.5,
  693,
  693.5,
  693.5,
  693.5,
  694,
  694,
  694.5,
  695,
  695,
  695.5,
  695.5,
  695.5,
  696,
  696,
  696.5,
  696.5,
  697,
  697,
  697.5,
  697.5,
  698,
  698,
  698.5,
  698.5,
  698.5,
  699,
  699,
  699.5,
  699.5,
  700,
  700,
  700.5,
  700.5,
  701,
  701,
  701.5,
  701.5,
  702,
  702,
  703,
  703,
  703.5,
  703.5,
  704,
  704,
  704,
  704.5,
  705,
  705,
  705.5,
  705.5,
  705.5,
  706,
  706,
  706,
  706.5,
  706.5,
  706.5,
  707,
  707,
  707,
  707.5,
  707.5,
  707.5,
  708,
  708,
  708,
  708.5,
  708.5,
  709,
  709,
  709,
  709.5,
  709.5,
  710,
  710,
  710,
  710.5,
  710.5,
  711,
  711,
  711.5,
  711.5,
  712,
  712,
  712.5,
  712.5,
  713,
  713,
  713.5,
  714,
  714,
  714.5,
  714.5,
  715,
  715,
  715.5,
  715.5,
  716,
  716,
  716,
  716,
  716,
  716.5,
  716.5,
  716.5,
  716.5,
  716.5,
  717,
  717,
  717,
  717,
  717,
  717,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
  717.5,
];

dataMaps.srr = new DataMapNumeric(
  'SRR',
  'Seismic Reflection and Refraction',
  'ft',
  a,
  320,
  200,
);

a = [];
a[199] = [
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
];
a[198] = [
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
];
a[197] = [
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
  844,
];
a[196] = [
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  844,
  844,
  844,
  844,
  844,
  844,
];
a[195] = [
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  844,
];
a[194] = [
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
];
a[193] = [
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.6,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
];
a[192] = [
  850.6,
  850.6,
  850.6,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
];
a[191] = [
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
];
a[190] = [
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.8,
  843.8,
];
a[189] = [
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
];
a[188] = [
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
];
a[187] = [
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
  843.6,
];
a[186] = [
  850.4,
  850.4,
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
  843.6,
  843.6,
];
a[185] = [
  850.4,
  850.4,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.6,
  843.6,
];
a[184] = [
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
];
a[183] = [
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
];
a[182] = [
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
];
a[181] = [
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
  843.4,
  843.4,
  843.4,
  843.4,
];
a[180] = [
  850.2,
  850.2,
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.4,
];
a[179] = [
  850.2,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
];
a[178] = [
  850,
  850,
  850,
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
];
a[177] = [
  850,
  850,
  850,
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
  843.2,
];
a[176] = [
  850,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
  843.2,
  843.2,
];
a[175] = [
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843.2,
  843.2,
];
a[174] = [
  849.8,
  849.8,
  849.8,
  849.8,
  849.8,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
];
a[173] = [
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
];
a[172] = [
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
  843,
  843,
];
a[171] = [
  849.6,
  849.6,
  849.6,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
  843,
  843,
  843,
];
a[170] = [
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  843,
  843,
];
a[169] = [
  849.4,
  849.4,
  849.4,
  849.4,
  849.4,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
];
a[168] = [
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
];
a[167] = [
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849.2,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
];
a[166] = [
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
  842.8,
  842.8,
];
a[165] = [
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  849,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.8,
  842.8,
  842.8,
];
a[164] = [
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
];
a[163] = [
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
];
a[162] = [
  848.8,
  848.8,
  848.8,
  848.8,
  848.8,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
];
a[161] = [
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
  842.6,
  842.6,
];
a[160] = [
  848.6,
  848.6,
  848.6,
  848.6,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
  842.6,
];
a[159] = [
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.6,
  842.6,
];
a[158] = [
  848.4,
  848.4,
  848.4,
  848.4,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
];
a[157] = [
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
];
a[156] = [
  848.2,
  848.2,
  848.2,
  848.2,
  848.2,
  848,
  848,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839,
  839,
  839,
  839,
  839,
  839,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
  842.4,
];
a[155] = [
  848,
  848,
  848,
  848,
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839.2,
  839,
  839,
  839,
  839,
  839,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
  842.4,
];
a[154] = [
  848,
  848,
  848,
  848,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839.2,
  839,
  839,
  839,
  839,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
  842.4,
];
a[153] = [
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839,
  839,
  839,
  838.8,
  838.8,
  838.8,
  838.8,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.4,
];
a[152] = [
  847.8,
  847.8,
  847.8,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.2,
  843.2,
  843,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840,
  840,
  840,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839,
  839,
  839,
  838.8,
  838.8,
  838.8,
  838.6,
  838.6,
  838.6,
  838.6,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
];
a[151] = [
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839,
  839,
  839,
  838.8,
  838.8,
  838.6,
  838.6,
  838.6,
  838.4,
  838.4,
  838.4,
  838.4,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
];
a[150] = [
  847.6,
  847.6,
  847.6,
  847.6,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839,
  839,
  839,
  838.8,
  838.8,
  838.6,
  838.6,
  838.6,
  838.4,
  838.4,
  838.4,
  838.2,
  838.2,
  838.2,
  838,
  838,
  838,
  838,
  838,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
  842.2,
  842.2,
];
a[149] = [
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839,
  839,
  838.8,
  838.8,
  838.6,
  838.6,
  838.6,
  838.4,
  838.4,
  838.2,
  838.2,
  838.2,
  838,
  838,
  838,
  837.8,
  837.8,
  837.8,
  837.8,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
  842.2,
  842.2,
];
a[148] = [
  847.4,
  847.4,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839,
  839,
  838.8,
  838.8,
  838.8,
  838.6,
  838.6,
  838.4,
  838.4,
  838.4,
  838.2,
  838.2,
  838,
  838,
  838,
  837.8,
  837.8,
  837.8,
  837.6,
  837.6,
  837.6,
  837.6,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842.2,
];
a[147] = [
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847.2,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839,
  839,
  839,
  838.8,
  838.8,
  838.6,
  838.6,
  838.6,
  838.4,
  838.4,
  838.2,
  838.2,
  838.2,
  838,
  838,
  837.8,
  837.8,
  837.8,
  837.6,
  837.6,
  837.6,
  837.6,
  837.4,
  837.4,
  837.4,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
];
a[146] = [
  847,
  847,
  847,
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839,
  839,
  838.8,
  838.8,
  838.6,
  838.6,
  838.4,
  838.4,
  838.4,
  838.2,
  838.2,
  838,
  838,
  838,
  837.8,
  837.8,
  837.8,
  837.6,
  837.6,
  837.4,
  837.4,
  837.4,
  837.2,
  837.2,
  837.2,
  837.2,
  837,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
  842,
];
a[145] = [
  847,
  847,
  847,
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.8,
  838.6,
  838.6,
  838.4,
  838.4,
  838.2,
  838.2,
  838,
  838,
  838,
  837.8,
  837.8,
  837.8,
  837.6,
  837.6,
  837.6,
  837.4,
  837.4,
  837.2,
  837.2,
  837.2,
  837.2,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
  842,
  842,
];
a[144] = [
  847,
  846.8,
  846.8,
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.4,
  838.2,
  838.2,
  838,
  838,
  837.8,
  837.8,
  837.8,
  837.6,
  837.6,
  837.6,
  837.4,
  837.4,
  837.2,
  837.2,
  837.2,
  837,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.6,
  836.6,
  836.6,
  836.6,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
  842,
];
a[143] = [
  846.8,
  846.8,
  846.8,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.6,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838,
  838,
  837.8,
  837.8,
  837.6,
  837.6,
  837.6,
  837.4,
  837.4,
  837.2,
  837.2,
  837.2,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.6,
  836.6,
  836.6,
  836.6,
  836.4,
  836.4,
  836.4,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
  842,
  842,
];
a[142] = [
  846.6,
  846.6,
  846.6,
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.6,
  844.6,
  844.2,
  844,
  844,
  843.8,
  843.6,
  843.6,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  838,
  837.8,
  837.6,
  837.6,
  837.4,
  837.4,
  837.4,
  837.2,
  837.2,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.6,
  836.6,
  836.6,
  836.4,
  836.4,
  836.4,
  836.4,
  836.2,
  836.2,
  836.2,
  836,
  836,
  836,
  836,
  836,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  842,
];
a[141] = [
  846.6,
  846.6,
  846.4,
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.2,
  844.2,
  844,
  843.8,
  843.8,
  843.6,
  843.4,
  843.4,
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839,
  839,
  838.8,
  838.8,
  838.6,
  838.6,
  838.4,
  838.4,
  838.2,
  838,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837.2,
  837.2,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.6,
  836.6,
  836.4,
  836.4,
  836.4,
  836.4,
  836.2,
  836.2,
  836.2,
  836.2,
  836,
  836,
  836,
  836,
  835.8,
  835.8,
  835.8,
  835.8,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
];
a[140] = [
  846.4,
  846.4,
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  843.8,
  843.8,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.6,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.4,
  838.2,
  838.2,
  838,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837.2,
  837,
  837,
  836.8,
  836.8,
  836.6,
  836.6,
  836.4,
  836.4,
  836.4,
  836.2,
  836.2,
  836.2,
  836,
  836,
  836,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  835.6,
  835.6,
  835.6,
  835.6,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
];
a[139] = [
  846.4,
  846.2,
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.6,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.6,
  843.6,
  843.4,
  843.2,
  843.2,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838.2,
  838,
  838,
  837.8,
  837.8,
  837.6,
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  837,
  836.8,
  836.8,
  836.6,
  836.6,
  836.4,
  836.4,
  836.2,
  836.2,
  836.2,
  836,
  836,
  836,
  835.8,
  835.8,
  835.8,
  835.6,
  835.6,
  835.6,
  835.6,
  835.6,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.2,
  835.2,
  835.2,
  835.2,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
  841.8,
];
a[138] = [
  846.2,
  846.2,
  846.2,
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837.2,
  837,
  837,
  836.8,
  836.8,
  836.6,
  836.6,
  836.4,
  836.4,
  836.2,
  836.2,
  836,
  836,
  836,
  835.8,
  835.8,
  835.8,
  835.6,
  835.6,
  835.6,
  835.4,
  835.4,
  835.4,
  835.4,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835,
  835,
  835,
  835,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
  841.8,
];
a[137] = [
  846,
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.4,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.6,
  836.4,
  836.4,
  836.2,
  836.2,
  836,
  836,
  835.8,
  835.8,
  835.6,
  835.6,
  835.6,
  835.4,
  835.4,
  835.4,
  835.4,
  835.2,
  835.2,
  835.2,
  835,
  835,
  835,
  835,
  835,
  835,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
  841.8,
  841.8,
];
a[136] = [
  846,
  846,
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838,
  838,
  837.8,
  837.6,
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.4,
  836.2,
  836.2,
  836,
  836,
  835.8,
  835.8,
  835.6,
  835.6,
  835.4,
  835.4,
  835.4,
  835.2,
  835.2,
  835.2,
  835.2,
  835,
  835,
  835,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.8,
];
a[135] = [
  845.8,
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  843,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836.2,
  836,
  836,
  835.8,
  835.8,
  835.6,
  835.6,
  835.4,
  835.4,
  835.2,
  835.2,
  835,
  835,
  835,
  835,
  835,
  834.8,
  834.8,
  834.8,
  834.8,
  834.6,
  834.6,
  834.6,
  834.6,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
];
a[134] = [
  845.8,
  845.8,
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.2,
  840.2,
  840,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838,
  838,
  837.8,
  837.6,
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  836,
  835.8,
  835.8,
  835.6,
  835.6,
  835.4,
  835.4,
  835.4,
  835.2,
  835.2,
  835,
  835,
  834.8,
  834.8,
  834.8,
  834.8,
  834.6,
  834.6,
  834.6,
  834.6,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
];
a[133] = [
  845.6,
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  845,
  844.8,
  844.6,
  844.6,
  844.2,
  844.2,
  844,
  844,
  843.8,
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.6,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.4,
  835.2,
  835.2,
  835.2,
  835,
  835,
  835,
  834.8,
  834.8,
  834.6,
  834.6,
  834.4,
  834.4,
  834.4,
  834.4,
  834.4,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
  841.6,
];
a[132] = [
  845.6,
  845.4,
  845.4,
  845.2,
  845.2,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844,
  844,
  843.8,
  843.8,
  843.6,
  843.4,
  843.4,
  843.2,
  843.2,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  835,
  835,
  834.8,
  834.8,
  834.8,
  834.6,
  834.6,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834.2,
  834.2,
  834.2,
  834,
  834,
  834,
  834,
  834,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834,
  834,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
  841.6,
];
a[131] = [
  845.4,
  845.4,
  845.2,
  845,
  845,
  844.8,
  844.8,
  844.6,
  844.6,
  844.2,
  844,
  844,
  843.8,
  843.6,
  843.6,
  843.4,
  843.2,
  843.2,
  843,
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  841.8,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838,
  838,
  837.8,
  837.6,
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.8,
  834.8,
  834.6,
  834.6,
  834.6,
  834.4,
  834.4,
  834.4,
  834.2,
  834.2,
  834.2,
  834,
  834,
  834,
  834,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
  841.6,
  841.6,
];
a[130] = [
  845.2,
  845.2,
  845,
  844.8,
  844.8,
  844.6,
  844.2,
  844.2,
  844,
  843.8,
  843.8,
  843.6,
  843.4,
  843.4,
  843.2,
  843,
  843,
  842.8,
  842.6,
  842.6,
  842.4,
  842.4,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.6,
  834.4,
  834.4,
  834.4,
  834.2,
  834.2,
  834.2,
  834,
  834,
  834,
  833.8,
  833.8,
  833.8,
  833.8,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.6,
];
a[129] = [
  845.2,
  845,
  844.8,
  844.8,
  844.6,
  844.2,
  844.2,
  844,
  843.8,
  843.6,
  843.6,
  843.4,
  843.2,
  843.2,
  843,
  842.8,
  842.8,
  842.6,
  842.4,
  842.4,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.8,
  835.6,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834.2,
  834,
  834,
  834,
  834,
  833.8,
  833.8,
  833.8,
  833.6,
  833.6,
  833.6,
  833.6,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
];
a[128] = [
  845,
  844.8,
  844.8,
  844.6,
  844.2,
  844,
  844,
  843.8,
  843.6,
  843.4,
  843.4,
  843.2,
  843,
  843,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835.2,
  835,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  834,
  834,
  833.8,
  833.8,
  833.8,
  833.8,
  833.6,
  833.6,
  833.6,
  833.4,
  833.4,
  833.4,
  833.4,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  833,
  833,
  833,
  833,
  833,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
];
a[127] = [
  844.6,
  844.6,
  844.2,
  844,
  844,
  843.8,
  843.6,
  843.4,
  843.4,
  843.2,
  843,
  842.8,
  842.8,
  842.6,
  842.4,
  842.4,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.4,
  841.4,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.8,
  834.6,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.8,
  833.6,
  833.6,
  833.6,
  833.4,
  833.4,
  833.4,
  833.2,
  833.2,
  833.2,
  833.2,
  833,
  833,
  833,
  833,
  833,
  833,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  833,
  833,
  833,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
  841.4,
];
a[126] = [
  844.2,
  844.2,
  844,
  843.8,
  843.8,
  843.6,
  843.4,
  843.2,
  843.2,
  843,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841,
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.6,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.6,
  833.4,
  833.4,
  833.4,
  833.2,
  833.2,
  833.2,
  833.2,
  833,
  833,
  833,
  833,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  832.8,
  832.8,
  832.8,
  833,
  833,
  833,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
];
a[125] = [
  844,
  843.8,
  843.8,
  843.6,
  843.6,
  843.4,
  843.2,
  843,
  843,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.4,
  841.4,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.4,
  833.2,
  833.2,
  833.2,
  833,
  833,
  833,
  833,
  832.8,
  832.8,
  832.8,
  832.8,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  832.8,
  832.8,
  833,
  833,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
  841.4,
  841.4,
];
a[124] = [
  843.6,
  843.6,
  843.4,
  843.4,
  843.2,
  843,
  842.8,
  842.8,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841,
  841,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.2,
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833.2,
  833,
  833,
  833,
  832.8,
  832.8,
  832.8,
  832.8,
  832.6,
  832.6,
  832.6,
  832.6,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  832.8,
  832.8,
  833,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
  841.4,
];
a[123] = [
  843.4,
  843.4,
  843.2,
  843,
  843,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.4,
  841.4,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  833,
  833,
  832.8,
  832.8,
  832.8,
  832.6,
  832.6,
  832.6,
  832.6,
  832.4,
  832.4,
  832.4,
  832.4,
  832.4,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  832.8,
  833,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.4,
];
a[122] = [
  843.2,
  843,
  843,
  842.8,
  842.8,
  842.6,
  842.4,
  842.4,
  842.2,
  842,
  841.8,
  841.8,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.8,
  832.6,
  832.6,
  832.6,
  832.6,
  832.4,
  832.4,
  832.4,
  832.4,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832,
  832,
  832,
  832,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832,
  832,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  832.8,
  833,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
];
a[121] = [
  842.8,
  842.8,
  842.6,
  842.6,
  842.4,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.4,
  841.4,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  835.8,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.6,
  832.4,
  832.4,
  832.4,
  832.4,
  832.2,
  832.2,
  832.2,
  832.2,
  832,
  832,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
];
a[120] = [
  842.6,
  842.6,
  842.4,
  842.2,
  842.2,
  842,
  841.8,
  841.8,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  840.8,
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.2,
  839.2,
  839,
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838,
  838,
  837.8,
  837.6,
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.4,
  832.2,
  832.2,
  832.2,
  832.2,
  832,
  832,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.8,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
];
a[119] = [
  842.4,
  842.2,
  842.2,
  842,
  842,
  841.8,
  841.6,
  841.4,
  841.4,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.6,
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.6,
  832.4,
  832.4,
  832.4,
  832.2,
  832.2,
  832.2,
  832,
  832,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.6,
  831.6,
  831.6,
  831.8,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
  841.2,
  841.2,
];
a[118] = [
  842,
  842,
  841.8,
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.2,
  840,
  840,
  839.8,
  839.6,
  839.4,
  839.2,
  839.2,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.4,
  832.2,
  832.2,
  832.2,
  832,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.6,
  831.6,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  837,
  836.8,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
  841.2,
];
a[117] = [
  841.8,
  841.8,
  841.6,
  841.4,
  841.4,
  841.2,
  841,
  840.8,
  840.8,
  840.6,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.2,
  838,
  838,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831.4,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.6,
  831.6,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
];
a[116] = [
  841.6,
  841.6,
  841.4,
  841.2,
  841.2,
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832.2,
  832,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831,
  831,
  831,
  831,
  831,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831,
  831,
  831,
  831,
  831.2,
  831.2,
  831.2,
  831.2,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.6,
  831.6,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841.2,
  841.2,
];
a[115] = [
  841.4,
  841.2,
  841,
  841,
  840.8,
  840.6,
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.6,
  837.6,
  837.4,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831.2,
  831.2,
  831,
  831,
  831,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831,
  831,
  831.2,
  831.2,
  831.2,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.6,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
  841,
];
a[114] = [
  841,
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831,
  831,
  831,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.2,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831,
  831,
  831.2,
  831.2,
  831.2,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.6,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
];
a[113] = [
  841,
  840.8,
  840.6,
  840.6,
  840.4,
  840.2,
  840,
  839.8,
  839.8,
  839.6,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831,
  831,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831,
  831.2,
  831.2,
  831.2,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.8,
  831.8,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
  841,
];
a[112] = [
  840.6,
  840.4,
  840.4,
  840.2,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831,
  831,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831,
  831.2,
  831.2,
  831.2,
  831.4,
  831.4,
  831.6,
  831.6,
  831.6,
  831.8,
  831.8,
  832,
  832,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
  841,
];
a[111] = [
  840.4,
  840.2,
  840.2,
  840,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831,
  831.2,
  831.2,
  831.2,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.8,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
  841,
];
a[110] = [
  840.2,
  840.2,
  840,
  839.8,
  839.6,
  839.6,
  839.4,
  839.2,
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830.2,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830,
  830,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.8,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
  841,
];
a[109] = [
  840,
  839.8,
  839.6,
  839.4,
  839.4,
  839.2,
  839,
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838,
  837.8,
  837.6,
  837.6,
  837.4,
  837.2,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836,
  835.8,
  835.8,
  835.6,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831.2,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830.2,
  830,
  830,
  830,
  830,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.4,
  831.4,
  831.6,
  831.6,
  831.8,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
  841,
];
a[108] = [
  839.8,
  839.6,
  839.4,
  839.2,
  839.2,
  839,
  838.8,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  836.8,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830.2,
  830,
  830,
  830,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.4,
  831.6,
  831.6,
  831.8,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
];
a[107] = [
  839.6,
  839.4,
  839.2,
  839,
  839,
  838.8,
  838.6,
  838.4,
  838.4,
  838,
  838,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  836.8,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  831,
  830.8,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830,
  830,
  830,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  831,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.4,
  831.6,
  831.6,
  831.8,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  841,
];
a[106] = [
  839.2,
  839,
  838.8,
  838.8,
  838.6,
  838.4,
  838.2,
  838.2,
  838,
  837.8,
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  836.8,
  836.6,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830,
  830,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.6,
  830.6,
  830.8,
  830.8,
  831,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
];
a[105] = [
  839,
  838.8,
  838.6,
  838.6,
  838.4,
  838.2,
  838,
  838,
  837.8,
  837.6,
  837.4,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.2,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.6,
  833.4,
  833.4,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830.2,
  830,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  831,
  831.2,
  831.2,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
];
a[104] = [
  838.8,
  838.6,
  838.4,
  838.4,
  838.2,
  838,
  837.8,
  837.6,
  837.6,
  837.4,
  837.2,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
  840.8,
];
a[103] = [
  838.4,
  838.4,
  838.2,
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.2,
  837,
  836.8,
  836.8,
  836.6,
  836.4,
  836.2,
  836,
  835.8,
  835.8,
  835.6,
  835.4,
  835.2,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.4,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  829,
  829,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.4,
  830.4,
  830.6,
  830.6,
  830.8,
  830.8,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
  840.8,
];
a[102] = [
  838.2,
  838,
  838,
  837.8,
  837.6,
  837.6,
  837.4,
  837.2,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.6,
  830.8,
  830.8,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
];
a[101] = [
  838,
  837.8,
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.4,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.6,
  830.8,
  830.8,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
  840.8,
];
a[100] = [
  837.8,
  837.6,
  837.4,
  837.4,
  837.2,
  837,
  836.8,
  836.6,
  836.6,
  836.4,
  836.2,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.4,
  833.4,
  833.2,
  833,
  833,
  832.8,
  832.8,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.6,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
  840.8,
];
a[99] = [
  837.6,
  837.4,
  837.2,
  837.2,
  837,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.4,
  833.2,
  833,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
];
a[98] = [
  837.4,
  837.2,
  837,
  837,
  836.8,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.8,
  832.6,
  832.4,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831.2,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.8,
];
a[97] = [
  837,
  837,
  836.8,
  836.6,
  836.4,
  836.4,
  836.2,
  836,
  835.8,
  835.6,
  835.6,
  835.4,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.8,
  832.6,
  832.4,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828,
  828,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
];
a[96] = [
  836.8,
  836.8,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828.2,
  828.2,
  828,
  828,
  828,
  828,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
];
a[95] = [
  836.6,
  836.6,
  836.4,
  836.2,
  836.2,
  836,
  835.8,
  835.6,
  835.4,
  835.2,
  835.2,
  835,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828.2,
  828,
  828,
  828,
  828,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
];
a[94] = [
  836.6,
  836.4,
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835,
  835,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831.2,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828.2,
  828,
  828,
  828,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
  840.6,
];
a[93] = [
  836.2,
  836,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.4,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828.2,
  828,
  828,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
];
a[92] = [
  836,
  836,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  829,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828,
  828,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
  840.6,
];
a[91] = [
  835.8,
  835.8,
  835.6,
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831.2,
  831,
  830.8,
  830.8,
  830.6,
  830.6,
  830.4,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
];
a[90] = [
  835.6,
  835.6,
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.6,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831.2,
  831,
  830.8,
  830.8,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
];
a[89] = [
  835.4,
  835.4,
  835.2,
  835,
  834.8,
  834.8,
  834.6,
  834.4,
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.8,
  830.6,
  830.4,
  830.4,
  830.2,
  830.2,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.8,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827.2,
  827.2,
  827,
  827,
  827,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
  840.6,
];
a[88] = [
  835.4,
  835.2,
  835,
  835,
  834.8,
  834.6,
  834.4,
  834.2,
  834.2,
  834,
  833.8,
  833.6,
  833.4,
  833.4,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827.2,
  827,
  827,
  827,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
  840.6,
];
a[87] = [
  835,
  835,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  833.8,
  833.6,
  833.6,
  833.4,
  833.2,
  833,
  832.8,
  832.8,
  832.6,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827.2,
  827,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
];
a[86] = [
  835,
  834.8,
  834.6,
  834.4,
  834.4,
  834.2,
  834,
  833.8,
  833.6,
  833.6,
  833.4,
  833.2,
  833,
  832.8,
  832.8,
  832.6,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830.2,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827.2,
  827,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.6,
];
a[85] = [
  834.8,
  834.6,
  834.6,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833,
  832.8,
  832.8,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830.2,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
];
a[84] = [
  834.4,
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830.2,
  830,
  829.8,
  829.8,
  829.6,
  829.6,
  829.4,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
];
a[83] = [
  834.4,
  834.2,
  834,
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833,
  833,
  832.8,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831,
  830.8,
  830.8,
  830.6,
  830.4,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.8,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
];
a[82] = [
  834.2,
  834,
  834,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.2,
  832.2,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830.2,
  830,
  829.8,
  829.8,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
];
a[81] = [
  833.8,
  833.8,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832,
  831.8,
  831.8,
  831.6,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.4,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.6,
  829.4,
  829.4,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826,
  826,
  826,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
];
a[80] = [
  833.6,
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832,
  831.8,
  831.8,
  831.6,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.4,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.6,
  829.4,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826.2,
  826.2,
  826,
  826,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
  840.4,
];
a[79] = [
  833.6,
  833.4,
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831,
  830.8,
  830.6,
  830.4,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.6,
  829.4,
  829.2,
  829.2,
  829,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826.2,
  826.2,
  826,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
  840.4,
];
a[78] = [
  833.2,
  833.2,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.4,
  831.2,
  831.2,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.6,
  829.4,
  829.2,
  829.2,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826.2,
  826,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
];
a[77] = [
  833,
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.4,
  831.2,
  831.2,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830,
  829.8,
  829.8,
  829.6,
  829.4,
  829.4,
  829.2,
  829.2,
  829,
  828.8,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826.2,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
];
a[76] = [
  833,
  832.8,
  832.6,
  832.6,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831,
  830.8,
  830.8,
  830.6,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.6,
  829.4,
  829.2,
  829.2,
  829,
  828.8,
  828.8,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
  840.4,
];
a[75] = [
  832.6,
  832.6,
  832.4,
  832.2,
  832.2,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831,
  830.8,
  830.8,
  830.6,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.6,
  829.4,
  829.2,
  829,
  829,
  828.8,
  828.8,
  828.6,
  828.4,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
];
a[74] = [
  832.4,
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831,
  830.8,
  830.8,
  830.6,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.4,
  829.4,
  829.2,
  829,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.4,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
];
a[73] = [
  832.4,
  832.2,
  832,
  832,
  831.8,
  831.6,
  831.4,
  831.4,
  831.2,
  831,
  830.8,
  830.8,
  830.6,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.4,
  829.4,
  829.2,
  829,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825.2,
  825.2,
  825,
  825,
  825,
  825,
  825,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
  840.4,
];
a[72] = [
  832,
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.4,
  830.4,
  830.2,
  830,
  829.8,
  829.6,
  829.6,
  829.4,
  829.2,
  829,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.8,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825,
  825,
  825,
  825,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
];
a[71] = [
  832,
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.4,
  830.4,
  830.2,
  830,
  829.8,
  829.6,
  829.6,
  829.4,
  829.2,
  829,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  828,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825,
  825,
  825,
  825,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
];
a[70] = [
  831.8,
  831.6,
  831.6,
  831.4,
  831.2,
  831,
  831,
  830.8,
  830.6,
  830.4,
  830.4,
  830.2,
  830,
  829.8,
  829.6,
  829.6,
  829.4,
  829.2,
  829,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.4,
  827.2,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  826,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825,
  825,
  825,
  824.8,
  824.8,
  824.8,
  824.8,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.4,
];
a[69] = [
  831.6,
  831.4,
  831.2,
  831.2,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.4,
  829.4,
  829.2,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  827.8,
  827.8,
  827.6,
  827.6,
  827.4,
  827.2,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  825.8,
  825.8,
  825.6,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825,
  825,
  825,
  824.8,
  824.8,
  824.8,
  824.6,
  824.6,
  824.6,
  824.6,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[68] = [
  831.4,
  831.2,
  831.2,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830,
  829.8,
  829.8,
  829.6,
  829.4,
  829.2,
  829.2,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  827.8,
  827.8,
  827.6,
  827.4,
  827.4,
  827.2,
  827.2,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  826,
  825.8,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825.2,
  825,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.6,
  824.6,
  824.4,
  824.4,
  824.4,
  824.4,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[67] = [
  831.2,
  831.2,
  831,
  830.8,
  830.6,
  830.6,
  830.4,
  830.2,
  830,
  829.8,
  829.8,
  829.6,
  829.4,
  829.2,
  829.2,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828,
  828,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  825.8,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.2,
  825.2,
  825,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.6,
  824.4,
  824.4,
  824.4,
  824.4,
  824.2,
  824.2,
  824.2,
  824.2,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[66] = [
  831,
  830.8,
  830.8,
  830.6,
  830.4,
  830.4,
  830.2,
  830,
  829.8,
  829.6,
  829.4,
  829.4,
  829.2,
  829,
  828.8,
  828.8,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  827.8,
  827.6,
  827.6,
  827.4,
  827.4,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  825.8,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.6,
  824.4,
  824.4,
  824.4,
  824.2,
  824.2,
  824.2,
  824,
  824,
  824,
  824,
  824,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[65] = [
  830.8,
  830.8,
  830.6,
  830.4,
  830.2,
  830.2,
  830,
  829.8,
  829.6,
  829.4,
  829.4,
  829.2,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828,
  828,
  827.8,
  827.6,
  827.6,
  827.4,
  827.2,
  827.2,
  827,
  826.8,
  826.8,
  826.6,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  825.8,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.6,
  824.4,
  824.4,
  824.2,
  824.2,
  824.2,
  824,
  824,
  824,
  824,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[64] = [
  830.8,
  830.6,
  830.4,
  830.2,
  830.2,
  830,
  829.8,
  829.6,
  829.4,
  829.4,
  829.2,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828,
  828,
  827.8,
  827.6,
  827.4,
  827.4,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  825.8,
  825.8,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.4,
  824.4,
  824.4,
  824.2,
  824.2,
  824.2,
  824,
  824,
  824,
  823.8,
  823.8,
  823.8,
  823.8,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[63] = [
  830.6,
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.4,
  829.2,
  829,
  829,
  828.8,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  827.8,
  827.6,
  827.6,
  827.4,
  827.2,
  827,
  827,
  826.8,
  826.8,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  826,
  825.8,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.4,
  824.4,
  824.4,
  824.2,
  824.2,
  824,
  824,
  824,
  823.8,
  823.8,
  823.8,
  823.6,
  823.6,
  823.6,
  823.6,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[62] = [
  830.4,
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.4,
  829.2,
  829,
  829,
  828.8,
  828.6,
  828.4,
  828.2,
  828,
  828,
  827.8,
  827.6,
  827.4,
  827.4,
  827.2,
  827,
  827,
  826.8,
  826.6,
  826.6,
  826.4,
  826.2,
  826.2,
  826,
  826,
  825.8,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.2,
  825.2,
  825,
  825,
  824.8,
  824.6,
  824.6,
  824.6,
  824.4,
  824.4,
  824.2,
  824.2,
  824,
  824,
  824,
  823.8,
  823.8,
  823.8,
  823.6,
  823.6,
  823.6,
  823.4,
  823.4,
  823.4,
  823.4,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[61] = [
  830.2,
  830,
  830,
  829.8,
  829.6,
  829.4,
  829.2,
  829,
  829,
  828.8,
  828.6,
  828.4,
  828.2,
  828,
  828,
  827.8,
  827.6,
  827.4,
  827.4,
  827.2,
  827,
  826.8,
  826.8,
  826.6,
  826.4,
  826.4,
  826.2,
  826.2,
  826,
  825.8,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.4,
  825.2,
  825.2,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.4,
  824.4,
  824.2,
  824.2,
  824,
  824,
  824,
  823.8,
  823.8,
  823.6,
  823.6,
  823.6,
  823.4,
  823.4,
  823.4,
  823.4,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[60] = [
  830,
  829.8,
  829.8,
  829.6,
  829.4,
  829.2,
  829,
  828.8,
  828.6,
  828.4,
  828.4,
  828.2,
  828,
  827.8,
  827.6,
  827.6,
  827.4,
  827.2,
  827,
  826.8,
  826.8,
  826.6,
  826.4,
  826.4,
  826.2,
  826,
  826,
  825.8,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.4,
  824.4,
  824.2,
  824.2,
  824,
  824,
  823.8,
  823.8,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.4,
  823.2,
  823.2,
  823.2,
  823.2,
  823,
  823,
  823,
  823,
  823,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[59] = [
  829.8,
  829.6,
  829.6,
  829.4,
  829.2,
  829,
  828.8,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  827.8,
  827.6,
  827.4,
  827.4,
  827.2,
  827,
  826.8,
  826.8,
  826.6,
  826.4,
  826.2,
  826.2,
  826,
  826,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.6,
  824.4,
  824.2,
  824.2,
  824,
  824,
  823.8,
  823.8,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.4,
  823.2,
  823.2,
  823.2,
  823,
  823,
  823,
  823,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[58] = [
  829.6,
  829.6,
  829.4,
  829.2,
  829,
  828.8,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  827.8,
  827.6,
  827.4,
  827.2,
  827.2,
  827,
  826.8,
  826.6,
  826.6,
  826.4,
  826.2,
  826.2,
  826,
  825.8,
  825.8,
  825.6,
  825.4,
  825.4,
  825.2,
  825.2,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.4,
  824.4,
  824.4,
  824.2,
  824.2,
  824,
  824,
  823.8,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.2,
  823.2,
  823.2,
  823,
  823,
  823,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.4,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[57] = [
  829.4,
  829.2,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828,
  827.8,
  827.6,
  827.6,
  827.4,
  827.2,
  827,
  826.8,
  826.6,
  826.6,
  826.4,
  826.2,
  826.2,
  826,
  825.8,
  825.6,
  825.6,
  825.4,
  825.4,
  825.2,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.4,
  824.4,
  824.2,
  824.2,
  824.2,
  824,
  824,
  823.8,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.2,
  823.2,
  823,
  823,
  823,
  822.8,
  822.8,
  822.8,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
  840.2,
];
a[56] = [
  829.2,
  829,
  828.8,
  828.6,
  828.6,
  828.4,
  828.2,
  828,
  827.8,
  827.6,
  827.4,
  827.4,
  827.2,
  827,
  826.8,
  826.6,
  826.6,
  826.4,
  826.2,
  826,
  826,
  825.8,
  825.6,
  825.6,
  825.4,
  825.2,
  825.2,
  825,
  825,
  824.8,
  824.6,
  824.6,
  824.4,
  824.4,
  824.2,
  824.2,
  824,
  824,
  824,
  823.8,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.2,
  823.2,
  823,
  823,
  823,
  822.8,
  822.8,
  822.8,
  822.6,
  822.6,
  822.6,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
];
a[55] = [
  829,
  828.8,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  827.8,
  827.6,
  827.4,
  827.2,
  827.2,
  827,
  826.8,
  826.6,
  826.4,
  826.4,
  826.2,
  826,
  825.8,
  825.8,
  825.6,
  825.4,
  825.4,
  825.2,
  825,
  825,
  824.8,
  824.8,
  824.6,
  824.4,
  824.4,
  824.2,
  824.2,
  824,
  824,
  823.8,
  823.8,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.2,
  823.2,
  823,
  823,
  822.8,
  822.8,
  822.8,
  822.6,
  822.6,
  822.6,
  822.4,
  822.4,
  822.4,
  822.4,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
];
a[54] = [
  828.8,
  828.6,
  828.4,
  828.2,
  828.2,
  828,
  827.8,
  827.6,
  827.4,
  827.2,
  827.2,
  827,
  826.8,
  826.6,
  826.4,
  826.4,
  826.2,
  826,
  825.8,
  825.8,
  825.6,
  825.4,
  825.2,
  825.2,
  825,
  824.8,
  824.8,
  824.6,
  824.6,
  824.4,
  824.4,
  824.2,
  824,
  824,
  823.8,
  823.8,
  823.6,
  823.6,
  823.6,
  823.4,
  823.4,
  823.2,
  823.2,
  823,
  823,
  822.8,
  822.8,
  822.8,
  822.6,
  822.6,
  822.4,
  822.4,
  822.4,
  822.2,
  822.2,
  822.2,
  822.2,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
];
a[53] = [
  828.4,
  828.2,
  828,
  828,
  827.8,
  827.6,
  827.4,
  827.2,
  827.2,
  827,
  826.8,
  826.6,
  826.4,
  826.2,
  826.2,
  826,
  825.8,
  825.6,
  825.6,
  825.4,
  825.2,
  825.2,
  825,
  824.8,
  824.8,
  824.6,
  824.4,
  824.4,
  824.2,
  824.2,
  824,
  823.8,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.2,
  823.2,
  823.2,
  823,
  823,
  822.8,
  822.8,
  822.6,
  822.6,
  822.6,
  822.4,
  822.4,
  822.2,
  822.2,
  822.2,
  822,
  822,
  822,
  822,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822,
  822,
  822,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
];
a[52] = [
  828.2,
  828,
  827.8,
  827.8,
  827.6,
  827.4,
  827.2,
  827,
  827,
  826.8,
  826.6,
  826.4,
  826.2,
  826,
  826,
  825.8,
  825.6,
  825.4,
  825.4,
  825.2,
  825,
  825,
  824.8,
  824.6,
  824.6,
  824.4,
  824.2,
  824.2,
  824,
  824,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.2,
  823.2,
  823,
  823,
  823,
  822.8,
  822.8,
  822.6,
  822.6,
  822.4,
  822.4,
  822.4,
  822.2,
  822.2,
  822.2,
  822,
  822,
  822,
  821.8,
  821.8,
  821.8,
  821.8,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
];
a[51] = [
  828,
  827.8,
  827.6,
  827.6,
  827.4,
  827.2,
  827,
  827,
  826.8,
  826.6,
  826.4,
  826.2,
  826,
  826,
  825.8,
  825.6,
  825.4,
  825.4,
  825.2,
  825,
  824.8,
  824.8,
  824.6,
  824.4,
  824.4,
  824.2,
  824,
  824,
  823.8,
  823.8,
  823.6,
  823.6,
  823.4,
  823.2,
  823.2,
  823,
  823,
  823,
  822.8,
  822.8,
  822.6,
  822.6,
  822.4,
  822.4,
  822.2,
  822.2,
  822.2,
  822,
  822,
  822,
  821.8,
  821.8,
  821.8,
  821.8,
  821.6,
  821.6,
  821.6,
  821.6,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
  840.2,
];
a[50] = [
  827.6,
  827.4,
  827.4,
  827.2,
  827,
  826.8,
  826.6,
  826.6,
  826.4,
  826.2,
  826,
  825.8,
  825.8,
  825.6,
  825.4,
  825.2,
  825.2,
  825,
  824.8,
  824.6,
  824.6,
  824.4,
  824.2,
  824.2,
  824,
  823.8,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.2,
  823,
  823,
  822.8,
  822.8,
  822.6,
  822.6,
  822.6,
  822.4,
  822.4,
  822.2,
  822.2,
  822,
  822,
  822,
  821.8,
  821.8,
  821.8,
  821.6,
  821.6,
  821.6,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
];
a[49] = [
  827.4,
  827.2,
  827,
  827,
  826.8,
  826.6,
  826.4,
  826.4,
  826.2,
  826,
  825.8,
  825.6,
  825.6,
  825.4,
  825.2,
  825,
  825,
  824.8,
  824.6,
  824.4,
  824.4,
  824.2,
  824,
  824,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.2,
  823.2,
  823,
  823,
  822.8,
  822.6,
  822.6,
  822.6,
  822.4,
  822.4,
  822.2,
  822.2,
  822,
  822,
  821.8,
  821.8,
  821.8,
  821.6,
  821.6,
  821.6,
  821.4,
  821.4,
  821.4,
  821.4,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821,
  821,
  821,
  821,
  821,
  821,
  821,
  821,
  821,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
];
a[48] = [
  827.2,
  827,
  826.8,
  826.8,
  826.6,
  826.4,
  826.2,
  826.2,
  826,
  825.8,
  825.6,
  825.4,
  825.4,
  825.2,
  825,
  824.8,
  824.8,
  824.6,
  824.4,
  824.2,
  824.2,
  824,
  823.8,
  823.8,
  823.6,
  823.4,
  823.4,
  823.2,
  823.2,
  823,
  823,
  822.8,
  822.8,
  822.6,
  822.6,
  822.4,
  822.4,
  822.2,
  822.2,
  822,
  822,
  821.8,
  821.8,
  821.8,
  821.6,
  821.6,
  821.6,
  821.4,
  821.4,
  821.4,
  821.2,
  821.2,
  821.2,
  821.2,
  821,
  821,
  821,
  821,
  821,
  821,
  821,
  820.8,
  820.8,
  820.8,
  821,
  821,
  821,
  821,
  821,
  821,
  821,
  821.2,
  821.2,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
  840.2,
];
a[47] = [
  826.8,
  826.6,
  826.6,
  826.4,
  826.2,
  826.2,
  826,
  825.8,
  825.6,
  825.4,
  825.4,
  825.2,
  825,
  824.8,
  824.6,
  824.6,
  824.4,
  824.2,
  824.2,
  824,
  823.8,
  823.6,
  823.6,
  823.4,
  823.4,
  823.2,
  823,
  823,
  822.8,
  822.8,
  822.6,
  822.6,
  822.4,
  822.4,
  822.2,
  822.2,
  822,
  822,
  821.8,
  821.8,
  821.6,
  821.6,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821.2,
  821.2,
  821,
  821,
  821,
  821,
  820.8,
  820.8,
  820.8,
  820.8,
  820.8,
  820.8,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.8,
  820.8,
  820.8,
  820.8,
  820.8,
  820.8,
  821,
  821,
  821,
  821,
  821.2,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
];
a[46] = [
  826.6,
  826.4,
  826.4,
  826.2,
  826,
  825.8,
  825.8,
  825.6,
  825.4,
  825.2,
  825.2,
  825,
  824.8,
  824.6,
  824.4,
  824.4,
  824.2,
  824,
  824,
  823.8,
  823.6,
  823.4,
  823.4,
  823.2,
  823.2,
  823,
  822.8,
  822.8,
  822.6,
  822.6,
  822.4,
  822.4,
  822.2,
  822.2,
  822,
  822,
  821.8,
  821.8,
  821.6,
  821.6,
  821.4,
  821.4,
  821.4,
  821.2,
  821.2,
  821.2,
  821,
  821,
  821,
  820.8,
  820.8,
  820.8,
  820.8,
  820.8,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.8,
  820.8,
  820.8,
  820.8,
  821,
  821,
  821,
  821,
  821.2,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
];
a[45] = [
  826.4,
  826.2,
  826.2,
  826,
  825.8,
  825.6,
  825.6,
  825.4,
  825.2,
  825,
  824.8,
  824.8,
  824.6,
  824.4,
  824.2,
  824.2,
  824,
  823.8,
  823.8,
  823.6,
  823.4,
  823.2,
  823.2,
  823,
  823,
  822.8,
  822.6,
  822.6,
  822.4,
  822.4,
  822.2,
  822.2,
  822,
  822,
  821.8,
  821.8,
  821.6,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821.2,
  821,
  821,
  821,
  820.8,
  820.8,
  820.8,
  820.8,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.4,
  820.4,
  820.4,
  820.4,
  820.4,
  820.4,
  820.4,
  820.4,
  820.4,
  820.4,
  820.6,
  820.6,
  820.6,
  820.6,
  820.8,
  820.8,
  820.8,
  820.8,
  821,
  821,
  821,
  821,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840.2,
];
a[44] = [
  826,
  826,
  825.8,
  825.6,
  825.6,
  825.4,
  825.2,
  825,
  824.8,
  824.8,
  824.6,
  824.4,
  824.2,
  824.2,
  824,
  823.8,
  823.6,
  823.6,
  823.4,
  823.2,
  823.2,
  823,
  822.8,
  822.8,
  822.6,
  822.4,
  822.4,
  822.2,
  822.2,
  822,
  822,
  821.8,
  821.8,
  821.6,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.8,
  820.6,
  820.6,
  820.6,
  820.6,
  820.6,
  820.4,
  820.4,
  820.4,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820.4,
  820.4,
  820.4,
  820.6,
  820.6,
  820.6,
  820.8,
  820.8,
  820.8,
  820.8,
  821,
  821,
  821,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[43] = [
  825.8,
  825.8,
  825.6,
  825.4,
  825.4,
  825.2,
  825,
  824.8,
  824.6,
  824.6,
  824.4,
  824.2,
  824,
  824,
  823.8,
  823.6,
  823.4,
  823.4,
  823.2,
  823,
  823,
  822.8,
  822.6,
  822.6,
  822.4,
  822.4,
  822.2,
  822,
  822,
  821.8,
  821.8,
  821.6,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.8,
  820.6,
  820.6,
  820.6,
  820.4,
  820.4,
  820.4,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820,
  820,
  820,
  820,
  820,
  820,
  820.2,
  820.2,
  820.2,
  820.4,
  820.4,
  820.4,
  820.4,
  820.6,
  820.6,
  820.6,
  820.8,
  820.8,
  820.8,
  821,
  821,
  821,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[42] = [
  825.6,
  825.6,
  825.4,
  825.2,
  825,
  825,
  824.8,
  824.6,
  824.4,
  824.4,
  824.2,
  824,
  823.8,
  823.6,
  823.6,
  823.4,
  823.2,
  823.2,
  823,
  822.8,
  822.8,
  822.6,
  822.4,
  822.4,
  822.2,
  822.2,
  822,
  821.8,
  821.8,
  821.6,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821,
  821,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.6,
  820.4,
  820.4,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820.2,
  820,
  820,
  820,
  820,
  820,
  820,
  820,
  820,
  820,
  820,
  820,
  820,
  820,
  820.2,
  820.2,
  820.2,
  820.4,
  820.4,
  820.4,
  820.6,
  820.6,
  820.6,
  820.8,
  820.8,
  820.8,
  821,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[41] = [
  825.4,
  825.2,
  825,
  825,
  824.8,
  824.6,
  824.4,
  824.4,
  824.2,
  824,
  823.8,
  823.6,
  823.6,
  823.4,
  823.2,
  823,
  823,
  822.8,
  822.6,
  822.6,
  822.4,
  822.2,
  822.2,
  822,
  822,
  821.8,
  821.8,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.6,
  820.4,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820,
  820,
  820,
  820,
  820,
  820,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  820,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.4,
  820.6,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821,
  821,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[40] = [
  825.2,
  825,
  824.8,
  824.8,
  824.6,
  824.4,
  824.2,
  824,
  824,
  823.8,
  823.6,
  823.4,
  823.4,
  823.2,
  823,
  822.8,
  822.8,
  822.6,
  822.4,
  822.4,
  822.2,
  822,
  822,
  821.8,
  821.8,
  821.6,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820,
  820,
  820,
  820,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  820,
  820,
  820,
  820.2,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[39] = [
  825,
  824.8,
  824.6,
  824.4,
  824.4,
  824.2,
  824,
  823.8,
  823.8,
  823.6,
  823.4,
  823.2,
  823.2,
  823,
  822.8,
  822.6,
  822.6,
  822.4,
  822.2,
  822.2,
  822,
  821.8,
  821.8,
  821.6,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.8,
  819.8,
  819.8,
  819.8,
  820,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[38] = [
  824.6,
  824.4,
  824.4,
  824.2,
  824,
  823.8,
  823.8,
  823.6,
  823.4,
  823.2,
  823,
  823,
  822.8,
  822.6,
  822.6,
  822.4,
  822.2,
  822.2,
  822,
  821.8,
  821.8,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.6,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.8,
  819.8,
  819.8,
  820,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[37] = [
  824.4,
  824.2,
  824.2,
  824,
  823.8,
  823.6,
  823.4,
  823.4,
  823.2,
  823,
  822.8,
  822.8,
  822.6,
  822.4,
  822.4,
  822.2,
  822,
  822,
  821.8,
  821.6,
  821.6,
  821.4,
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.8,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[36] = [
  824.2,
  824,
  823.8,
  823.8,
  823.6,
  823.4,
  823.2,
  823.2,
  823,
  822.8,
  822.6,
  822.6,
  822.4,
  822.2,
  822.2,
  822,
  821.8,
  821.8,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821,
  820.8,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.4,
  820.2,
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.6,
  819.6,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[35] = [
  823.8,
  823.6,
  823.6,
  823.4,
  823.2,
  823,
  823,
  822.8,
  822.6,
  822.4,
  822.4,
  822.2,
  822,
  822,
  821.8,
  821.6,
  821.6,
  821.4,
  821.4,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.4,
  820.2,
  820.2,
  820,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.6,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  826,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[34] = [
  823.6,
  823.4,
  823.2,
  823.2,
  823,
  822.8,
  822.8,
  822.6,
  822.4,
  822.2,
  822.2,
  822,
  821.8,
  821.8,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820,
  820,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.4,
  819.4,
  819.4,
  819.4,
  819.6,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[33] = [
  823.4,
  823.2,
  823,
  823,
  822.8,
  822.6,
  822.4,
  822.4,
  822.2,
  822,
  822,
  821.8,
  821.6,
  821.6,
  821.4,
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.6,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820,
  820,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.4,
  819.4,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[32] = [
  823,
  822.8,
  822.8,
  822.6,
  822.4,
  822.4,
  822.2,
  822,
  821.8,
  821.8,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.2,
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.4,
  819.4,
  819.4,
  819.6,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[31] = [
  822.8,
  822.6,
  822.6,
  822.4,
  822.2,
  822,
  822,
  821.8,
  821.6,
  821.6,
  821.4,
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819.2,
  819.2,
  819.2,
  819.2,
  819.4,
  819.4,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[30] = [
  822.6,
  822.4,
  822.2,
  822.2,
  822,
  821.8,
  821.8,
  821.6,
  821.4,
  821.4,
  821.2,
  821,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.2,
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819.2,
  819.2,
  819.2,
  819.4,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
  840,
];
a[29] = [
  822.2,
  822,
  822,
  821.8,
  821.6,
  821.6,
  821.4,
  821.4,
  821.2,
  821,
  821,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.4,
  820.2,
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819.2,
  819.2,
  819.2,
  819.4,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
];
a[28] = [
  822,
  821.8,
  821.8,
  821.6,
  821.4,
  821.4,
  821.2,
  821.2,
  821,
  820.8,
  820.8,
  820.6,
  820.4,
  820.4,
  820.4,
  820.2,
  820.2,
  820,
  820,
  820,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  819,
  819,
  819,
  819,
  819,
  819.2,
  819.2,
  819.4,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
];
a[27] = [
  821.8,
  821.6,
  821.6,
  821.4,
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.2,
  820.2,
  820,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  819,
  819,
  819,
  819.2,
  819.2,
  819.4,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
];
a[26] = [
  821.4,
  821.4,
  821.2,
  821.2,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.2,
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  819,
  819,
  819.2,
  819.2,
  819.4,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
];
a[25] = [
  821.2,
  821.2,
  821,
  821,
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.2,
  820.2,
  820,
  819.8,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  819,
  819,
  819,
  819.2,
  819.4,
  819.4,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
];
a[24] = [
  821,
  821,
  820.8,
  820.8,
  820.6,
  820.6,
  820.4,
  820.2,
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  819,
  819,
  819.2,
  819.4,
  819.4,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  823,
  823,
  823,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
  840,
];
a[23] = [
  820.8,
  820.6,
  820.6,
  820.4,
  820.4,
  820.2,
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  818.8,
  818.8,
  819,
  819,
  819.2,
  819.4,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
];
a[22] = [
  820.6,
  820.4,
  820.4,
  820.2,
  820.2,
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  818.8,
  819,
  819,
  819.2,
  819.4,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
];
a[21] = [
  820.4,
  820.4,
  820.2,
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  818.8,
  819,
  819,
  819.2,
  819.4,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.2,
  823.2,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
];
a[20] = [
  820.2,
  820,
  820,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  818.8,
  819,
  819.2,
  819.2,
  819.4,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821.2,
  821.2,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
];
a[19] = [
  820,
  819.8,
  819.8,
  819.8,
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  818.8,
  819,
  819.2,
  819.2,
  819.4,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.6,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
];
a[18] = [
  819.8,
  819.8,
  819.6,
  819.6,
  819.6,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.4,
  818.4,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  818.8,
  819,
  819.2,
  819.2,
  819.4,
  819.6,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
];
a[17] = [
  819.6,
  819.6,
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.4,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  819,
  819,
  819.2,
  819.4,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
];
a[16] = [
  819.4,
  819.4,
  819.4,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  819,
  819.2,
  819.2,
  819.4,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.2,
  822.4,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
  840,
];
a[15] = [
  819.4,
  819.2,
  819.2,
  819.2,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818,
  818,
  818,
  818,
  818,
  818,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  818.2,
  818.2,
  818.2,
  818.2,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.8,
  818.8,
  819,
  819.2,
  819.2,
  819.4,
  819.6,
  819.6,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.6,
  820.8,
  820.8,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.6,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[14] = [
  819.2,
  819.2,
  819,
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818,
  818,
  818,
  818,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  818,
  818,
  818,
  818,
  818,
  818.2,
  818.2,
  818.2,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.8,
  819,
  819,
  819.2,
  819.4,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.6,
  822.8,
  823,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[13] = [
  819,
  819,
  818.8,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818,
  818,
  818,
  818,
  818,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  818,
  818,
  818,
  818.2,
  818.2,
  818.4,
  818.4,
  818.6,
  818.6,
  818.6,
  818.8,
  819,
  819,
  819.2,
  819.4,
  819.4,
  819.6,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.6,
  822.8,
  823,
  823,
  823.2,
  823.4,
  823.4,
  823.6,
  823.8,
  823.8,
  823.8,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[12] = [
  819,
  818.8,
  818.8,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818,
  818,
  818,
  818,
  818,
  818,
  818,
  817.8,
  817.8,
  817.8,
  817.8,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.8,
  817.8,
  817.8,
  817.8,
  818,
  818,
  818,
  818.2,
  818.2,
  818.2,
  818.4,
  818.6,
  818.6,
  818.8,
  818.8,
  819,
  819.2,
  819.4,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.2,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824.2,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.8,
  828,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[11] = [
  818.8,
  818.6,
  818.6,
  818.6,
  818.4,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818.2,
  818,
  818,
  818,
  818,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.8,
  817.8,
  817.8,
  817.8,
  818,
  818,
  818.2,
  818.2,
  818.2,
  818.4,
  818.6,
  818.6,
  818.8,
  819,
  819,
  819.2,
  819.4,
  819.6,
  819.6,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.6,
  820.8,
  820.8,
  821,
  821.2,
  821.2,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.2,
  823.4,
  823.6,
  823.6,
  823.8,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.4,
  833.4,
  833.6,
  833.8,
  833.8,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[10] = [
  818.6,
  818.4,
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818.2,
  818,
  818,
  818,
  818,
  818,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.8,
  817.8,
  817.8,
  818,
  818,
  818.2,
  818.2,
  818.4,
  818.6,
  818.8,
  818.8,
  819,
  819.2,
  819.4,
  819.6,
  819.6,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.6,
  822.6,
  822.8,
  823,
  823,
  823.2,
  823.4,
  823.4,
  823.6,
  823.6,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.4,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[9] = [
  818.4,
  818.4,
  818.2,
  818.2,
  818.2,
  818,
  818,
  818,
  818,
  818,
  818,
  817.8,
  817.8,
  817.8,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.8,
  817.8,
  817.8,
  818,
  818.2,
  818.4,
  818.6,
  818.6,
  818.8,
  819,
  819.2,
  819.2,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821.2,
  821.2,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.6,
  822.8,
  823,
  823.2,
  823.2,
  823.4,
  823.4,
  823.6,
  823.8,
  823.8,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  833,
  833,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[8] = [
  818.2,
  818.2,
  818.2,
  818,
  818,
  818,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.8,
  817.6,
  817.6,
  817.6,
  817.6,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.6,
  817.6,
  817.6,
  817.8,
  817.8,
  817.8,
  818,
  818.2,
  818.4,
  818.6,
  818.6,
  818.8,
  819,
  819.2,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.6,
  822.8,
  823,
  823,
  823.2,
  823.4,
  823.4,
  823.6,
  823.8,
  823.8,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[7] = [
  818,
  818,
  818,
  817.8,
  817.8,
  817.8,
  817.6,
  817.6,
  817.6,
  817.6,
  817.6,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.4,
  817.4,
  817.4,
  817.4,
  817.6,
  817.6,
  817.6,
  817.8,
  817.8,
  817.8,
  818,
  818.2,
  818.4,
  818.6,
  818.8,
  819,
  819.2,
  819.4,
  819.4,
  819.6,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.2,
  823.4,
  823.6,
  823.6,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.6,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.8,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.6,
  832.6,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[6] = [
  818,
  817.8,
  817.8,
  817.8,
  817.6,
  817.6,
  817.6,
  817.4,
  817.4,
  817.4,
  817.4,
  817.4,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.4,
  817.4,
  817.4,
  817.4,
  817.6,
  817.6,
  817.8,
  817.8,
  817.8,
  818,
  818.2,
  818.4,
  818.6,
  818.8,
  819,
  819.2,
  819.4,
  819.6,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.4,
  823.4,
  823.6,
  823.8,
  824,
  824,
  824.2,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.2,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[5] = [
  817.8,
  817.8,
  817.6,
  817.6,
  817.6,
  817.4,
  817.4,
  817.4,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817.2,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  816.8,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817.2,
  817.2,
  817.2,
  817.2,
  817.4,
  817.4,
  817.4,
  817.4,
  817.6,
  817.6,
  817.8,
  817.8,
  818,
  818.2,
  818.4,
  818.6,
  818.8,
  819,
  819.2,
  819.4,
  819.6,
  819.8,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.2,
  823.4,
  823.6,
  823.6,
  823.8,
  824,
  824,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832.2,
  832.2,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.2,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[4] = [
  817.6,
  817.6,
  817.4,
  817.4,
  817.4,
  817.2,
  817.2,
  817.2,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  816.8,
  816.8,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817.2,
  817.2,
  817.2,
  817.2,
  817.4,
  817.4,
  817.4,
  817.6,
  817.6,
  817.8,
  817.8,
  818,
  818.2,
  818.4,
  818.6,
  819,
  819.2,
  819.4,
  819.6,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.4,
  823.4,
  823.6,
  823.8,
  823.8,
  824,
  824.2,
  824.2,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828.2,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.6,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  831.8,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
  840,
];
a[3] = [
  817.4,
  817.4,
  817.4,
  817.2,
  817.2,
  817.2,
  817.2,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  817,
  817,
  817,
  817,
  817,
  817,
  817.2,
  817.2,
  817.2,
  817.4,
  817.4,
  817.6,
  817.6,
  817.6,
  817.8,
  818,
  818,
  818.4,
  818.6,
  818.8,
  819.2,
  819.4,
  819.4,
  819.6,
  819.8,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.6,
  821.6,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.6,
  822.8,
  823,
  823,
  823.2,
  823.4,
  823.6,
  823.6,
  823.8,
  824,
  824.2,
  824.2,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831,
  831.2,
  831.4,
  831.4,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  834.8,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
];
a[2] = [
  817.4,
  817.2,
  817.2,
  817.2,
  817.2,
  817,
  817,
  817,
  817,
  816.8,
  816.8,
  816.8,
  817,
  817,
  817,
  817,
  817,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  817,
  817,
  817,
  817,
  817.2,
  817.2,
  817.2,
  817.4,
  817.4,
  817.6,
  817.6,
  817.8,
  818,
  818,
  818.2,
  818.6,
  818.8,
  819,
  819.2,
  819.4,
  819.6,
  819.8,
  820,
  820,
  820.2,
  820.4,
  820.4,
  820.4,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.4,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.4,
  823.4,
  823.6,
  823.8,
  823.8,
  824,
  824.2,
  824.4,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.4,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.6,
  829.6,
  829.8,
  829.8,
  830,
  830,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
];
a[1] = [
  817.2,
  817.2,
  817,
  817,
  817,
  817,
  817,
  817,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  817,
  817,
  817,
  817,
  817.2,
  817.2,
  817.4,
  817.4,
  817.4,
  817.6,
  817.8,
  817.8,
  818,
  818.2,
  818.4,
  818.8,
  819,
  819.2,
  819.6,
  819.6,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.4,
  821.4,
  821.6,
  821.6,
  821.8,
  821.8,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.6,
  822.8,
  823,
  823,
  823.2,
  823.4,
  823.4,
  823.6,
  823.8,
  824,
  824,
  824.2,
  824.4,
  824.6,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  826.8,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828,
  828.2,
  828.2,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  828.8,
  829,
  829,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
];
a[0] = [
  817,
  817,
  817,
  817,
  817,
  817,
  817,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  816.8,
  817,
  817,
  817,
  817.2,
  817.2,
  817.4,
  817.4,
  817.6,
  817.6,
  817.8,
  818,
  818.2,
  818.4,
  818.6,
  819,
  819.2,
  819.4,
  819.6,
  819.8,
  820,
  820,
  820.2,
  820.2,
  820.4,
  820.4,
  820.6,
  820.6,
  820.8,
  820.8,
  821,
  821,
  821.2,
  821.2,
  821.4,
  821.4,
  821.6,
  821.8,
  821.8,
  822,
  822,
  822.2,
  822.2,
  822.4,
  822.6,
  822.8,
  822.8,
  823,
  823.2,
  823.2,
  823.4,
  823.6,
  823.6,
  823.8,
  824,
  824.2,
  824.4,
  824.4,
  824.6,
  824.8,
  824.8,
  825,
  825,
  825,
  825,
  825.2,
  825.2,
  825.2,
  825.2,
  825.4,
  825.4,
  825.4,
  825.6,
  825.6,
  825.6,
  825.6,
  825.8,
  825.8,
  825.8,
  826,
  826,
  826,
  826,
  826.2,
  826.2,
  826.2,
  826.4,
  826.4,
  826.4,
  826.6,
  826.6,
  826.6,
  826.8,
  826.8,
  827,
  827,
  827,
  827.2,
  827.2,
  827.2,
  827.4,
  827.4,
  827.6,
  827.6,
  827.8,
  827.8,
  828,
  828,
  828,
  828.2,
  828.4,
  828.4,
  828.4,
  828.6,
  828.6,
  828.8,
  829,
  829,
  829.2,
  829.2,
  829.4,
  829.4,
  829.6,
  829.6,
  829.8,
  830,
  830,
  830.2,
  830.2,
  830.4,
  830.4,
  830.6,
  830.8,
  830.8,
  831,
  831.2,
  831.2,
  831.4,
  831.6,
  831.6,
  831.8,
  832,
  832,
  832.2,
  832.4,
  832.4,
  832.6,
  832.8,
  832.8,
  833,
  833.2,
  833.2,
  833.4,
  833.6,
  833.6,
  833.8,
  834,
  834,
  834.2,
  834.4,
  834.4,
  834.6,
  834.6,
  834.8,
  835,
  835,
  835,
  835.2,
  835.2,
  835.2,
  835.4,
  835.4,
  835.4,
  835.4,
  835.6,
  835.6,
  835.6,
  835.6,
  835.8,
  835.8,
  835.8,
  835.8,
  836,
  836,
  836,
  836,
  836.2,
  836.2,
  836.2,
  836.2,
  836.2,
  836.4,
  836.4,
  836.4,
  836.4,
  836.6,
  836.6,
  836.6,
  836.6,
  836.6,
  836.8,
  836.8,
  836.8,
  836.8,
  837,
  837,
  837,
  837,
  837,
  837.2,
  837.2,
  837.2,
  837.2,
  837.2,
  837.4,
  837.4,
  837.4,
  837.4,
  837.4,
  837.6,
  837.6,
  837.6,
  837.6,
  837.6,
  837.8,
  837.8,
  837.8,
  837.8,
  837.8,
  838,
  838,
  838,
  838,
  838,
  838.2,
  838.2,
  838.2,
  838.2,
  838.2,
  838.4,
  838.4,
  838.4,
  838.4,
  838.4,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.6,
  838.8,
  838.8,
  838.8,
  838.8,
  839,
  839,
  839,
  839,
  839,
  839,
  839.2,
  839.2,
  839.2,
  839.2,
  839.2,
  839.4,
  839.4,
  839.4,
  839.4,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.6,
  839.8,
  839.8,
  839.8,
  839.8,
  839.8,
  840,
  840,
];

dataMaps.surf = new DataMapNumeric(
  'Surface Elevation',
  'Surface Elevation Above Sea Level',
  'ft',
  a,
  320,
  200,
);

a = [];
a[199] = [
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.34,
  807.34,
  807.34,
  807.34,
  807.34,
  807.33,
  807.33,
  807.33,
  807.32,
  807.32,
  807.32,
  807.31,
  807.31,
  807.31,
  807.31,
  807.3,
  807.3,
  807.3,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
  807.68,
  807.68,
  807.68,
];
a[198] = [
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.34,
  807.34,
  807.34,
  807.34,
  807.34,
  807.33,
  807.33,
  807.33,
  807.32,
  807.32,
  807.32,
  807.31,
  807.31,
  807.31,
  807.31,
  807.3,
  807.3,
  807.3,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
  807.68,
  807.68,
  807.68,
];
a[197] = [
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.34,
  807.34,
  807.33,
  807.33,
  807.33,
  807.32,
  807.32,
  807.32,
  807.31,
  807.31,
  807.31,
  807.3,
  807.3,
  807.3,
  807.3,
  807.29,
  807.29,
  807.29,
  807.29,
  807.28,
  807.28,
  807.28,
  807.28,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.68,
  807.68,
  807.68,
];
a[196] = [
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.33,
  807.34,
  807.33,
  807.33,
  807.33,
  807.32,
  807.32,
  807.32,
  807.31,
  807.31,
  807.3,
  807.3,
  807.3,
  807.3,
  807.29,
  807.29,
  807.29,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.68,
  807.68,
  807.68,
];
a[195] = [
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.32,
  807.32,
  807.31,
  807.31,
  807.31,
  807.3,
  807.3,
  807.3,
  807.29,
  807.29,
  807.29,
  807.28,
  807.28,
  807.28,
  807.28,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.68,
  807.68,
  807.68,
];
a[194] = [
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.32,
  807.31,
  807.31,
  807.3,
  807.3,
  807.3,
  807.29,
  807.29,
  807.29,
  807.28,
  807.28,
  807.28,
  807.28,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
  807.68,
  807.68,
];
a[193] = [
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.31,
  807.3,
  807.3,
  807.3,
  807.3,
  807.29,
  807.29,
  807.29,
  807.28,
  807.28,
  807.28,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
  807.68,
  807.68,
];
a[192] = [
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.3,
  807.29,
  807.29,
  807.29,
  807.28,
  807.28,
  807.28,
  807.28,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
  807.68,
  807.68,
];
a[191] = [
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.28,
  807.28,
  807.28,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.68,
  807.68,
];
a[190] = [
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.28,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
  807.68,
];
a[189] = [
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
  807.68,
];
a[188] = [
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.27,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
  807.68,
];
a[187] = [
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.26,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.68,
];
a[186] = [
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
];
a[185] = [
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.25,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
];
a[184] = [
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.24,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
  807.67,
];
a[183] = [
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
];
a[182] = [
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.23,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
];
a[181] = [
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
];
a[180] = [
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
];
a[179] = [
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.22,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
];
a[178] = [
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
];
a[177] = [
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.21,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.17,
  807.17,
  807.16,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
  807.67,
];
a[176] = [
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.18,
  807.17,
  807.16,
  807.15,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
];
a[175] = [
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.2,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.18,
  807.16,
  807.15,
  807.14,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
];
a[174] = [
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.17,
  807.15,
  807.14,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
];
a[173] = [
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.19,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.14,
  807.13,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
];
a[172] = [
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
  807.67,
];
a[171] = [
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.18,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
];
a[170] = [
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
];
a[169] = [
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.17,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
];
a[168] = [
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
  807.67,
];
a[167] = [
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.16,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.67,
];
a[166] = [
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
];
a[165] = [
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.15,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
  807.66,
];
a[164] = [
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
];
a[163] = [
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
];
a[162] = [
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.14,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
];
a[161] = [
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
  807.66,
];
a[160] = [
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.13,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
];
a[159] = [
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.66,
  807.66,
];
a[158] = [
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.12,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.65,
  807.66,
];
a[157] = [
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.65,
  807.66,
];
a[156] = [
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.11,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
  807.65,
];
a[155] = [
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
];
a[154] = [
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
  807.65,
];
a[153] = [
  807.1,
  807.1,
  807.1,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
];
a[152] = [
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
];
a[151] = [
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.09,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
  807.65,
];
a[150] = [
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.65,
];
a[149] = [
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.08,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
  807.64,
];
a[148] = [
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
];
a[147] = [
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
];
a[146] = [
  807.07,
  807.07,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
  807.64,
];
a[145] = [
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
];
a[144] = [
  807.06,
  807.06,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
  807.64,
];
a[143] = [
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
];
a[142] = [
  807.05,
  807.05,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
];
a[141] = [
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
];
a[140] = [
  807.04,
  807.04,
  807.04,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
];
a[139] = [
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
];
a[138] = [
  807.02,
  807.02,
  807.02,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
];
a[137] = [
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
];
a[136] = [
  807.01,
  807.01,
  807.01,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
];
a[135] = [
  807,
  807,
  807,
  807,
  807,
  807,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
];
a[134] = [
  807,
  807,
  807,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.05,
  807.06,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
];
a[133] = [
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
];
a[132] = [
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
];
a[131] = [
  806.98,
  806.98,
  806.98,
  806.97,
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
];
a[130] = [
  806.97,
  806.97,
  806.97,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.91,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
];
a[129] = [
  806.96,
  806.96,
  806.96,
  806.96,
  806.96,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
];
a[128] = [
  806.95,
  806.95,
  806.95,
  806.95,
  806.95,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.04,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
];
a[127] = [
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.94,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.93,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
];
a[126] = [
  806.94,
  806.94,
  806.93,
  806.93,
  806.93,
  806.93,
  806.93,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
];
a[125] = [
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.92,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
];
a[124] = [
  806.92,
  806.92,
  806.91,
  806.91,
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.08,
  807.09,
  807.09,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
];
a[123] = [
  806.91,
  806.91,
  806.91,
  806.9,
  806.9,
  806.9,
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
];
a[122] = [
  806.9,
  806.9,
  806.89,
  806.89,
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
];
a[121] = [
  806.89,
  806.89,
  806.89,
  806.88,
  806.88,
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
];
a[120] = [
  806.88,
  806.88,
  806.88,
  806.87,
  806.87,
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807,
  807,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
];
a[119] = [
  806.87,
  806.87,
  806.87,
  806.86,
  806.86,
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.04,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.11,
  807.11,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
];
a[118] = [
  806.86,
  806.86,
  806.86,
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.79,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  807,
  807.01,
  807.04,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
];
a[117] = [
  806.85,
  806.85,
  806.85,
  806.85,
  806.85,
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.99,
  807,
  807.01,
  807.02,
  807.04,
  807.05,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
];
a[116] = [
  806.84,
  806.84,
  806.84,
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.79,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.02,
  807.04,
  807.04,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
];
a[115] = [
  806.83,
  806.83,
  806.83,
  806.83,
  806.83,
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.02,
  807.04,
  807.04,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
];
a[114] = [
  806.82,
  806.82,
  806.82,
  806.81,
  806.81,
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
];
a[113] = [
  806.81,
  806.81,
  806.81,
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
];
a[112] = [
  806.8,
  806.8,
  806.8,
  806.8,
  806.8,
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
];
a[111] = [
  806.79,
  806.79,
  806.79,
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
];
a[110] = [
  806.78,
  806.78,
  806.78,
  806.78,
  806.78,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
];
a[109] = [
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.77,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  806.99,
  806.99,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
];
a[108] = [
  806.76,
  806.76,
  806.76,
  806.76,
  806.76,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
];
a[107] = [
  806.75,
  806.75,
  806.75,
  806.75,
  806.75,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.7,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
];
a[106] = [
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.74,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
];
a[105] = [
  806.73,
  806.73,
  806.73,
  806.73,
  806.73,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.69,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
];
a[104] = [
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.72,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.65,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.68,
  806.68,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
];
a[103] = [
  806.72,
  806.72,
  806.71,
  806.71,
  806.71,
  806.71,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.96,
  806.97,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
];
a[102] = [
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.7,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.66,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
];
a[101] = [
  806.7,
  806.7,
  806.69,
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
];
a[100] = [
  806.69,
  806.69,
  806.69,
  806.68,
  806.68,
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
];
a[99] = [
  806.68,
  806.68,
  806.67,
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
];
a[98] = [
  806.67,
  806.67,
  806.67,
  806.66,
  806.66,
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.61,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[97] = [
  806.66,
  806.66,
  806.65,
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.58,
  806.58,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[96] = [
  806.65,
  806.65,
  806.65,
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[95] = [
  806.64,
  806.64,
  806.64,
  806.63,
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.59,
  806.6,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[94] = [
  806.63,
  806.63,
  806.63,
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.49,
  806.48,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.44,
  806.44,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.55,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[93] = [
  806.62,
  806.62,
  806.62,
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.44,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.56,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[92] = [
  806.61,
  806.61,
  806.61,
  806.6,
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.42,
  806.42,
  806.42,
  806.43,
  806.43,
  806.43,
  806.43,
  806.44,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.52,
  806.52,
  806.52,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.56,
  806.56,
  806.57,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[91] = [
  806.6,
  806.6,
  806.6,
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.5,
  806.49,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.42,
  806.42,
  806.43,
  806.43,
  806.43,
  806.43,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[90] = [
  806.59,
  806.59,
  806.59,
  806.58,
  806.58,
  806.58,
  806.58,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.49,
  806.48,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.42,
  806.42,
  806.43,
  806.43,
  806.43,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.5,
  806.5,
  806.5,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[89] = [
  806.58,
  806.58,
  806.58,
  806.57,
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.48,
  806.47,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.39,
  806.39,
  806.39,
  806.39,
  806.39,
  806.4,
  806.4,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.42,
  806.42,
  806.43,
  806.43,
  806.43,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[88] = [
  806.57,
  806.57,
  806.57,
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.48,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.38,
  806.38,
  806.38,
  806.39,
  806.39,
  806.39,
  806.39,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.42,
  806.43,
  806.43,
  806.43,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.46,
  806.46,
  806.46,
  806.47,
  806.47,
  806.48,
  806.48,
  806.48,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[87] = [
  806.56,
  806.56,
  806.56,
  806.55,
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.53,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.47,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.39,
  806.38,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.37,
  806.37,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.38,
  806.38,
  806.39,
  806.39,
  806.39,
  806.39,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.42,
  806.43,
  806.43,
  806.43,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.47,
  806.47,
  806.48,
  806.48,
  806.49,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[86] = [
  806.55,
  806.55,
  806.55,
  806.54,
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.52,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.46,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.39,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.36,
  806.36,
  806.36,
  806.36,
  806.36,
  806.37,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.38,
  806.38,
  806.39,
  806.39,
  806.39,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.42,
  806.43,
  806.43,
  806.44,
  806.44,
  806.44,
  806.45,
  806.45,
  806.46,
  806.46,
  806.47,
  806.47,
  806.47,
  806.48,
  806.48,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[85] = [
  806.54,
  806.54,
  806.54,
  806.53,
  806.53,
  806.53,
  806.53,
  806.52,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.46,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.4,
  806.4,
  806.4,
  806.39,
  806.38,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.35,
  806.35,
  806.35,
  806.35,
  806.35,
  806.36,
  806.36,
  806.36,
  806.36,
  806.37,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.38,
  806.39,
  806.39,
  806.39,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.43,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.47,
  806.47,
  806.48,
  806.48,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[84] = [
  806.53,
  806.53,
  806.53,
  806.52,
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.46,
  806.46,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.39,
  806.39,
  806.39,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.36,
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.34,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.34,
  806.35,
  806.35,
  806.35,
  806.35,
  806.36,
  806.36,
  806.36,
  806.37,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.38,
  806.39,
  806.39,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.43,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.46,
  806.46,
  806.47,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[83] = [
  806.52,
  806.52,
  806.52,
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.46,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.41,
  806.4,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.38,
  806.38,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.34,
  806.33,
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.32,
  806.32,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.33,
  806.33,
  806.33,
  806.33,
  806.33,
  806.34,
  806.34,
  806.34,
  806.34,
  806.35,
  806.35,
  806.35,
  806.36,
  806.36,
  806.36,
  806.36,
  806.37,
  806.37,
  806.38,
  806.38,
  806.38,
  806.39,
  806.39,
  806.39,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.43,
  806.44,
  806.44,
  806.45,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.48,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[82] = [
  806.51,
  806.51,
  806.51,
  806.5,
  806.5,
  806.5,
  806.5,
  806.49,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.45,
  806.44,
  806.44,
  806.44,
  806.44,
  806.43,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.4,
  806.39,
  806.39,
  806.39,
  806.39,
  806.38,
  806.38,
  806.37,
  806.37,
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.34,
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.32,
  806.32,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.32,
  806.33,
  806.33,
  806.33,
  806.33,
  806.34,
  806.34,
  806.34,
  806.35,
  806.35,
  806.35,
  806.36,
  806.36,
  806.36,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.38,
  806.39,
  806.39,
  806.4,
  806.4,
  806.41,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.43,
  806.44,
  806.44,
  806.45,
  806.45,
  806.46,
  806.46,
  806.47,
  806.47,
  806.48,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[81] = [
  806.51,
  806.51,
  806.5,
  806.49,
  806.49,
  806.49,
  806.49,
  806.48,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.44,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.39,
  806.39,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.36,
  806.36,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.34,
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.32,
  806.31,
  806.31,
  806.31,
  806.31,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.31,
  806.31,
  806.31,
  806.31,
  806.31,
  806.32,
  806.32,
  806.32,
  806.32,
  806.33,
  806.33,
  806.33,
  806.33,
  806.34,
  806.34,
  806.34,
  806.35,
  806.35,
  806.35,
  806.36,
  806.36,
  806.36,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.39,
  806.39,
  806.4,
  806.4,
  806.4,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.43,
  806.44,
  806.44,
  806.45,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[80] = [
  806.49,
  806.49,
  806.49,
  806.48,
  806.48,
  806.48,
  806.47,
  806.47,
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.4,
  806.4,
  806.39,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.32,
  806.31,
  806.31,
  806.31,
  806.3,
  806.3,
  806.3,
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.3,
  806.3,
  806.3,
  806.31,
  806.31,
  806.31,
  806.31,
  806.32,
  806.32,
  806.32,
  806.32,
  806.33,
  806.33,
  806.33,
  806.34,
  806.34,
  806.34,
  806.35,
  806.35,
  806.35,
  806.36,
  806.36,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.39,
  806.39,
  806.4,
  806.4,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.43,
  806.44,
  806.44,
  806.45,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[79] = [
  806.49,
  806.49,
  806.48,
  806.47,
  806.47,
  806.47,
  806.47,
  806.46,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.42,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.39,
  806.39,
  806.38,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.34,
  806.34,
  806.34,
  806.33,
  806.33,
  806.32,
  806.32,
  806.32,
  806.31,
  806.31,
  806.31,
  806.3,
  806.3,
  806.3,
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.29,
  806.29,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.3,
  806.3,
  806.31,
  806.31,
  806.31,
  806.31,
  806.32,
  806.32,
  806.32,
  806.33,
  806.33,
  806.33,
  806.34,
  806.34,
  806.35,
  806.35,
  806.35,
  806.36,
  806.36,
  806.37,
  806.37,
  806.37,
  806.38,
  806.38,
  806.39,
  806.39,
  806.4,
  806.4,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[78] = [
  806.48,
  806.48,
  806.47,
  806.47,
  806.47,
  806.46,
  806.46,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.41,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.38,
  806.38,
  806.37,
  806.37,
  806.36,
  806.36,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.31,
  806.31,
  806.31,
  806.3,
  806.3,
  806.3,
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.28,
  806.27,
  806.27,
  806.27,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.28,
  806.29,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.3,
  806.3,
  806.31,
  806.31,
  806.31,
  806.32,
  806.32,
  806.32,
  806.33,
  806.33,
  806.34,
  806.34,
  806.34,
  806.35,
  806.35,
  806.36,
  806.36,
  806.36,
  806.37,
  806.37,
  806.38,
  806.38,
  806.39,
  806.39,
  806.4,
  806.4,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[77] = [
  806.46,
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.45,
  806.44,
  806.43,
  806.43,
  806.43,
  806.42,
  806.42,
  806.41,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.38,
  806.38,
  806.37,
  806.37,
  806.37,
  806.36,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.33,
  806.33,
  806.32,
  806.32,
  806.32,
  806.31,
  806.3,
  806.3,
  806.3,
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.28,
  806.27,
  806.27,
  806.27,
  806.27,
  806.26,
  806.26,
  806.26,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.28,
  806.28,
  806.28,
  806.28,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.3,
  806.31,
  806.31,
  806.31,
  806.32,
  806.32,
  806.32,
  806.33,
  806.33,
  806.34,
  806.34,
  806.34,
  806.35,
  806.35,
  806.36,
  806.36,
  806.37,
  806.37,
  806.38,
  806.38,
  806.39,
  806.39,
  806.4,
  806.4,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[76] = [
  806.46,
  806.46,
  806.45,
  806.45,
  806.45,
  806.44,
  806.44,
  806.43,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.4,
  806.39,
  806.39,
  806.39,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.36,
  806.36,
  806.35,
  806.34,
  806.34,
  806.34,
  806.33,
  806.33,
  806.32,
  806.32,
  806.31,
  806.31,
  806.31,
  806.3,
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.28,
  806.27,
  806.27,
  806.27,
  806.26,
  806.26,
  806.26,
  806.26,
  806.25,
  806.25,
  806.25,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.26,
  806.26,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.27,
  806.27,
  806.27,
  806.28,
  806.28,
  806.28,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.3,
  806.31,
  806.31,
  806.31,
  806.32,
  806.32,
  806.33,
  806.33,
  806.33,
  806.34,
  806.34,
  806.35,
  806.35,
  806.36,
  806.36,
  806.37,
  806.37,
  806.38,
  806.38,
  806.39,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[75] = [
  806.45,
  806.45,
  806.44,
  806.44,
  806.44,
  806.43,
  806.43,
  806.42,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.39,
  806.39,
  806.38,
  806.38,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.35,
  806.34,
  806.34,
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.31,
  806.31,
  806.3,
  806.3,
  806.29,
  806.29,
  806.28,
  806.28,
  806.28,
  806.27,
  806.27,
  806.27,
  806.26,
  806.26,
  806.26,
  806.25,
  806.25,
  806.25,
  806.25,
  806.24,
  806.24,
  806.24,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.25,
  806.25,
  806.25,
  806.25,
  806.25,
  806.26,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.27,
  806.27,
  806.28,
  806.28,
  806.28,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.3,
  806.31,
  806.31,
  806.32,
  806.32,
  806.32,
  806.33,
  806.33,
  806.34,
  806.34,
  806.35,
  806.35,
  806.36,
  806.36,
  806.37,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[74] = [
  806.44,
  806.44,
  806.43,
  806.42,
  806.42,
  806.42,
  806.42,
  806.41,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.38,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.35,
  806.35,
  806.34,
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.31,
  806.3,
  806.3,
  806.3,
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.27,
  806.27,
  806.26,
  806.26,
  806.26,
  806.25,
  806.25,
  806.25,
  806.24,
  806.24,
  806.24,
  806.23,
  806.23,
  806.23,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.24,
  806.24,
  806.24,
  806.25,
  806.25,
  806.25,
  806.25,
  806.26,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.27,
  806.28,
  806.28,
  806.28,
  806.29,
  806.29,
  806.3,
  806.3,
  806.3,
  806.31,
  806.31,
  806.32,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.35,
  806.36,
  806.36,
  806.37,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[73] = [
  806.43,
  806.43,
  806.42,
  806.42,
  806.42,
  806.41,
  806.41,
  806.4,
  806.39,
  806.39,
  806.39,
  806.38,
  806.38,
  806.37,
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.34,
  806.34,
  806.33,
  806.32,
  806.32,
  806.32,
  806.31,
  806.31,
  806.3,
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.28,
  806.27,
  806.27,
  806.26,
  806.26,
  806.25,
  806.25,
  806.25,
  806.24,
  806.24,
  806.24,
  806.23,
  806.23,
  806.23,
  806.22,
  806.22,
  806.22,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.24,
  806.24,
  806.25,
  806.25,
  806.25,
  806.25,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.27,
  806.28,
  806.28,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.31,
  806.31,
  806.32,
  806.32,
  806.33,
  806.33,
  806.34,
  806.34,
  806.35,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[72] = [
  806.42,
  806.42,
  806.41,
  806.41,
  806.41,
  806.4,
  806.4,
  806.39,
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.36,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.33,
  806.33,
  806.32,
  806.31,
  806.31,
  806.31,
  806.3,
  806.3,
  806.29,
  806.28,
  806.28,
  806.28,
  806.27,
  806.27,
  806.27,
  806.26,
  806.26,
  806.25,
  806.25,
  806.24,
  806.24,
  806.24,
  806.23,
  806.23,
  806.23,
  806.22,
  806.22,
  806.22,
  806.21,
  806.21,
  806.21,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.22,
  806.22,
  806.22,
  806.22,
  806.22,
  806.23,
  806.23,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.24,
  806.25,
  806.25,
  806.25,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.27,
  806.28,
  806.28,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.31,
  806.31,
  806.32,
  806.32,
  806.33,
  806.33,
  806.34,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[71] = [
  806.41,
  806.41,
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.38,
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.35,
  806.34,
  806.34,
  806.34,
  806.33,
  806.33,
  806.32,
  806.31,
  806.31,
  806.3,
  806.3,
  806.29,
  806.28,
  806.28,
  806.28,
  806.27,
  806.27,
  806.26,
  806.26,
  806.26,
  806.25,
  806.25,
  806.24,
  806.23,
  806.23,
  806.23,
  806.22,
  806.22,
  806.22,
  806.21,
  806.21,
  806.21,
  806.2,
  806.2,
  806.2,
  806.19,
  806.19,
  806.19,
  806.19,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.21,
  806.22,
  806.22,
  806.22,
  806.22,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.24,
  806.25,
  806.25,
  806.25,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.28,
  806.28,
  806.29,
  806.29,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[70] = [
  806.4,
  806.4,
  806.4,
  806.39,
  806.39,
  806.38,
  806.38,
  806.37,
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.34,
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.31,
  806.3,
  806.3,
  806.29,
  806.29,
  806.28,
  806.27,
  806.27,
  806.27,
  806.26,
  806.26,
  806.26,
  806.25,
  806.25,
  806.24,
  806.24,
  806.23,
  806.22,
  806.22,
  806.22,
  806.21,
  806.21,
  806.21,
  806.2,
  806.2,
  806.2,
  806.19,
  806.19,
  806.19,
  806.18,
  806.18,
  806.18,
  806.18,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.2,
  806.2,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.21,
  806.21,
  806.22,
  806.22,
  806.22,
  806.22,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.24,
  806.25,
  806.25,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.28,
  806.28,
  806.29,
  806.29,
  806.3,
  806.3,
  806.31,
  806.31,
  806.32,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[69] = [
  806.39,
  806.39,
  806.39,
  806.38,
  806.38,
  806.37,
  806.37,
  806.36,
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.33,
  806.32,
  806.32,
  806.32,
  806.31,
  806.3,
  806.3,
  806.29,
  806.29,
  806.28,
  806.28,
  806.27,
  806.27,
  806.26,
  806.26,
  806.25,
  806.25,
  806.24,
  806.24,
  806.23,
  806.23,
  806.22,
  806.22,
  806.21,
  806.21,
  806.21,
  806.2,
  806.2,
  806.2,
  806.19,
  806.19,
  806.19,
  806.18,
  806.18,
  806.18,
  806.17,
  806.17,
  806.17,
  806.17,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.19,
  806.2,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.21,
  806.21,
  806.22,
  806.22,
  806.22,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.25,
  806.25,
  806.25,
  806.26,
  806.26,
  806.27,
  806.27,
  806.28,
  806.28,
  806.29,
  806.29,
  806.3,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[68] = [
  806.38,
  806.38,
  806.38,
  806.37,
  806.37,
  806.36,
  806.36,
  806.35,
  806.34,
  806.34,
  806.34,
  806.33,
  806.32,
  806.32,
  806.31,
  806.31,
  806.3,
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.27,
  806.27,
  806.26,
  806.25,
  806.25,
  806.25,
  806.24,
  806.24,
  806.23,
  806.23,
  806.22,
  806.22,
  806.21,
  806.21,
  806.2,
  806.2,
  806.19,
  806.19,
  806.19,
  806.18,
  806.18,
  806.18,
  806.17,
  806.17,
  806.17,
  806.16,
  806.16,
  806.16,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.18,
  806.18,
  806.18,
  806.18,
  806.18,
  806.19,
  806.19,
  806.19,
  806.19,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.21,
  806.22,
  806.22,
  806.22,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.25,
  806.25,
  806.26,
  806.26,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
];
a[67] = [
  806.37,
  806.37,
  806.37,
  806.36,
  806.36,
  806.35,
  806.35,
  806.34,
  806.33,
  806.33,
  806.33,
  806.32,
  806.31,
  806.31,
  806.3,
  806.3,
  806.29,
  806.28,
  806.28,
  806.28,
  806.27,
  806.27,
  806.26,
  806.26,
  806.25,
  806.24,
  806.24,
  806.24,
  806.23,
  806.22,
  806.22,
  806.21,
  806.21,
  806.21,
  806.2,
  806.2,
  806.19,
  806.19,
  806.18,
  806.18,
  806.18,
  806.17,
  806.17,
  806.17,
  806.16,
  806.16,
  806.16,
  806.15,
  806.15,
  806.15,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.17,
  806.18,
  806.18,
  806.18,
  806.18,
  806.19,
  806.19,
  806.19,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.21,
  806.22,
  806.22,
  806.23,
  806.23,
  806.23,
  806.24,
  806.24,
  806.25,
  806.25,
  806.26,
  806.26,
  806.27,
  806.27,
  806.28,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[66] = [
  806.36,
  806.36,
  806.36,
  806.35,
  806.35,
  806.34,
  806.34,
  806.33,
  806.32,
  806.32,
  806.31,
  806.3,
  806.3,
  806.3,
  806.29,
  806.29,
  806.28,
  806.27,
  806.27,
  806.26,
  806.26,
  806.25,
  806.24,
  806.24,
  806.24,
  806.23,
  806.23,
  806.22,
  806.21,
  806.21,
  806.21,
  806.2,
  806.2,
  806.19,
  806.19,
  806.18,
  806.17,
  806.17,
  806.17,
  806.16,
  806.16,
  806.16,
  806.15,
  806.15,
  806.15,
  806.14,
  806.14,
  806.14,
  806.13,
  806.13,
  806.13,
  806.13,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.14,
  806.14,
  806.14,
  806.14,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.17,
  806.17,
  806.17,
  806.17,
  806.18,
  806.18,
  806.18,
  806.19,
  806.19,
  806.19,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.22,
  806.22,
  806.23,
  806.23,
  806.24,
  806.24,
  806.25,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[65] = [
  806.35,
  806.35,
  806.35,
  806.34,
  806.34,
  806.33,
  806.33,
  806.32,
  806.31,
  806.31,
  806.31,
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.27,
  806.26,
  806.26,
  806.26,
  806.25,
  806.24,
  806.23,
  806.23,
  806.23,
  806.22,
  806.22,
  806.21,
  806.2,
  806.2,
  806.2,
  806.19,
  806.19,
  806.18,
  806.18,
  806.17,
  806.16,
  806.16,
  806.16,
  806.15,
  806.15,
  806.15,
  806.14,
  806.14,
  806.14,
  806.13,
  806.13,
  806.13,
  806.12,
  806.12,
  806.12,
  806.12,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.13,
  806.13,
  806.13,
  806.13,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.15,
  806.16,
  806.16,
  806.16,
  806.16,
  806.16,
  806.17,
  806.17,
  806.17,
  806.18,
  806.18,
  806.18,
  806.19,
  806.19,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.22,
  806.22,
  806.23,
  806.23,
  806.24,
  806.24,
  806.25,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[64] = [
  806.34,
  806.34,
  806.34,
  806.33,
  806.33,
  806.32,
  806.32,
  806.31,
  806.3,
  806.3,
  806.3,
  806.29,
  806.28,
  806.28,
  806.27,
  806.27,
  806.26,
  806.25,
  806.25,
  806.24,
  806.24,
  806.23,
  806.22,
  806.22,
  806.22,
  806.21,
  806.21,
  806.2,
  806.19,
  806.19,
  806.19,
  806.18,
  806.18,
  806.17,
  806.17,
  806.16,
  806.15,
  806.15,
  806.15,
  806.14,
  806.14,
  806.14,
  806.13,
  806.13,
  806.13,
  806.12,
  806.12,
  806.12,
  806.11,
  806.11,
  806.11,
  806.11,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.12,
  806.12,
  806.12,
  806.12,
  806.13,
  806.13,
  806.13,
  806.13,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.14,
  806.15,
  806.15,
  806.15,
  806.15,
  806.16,
  806.16,
  806.16,
  806.16,
  806.17,
  806.17,
  806.18,
  806.18,
  806.18,
  806.19,
  806.19,
  806.2,
  806.2,
  806.2,
  806.21,
  806.21,
  806.22,
  806.22,
  806.23,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[63] = [
  806.33,
  806.33,
  806.33,
  806.32,
  806.32,
  806.31,
  806.31,
  806.3,
  806.29,
  806.29,
  806.28,
  806.27,
  806.27,
  806.27,
  806.26,
  806.25,
  806.25,
  806.24,
  806.24,
  806.23,
  806.23,
  806.22,
  806.21,
  806.21,
  806.2,
  806.19,
  806.19,
  806.19,
  806.18,
  806.18,
  806.17,
  806.17,
  806.16,
  806.16,
  806.15,
  806.15,
  806.14,
  806.14,
  806.13,
  806.13,
  806.13,
  806.12,
  806.12,
  806.12,
  806.11,
  806.11,
  806.11,
  806.1,
  806.1,
  806.1,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.1,
  806.1,
  806.1,
  806.1,
  806.11,
  806.11,
  806.11,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.13,
  806.14,
  806.14,
  806.14,
  806.14,
  806.15,
  806.15,
  806.15,
  806.15,
  806.16,
  806.16,
  806.17,
  806.17,
  806.17,
  806.18,
  806.18,
  806.19,
  806.19,
  806.2,
  806.2,
  806.21,
  806.21,
  806.22,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[62] = [
  806.32,
  806.32,
  806.32,
  806.31,
  806.31,
  806.3,
  806.3,
  806.29,
  806.28,
  806.28,
  806.27,
  806.26,
  806.26,
  806.26,
  806.25,
  806.24,
  806.24,
  806.23,
  806.23,
  806.22,
  806.22,
  806.21,
  806.2,
  806.2,
  806.19,
  806.18,
  806.18,
  806.18,
  806.17,
  806.17,
  806.16,
  806.16,
  806.15,
  806.15,
  806.14,
  806.14,
  806.13,
  806.13,
  806.12,
  806.12,
  806.12,
  806.11,
  806.11,
  806.11,
  806.1,
  806.1,
  806.1,
  806.09,
  806.09,
  806.09,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.09,
  806.09,
  806.09,
  806.09,
  806.1,
  806.1,
  806.1,
  806.11,
  806.11,
  806.11,
  806.11,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.13,
  806.13,
  806.13,
  806.13,
  806.14,
  806.14,
  806.14,
  806.15,
  806.15,
  806.15,
  806.16,
  806.16,
  806.17,
  806.17,
  806.17,
  806.18,
  806.18,
  806.19,
  806.19,
  806.2,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[61] = [
  806.32,
  806.31,
  806.31,
  806.3,
  806.3,
  806.29,
  806.29,
  806.28,
  806.27,
  806.27,
  806.26,
  806.26,
  806.25,
  806.25,
  806.24,
  806.23,
  806.23,
  806.22,
  806.22,
  806.21,
  806.2,
  806.2,
  806.19,
  806.19,
  806.18,
  806.17,
  806.17,
  806.17,
  806.16,
  806.16,
  806.15,
  806.14,
  806.14,
  806.14,
  806.13,
  806.13,
  806.12,
  806.12,
  806.11,
  806.11,
  806.11,
  806.1,
  806.1,
  806.09,
  806.09,
  806.09,
  806.09,
  806.08,
  806.08,
  806.08,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.08,
  806.08,
  806.08,
  806.08,
  806.09,
  806.09,
  806.09,
  806.09,
  806.1,
  806.1,
  806.1,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.12,
  806.12,
  806.12,
  806.12,
  806.12,
  806.13,
  806.13,
  806.13,
  806.14,
  806.14,
  806.14,
  806.15,
  806.15,
  806.16,
  806.16,
  806.16,
  806.17,
  806.17,
  806.18,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
];
a[60] = [
  806.3,
  806.3,
  806.3,
  806.29,
  806.29,
  806.28,
  806.28,
  806.27,
  806.26,
  806.26,
  806.25,
  806.24,
  806.24,
  806.23,
  806.22,
  806.22,
  806.22,
  806.21,
  806.2,
  806.2,
  806.19,
  806.19,
  806.18,
  806.17,
  806.17,
  806.16,
  806.16,
  806.15,
  806.14,
  806.14,
  806.14,
  806.13,
  806.13,
  806.12,
  806.12,
  806.11,
  806.1,
  806.1,
  806.1,
  806.09,
  806.09,
  806.09,
  806.08,
  806.08,
  806.08,
  806.07,
  806.07,
  806.07,
  806.06,
  806.06,
  806.06,
  806.06,
  806.05,
  806.05,
  806.05,
  806.05,
  806.05,
  806.05,
  806.05,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.05,
  806.05,
  806.05,
  806.05,
  806.05,
  806.05,
  806.05,
  806.06,
  806.06,
  806.06,
  806.06,
  806.07,
  806.07,
  806.07,
  806.07,
  806.08,
  806.08,
  806.08,
  806.09,
  806.09,
  806.09,
  806.09,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.1,
  806.11,
  806.11,
  806.11,
  806.11,
  806.11,
  806.12,
  806.12,
  806.12,
  806.13,
  806.13,
  806.13,
  806.14,
  806.14,
  806.15,
  806.15,
  806.16,
  806.16,
  806.17,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
];
a[59] = [
  806.29,
  806.29,
  806.29,
  806.28,
  806.28,
  806.27,
  806.27,
  806.26,
  806.25,
  806.25,
  806.24,
  806.23,
  806.23,
  806.23,
  806.21,
  806.21,
  806.21,
  806.2,
  806.19,
  806.19,
  806.18,
  806.18,
  806.17,
  806.16,
  806.16,
  806.15,
  806.15,
  806.14,
  806.13,
  806.13,
  806.13,
  806.12,
  806.12,
  806.11,
  806.11,
  806.1,
  806.09,
  806.09,
  806.09,
  806.08,
  806.08,
  806.08,
  806.07,
  806.07,
  806.07,
  806.06,
  806.06,
  806.06,
  806.05,
  806.05,
  806.05,
  806.05,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.03,
  806.03,
  806.03,
  806.03,
  806.03,
  806.03,
  806.03,
  806.03,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.05,
  806.05,
  806.05,
  806.05,
  806.05,
  806.06,
  806.06,
  806.06,
  806.07,
  806.07,
  806.07,
  806.07,
  806.08,
  806.08,
  806.08,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.1,
  806.1,
  806.1,
  806.1,
  806.11,
  806.11,
  806.11,
  806.11,
  806.12,
  806.12,
  806.12,
  806.13,
  806.13,
  806.14,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.18,
  806.19,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
];
a[58] = [
  806.29,
  806.28,
  806.28,
  806.27,
  806.27,
  806.26,
  806.26,
  806.25,
  806.24,
  806.24,
  806.23,
  806.22,
  806.22,
  806.21,
  806.21,
  806.2,
  806.2,
  806.19,
  806.18,
  806.18,
  806.17,
  806.17,
  806.16,
  806.15,
  806.15,
  806.14,
  806.14,
  806.13,
  806.12,
  806.12,
  806.12,
  806.11,
  806.11,
  806.1,
  806.1,
  806.09,
  806.08,
  806.08,
  806.08,
  806.07,
  806.07,
  806.07,
  806.06,
  806.06,
  806.06,
  806.05,
  806.05,
  806.05,
  806.04,
  806.04,
  806.04,
  806.04,
  806.03,
  806.03,
  806.03,
  806.03,
  806.03,
  806.03,
  806.03,
  806.02,
  806.02,
  806.02,
  806.02,
  806.02,
  806.02,
  806.02,
  806.03,
  806.03,
  806.03,
  806.03,
  806.03,
  806.03,
  806.03,
  806.04,
  806.04,
  806.04,
  806.04,
  806.04,
  806.05,
  806.05,
  806.05,
  806.05,
  806.06,
  806.06,
  806.06,
  806.07,
  806.07,
  806.07,
  806.08,
  806.08,
  806.08,
  806.08,
  806.08,
  806.09,
  806.09,
  806.09,
  806.09,
  806.09,
  806.1,
  806.1,
  806.1,
  806.1,
  806.11,
  806.11,
  806.12,
  806.12,
  806.12,
  806.13,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
];
a[57] = [
  806.27,
  806.27,
  806.27,
  806.26,
  806.26,
  806.25,
  806.25,
  806.24,
  806.23,
  806.23,
  806.22,
  806.21,
  806.21,
  806.2,
  806.19,
  806.19,
  806.18,
  806.17,
  806.17,
  806.17,
  806.16,
  806.15,
  806.14,
  806.14,
  806.14,
  806.12,
  806.12,
  806.12,
  806.11,
  806.11,
  806.1,
  806.1,
  806.09,
  806.09,
  806.08,
  806.08,
  806.07,
  806.07,
  806.06,
  806.06,
  806.06,
  806.05,
  806.05,
  806.05,
  806.04,
  806.04,
  806.04,
  806.03,
  806.03,
  806.03,
  806.02,
  806.02,
  806.02,
  806.02,
  806.02,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.02,
  806.02,
  806.02,
  806.02,
  806.02,
  806.02,
  806.03,
  806.03,
  806.03,
  806.03,
  806.04,
  806.04,
  806.04,
  806.05,
  806.05,
  806.05,
  806.05,
  806.06,
  806.06,
  806.06,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.08,
  806.08,
  806.08,
  806.08,
  806.09,
  806.09,
  806.09,
  806.1,
  806.1,
  806.1,
  806.11,
  806.11,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
];
a[56] = [
  806.27,
  806.26,
  806.26,
  806.25,
  806.25,
  806.24,
  806.24,
  806.23,
  806.22,
  806.22,
  806.21,
  806.2,
  806.2,
  806.19,
  806.18,
  806.18,
  806.17,
  806.16,
  806.16,
  806.16,
  806.15,
  806.14,
  806.13,
  806.13,
  806.13,
  806.12,
  806.11,
  806.11,
  806.1,
  806.1,
  806.09,
  806.09,
  806.08,
  806.08,
  806.07,
  806.07,
  806.06,
  806.06,
  806.05,
  806.05,
  806.05,
  806.04,
  806.04,
  806.04,
  806.03,
  806.03,
  806.03,
  806.02,
  806.02,
  806.02,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806,
  806,
  806,
  806,
  806,
  806,
  806,
  806,
  806,
  806,
  806,
  806,
  806,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.01,
  806.02,
  806.02,
  806.02,
  806.02,
  806.03,
  806.03,
  806.03,
  806.03,
  806.04,
  806.04,
  806.04,
  806.05,
  806.05,
  806.05,
  806.06,
  806.06,
  806.06,
  806.06,
  806.07,
  806.07,
  806.07,
  806.07,
  806.07,
  806.08,
  806.08,
  806.08,
  806.09,
  806.09,
  806.09,
  806.1,
  806.1,
  806.11,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
];
a[55] = [
  806.26,
  806.25,
  806.25,
  806.24,
  806.24,
  806.23,
  806.23,
  806.22,
  806.21,
  806.21,
  806.2,
  806.19,
  806.19,
  806.18,
  806.17,
  806.17,
  806.16,
  806.15,
  806.15,
  806.14,
  806.14,
  806.13,
  806.12,
  806.12,
  806.11,
  806.11,
  806.1,
  806.1,
  806.09,
  806.09,
  806.08,
  806.07,
  806.07,
  806.07,
  806.06,
  806.06,
  806.05,
  806.05,
  806.04,
  806.04,
  806.03,
  806.03,
  806.03,
  806.02,
  806.02,
  806.02,
  806.01,
  806.01,
  806.01,
  806.01,
  806,
  806,
  806,
  806,
  806,
  806,
  805.99,
  805.99,
  805.99,
  805.99,
  805.99,
  805.99,
  805.99,
  805.99,
  805.99,
  805.99,
  805.99,
  805.99,
  806,
  806,
  806,
  806,
  806,
  806.01,
  806.01,
  806.01,
  806.01,
  806.02,
  806.02,
  806.02,
  806.02,
  806.03,
  806.03,
  806.03,
  806.04,
  806.04,
  806.04,
  806.05,
  806.05,
  806.05,
  806.05,
  806.06,
  806.06,
  806.06,
  806.06,
  806.06,
  806.07,
  806.07,
  806.07,
  806.08,
  806.08,
  806.08,
  806.09,
  806.09,
  806.1,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
];
a[54] = [
  806.25,
  806.24,
  806.24,
  806.23,
  806.23,
  806.22,
  806.22,
  806.21,
  806.2,
  806.2,
  806.19,
  806.18,
  806.18,
  806.17,
  806.16,
  806.16,
  806.15,
  806.14,
  806.14,
  806.13,
  806.13,
  806.12,
  806.11,
  806.11,
  806.1,
  806.09,
  806.09,
  806.09,
  806.07,
  806.07,
  806.07,
  806.06,
  806.06,
  806.05,
  806.05,
  806.04,
  806.03,
  806.03,
  806.03,
  806.02,
  806.02,
  806.02,
  806.01,
  806.01,
  806.01,
  806,
  806,
  806,
  806,
  805.99,
  805.99,
  805.99,
  805.99,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.99,
  805.99,
  805.99,
  805.99,
  805.99,
  806,
  806,
  806,
  806,
  806.01,
  806.01,
  806.01,
  806.02,
  806.02,
  806.02,
  806.02,
  806.03,
  806.03,
  806.03,
  806.04,
  806.04,
  806.04,
  806.04,
  806.05,
  806.05,
  806.05,
  806.05,
  806.06,
  806.06,
  806.06,
  806.07,
  806.07,
  806.08,
  806.08,
  806.09,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
];
a[53] = [
  806.24,
  806.24,
  806.23,
  806.22,
  806.22,
  806.21,
  806.21,
  806.2,
  806.19,
  806.19,
  806.18,
  806.17,
  806.17,
  806.16,
  806.15,
  806.15,
  806.14,
  806.13,
  806.13,
  806.12,
  806.11,
  806.11,
  806.1,
  806.1,
  806.09,
  806.08,
  806.08,
  806.07,
  806.06,
  806.06,
  806.06,
  806.05,
  806.05,
  806.04,
  806.04,
  806.03,
  806.02,
  806.02,
  806.02,
  806.01,
  806.01,
  806.01,
  806,
  806,
  806,
  805.99,
  805.99,
  805.99,
  805.99,
  805.98,
  805.98,
  805.98,
  805.98,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.97,
  805.98,
  805.98,
  805.98,
  805.98,
  805.99,
  805.99,
  805.99,
  805.99,
  806,
  806,
  806,
  806,
  806.01,
  806.01,
  806.01,
  806.02,
  806.02,
  806.02,
  806.03,
  806.03,
  806.03,
  806.03,
  806.04,
  806.04,
  806.04,
  806.05,
  806.05,
  806.05,
  806.05,
  806.06,
  806.06,
  806.07,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
];
a[52] = [
  806.23,
  806.22,
  806.22,
  806.21,
  806.21,
  806.2,
  806.19,
  806.19,
  806.18,
  806.17,
  806.17,
  806.16,
  806.15,
  806.15,
  806.14,
  806.13,
  806.13,
  806.12,
  806.11,
  806.11,
  806.1,
  806.1,
  806.09,
  806.08,
  806.08,
  806.07,
  806.07,
  806.06,
  806.05,
  806.05,
  806.04,
  806.04,
  806.03,
  806.03,
  806.02,
  806.02,
  806.01,
  806.01,
  806.01,
  806,
  806,
  805.99,
  805.99,
  805.99,
  805.98,
  805.98,
  805.98,
  805.97,
  805.97,
  805.97,
  805.96,
  805.96,
  805.96,
  805.96,
  805.96,
  805.96,
  805.96,
  805.95,
  805.95,
  805.95,
  805.95,
  805.95,
  805.95,
  805.95,
  805.96,
  805.96,
  805.96,
  805.96,
  805.96,
  805.96,
  805.97,
  805.97,
  805.97,
  805.97,
  805.98,
  805.98,
  805.98,
  805.99,
  805.99,
  805.99,
  805.99,
  806,
  806,
  806,
  806.01,
  806.01,
  806.01,
  806.01,
  806.02,
  806.02,
  806.02,
  806.03,
  806.03,
  806.03,
  806.04,
  806.04,
  806.04,
  806.05,
  806.05,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
];
a[51] = [
  806.22,
  806.22,
  806.21,
  806.2,
  806.2,
  806.19,
  806.18,
  806.18,
  806.17,
  806.17,
  806.16,
  806.15,
  806.15,
  806.14,
  806.13,
  806.13,
  806.12,
  806.11,
  806.11,
  806.1,
  806.09,
  806.09,
  806.08,
  806.07,
  806.07,
  806.06,
  806.06,
  806.05,
  806.04,
  806.04,
  806.04,
  806.03,
  806.02,
  806.02,
  806.01,
  806.01,
  806,
  806,
  806,
  805.99,
  805.99,
  805.98,
  805.98,
  805.98,
  805.97,
  805.97,
  805.97,
  805.96,
  805.96,
  805.96,
  805.95,
  805.95,
  805.95,
  805.95,
  805.95,
  805.95,
  805.95,
  805.95,
  805.94,
  805.94,
  805.94,
  805.94,
  805.94,
  805.95,
  805.95,
  805.95,
  805.95,
  805.95,
  805.95,
  805.96,
  805.96,
  805.96,
  805.96,
  805.97,
  805.97,
  805.97,
  805.98,
  805.98,
  805.98,
  805.98,
  805.99,
  805.99,
  805.99,
  806,
  806,
  806,
  806,
  806.01,
  806.01,
  806.01,
  806.02,
  806.02,
  806.02,
  806.03,
  806.03,
  806.03,
  806.04,
  806.04,
  806.05,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
];
a[50] = [
  806.21,
  806.21,
  806.2,
  806.19,
  806.19,
  806.18,
  806.17,
  806.17,
  806.16,
  806.15,
  806.15,
  806.14,
  806.13,
  806.13,
  806.12,
  806.11,
  806.11,
  806.1,
  806.09,
  806.09,
  806.08,
  806.08,
  806.07,
  806.06,
  806.06,
  806.05,
  806.04,
  806.04,
  806.03,
  806.03,
  806.02,
  806.02,
  806.01,
  806.01,
  806,
  806,
  805.99,
  805.99,
  805.99,
  805.98,
  805.98,
  805.97,
  805.97,
  805.97,
  805.96,
  805.96,
  805.96,
  805.95,
  805.95,
  805.95,
  805.95,
  805.95,
  805.94,
  805.94,
  805.94,
  805.94,
  805.94,
  805.94,
  805.94,
  805.93,
  805.93,
  805.94,
  805.94,
  805.94,
  805.94,
  805.94,
  805.94,
  805.94,
  805.95,
  805.95,
  805.95,
  805.95,
  805.96,
  805.96,
  805.96,
  805.97,
  805.97,
  805.97,
  805.97,
  805.98,
  805.98,
  805.98,
  805.99,
  805.99,
  805.99,
  805.99,
  806,
  806,
  806,
  806,
  806.01,
  806.01,
  806.02,
  806.02,
  806.03,
  806.03,
  806.03,
  806.04,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
];
a[49] = [
  806.2,
  806.2,
  806.19,
  806.18,
  806.18,
  806.17,
  806.16,
  806.16,
  806.15,
  806.14,
  806.14,
  806.13,
  806.12,
  806.12,
  806.1,
  806.1,
  806.1,
  806.08,
  806.08,
  806.08,
  806.07,
  806.06,
  806.05,
  806.05,
  806.04,
  806.03,
  806.03,
  806.03,
  806.02,
  806.02,
  806.01,
  806.01,
  806,
  806,
  805.99,
  805.99,
  805.98,
  805.98,
  805.97,
  805.96,
  805.96,
  805.96,
  805.96,
  805.95,
  805.95,
  805.95,
  805.94,
  805.94,
  805.94,
  805.94,
  805.93,
  805.93,
  805.93,
  805.93,
  805.93,
  805.93,
  805.92,
  805.92,
  805.92,
  805.92,
  805.92,
  805.92,
  805.92,
  805.92,
  805.93,
  805.93,
  805.93,
  805.93,
  805.93,
  805.94,
  805.94,
  805.94,
  805.95,
  805.95,
  805.95,
  805.96,
  805.96,
  805.96,
  805.96,
  805.97,
  805.97,
  805.97,
  805.98,
  805.98,
  805.98,
  805.98,
  805.99,
  805.99,
  805.99,
  805.99,
  806,
  806,
  806.01,
  806.01,
  806.02,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
];
a[48] = [
  806.19,
  806.19,
  806.18,
  806.17,
  806.17,
  806.16,
  806.15,
  806.15,
  806.14,
  806.13,
  806.13,
  806.12,
  806.11,
  806.11,
  806.09,
  806.09,
  806.09,
  806.07,
  806.07,
  806.07,
  806.06,
  806.05,
  806.04,
  806.04,
  806.03,
  806.02,
  806.02,
  806.02,
  806.01,
  806.01,
  806,
  805.99,
  805.99,
  805.99,
  805.98,
  805.98,
  805.97,
  805.97,
  805.96,
  805.95,
  805.95,
  805.95,
  805.95,
  805.94,
  805.94,
  805.94,
  805.93,
  805.93,
  805.93,
  805.93,
  805.92,
  805.92,
  805.92,
  805.92,
  805.92,
  805.92,
  805.91,
  805.91,
  805.91,
  805.91,
  805.91,
  805.91,
  805.91,
  805.91,
  805.92,
  805.92,
  805.92,
  805.92,
  805.93,
  805.93,
  805.93,
  805.94,
  805.94,
  805.94,
  805.95,
  805.95,
  805.95,
  805.96,
  805.96,
  805.96,
  805.97,
  805.97,
  805.97,
  805.97,
  805.98,
  805.98,
  805.98,
  805.98,
  805.98,
  805.99,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
];
a[47] = [
  806.18,
  806.18,
  806.17,
  806.16,
  806.16,
  806.15,
  806.14,
  806.14,
  806.13,
  806.12,
  806.12,
  806.11,
  806.1,
  806.1,
  806.09,
  806.08,
  806.08,
  806.07,
  806.06,
  806.06,
  806.05,
  806.04,
  806.03,
  806.03,
  806.02,
  806.01,
  806.01,
  806.01,
  806,
  805.99,
  805.99,
  805.98,
  805.98,
  805.98,
  805.97,
  805.97,
  805.96,
  805.96,
  805.95,
  805.95,
  805.94,
  805.94,
  805.94,
  805.93,
  805.93,
  805.93,
  805.93,
  805.92,
  805.92,
  805.92,
  805.91,
  805.91,
  805.91,
  805.91,
  805.91,
  805.91,
  805.91,
  805.91,
  805.9,
  805.9,
  805.9,
  805.9,
  805.91,
  805.91,
  805.91,
  805.91,
  805.91,
  805.92,
  805.92,
  805.92,
  805.92,
  805.93,
  805.93,
  805.94,
  805.94,
  805.94,
  805.95,
  805.95,
  805.95,
  805.96,
  805.96,
  805.96,
  805.97,
  805.97,
  805.97,
  805.97,
  805.98,
  805.98,
  805.98,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
];
a[46] = [
  806.17,
  806.17,
  806.16,
  806.15,
  806.15,
  806.14,
  806.13,
  806.13,
  806.12,
  806.11,
  806.11,
  806.09,
  806.09,
  806.08,
  806.07,
  806.07,
  806.06,
  806.05,
  806.05,
  806.04,
  806.04,
  806.03,
  806.02,
  806.02,
  806.01,
  806,
  806,
  805.99,
  805.98,
  805.98,
  805.98,
  805.97,
  805.97,
  805.96,
  805.96,
  805.95,
  805.94,
  805.94,
  805.94,
  805.93,
  805.93,
  805.93,
  805.92,
  805.92,
  805.92,
  805.92,
  805.91,
  805.91,
  805.91,
  805.91,
  805.9,
  805.9,
  805.9,
  805.9,
  805.9,
  805.89,
  805.89,
  805.89,
  805.89,
  805.89,
  805.89,
  805.89,
  805.89,
  805.89,
  805.9,
  805.9,
  805.9,
  805.9,
  805.91,
  805.91,
  805.91,
  805.92,
  805.92,
  805.93,
  805.93,
  805.93,
  805.94,
  805.94,
  805.94,
  805.95,
  805.95,
  805.96,
  805.96,
  805.96,
  805.97,
  805.97,
  805.97,
  805.97,
  805.98,
  805.98,
  805.99,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
];
a[45] = [
  806.16,
  806.16,
  806.15,
  806.14,
  806.14,
  806.13,
  806.12,
  806.12,
  806.11,
  806.1,
  806.1,
  806.08,
  806.08,
  806.07,
  806.06,
  806.06,
  806.05,
  806.04,
  806.04,
  806.03,
  806.02,
  806.02,
  806.01,
  806.01,
  806,
  805.99,
  805.99,
  805.98,
  805.97,
  805.97,
  805.97,
  805.96,
  805.96,
  805.95,
  805.95,
  805.94,
  805.94,
  805.93,
  805.93,
  805.92,
  805.92,
  805.92,
  805.92,
  805.91,
  805.91,
  805.91,
  805.9,
  805.9,
  805.9,
  805.9,
  805.89,
  805.89,
  805.89,
  805.89,
  805.89,
  805.89,
  805.89,
  805.88,
  805.88,
  805.88,
  805.88,
  805.88,
  805.88,
  805.89,
  805.89,
  805.89,
  805.89,
  805.9,
  805.9,
  805.9,
  805.91,
  805.91,
  805.92,
  805.92,
  805.92,
  805.93,
  805.93,
  805.94,
  805.94,
  805.94,
  805.95,
  805.95,
  805.95,
  805.96,
  805.96,
  805.97,
  805.97,
  805.97,
  805.98,
  805.98,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
];
a[44] = [
  806.15,
  806.15,
  806.14,
  806.13,
  806.13,
  806.12,
  806.11,
  806.11,
  806.1,
  806.09,
  806.09,
  806.08,
  806.07,
  806.06,
  806.05,
  806.05,
  806.04,
  806.03,
  806.03,
  806.02,
  806.01,
  806.01,
  806,
  806,
  805.99,
  805.98,
  805.98,
  805.97,
  805.96,
  805.96,
  805.96,
  805.95,
  805.95,
  805.94,
  805.94,
  805.93,
  805.93,
  805.92,
  805.92,
  805.91,
  805.91,
  805.91,
  805.9,
  805.9,
  805.9,
  805.9,
  805.89,
  805.89,
  805.89,
  805.89,
  805.88,
  805.88,
  805.88,
  805.88,
  805.88,
  805.88,
  805.88,
  805.88,
  805.88,
  805.88,
  805.87,
  805.88,
  805.88,
  805.88,
  805.88,
  805.88,
  805.89,
  805.89,
  805.89,
  805.9,
  805.9,
  805.91,
  805.91,
  805.91,
  805.92,
  805.92,
  805.93,
  805.93,
  805.93,
  805.94,
  805.94,
  805.95,
  805.95,
  805.95,
  805.96,
  805.96,
  805.96,
  805.97,
  805.97,
  805.98,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
];
a[43] = [
  806.14,
  806.14,
  806.13,
  806.12,
  806.12,
  806.11,
  806.1,
  806.1,
  806.08,
  806.08,
  806.07,
  806.06,
  806.06,
  806.05,
  806.04,
  806.04,
  806.03,
  806.02,
  806.02,
  806.01,
  806,
  806,
  805.99,
  805.98,
  805.98,
  805.97,
  805.97,
  805.96,
  805.95,
  805.95,
  805.95,
  805.94,
  805.94,
  805.93,
  805.93,
  805.92,
  805.91,
  805.91,
  805.91,
  805.9,
  805.9,
  805.9,
  805.89,
  805.89,
  805.89,
  805.88,
  805.88,
  805.88,
  805.88,
  805.88,
  805.87,
  805.87,
  805.87,
  805.87,
  805.87,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.87,
  805.87,
  805.87,
  805.88,
  805.88,
  805.88,
  805.89,
  805.89,
  805.9,
  805.9,
  805.91,
  805.91,
  805.92,
  805.92,
  805.93,
  805.93,
  805.93,
  805.94,
  805.94,
  805.95,
  805.95,
  805.95,
  805.96,
  805.96,
  805.97,
  805.97,
  805.98,
  805.98,
  805.99,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
];
a[42] = [
  806.13,
  806.13,
  806.12,
  806.11,
  806.11,
  806.1,
  806.09,
  806.09,
  806.07,
  806.07,
  806.06,
  806.05,
  806.05,
  806.04,
  806.03,
  806.03,
  806.02,
  806.01,
  806.01,
  806,
  805.99,
  805.99,
  805.98,
  805.97,
  805.97,
  805.96,
  805.96,
  805.95,
  805.94,
  805.94,
  805.94,
  805.93,
  805.93,
  805.92,
  805.92,
  805.91,
  805.9,
  805.9,
  805.9,
  805.89,
  805.89,
  805.89,
  805.88,
  805.88,
  805.88,
  805.88,
  805.87,
  805.87,
  805.87,
  805.87,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.87,
  805.87,
  805.87,
  805.88,
  805.88,
  805.89,
  805.89,
  805.9,
  805.9,
  805.91,
  805.91,
  805.92,
  805.92,
  805.92,
  805.93,
  805.93,
  805.94,
  805.94,
  805.95,
  805.95,
  805.96,
  805.96,
  805.97,
  805.97,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
];
a[41] = [
  806.12,
  806.12,
  806.11,
  806.1,
  806.1,
  806.09,
  806.08,
  806.08,
  806.07,
  806.06,
  806.05,
  806.04,
  806.04,
  806.03,
  806.02,
  806.02,
  806.01,
  806,
  805.99,
  805.99,
  805.98,
  805.98,
  805.97,
  805.96,
  805.96,
  805.95,
  805.95,
  805.94,
  805.93,
  805.93,
  805.93,
  805.92,
  805.92,
  805.91,
  805.91,
  805.9,
  805.9,
  805.89,
  805.89,
  805.88,
  805.88,
  805.88,
  805.88,
  805.87,
  805.87,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.86,
  805.86,
  805.87,
  805.87,
  805.88,
  805.88,
  805.89,
  805.89,
  805.9,
  805.9,
  805.91,
  805.91,
  805.92,
  805.92,
  805.93,
  805.93,
  805.94,
  805.94,
  805.94,
  805.95,
  805.95,
  805.96,
  805.96,
  805.97,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
];
a[40] = [
  806.11,
  806.11,
  806.1,
  806.09,
  806.09,
  806.08,
  806.07,
  806.07,
  806.05,
  806.05,
  806.04,
  806.03,
  806.03,
  806.02,
  806.01,
  806,
  806,
  805.98,
  805.98,
  805.98,
  805.97,
  805.96,
  805.95,
  805.95,
  805.95,
  805.94,
  805.93,
  805.93,
  805.92,
  805.92,
  805.91,
  805.91,
  805.91,
  805.9,
  805.9,
  805.89,
  805.88,
  805.88,
  805.88,
  805.87,
  805.87,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.85,
  805.85,
  805.86,
  805.86,
  805.87,
  805.87,
  805.88,
  805.88,
  805.89,
  805.89,
  805.9,
  805.9,
  805.91,
  805.91,
  805.92,
  805.92,
  805.93,
  805.93,
  805.94,
  805.94,
  805.95,
  805.95,
  805.96,
  805.96,
  805.97,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
];
a[39] = [
  806.1,
  806.1,
  806.09,
  806.08,
  806.08,
  806.07,
  806.06,
  806.05,
  806.04,
  806.04,
  806.03,
  806.02,
  806.01,
  806.01,
  806,
  805.99,
  805.99,
  805.98,
  805.97,
  805.97,
  805.96,
  805.95,
  805.94,
  805.94,
  805.94,
  805.93,
  805.92,
  805.92,
  805.91,
  805.91,
  805.91,
  805.9,
  805.9,
  805.89,
  805.89,
  805.88,
  805.88,
  805.87,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.85,
  805.85,
  805.86,
  805.86,
  805.87,
  805.87,
  805.88,
  805.88,
  805.89,
  805.89,
  805.9,
  805.91,
  805.91,
  805.91,
  805.92,
  805.92,
  805.93,
  805.94,
  805.94,
  805.95,
  805.95,
  805.96,
  805.96,
  805.97,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
];
a[38] = [
  806.09,
  806.09,
  806.08,
  806.07,
  806.07,
  806.06,
  806.05,
  806.04,
  806.03,
  806.03,
  806.02,
  806.01,
  806,
  806,
  805.99,
  805.98,
  805.98,
  805.97,
  805.96,
  805.96,
  805.95,
  805.94,
  805.93,
  805.93,
  805.92,
  805.92,
  805.91,
  805.91,
  805.9,
  805.9,
  805.9,
  805.89,
  805.89,
  805.88,
  805.88,
  805.87,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.84,
  805.84,
  805.84,
  805.84,
  805.85,
  805.85,
  805.86,
  805.86,
  805.87,
  805.87,
  805.88,
  805.89,
  805.89,
  805.9,
  805.9,
  805.91,
  805.91,
  805.92,
  805.92,
  805.93,
  805.93,
  805.94,
  805.95,
  805.95,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
];
a[37] = [
  806.08,
  806.08,
  806.07,
  806.06,
  806.06,
  806.05,
  806.04,
  806.03,
  806.02,
  806.02,
  806.01,
  806,
  805.99,
  805.99,
  805.97,
  805.97,
  805.96,
  805.95,
  805.95,
  805.94,
  805.94,
  805.93,
  805.92,
  805.92,
  805.91,
  805.9,
  805.9,
  805.9,
  805.89,
  805.89,
  805.89,
  805.88,
  805.88,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.84,
  805.84,
  805.84,
  805.85,
  805.85,
  805.86,
  805.87,
  805.87,
  805.88,
  805.88,
  805.89,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.92,
  805.93,
  805.93,
  805.94,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
];
a[36] = [
  806.07,
  806.07,
  806.06,
  806.05,
  806.05,
  806.04,
  806.03,
  806.02,
  806.01,
  806.01,
  806,
  805.99,
  805.98,
  805.98,
  805.96,
  805.96,
  805.95,
  805.94,
  805.94,
  805.93,
  805.93,
  805.92,
  805.91,
  805.91,
  805.9,
  805.9,
  805.89,
  805.89,
  805.88,
  805.88,
  805.88,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.83,
  805.83,
  805.83,
  805.84,
  805.84,
  805.85,
  805.85,
  805.86,
  805.86,
  805.87,
  805.87,
  805.88,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.91,
  805.92,
  805.93,
  805.93,
  805.94,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
];
a[35] = [
  806.06,
  806.06,
  806.05,
  806.04,
  806.04,
  806.03,
  806.02,
  806.01,
  806,
  805.99,
  805.99,
  805.97,
  805.97,
  805.96,
  805.95,
  805.95,
  805.94,
  805.93,
  805.93,
  805.92,
  805.91,
  805.91,
  805.9,
  805.9,
  805.89,
  805.88,
  805.88,
  805.88,
  805.87,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.83,
  805.83,
  805.84,
  805.84,
  805.85,
  805.85,
  805.86,
  805.87,
  805.87,
  805.88,
  805.88,
  805.89,
  805.89,
  805.9,
  805.91,
  805.91,
  805.92,
  805.93,
  805.93,
  805.94,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
];
a[34] = [
  806.05,
  806.05,
  806.04,
  806.03,
  806.03,
  806.02,
  806.01,
  806,
  805.99,
  805.98,
  805.98,
  805.96,
  805.96,
  805.95,
  805.94,
  805.94,
  805.93,
  805.92,
  805.92,
  805.91,
  805.9,
  805.9,
  805.89,
  805.89,
  805.88,
  805.87,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.82,
  805.82,
  805.82,
  805.83,
  805.83,
  805.83,
  805.84,
  805.85,
  805.85,
  805.86,
  805.86,
  805.87,
  805.88,
  805.88,
  805.89,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.92,
  805.93,
  805.94,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
];
a[33] = [
  806.05,
  806.04,
  806.03,
  806.02,
  806.02,
  806.01,
  806,
  805.99,
  805.98,
  805.97,
  805.96,
  805.95,
  805.95,
  805.94,
  805.93,
  805.93,
  805.92,
  805.91,
  805.91,
  805.9,
  805.89,
  805.89,
  805.88,
  805.88,
  805.87,
  805.87,
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.82,
  805.82,
  805.82,
  805.83,
  805.83,
  805.84,
  805.84,
  805.85,
  805.86,
  805.86,
  805.87,
  805.87,
  805.88,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.92,
  805.93,
  805.94,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
];
a[32] = [
  806.03,
  806.03,
  806.02,
  806.01,
  806.01,
  806,
  805.99,
  805.98,
  805.96,
  805.96,
  805.95,
  805.94,
  805.94,
  805.93,
  805.92,
  805.92,
  805.91,
  805.9,
  805.9,
  805.89,
  805.88,
  805.88,
  805.87,
  805.87,
  805.86,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.81,
  805.81,
  805.81,
  805.81,
  805.82,
  805.82,
  805.83,
  805.84,
  805.84,
  805.85,
  805.85,
  805.86,
  805.86,
  805.87,
  805.88,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.92,
  805.93,
  805.94,
  805.94,
  805.95,
  805.96,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
];
a[31] = [
  806.03,
  806.02,
  806.01,
  806,
  805.99,
  805.99,
  805.98,
  805.97,
  805.95,
  805.95,
  805.94,
  805.93,
  805.92,
  805.92,
  805.91,
  805.9,
  805.9,
  805.89,
  805.89,
  805.88,
  805.87,
  805.87,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.81,
  805.81,
  805.82,
  805.82,
  805.83,
  805.83,
  805.84,
  805.84,
  805.85,
  805.86,
  805.86,
  805.87,
  805.88,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.92,
  805.93,
  805.94,
  805.94,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
];
a[30] = [
  806.02,
  806.01,
  806,
  805.99,
  805.98,
  805.98,
  805.96,
  805.96,
  805.94,
  805.94,
  805.93,
  805.92,
  805.91,
  805.91,
  805.9,
  805.89,
  805.89,
  805.88,
  805.88,
  805.87,
  805.86,
  805.86,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.8,
  805.8,
  805.8,
  805.8,
  805.81,
  805.81,
  805.82,
  805.82,
  805.83,
  805.84,
  805.84,
  805.85,
  805.86,
  805.86,
  805.87,
  805.88,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.92,
  805.93,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
];
a[29] = [
  806,
  806,
  805.99,
  805.98,
  805.97,
  805.96,
  805.95,
  805.94,
  805.93,
  805.93,
  805.92,
  805.9,
  805.9,
  805.9,
  805.88,
  805.88,
  805.88,
  805.87,
  805.87,
  805.86,
  805.86,
  805.85,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.8,
  805.8,
  805.8,
  805.81,
  805.82,
  805.82,
  805.83,
  805.83,
  805.84,
  805.85,
  805.85,
  805.86,
  805.87,
  805.87,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.93,
  805.93,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
];
a[28] = [
  806,
  805.99,
  805.98,
  805.97,
  805.96,
  805.95,
  805.94,
  805.93,
  805.92,
  805.91,
  805.91,
  805.89,
  805.89,
  805.88,
  805.87,
  805.87,
  805.87,
  805.86,
  805.86,
  805.85,
  805.85,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.8,
  805.8,
  805.81,
  805.81,
  805.82,
  805.83,
  805.83,
  805.84,
  805.85,
  805.85,
  805.86,
  805.87,
  805.87,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.93,
  805.93,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
];
a[27] = [
  805.99,
  805.98,
  805.97,
  805.96,
  805.95,
  805.94,
  805.93,
  805.92,
  805.91,
  805.9,
  805.89,
  805.88,
  805.88,
  805.87,
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.79,
  805.79,
  805.79,
  805.79,
  805.8,
  805.8,
  805.81,
  805.82,
  805.82,
  805.83,
  805.84,
  805.85,
  805.85,
  805.86,
  805.87,
  805.87,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.93,
  805.93,
  805.94,
  805.95,
  805.96,
  805.96,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
];
a[26] = [
  805.97,
  805.97,
  805.96,
  805.94,
  805.94,
  805.93,
  805.92,
  805.91,
  805.9,
  805.89,
  805.88,
  805.87,
  805.86,
  805.86,
  805.85,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.79,
  805.79,
  805.8,
  805.8,
  805.81,
  805.81,
  805.82,
  805.83,
  805.84,
  805.84,
  805.85,
  805.86,
  805.87,
  805.87,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
];
a[25] = [
  805.96,
  805.95,
  805.95,
  805.93,
  805.93,
  805.92,
  805.91,
  805.9,
  805.89,
  805.88,
  805.87,
  805.86,
  805.85,
  805.85,
  805.84,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.79,
  805.79,
  805.8,
  805.81,
  805.81,
  805.82,
  805.83,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.87,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
];
a[24] = [
  805.94,
  805.94,
  805.93,
  805.92,
  805.91,
  805.9,
  805.89,
  805.89,
  805.88,
  805.87,
  805.86,
  805.85,
  805.85,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.79,
  805.78,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.78,
  805.78,
  805.78,
  805.79,
  805.79,
  805.8,
  805.81,
  805.81,
  805.82,
  805.83,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.96,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
];
a[23] = [
  805.92,
  805.92,
  805.92,
  805.9,
  805.9,
  805.89,
  805.88,
  805.87,
  805.86,
  805.86,
  805.85,
  805.84,
  805.84,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.77,
  805.77,
  805.77,
  805.77,
  805.78,
  805.78,
  805.78,
  805.79,
  805.79,
  805.8,
  805.81,
  805.81,
  805.82,
  805.83,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.94,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
];
a[22] = [
  805.91,
  805.91,
  805.9,
  805.89,
  805.89,
  805.88,
  805.87,
  805.86,
  805.85,
  805.85,
  805.84,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.77,
  805.77,
  805.77,
  805.77,
  805.78,
  805.78,
  805.79,
  805.79,
  805.8,
  805.81,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
];
a[21] = [
  805.89,
  805.89,
  805.88,
  805.87,
  805.87,
  805.87,
  805.86,
  805.85,
  805.84,
  805.84,
  805.83,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.76,
  805.76,
  805.76,
  805.76,
  805.77,
  805.77,
  805.77,
  805.78,
  805.78,
  805.79,
  805.79,
  805.8,
  805.81,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
];
a[20] = [
  805.88,
  805.87,
  805.87,
  805.86,
  805.86,
  805.85,
  805.85,
  805.84,
  805.83,
  805.83,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.76,
  805.76,
  805.76,
  805.76,
  805.77,
  805.77,
  805.78,
  805.78,
  805.79,
  805.79,
  805.8,
  805.81,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.86,
  805.88,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
];
a[19] = [
  805.86,
  805.86,
  805.86,
  805.85,
  805.85,
  805.84,
  805.84,
  805.83,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.79,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.75,
  805.75,
  805.75,
  805.75,
  805.76,
  805.76,
  805.76,
  805.77,
  805.77,
  805.78,
  805.78,
  805.79,
  805.79,
  805.8,
  805.81,
  805.82,
  805.83,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.89,
  805.91,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.96,
  805.97,
  805.98,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
];
a[18] = [
  805.85,
  805.85,
  805.84,
  805.83,
  805.83,
  805.83,
  805.82,
  805.82,
  805.81,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.75,
  805.75,
  805.75,
  805.76,
  805.76,
  805.77,
  805.77,
  805.78,
  805.78,
  805.79,
  805.79,
  805.8,
  805.81,
  805.82,
  805.83,
  805.84,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.92,
  805.94,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.43,
  807.43,
  807.44,
  807.45,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
];
a[17] = [
  805.84,
  805.84,
  805.83,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.74,
  805.74,
  805.74,
  805.75,
  805.75,
  805.75,
  805.76,
  805.76,
  805.76,
  805.77,
  805.78,
  805.78,
  805.79,
  805.8,
  805.8,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.87,
  805.89,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.45,
  807.46,
  807.47,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.62,
];
a[16] = [
  805.83,
  805.82,
  805.82,
  805.82,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.74,
  805.74,
  805.74,
  805.75,
  805.75,
  805.76,
  805.76,
  805.76,
  805.77,
  805.78,
  805.78,
  805.79,
  805.8,
  805.81,
  805.82,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.47,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
];
a[15] = [
  805.82,
  805.81,
  805.81,
  805.8,
  805.8,
  805.8,
  805.79,
  805.79,
  805.78,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.73,
  805.73,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.71,
  805.71,
  805.71,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.73,
  805.73,
  805.73,
  805.74,
  805.74,
  805.74,
  805.75,
  805.75,
  805.76,
  805.76,
  805.77,
  805.78,
  805.78,
  805.79,
  805.8,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.85,
  805.87,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.49,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
];
a[14] = [
  805.81,
  805.8,
  805.8,
  805.79,
  805.79,
  805.79,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.75,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.73,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.72,
  805.72,
  805.72,
  805.72,
  805.72,
  805.73,
  805.73,
  805.73,
  805.74,
  805.74,
  805.75,
  805.75,
  805.76,
  805.77,
  805.77,
  805.78,
  805.79,
  805.8,
  805.8,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.51,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
];
a[13] = [
  805.8,
  805.8,
  805.79,
  805.79,
  805.78,
  805.78,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.72,
  805.72,
  805.72,
  805.72,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.72,
  805.72,
  805.72,
  805.73,
  805.73,
  805.74,
  805.74,
  805.75,
  805.75,
  805.76,
  805.77,
  805.78,
  805.78,
  805.79,
  805.8,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.86,
  805.88,
  805.89,
  805.89,
  805.91,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.21,
  807.22,
  807.23,
  807.23,
  807.24,
  807.25,
  807.25,
  807.26,
  807.27,
  807.27,
  807.28,
  807.29,
  807.29,
  807.3,
  807.31,
  807.31,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
];
a[12] = [
  805.79,
  805.79,
  805.78,
  805.77,
  805.77,
  805.77,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.73,
  805.72,
  805.72,
  805.72,
  805.72,
  805.71,
  805.71,
  805.71,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.7,
  805.71,
  805.71,
  805.71,
  805.72,
  805.72,
  805.72,
  805.73,
  805.73,
  805.74,
  805.75,
  805.75,
  805.76,
  805.77,
  805.78,
  805.78,
  805.79,
  805.8,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.95,
  805.97,
  805.97,
  805.98,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.53,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
];
a[11] = [
  805.78,
  805.78,
  805.77,
  805.76,
  805.76,
  805.76,
  805.75,
  805.75,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.72,
  805.72,
  805.72,
  805.72,
  805.71,
  805.71,
  805.71,
  805.71,
  805.7,
  805.7,
  805.7,
  805.7,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.7,
  805.7,
  805.7,
  805.7,
  805.71,
  805.71,
  805.71,
  805.72,
  805.72,
  805.73,
  805.73,
  805.74,
  805.75,
  805.76,
  805.76,
  805.77,
  805.78,
  805.79,
  805.8,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.93,
  805.95,
  805.95,
  805.96,
  805.97,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.55,
  807.56,
  807.57,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.63,
];
a[10] = [
  805.77,
  805.77,
  805.76,
  805.76,
  805.76,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.72,
  805.72,
  805.72,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.7,
  805.7,
  805.7,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.68,
  805.68,
  805.68,
  805.68,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.7,
  805.7,
  805.7,
  805.71,
  805.71,
  805.71,
  805.72,
  805.72,
  805.73,
  805.74,
  805.75,
  805.76,
  805.76,
  805.77,
  805.78,
  805.79,
  805.8,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.96,
  805.97,
  805.98,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.64,
];
a[9] = [
  805.76,
  805.75,
  805.75,
  805.74,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.73,
  805.72,
  805.72,
  805.72,
  805.71,
  805.71,
  805.71,
  805.7,
  805.7,
  805.7,
  805.7,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.69,
  805.69,
  805.69,
  805.69,
  805.7,
  805.7,
  805.71,
  805.71,
  805.72,
  805.72,
  805.73,
  805.74,
  805.75,
  805.76,
  805.77,
  805.78,
  805.79,
  805.8,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.32,
  807.33,
  807.34,
  807.34,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.57,
  807.58,
  807.59,
  807.59,
  807.6,
  807.6,
  807.61,
  807.62,
  807.62,
  807.62,
  807.63,
  807.63,
  807.64,
];
a[8] = [
  805.75,
  805.74,
  805.74,
  805.73,
  805.73,
  805.73,
  805.72,
  805.72,
  805.72,
  805.72,
  805.71,
  805.71,
  805.71,
  805.7,
  805.7,
  805.7,
  805.69,
  805.69,
  805.69,
  805.69,
  805.69,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.69,
  805.69,
  805.69,
  805.69,
  805.7,
  805.7,
  805.71,
  805.71,
  805.72,
  805.73,
  805.74,
  805.75,
  805.76,
  805.77,
  805.78,
  805.8,
  805.81,
  805.81,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.95,
  805.96,
  805.97,
  805.98,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.64,
  807.64,
];
a[7] = [
  805.74,
  805.74,
  805.73,
  805.72,
  805.72,
  805.72,
  805.71,
  805.71,
  805.71,
  805.71,
  805.71,
  805.7,
  805.7,
  805.69,
  805.69,
  805.69,
  805.69,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.68,
  805.68,
  805.68,
  805.68,
  805.69,
  805.69,
  805.69,
  805.7,
  805.7,
  805.71,
  805.71,
  805.72,
  805.73,
  805.74,
  805.75,
  805.76,
  805.77,
  805.79,
  805.8,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.59,
  807.6,
  807.61,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.64,
  807.64,
];
a[6] = [
  805.72,
  805.72,
  805.72,
  805.71,
  805.71,
  805.7,
  805.7,
  805.7,
  805.69,
  805.69,
  805.69,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.68,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.68,
  805.68,
  805.68,
  805.69,
  805.69,
  805.7,
  805.7,
  805.71,
  805.71,
  805.72,
  805.73,
  805.74,
  805.75,
  805.77,
  805.78,
  805.79,
  805.81,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.88,
  805.88,
  805.9,
  805.91,
  805.91,
  805.93,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.02,
  807.02,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.63,
  807.63,
  807.64,
  807.64,
  807.64,
];
a[5] = [
  805.71,
  805.71,
  805.71,
  805.7,
  805.7,
  805.69,
  805.69,
  805.68,
  805.68,
  805.68,
  805.68,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.67,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.65,
  805.65,
  805.65,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.67,
  805.67,
  805.67,
  805.68,
  805.68,
  805.68,
  805.69,
  805.69,
  805.69,
  805.7,
  805.71,
  805.71,
  805.72,
  805.74,
  805.75,
  805.76,
  805.78,
  805.79,
  805.8,
  805.82,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.91,
  805.91,
  805.92,
  805.94,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.99,
  805.99,
  806,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.96,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.04,
  807.05,
  807.06,
  807.06,
  807.07,
  807.08,
  807.08,
  807.09,
  807.1,
  807.1,
  807.11,
  807.12,
  807.12,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.61,
  807.61,
  807.62,
  807.63,
  807.63,
  807.64,
  807.64,
  807.65,
];
a[4] = [
  805.7,
  805.7,
  805.69,
  805.69,
  805.69,
  805.68,
  805.68,
  805.67,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.67,
  805.67,
  805.67,
  805.68,
  805.68,
  805.69,
  805.69,
  805.7,
  805.7,
  805.71,
  805.72,
  805.73,
  805.75,
  805.76,
  805.77,
  805.79,
  805.8,
  805.81,
  805.83,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.92,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806.01,
  806.02,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.33,
  806.33,
  806.34,
  806.35,
  806.35,
  806.36,
  806.37,
  806.37,
  806.38,
  806.39,
  806.39,
  806.4,
  806.41,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.81,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.9,
  806.9,
  806.91,
  806.92,
  806.92,
  806.93,
  806.94,
  806.94,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.14,
  807.15,
  807.16,
  807.16,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.64,
  807.64,
  807.65,
];
a[3] = [
  805.69,
  805.69,
  805.69,
  805.68,
  805.68,
  805.67,
  805.67,
  805.66,
  805.66,
  805.65,
  805.65,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.67,
  805.67,
  805.68,
  805.68,
  805.69,
  805.69,
  805.7,
  805.7,
  805.71,
  805.72,
  805.73,
  805.75,
  805.76,
  805.78,
  805.8,
  805.81,
  805.82,
  805.84,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.82,
  806.83,
  806.84,
  806.84,
  806.85,
  806.86,
  806.86,
  806.87,
  806.88,
  806.88,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.18,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.41,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.61,
  807.62,
  807.62,
  807.63,
  807.63,
  807.64,
  807.65,
  807.65,
];
a[2] = [
  805.68,
  805.68,
  805.68,
  805.67,
  805.67,
  805.67,
  805.66,
  805.66,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.66,
  805.66,
  805.66,
  805.67,
  805.67,
  805.68,
  805.68,
  805.69,
  805.69,
  805.7,
  805.71,
  805.72,
  805.73,
  805.74,
  805.76,
  805.78,
  805.79,
  805.81,
  805.82,
  805.83,
  805.85,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.97,
  805.98,
  805.99,
  806,
  806.01,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.09,
  806.09,
  806.1,
  806.11,
  806.11,
  806.12,
  806.13,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.3,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.43,
  806.43,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.49,
  806.5,
  806.51,
  806.51,
  806.52,
  806.53,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.37,
  807.37,
  807.38,
  807.39,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.61,
  807.62,
  807.63,
  807.63,
  807.64,
  807.64,
  807.65,
  807.65,
];
a[1] = [
  805.67,
  805.67,
  805.67,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.66,
  805.66,
  805.66,
  805.67,
  805.67,
  805.68,
  805.69,
  805.69,
  805.7,
  805.71,
  805.71,
  805.73,
  805.74,
  805.75,
  805.78,
  805.79,
  805.8,
  805.82,
  805.83,
  805.84,
  805.86,
  805.87,
  805.88,
  805.89,
  805.9,
  805.91,
  805.92,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.03,
  806.04,
  806.04,
  806.05,
  806.06,
  806.06,
  806.07,
  806.08,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.15,
  806.15,
  806.16,
  806.17,
  806.17,
  806.18,
  806.19,
  806.19,
  806.2,
  806.21,
  806.21,
  806.22,
  806.23,
  806.23,
  806.24,
  806.25,
  806.25,
  806.26,
  806.27,
  806.27,
  806.28,
  806.29,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.45,
  806.46,
  806.47,
  806.47,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.54,
  806.55,
  806.56,
  806.56,
  806.57,
  806.58,
  806.58,
  806.59,
  806.6,
  806.6,
  806.61,
  806.62,
  806.62,
  806.63,
  806.64,
  806.64,
  806.65,
  806.66,
  806.66,
  806.67,
  806.68,
  806.68,
  806.69,
  806.7,
  806.7,
  806.71,
  806.72,
  806.72,
  806.73,
  806.74,
  806.74,
  806.75,
  806.76,
  806.76,
  806.77,
  806.78,
  806.78,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  806.99,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.61,
  807.62,
  807.63,
  807.63,
  807.64,
  807.64,
  807.65,
  807.65,
];
a[0] = [
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.66,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.65,
  805.66,
  805.66,
  805.67,
  805.67,
  805.68,
  805.69,
  805.69,
  805.7,
  805.71,
  805.72,
  805.74,
  805.75,
  805.76,
  805.79,
  805.8,
  805.82,
  805.83,
  805.84,
  805.85,
  805.87,
  805.88,
  805.88,
  805.9,
  805.91,
  805.91,
  805.93,
  805.94,
  805.95,
  805.96,
  805.97,
  805.98,
  805.98,
  805.99,
  806,
  806,
  806.01,
  806.02,
  806.03,
  806.03,
  806.04,
  806.05,
  806.05,
  806.06,
  806.07,
  806.07,
  806.08,
  806.09,
  806.1,
  806.1,
  806.11,
  806.12,
  806.12,
  806.13,
  806.14,
  806.14,
  806.15,
  806.16,
  806.16,
  806.17,
  806.18,
  806.18,
  806.19,
  806.2,
  806.2,
  806.21,
  806.22,
  806.22,
  806.23,
  806.24,
  806.24,
  806.25,
  806.26,
  806.26,
  806.27,
  806.28,
  806.28,
  806.29,
  806.3,
  806.31,
  806.31,
  806.32,
  806.32,
  806.33,
  806.34,
  806.34,
  806.35,
  806.36,
  806.36,
  806.37,
  806.38,
  806.38,
  806.39,
  806.4,
  806.4,
  806.41,
  806.42,
  806.42,
  806.43,
  806.44,
  806.44,
  806.45,
  806.46,
  806.46,
  806.47,
  806.48,
  806.48,
  806.49,
  806.5,
  806.5,
  806.51,
  806.52,
  806.52,
  806.53,
  806.54,
  806.55,
  806.55,
  806.56,
  806.57,
  806.57,
  806.58,
  806.59,
  806.59,
  806.6,
  806.61,
  806.61,
  806.62,
  806.63,
  806.63,
  806.64,
  806.65,
  806.65,
  806.66,
  806.67,
  806.67,
  806.68,
  806.69,
  806.69,
  806.7,
  806.71,
  806.71,
  806.72,
  806.73,
  806.73,
  806.74,
  806.75,
  806.75,
  806.76,
  806.77,
  806.77,
  806.78,
  806.79,
  806.79,
  806.8,
  806.8,
  806.81,
  806.82,
  806.83,
  806.83,
  806.84,
  806.85,
  806.85,
  806.86,
  806.87,
  806.87,
  806.88,
  806.89,
  806.89,
  806.9,
  806.91,
  806.91,
  806.92,
  806.93,
  806.93,
  806.94,
  806.95,
  806.95,
  806.96,
  806.97,
  806.97,
  806.98,
  806.99,
  807,
  807,
  807.01,
  807.01,
  807.02,
  807.04,
  807.05,
  807.05,
  807.06,
  807.07,
  807.07,
  807.08,
  807.09,
  807.09,
  807.1,
  807.11,
  807.11,
  807.12,
  807.13,
  807.13,
  807.14,
  807.15,
  807.15,
  807.16,
  807.17,
  807.17,
  807.18,
  807.19,
  807.19,
  807.2,
  807.2,
  807.21,
  807.22,
  807.22,
  807.23,
  807.24,
  807.24,
  807.25,
  807.26,
  807.26,
  807.27,
  807.28,
  807.28,
  807.29,
  807.3,
  807.3,
  807.31,
  807.32,
  807.33,
  807.33,
  807.34,
  807.35,
  807.35,
  807.36,
  807.36,
  807.37,
  807.38,
  807.38,
  807.39,
  807.4,
  807.4,
  807.41,
  807.42,
  807.42,
  807.43,
  807.44,
  807.44,
  807.45,
  807.46,
  807.46,
  807.47,
  807.48,
  807.48,
  807.49,
  807.5,
  807.5,
  807.51,
  807.52,
  807.52,
  807.53,
  807.54,
  807.54,
  807.55,
  807.56,
  807.56,
  807.57,
  807.58,
  807.58,
  807.59,
  807.6,
  807.6,
  807.61,
  807.62,
  807.63,
  807.63,
  807.64,
  807.65,
  807.65,
  807.65,
];

dataMaps.water = new DataMapNumeric(
  'Water Table',
  'Water Table Elevation Above Sea Level',
  'ft',
  a,
  320,
  200,
);

a = [];
a[9] = [0, 0, 0, 0, 0, 0, 0];
a[8] = [0, 0, 0, 0, 0, 0, 0];
a[7] = [0, 0, 0, 0, 0, 0, 0];
a[6] = [0, 0, 0, 0, 0, 0, 0];
a[5] = [0, 0, 0, 0, 0, 0, 0];
a[4] = [0, 0, 0, 0, 0, 0, 0];
a[3] = [0, 0, 0, 0, 0, 0, 0];
a[2] = [0, 0, 0, 0, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0];

dataMaps.gas650 = new DataMapNumeric(
  'Gas 650',
  'Gas Content at 650 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  87,
  34,
  7,
  10,
);

a = [];
a[20] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[19] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[18] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[17] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[16] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[15] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[14] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[13] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[12] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[11] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[10] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[9] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[8] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[7] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[6] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[5] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[4] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[3] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.gas660 = new DataMapNumeric(
  'Gas 660',
  'Gas Content at 660 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  83,
  31,
  10,
  21,
);

a = [];
a[29] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[28] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[27] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[26] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[25] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[24] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[23] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[22] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[21] = [0, 0, 0, 0, 0, 0, 500, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[20] = [0, 0, 0, 0, 0, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[19] = [0, 0, 0, 0, 0, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[18] = [0, 0, 0, 0, 0, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[17] = [0, 0, 0, 0, 0, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[16] = [0, 0, 0, 0, 0, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[15] = [0, 0, 0, 0, 0, 0, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[14] = [0, 0, 0, 0, 0, 0, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[13] = [0, 0, 0, 0, 0, 0, 500, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[12] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[11] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[10] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[9] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[8] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[7] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[6] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[5] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[4] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[3] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.gas670 = new DataMapNumeric(
  'Gas 670',
  'Gas Content at 670 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  83,
  42,
  18,
  30,
);

a = [];
a[42] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[41] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[40] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[39] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[38] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[37] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[36] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[35] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[34] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[33] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[32] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[31] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[30] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[29] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 500, 0, 0, 0, 0, 0, 0, 0];
a[28] = [0, 0, 0, 0, 0, 0, 0, 500, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0];
a[27] = [0, 0, 0, 0, 0, 0, 500, 500, 1000, 1000, 500, 500, 0, 0, 0, 0, 0, 0];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [0, 0, 0, 0, 0, 500, 500, 500, 1000, 1000, 500, 500, 0, 0, 0, 0, 0, 0];
a[19] = [0, 0, 0, 0, 0, 500, 500, 500, 1000, 500, 500, 500, 0, 0, 0, 0, 0, 0];
a[18] = [0, 0, 0, 0, 0, 0, 500, 500, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0];
a[17] = [0, 0, 0, 0, 0, 0, 500, 500, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0];
a[16] = [0, 0, 0, 0, 0, 0, 0, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0];
a[15] = [0, 0, 0, 0, 0, 0, 0, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0];
a[14] = [0, 0, 0, 0, 0, 0, 0, 0, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0];
a[13] = [0, 0, 0, 0, 0, 0, 0, 0, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0];
a[12] = [0, 0, 0, 0, 0, 0, 0, 0, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0];
a[11] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[10] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[9] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[8] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[7] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[6] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[5] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[4] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[3] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.gas680 = new DataMapNumeric(
  'Gas 680',
  'Gas Content at 680 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  81,
  38,
  18,
  43,
);

a = [];
a[52] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[51] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[50] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[49] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[48] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[47] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[46] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[45] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[44] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[43] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[42] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[41] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[40] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2000,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  2500,
  3000,
  2000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  2500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  2500,
  2500,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  2500,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[10] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[9] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[8] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[7] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[6] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[5] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[4] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[3] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.gas690 = new DataMapNumeric(
  'Gas 690',
  'Gas Content at 690 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  78,
  37,
  23,
  53,
);

a = [];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  2500,
  3000,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3000,
  3500,
  3500,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2000,
  3000,
  3500,
  4000,
  4000,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2500,
  3000,
  3500,
  4000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2500,
  3500,
  3500,
  4000,
  4000,
  3500,
  3000,
  3000,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  3000,
  3500,
  3500,
  4000,
  4000,
  4000,
  3500,
  3000,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2500,
  3500,
  3500,
  4000,
  4000,
  4000,
  4000,
  3500,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3500,
  3500,
  3500,
  4000,
  4000,
  3500,
  3500,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3000,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  3000,
  3500,
  3500,
  3500,
  3500,
  3500,
  3000,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2500,
  2500,
  3000,
  3000,
  3000,
  3000,
  2500,
  2000,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  2500,
  3000,
  3000,
  2500,
  2500,
  2000,
  1500,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  2500,
  3000,
  3000,
  2500,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2000,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas700 = new DataMapNumeric(
  'Gas 700',
  'Gas Content at 700 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  74,
  37,
  31,
  61,
);

a = [];
a[71] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[70] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[69] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[68] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[67] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[66] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[65] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[64] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[63] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[62] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[61] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  2000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  2500,
  2500,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  3000,
  3500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3500,
  4000,
  5000,
  4000,
  3500,
  2500,
  2000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  6500,
  5000,
  4000,
  3000,
  2500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  5500,
  5000,
  4000,
  3000,
  2500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  3500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2500,
  2000,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas710 = new DataMapNumeric(
  'Gas 710',
  'Gas Content at 710 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  73,
  38,
  34,
  72,
);

a = [];
a[78] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[77] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[76] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[75] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[74] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[73] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[72] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[71] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[70] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[69] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[68] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[67] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[66] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[65] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3000,
  2500,
  2500,
  2000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[64] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3500,
  4000,
  4500,
  4500,
  4000,
  3500,
  2500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[63] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  5000,
  7000,
  9500,
  10500,
  6000,
  4500,
  3000,
  2500,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[62] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  7000,
  11500,
  15500,
  15500,
  8500,
  6500,
  4000,
  3000,
  2000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[61] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  3500,
  5000,
  6000,
  10500,
  15500,
  22500,
  21000,
  12000,
  8500,
  5500,
  3500,
  2500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  3500,
  4500,
  6000,
  8000,
  12500,
  18000,
  20500,
  20500,
  14000,
  9500,
  5500,
  4000,
  3000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  3000,
  4000,
  5500,
  7000,
  9500,
  14000,
  17000,
  19000,
  18500,
  14000,
  10000,
  7000,
  4500,
  3500,
  2000,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2000,
  3500,
  4500,
  6000,
  8000,
  10500,
  14000,
  16000,
  17500,
  17000,
  13000,
  10000,
  7500,
  5500,
  4000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3500,
  5000,
  6500,
  8000,
  10000,
  13000,
  15000,
  16000,
  15500,
  12500,
  10000,
  7500,
  6000,
  4500,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  3500,
  4500,
  6000,
  7500,
  9500,
  12000,
  13500,
  13500,
  13500,
  11000,
  9500,
  7500,
  6000,
  4500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  3000,
  4000,
  5500,
  7000,
  8500,
  11000,
  12500,
  12500,
  12500,
  10000,
  9000,
  7500,
  6000,
  4500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  3500,
  4500,
  5000,
  7500,
  10000,
  12000,
  12500,
  11500,
  9000,
  8000,
  6500,
  5500,
  4500,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  6000,
  9000,
  11000,
  11000,
  10500,
  8000,
  7000,
  5500,
  4500,
  4000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2500,
  3000,
  3500,
  4000,
  5500,
  8000,
  9500,
  10000,
  9500,
  7000,
  6000,
  5000,
  4000,
  3500,
  2000,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  7000,
  8000,
  8000,
  8000,
  6000,
  4500,
  4000,
  3500,
  2500,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  6000,
  7500,
  7500,
  7000,
  5500,
  4500,
  4000,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  5500,
  6000,
  6000,
  6000,
  5000,
  4500,
  3500,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  2500,
  3000,
  3500,
  4500,
  5000,
  5000,
  5000,
  4500,
  4000,
  3500,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  4500,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  2500,
  3000,
  3500,
  3500,
  3500,
  3500,
  3000,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  2500,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas720 = new DataMapNumeric(
  'Gas 720',
  'Gas Content at 720 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  73,
  38,
  35,
  79,
);

a = [];
a[85] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[84] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[83] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[82] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[81] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[80] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[79] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[78] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[77] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[76] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[75] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[74] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[73] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[72] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2500,
  2500,
  3000,
  3500,
  3000,
  3000,
  4000,
  3000,
  2500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[71] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  3500,
  4000,
  5500,
  6000,
  4500,
  5000,
  6500,
  4500,
  3500,
  2500,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[70] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4500,
  7000,
  8500,
  10000,
  10000,
  10000,
  11500,
  7000,
  5000,
  3000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[69] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  3000,
  4000,
  5000,
  8000,
  10500,
  12500,
  15000,
  16000,
  16500,
  17000,
  10500,
  7500,
  4000,
  3000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[68] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  4000,
  6000,
  8500,
  14500,
  17000,
  20000,
  22500,
  25000,
  25000,
  22000,
  15000,
  11000,
  6500,
  3500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[67] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  2500,
  5000,
  7000,
  10000,
  17500,
  20500,
  25000,
  28000,
  30500,
  29000,
  24500,
  17500,
  12500,
  6500,
  3500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[66] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  5500,
  8500,
  12000,
  19500,
  22500,
  27500,
  32500,
  35500,
  32000,
  28500,
  19500,
  14500,
  9000,
  4500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[65] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2000,
  4500,
  7500,
  12500,
  20500,
  25500,
  29500,
  33000,
  34500,
  33000,
  30500,
  22000,
  15500,
  11000,
  7500,
  3500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[64] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3500,
  5000,
  10000,
  20000,
  24500,
  28000,
  31000,
  31000,
  30500,
  29000,
  21500,
  16000,
  11500,
  8000,
  4000,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[63] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  4500,
  10000,
  19500,
  24000,
  26500,
  29000,
  29000,
  28500,
  26500,
  20500,
  16000,
  11500,
  8000,
  4500,
  2500,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[62] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3500,
  6000,
  10500,
  18500,
  21500,
  25500,
  27000,
  27000,
  27000,
  25000,
  19500,
  15500,
  11500,
  8000,
  4500,
  2500,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[61] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  4000,
  6500,
  10000,
  16500,
  19500,
  23000,
  25000,
  25000,
  25000,
  23000,
  17500,
  14000,
  9500,
  6000,
  4000,
  2500,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3500,
  6000,
  9000,
  15500,
  18000,
  21000,
  23500,
  24000,
  24000,
  23000,
  17000,
  13000,
  8500,
  4500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  3500,
  4500,
  8000,
  14500,
  17000,
  19500,
  22000,
  22500,
  22500,
  21500,
  15500,
  11500,
  7000,
  4500,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3500,
  4500,
  8000,
  14000,
  16500,
  19000,
  20500,
  21000,
  21000,
  19000,
  14500,
  10500,
  7500,
  5500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  2500,
  4000,
  6000,
  9000,
  13000,
  15500,
  17500,
  19000,
  19000,
  18000,
  16500,
  12500,
  10000,
  7500,
  5500,
  3500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  4500,
  6500,
  9000,
  12500,
  14500,
  16500,
  17500,
  17500,
  16500,
  15000,
  11500,
  9500,
  7500,
  5500,
  3500,
  2500,
  2000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  5000,
  6500,
  8000,
  12000,
  13500,
  15000,
  16500,
  16500,
  15000,
  13000,
  10000,
  8500,
  7000,
  5500,
  3500,
  2500,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  4500,
  6000,
  7500,
  10500,
  12000,
  14000,
  15000,
  15000,
  13500,
  11500,
  8000,
  7500,
  6000,
  4500,
  3500,
  2500,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  4000,
  5000,
  6500,
  9000,
  11000,
  13000,
  13500,
  13500,
  12000,
  10500,
  7000,
  6500,
  5000,
  4500,
  3000,
  2500,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2500,
  3500,
  4500,
  5500,
  8000,
  9500,
  11500,
  12500,
  12500,
  11000,
  9000,
  6000,
  5500,
  4500,
  3500,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  3500,
  4500,
  6500,
  8000,
  9500,
  11000,
  11000,
  10000,
  8000,
  4500,
  4500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2500,
  3000,
  3500,
  5000,
  7000,
  9000,
  10000,
  9500,
  8500,
  5500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3500,
  5000,
  6000,
  7500,
  7500,
  7500,
  6500,
  5500,
  3500,
  3000,
  2500,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  2500,
  3000,
  4500,
  5000,
  5500,
  5500,
  5500,
  5500,
  4500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  4000,
  4000,
  4500,
  4500,
  4000,
  4000,
  3500,
  3000,
  2500,
  2000,
  2000,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  1500,
  2000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas730 = new DataMapNumeric(
  'Gas 730',
  'Gas Content at 730 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  75,
  38,
  35,
  86,
);

a = [];
a[75] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[74] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[73] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[72] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[71] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[70] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1000,
  1000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[69] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  3000,
  3500,
  3500,
  2500,
  2500,
  3000,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[68] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3500,
  5000,
  6000,
  6500,
  4500,
  4500,
  5500,
  4000,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[67] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  5500,
  7500,
  9000,
  11000,
  12000,
  11500,
  9500,
  6500,
  4500,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[66] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  3000,
  6500,
  10000,
  13500,
  16000,
  19500,
  18500,
  14000,
  10000,
  7000,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[65] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  3500,
  8000,
  12000,
  17000,
  22500,
  26500,
  25500,
  20000,
  12500,
  7500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[64] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3500,
  8500,
  14000,
  20000,
  27000,
  39500,
  34000,
  27000,
  18000,
  11000,
  4000,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[63] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  7000,
  13000,
  21000,
  30000,
  43500,
  37000,
  28000,
  19000,
  12000,
  5500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[62] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  5000,
  12500,
  21000,
  30000,
  39000,
  37000,
  29500,
  21500,
  14500,
  6500,
  3000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[61] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  5500,
  12500,
  21500,
  30500,
  39000,
  37000,
  30500,
  23500,
  16000,
  6500,
  3500,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  5000,
  9500,
  17500,
  25000,
  32500,
  39500,
  38000,
  31500,
  24500,
  17500,
  6000,
  3500,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  3500,
  6000,
  11500,
  18000,
  25000,
  31500,
  38500,
  37000,
  31500,
  25500,
  19000,
  9500,
  5000,
  3000,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  4500,
  7000,
  13500,
  19000,
  25000,
  30500,
  36000,
  35000,
  31500,
  26000,
  20500,
  12500,
  8000,
  5000,
  3500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  4000,
  7000,
  13000,
  18500,
  23500,
  29000,
  34500,
  34000,
  31000,
  26000,
  21500,
  15000,
  11000,
  7500,
  5000,
  3000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  4000,
  7000,
  12500,
  18500,
  23500,
  29000,
  33000,
  32500,
  30000,
  26000,
  21500,
  15500,
  12000,
  8500,
  6000,
  4000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  4000,
  10000,
  16000,
  21000,
  25500,
  30500,
  30500,
  29000,
  26000,
  22500,
  17000,
  14000,
  10500,
  8000,
  5000,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  4000,
  10000,
  16000,
  20500,
  25000,
  29000,
  29500,
  28500,
  25500,
  22500,
  17500,
  14000,
  11000,
  8500,
  5000,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  3500,
  5500,
  10500,
  16000,
  20500,
  24500,
  29000,
  29000,
  27500,
  25500,
  22500,
  17500,
  14000,
  11000,
  8500,
  5000,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  3000,
  4500,
  6500,
  11500,
  16000,
  20000,
  23500,
  28000,
  28500,
  26500,
  24500,
  22000,
  17000,
  14000,
  11000,
  8500,
  5000,
  3500,
  2000,
  1000,
  500,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3500,
  5500,
  7500,
  12000,
  15500,
  19000,
  22500,
  26000,
  26000,
  25000,
  22500,
  20000,
  16000,
  12500,
  9500,
  7000,
  4000,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3500,
  5000,
  7500,
  11500,
  15000,
  18500,
  21500,
  25000,
  25000,
  24500,
  22500,
  20000,
  15500,
  12500,
  9500,
  7000,
  3500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  4500,
  6500,
  10500,
  14000,
  17500,
  20500,
  24500,
  24500,
  23000,
  21500,
  19000,
  14500,
  12000,
  8500,
  6000,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  2500,
  4000,
  5500,
  9500,
  13000,
  16000,
  19500,
  23000,
  23000,
  21500,
  20000,
  18000,
  13500,
  11000,
  8000,
  5000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  2500,
  3500,
  4500,
  8000,
  12000,
  15000,
  18000,
  21500,
  21500,
  20500,
  18500,
  16500,
  12500,
  10000,
  7000,
  4500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  2500,
  3500,
  4500,
  8500,
  11500,
  14500,
  17500,
  20000,
  20000,
  19000,
  16500,
  14000,
  11000,
  8000,
  5500,
  4000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  3500,
  5000,
  8500,
  11500,
  14000,
  16500,
  19500,
  19500,
  18000,
  16000,
  13500,
  10000,
  7500,
  5500,
  4000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  4000,
  5500,
  8500,
  11000,
  13500,
  15500,
  18000,
  18000,
  16500,
  14500,
  12000,
  8500,
  6000,
  4500,
  3500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  3000,
  4000,
  5500,
  8500,
  10500,
  12500,
  14500,
  16500,
  16500,
  15000,
  13000,
  11000,
  6500,
  4500,
  3500,
  3000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  3000,
  4000,
  5500,
  8000,
  10000,
  11500,
  13500,
  15000,
  15000,
  13500,
  11000,
  8500,
  5500,
  4000,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  3000,
  4000,
  5000,
  7000,
  9000,
  10500,
  12500,
  14500,
  14500,
  13000,
  11000,
  8500,
  5500,
  4000,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  3000,
  3500,
  4500,
  6500,
  8000,
  9500,
  11500,
  13000,
  13000,
  11500,
  10000,
  8000,
  5500,
  4000,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  5000,
  6500,
  8500,
  10500,
  11500,
  11500,
  10500,
  9000,
  7500,
  5000,
  4000,
  3000,
  2000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  6500,
  8000,
  9500,
  10500,
  10500,
  9500,
  8000,
  6500,
  4500,
  3500,
  2500,
  2000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  6000,
  7000,
  8500,
  10000,
  9500,
  8500,
  7500,
  5500,
  4000,
  3000,
  2500,
  2000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  1500,
  2000,
  3000,
  3500,
  4500,
  5500,
  6500,
  7500,
  8500,
  8500,
  7500,
  6500,
  5500,
  4000,
  3000,
  2500,
  2000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3500,
  4500,
  5000,
  6000,
  7000,
  7500,
  7500,
  6500,
  6000,
  5000,
  3500,
  3000,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  5500,
  6000,
  6500,
  6500,
  6000,
  5500,
  4500,
  3500,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  5500,
  5500,
  5500,
  5500,
  4500,
  4000,
  3000,
  2500,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3500,
  4000,
  4500,
  4500,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4000,
  4000,
  4000,
  3500,
  3500,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  3500,
  3500,
  3500,
  3500,
  3000,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas740 = new DataMapNumeric(
  'Gas 740',
  'Gas Content at 740 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  74,
  53,
  34,
  76,
);

a = [];
a[96] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[95] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[94] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[93] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[92] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[91] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  1500,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[90] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2500,
  3000,
  4500,
  4500,
  7000,
  5000,
  5000,
  2000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[89] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3500,
  7000,
  10000,
  16000,
  13000,
  10000,
  8000,
  4000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[88] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  4500,
  11500,
  19000,
  27000,
  21500,
  16500,
  12000,
  6500,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[87] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  3500,
  6000,
  10500,
  19000,
  30000,
  37500,
  32000,
  23500,
  17000,
  6500,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[86] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  5500,
  10000,
  17000,
  27500,
  41000,
  50000,
  41000,
  29000,
  19500,
  10500,
  3000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[85] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3500,
  8500,
  14500,
  23500,
  34000,
  45000,
  50000,
  46500,
  35500,
  24500,
  16000,
  7000,
  4000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[84] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  4000,
  10000,
  16000,
  25000,
  34500,
  41500,
  46500,
  43500,
  35500,
  26500,
  18500,
  9500,
  5500,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[83] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3500,
  9500,
  16500,
  25000,
  33500,
  39500,
  44000,
  41500,
  34500,
  26500,
  19000,
  10000,
  6000,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[82] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  7000,
  16000,
  24500,
  33000,
  39000,
  42500,
  40000,
  34000,
  26500,
  19000,
  10000,
  6000,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[81] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  7000,
  16000,
  24500,
  33000,
  39000,
  42000,
  39000,
  33000,
  25500,
  18500,
  9000,
  5000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[80] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  4500,
  11000,
  17500,
  25000,
  32000,
  37500,
  41000,
  38000,
  32000,
  24500,
  16500,
  5000,
  3500,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[79] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  3500,
  6000,
  12500,
  18500,
  25500,
  31500,
  36000,
  39000,
  37000,
  31500,
  24000,
  17000,
  6000,
  4000,
  2500,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[78] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  4500,
  7000,
  14000,
  19500,
  25500,
  31000,
  35500,
  38000,
  36000,
  31000,
  25000,
  19000,
  10000,
  6000,
  4000,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
];
a[77] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  4500,
  7500,
  14000,
  19500,
  25500,
  30500,
  35500,
  38500,
  35500,
  31500,
  26500,
  21000,
  13000,
  9000,
  6000,
  4500,
  3000,
  1500,
  0,
  0,
  0,
  0,
];
a[76] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2500,
  3500,
  6500,
  14000,
  19500,
  25000,
  30000,
  34500,
  38500,
  35500,
  31500,
  27000,
  22000,
  14000,
  11000,
  8000,
  6500,
  4500,
  2500,
  500,
  0,
  0,
  0,
];
a[75] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3500,
  5000,
  13000,
  18500,
  24000,
  29000,
  33000,
  35500,
  34500,
  31500,
  27500,
  23500,
  17500,
  13500,
  10000,
  8000,
  5500,
  3500,
  1000,
  0,
  0,
  0,
];
a[74] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  4000,
  5500,
  13000,
  18500,
  24000,
  28500,
  32000,
  34500,
  34000,
  31000,
  27500,
  23500,
  18000,
  14500,
  11000,
  8500,
  6000,
  4000,
  1500,
  0,
  0,
  0,
];
a[73] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2000,
  3500,
  5000,
  7500,
  13500,
  19000,
  24000,
  28000,
  31500,
  34500,
  33000,
  30500,
  27500,
  23500,
  18000,
  15000,
  11500,
  9000,
  6500,
  4500,
  1500,
  0,
  0,
  0,
];
a[72] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  3000,
  5000,
  6500,
  9000,
  15000,
  19500,
  24000,
  27500,
  30500,
  33500,
  32000,
  29500,
  27000,
  23500,
  18000,
  15000,
  12000,
  9000,
  6500,
  4500,
  1500,
  0,
  0,
  0,
];
a[71] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  4000,
  6000,
  7500,
  10500,
  16000,
  20000,
  24000,
  27000,
  30000,
  31500,
  31000,
  28500,
  26000,
  23000,
  18000,
  15000,
  12000,
  9000,
  6500,
  4500,
  1500,
  0,
  0,
  0,
];
a[70] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  3500,
  5000,
  7000,
  9000,
  11500,
  16500,
  20000,
  23500,
  26500,
  28500,
  30000,
  29000,
  26500,
  25000,
  22000,
  17000,
  14000,
  11000,
  9000,
  6500,
  4500,
  2000,
  500,
  0,
  0,
];
a[69] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  4000,
  5500,
  7500,
  9500,
  12500,
  17000,
  20000,
  23000,
  25500,
  28000,
  30000,
  28000,
  25000,
  23000,
  20500,
  15500,
  13000,
  10000,
  8500,
  6000,
  4500,
  2000,
  500,
  0,
  0,
];
a[68] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  4500,
  6000,
  8000,
  10000,
  12500,
  16500,
  19000,
  22500,
  24500,
  26500,
  28000,
  26000,
  23000,
  21000,
  18000,
  14000,
  11500,
  9000,
  7500,
  5500,
  4000,
  2000,
  500,
  0,
  0,
];
a[67] = [
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  3000,
  5000,
  6500,
  8500,
  10000,
  12000,
  15500,
  18500,
  21500,
  23500,
  25500,
  25500,
  24000,
  21000,
  19000,
  16000,
  12000,
  10000,
  8000,
  6500,
  5000,
  3500,
  1500,
  500,
  0,
  0,
];
a[66] = [
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  3500,
  5000,
  6500,
  8500,
  10000,
  12000,
  15500,
  18500,
  21000,
  23000,
  24500,
  24000,
  22000,
  18500,
  16500,
  13500,
  10000,
  8000,
  6500,
  5500,
  4000,
  3000,
  1500,
  500,
  0,
  0,
];
a[65] = [
  0,
  0,
  0,
  0,
  1000,
  1500,
  2500,
  3500,
  5500,
  6500,
  8000,
  9500,
  11000,
  13500,
  16000,
  19500,
  22000,
  24000,
  22500,
  19000,
  15000,
  13000,
  10000,
  6500,
  5500,
  4500,
  4000,
  3500,
  2500,
  1000,
  0,
  0,
  0,
];
a[64] = [
  0,
  0,
  0,
  0,
  1000,
  1500,
  2500,
  3500,
  5000,
  6500,
  8000,
  9000,
  11000,
  13500,
  15500,
  18500,
  20500,
  22500,
  21000,
  18000,
  14000,
  11000,
  7500,
  5000,
  4500,
  4000,
  3500,
  3000,
  2000,
  1000,
  0,
  0,
  0,
];
a[63] = [
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  3500,
  5000,
  6000,
  7500,
  9000,
  10500,
  13000,
  15000,
  17500,
  19000,
  20500,
  19500,
  17000,
  13500,
  9500,
  7000,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[62] = [
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  3000,
  4500,
  6000,
  7500,
  8500,
  10000,
  12500,
  14500,
  17000,
  18000,
  19500,
  18500,
  16500,
  13500,
  10500,
  8000,
  5000,
  4000,
  3500,
  3000,
  2000,
  1500,
  500,
  0,
  0,
  0,
];
a[61] = [
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  3000,
  4500,
  5500,
  7000,
  8000,
  9500,
  12500,
  14500,
  16500,
  17500,
  19000,
  18000,
  16500,
  13500,
  11000,
  8500,
  5500,
  4500,
  3500,
  3000,
  2000,
  1500,
  500,
  0,
  0,
  0,
];
a[60] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  4000,
  5000,
  6000,
  7000,
  8500,
  11000,
  13000,
  15000,
  16500,
  18000,
  19000,
  16500,
  14000,
  11500,
  9500,
  6500,
  5500,
  4000,
  3000,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3500,
  4500,
  5500,
  6500,
  7500,
  10000,
  12000,
  14000,
  15500,
  17000,
  17500,
  16000,
  13500,
  11500,
  9500,
  7000,
  5500,
  4500,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  4000,
  4500,
  5500,
  6500,
  9000,
  11000,
  13000,
  14000,
  15000,
  15500,
  14500,
  13000,
  11500,
  9500,
  7000,
  5500,
  4500,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2500,
  3000,
  4000,
  4500,
  5500,
  7500,
  9500,
  11500,
  12500,
  13000,
  13500,
  13000,
  12000,
  10500,
  9500,
  7000,
  5500,
  4500,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  2000,
  3000,
  3500,
  4000,
  4500,
  7500,
  8500,
  10500,
  11000,
  11500,
  12000,
  11500,
  11000,
  10000,
  8500,
  7000,
  5500,
  4500,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2500,
  3000,
  3500,
  4500,
  6000,
  7500,
  9000,
  9500,
  10000,
  10500,
  10000,
  9500,
  9000,
  8000,
  6500,
  5000,
  4000,
  3500,
  2500,
  2000,
  1000,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  3000,
  3500,
  4500,
  6000,
  7000,
  8500,
  9000,
  9500,
  10000,
  9500,
  9000,
  8000,
  7500,
  6000,
  5000,
  4000,
  3000,
  2500,
  2000,
  1000,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  2500,
  3500,
  4000,
  6000,
  7000,
  8500,
  9000,
  9500,
  9500,
  9000,
  8000,
  7500,
  6500,
  5500,
  4500,
  3500,
  3000,
  2500,
  1500,
  1000,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  2500,
  3000,
  4000,
  5500,
  7000,
  8500,
  9500,
  10000,
  10000,
  9000,
  7500,
  7000,
  6000,
  5000,
  4000,
  3500,
  3000,
  2000,
  1500,
  500,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  5500,
  7000,
  8500,
  10000,
  11000,
  10000,
  8500,
  7000,
  6000,
  5000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  500,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  5000,
  6500,
  8500,
  11000,
  12000,
  10500,
  8500,
  5500,
  5000,
  4500,
  4000,
  3500,
  2500,
  2500,
  2000,
  1500,
  500,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  5500,
  8000,
  10000,
  12000,
  10500,
  7500,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  6000,
  7500,
  9000,
  10000,
  9000,
  7500,
  5500,
  4500,
  4000,
  3000,
  2500,
  2000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  5500,
  7000,
  8000,
  8500,
  8000,
  6500,
  5500,
  4500,
  4000,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  5500,
  6500,
  7000,
  7000,
  7000,
  6000,
  5000,
  4500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  5000,
  5500,
  6000,
  6000,
  6000,
  5500,
  4500,
  4000,
  3500,
  2500,
  2000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4000,
  4500,
  4000,
  4000,
  3500,
  3500,
  3000,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  3500,
  3500,
  4000,
  3500,
  3500,
  3000,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3000,
  3500,
  3500,
  3500,
  3000,
  3000,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas750 = new DataMapNumeric(
  'Gas 750',
  'Gas Content at 750 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  73,
  42,
  33,
  97,
);

a = [];
a[108] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[107] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[106] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[105] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[104] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[103] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[102] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[101] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[100] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[99] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[98] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[97] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  4000,
  4000,
  3000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[96] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  5500,
  7500,
  7500,
  5500,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[95] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  6500,
  10500,
  14000,
  13000,
  9000,
  5000,
  2500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[94] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  3500,
  5500,
  8500,
  13500,
  20000,
  25500,
  22000,
  15000,
  9000,
  4000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[93] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  4500,
  9500,
  15000,
  23000,
  33000,
  42500,
  49000,
  41500,
  27500,
  15500,
  7500,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[92] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  5500,
  13500,
  21000,
  32000,
  47000,
  51500,
  52500,
  51000,
  38500,
  24000,
  9000,
  2000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[91] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  3500,
  8000,
  18000,
  28000,
  40000,
  50500,
  54500,
  56500,
  53500,
  50000,
  32500,
  11000,
  4000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[90] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3500,
  10000,
  22500,
  36000,
  50500,
  53500,
  57500,
  60500,
  56000,
  52500,
  43000,
  22500,
  11000,
  6500,
  3500,
  1500,
  0,
  0,
  0,
  0,
  0,
];
a[89] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3000,
  10500,
  28000,
  45500,
  51500,
  55500,
  59500,
  61000,
  57500,
  54500,
  51500,
  40500,
  22000,
  13500,
  10000,
  5000,
  2000,
  0,
  0,
  0,
  0,
];
a[88] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  7500,
  30000,
  50000,
  53000,
  55500,
  58000,
  59500,
  57500,
  54500,
  52500,
  50000,
  36500,
  24000,
  16000,
  8500,
  5000,
  2500,
  500,
  0,
  0,
];
a[87] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  3500,
  27500,
  50000,
  52500,
  55000,
  57000,
  58000,
  57000,
  54500,
  52500,
  50500,
  43500,
  32000,
  22500,
  12500,
  8000,
  4000,
  1000,
  0,
  0,
];
a[86] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  6000,
  30500,
  50000,
  52000,
  54000,
  56000,
  56000,
  55500,
  54000,
  52000,
  50500,
  44500,
  33500,
  24500,
  14000,
  9000,
  4500,
  1500,
  0,
  0,
];
a[85] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  5500,
  11000,
  30500,
  50000,
  51500,
  53500,
  55000,
  55500,
  54500,
  53500,
  52000,
  50500,
  44500,
  33500,
  24500,
  14500,
  9500,
  5000,
  1500,
  0,
  0,
];
a[84] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  5000,
  8500,
  15500,
  33500,
  48500,
  51000,
  52500,
  54000,
  54000,
  53500,
  52000,
  51000,
  50000,
  42000,
  33000,
  24500,
  14500,
  9500,
  5000,
  1500,
  0,
  0,
];
a[83] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  3500,
  6500,
  11500,
  19000,
  33500,
  44500,
  50500,
  52000,
  53000,
  53000,
  52500,
  51000,
  50000,
  43000,
  36500,
  30000,
  23000,
  14000,
  9000,
  5000,
  1500,
  0,
  0,
];
a[82] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  5000,
  8500,
  13500,
  20500,
  31500,
  40000,
  50000,
  51000,
  52000,
  52500,
  51500,
  50000,
  45500,
  38500,
  32500,
  26500,
  21000,
  13000,
  8500,
  4500,
  1000,
  0,
  0,
];
a[81] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  5500,
  9500,
  14000,
  19500,
  29000,
  36000,
  43500,
  50000,
  51500,
  51500,
  51000,
  50000,
  42000,
  35000,
  28500,
  23000,
  18000,
  11000,
  7000,
  3500,
  500,
  0,
  0,
];
a[80] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  5500,
  9500,
  14000,
  19500,
  27500,
  34000,
  40500,
  47500,
  50500,
  50500,
  50000,
  44500,
  36500,
  30500,
  24500,
  19500,
  14500,
  8000,
  4500,
  2000,
  0,
  0,
  0,
];
a[79] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  4000,
  7500,
  12000,
  16500,
  24000,
  29500,
  35500,
  39500,
  42000,
  42000,
  41500,
  36000,
  31000,
  26000,
  20500,
  15500,
  11000,
  5000,
  2000,
  0,
  0,
  0,
  0,
];
a[78] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  3000,
  6500,
  10500,
  15000,
  21500,
  26500,
  30500,
  33500,
  35000,
  35000,
  34500,
  30500,
  25500,
  21000,
  16000,
  11500,
  8000,
  2500,
  0,
  0,
  0,
  0,
  0,
];
a[77] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  3000,
  6500,
  9500,
  13000,
  19000,
  23000,
  26500,
  28500,
  29500,
  29500,
  29000,
  25500,
  21000,
  16500,
  12000,
  8000,
  5000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[76] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  3500,
  6000,
  9000,
  12000,
  16500,
  20000,
  22500,
  24000,
  24500,
  24500,
  24000,
  21000,
  16500,
  13000,
  8500,
  4500,
  2500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[75] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3500,
  6000,
  8000,
  10500,
  14500,
  17500,
  19000,
  20500,
  20500,
  20500,
  20000,
  17000,
  13500,
  10500,
  6500,
  3500,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[74] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  4000,
  5500,
  7500,
  9500,
  12500,
  15000,
  16500,
  17000,
  17500,
  17500,
  16500,
  14000,
  11000,
  8500,
  5500,
  3000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[73] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  4000,
  5500,
  7500,
  9000,
  11000,
  13000,
  14000,
  14500,
  14500,
  14500,
  14000,
  12000,
  9500,
  7500,
  5000,
  3000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[72] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  3500,
  5000,
  6000,
  7500,
  9500,
  10500,
  11500,
  11500,
  11500,
  11500,
  11000,
  9500,
  8000,
  6500,
  4500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[71] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  3500,
  4500,
  5500,
  6500,
  8500,
  9000,
  10000,
  10000,
  10000,
  10000,
  9500,
  8500,
  7500,
  6000,
  4000,
  2500,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[70] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  4000,
  5000,
  6000,
  7500,
  8000,
  8500,
  9000,
  9000,
  9000,
  8500,
  7500,
  6500,
  5500,
  4000,
  3000,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[69] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  2000,
  2500,
  3500,
  4500,
  5500,
  6500,
  7000,
  7500,
  8000,
  8000,
  8000,
  7500,
  7000,
  6000,
  5000,
  4000,
  3000,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[68] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  3000,
  4000,
  4500,
  6000,
  6500,
  7000,
  7000,
  7500,
  7500,
  7000,
  6500,
  6000,
  5000,
  4500,
  3500,
  2500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[67] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  3000,
  4000,
  4500,
  5500,
  6000,
  6500,
  6500,
  6500,
  6500,
  6500,
  6000,
  5500,
  5000,
  4500,
  3500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[66] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3500,
  4000,
  5000,
  5500,
  6000,
  6000,
  6000,
  6000,
  6000,
  6000,
  5500,
  5000,
  4500,
  3500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[65] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  5500,
  5500,
  5500,
  5500,
  5500,
  5500,
  5500,
  5000,
  4500,
  4000,
  3000,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[64] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  2500,
  3000,
  3500,
  4500,
  5000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5500,
  5000,
  4500,
  4000,
  3500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[63] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  4500,
  5000,
  5000,
  5500,
  5500,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[62] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1000,
  1500,
  2000,
  2500,
  3500,
  4000,
  4500,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[61] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  2500,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  2500,
  3000,
  3500,
  3500,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5500,
  5500,
  5500,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  3000,
  2000,
  1500,
  1000,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5500,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5500,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5000,
  5000,
  5000,
  4500,
  3500,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  5000,
  5000,
  5000,
  5500,
  5500,
  5000,
  5000,
  4500,
  4500,
  4000,
  3000,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  2500,
  3000,
  3500,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  3000,
  2500,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  4500,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  4500,
  4500,
  4000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4000,
  4000,
  3500,
  3000,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3000,
  2500,
  2000,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas760 = new DataMapNumeric(
  'Gas 760',
  'Gas Content at 760 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  72,
  44,
  34,
  109,
);

a = [];
a[112] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[111] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[110] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[109] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[108] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[107] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[106] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[105] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[104] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  3500,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[103] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  7000,
  9000,
  7000,
  3500,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[102] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  5000,
  8500,
  15500,
  19000,
  14000,
  8000,
  4000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[101] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  4000,
  9000,
  17500,
  28500,
  36500,
  41500,
  31000,
  19500,
  10500,
  5500,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[100] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  6000,
  13000,
  25500,
  43000,
  50500,
  51000,
  45000,
  29000,
  18000,
  8000,
  2000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[99] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  8500,
  18500,
  35000,
  50500,
  53000,
  54500,
  51500,
  43000,
  26000,
  10000,
  3000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[98] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  12000,
  27500,
  50000,
  55000,
  57500,
  58500,
  54500,
  50500,
  35000,
  17000,
  5000,
  2500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[97] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  5000,
  19500,
  39500,
  52500,
  59000,
  63000,
  63000,
  57500,
  52500,
  44000,
  24500,
  13000,
  7000,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
];
a[96] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  6000,
  12500,
  29000,
  46500,
  55500,
  62500,
  69500,
  68500,
  58500,
  53500,
  50000,
  31500,
  18000,
  10500,
  5500,
  3000,
  1500,
  0,
  0,
  0,
  0,
];
a[95] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  4500,
  12000,
  24000,
  50500,
  53000,
  58000,
  62500,
  65500,
  66000,
  60500,
  55500,
  51500,
  43000,
  28000,
  18500,
  9500,
  6000,
  3500,
  1500,
  0,
  0,
  0,
];
a[94] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  7000,
  18000,
  33500,
  51500,
  55000,
  59000,
  62500,
  64500,
  65000,
  60500,
  55500,
  51500,
  43000,
  32000,
  22500,
  13000,
  8500,
  5500,
  2500,
  0,
  0,
  0,
];
a[93] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  8000,
  21500,
  40000,
  52500,
  56000,
  59000,
  62500,
  64500,
  64500,
  60500,
  56500,
  53000,
  47500,
  36500,
  27500,
  17000,
  12000,
  7500,
  4000,
  500,
  0,
  0,
];
a[92] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  9500,
  21000,
  38000,
  52000,
  55000,
  58500,
  61000,
  63500,
  63000,
  60000,
  57000,
  54000,
  51500,
  47000,
  35000,
  22000,
  15500,
  9500,
  5000,
  1500,
  0,
  0,
];
a[91] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  9500,
  21000,
  38000,
  51500,
  54500,
  58000,
  60500,
  62500,
  62500,
  60000,
  57000,
  54000,
  51500,
  50000,
  37500,
  24500,
  15500,
  9500,
  5000,
  1500,
  0,
  0,
];
a[90] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  7000,
  17000,
  32000,
  50500,
  54000,
  57000,
  59500,
  61500,
  61500,
  59500,
  57000,
  54500,
  52500,
  50500,
  43000,
  25500,
  17000,
  10500,
  5500,
  1500,
  0,
  0,
];
a[89] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  4500,
  12500,
  27000,
  48000,
  53000,
  55500,
  58500,
  60000,
  60500,
  59000,
  57000,
  55000,
  53000,
  51000,
  46000,
  27000,
  18000,
  11000,
  5500,
  1500,
  0,
  0,
];
a[88] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3500,
  7500,
  15500,
  28000,
  50000,
  52500,
  55500,
  58000,
  60000,
  60500,
  58500,
  56500,
  54500,
  53000,
  51000,
  46000,
  26000,
  16500,
  10000,
  4500,
  1000,
  0,
  0,
];
a[87] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  5500,
  10500,
  19000,
  31000,
  50500,
  52500,
  54500,
  56500,
  59000,
  59500,
  57500,
  56000,
  54000,
  52500,
  50500,
  43000,
  23000,
  13500,
  6000,
  2000,
  500,
  0,
  0,
];
a[86] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  3500,
  7500,
  13000,
  21500,
  32500,
  50000,
  51500,
  53500,
  55500,
  57500,
  57500,
  56500,
  54500,
  53000,
  51500,
  50000,
  38500,
  18500,
  8000,
  2000,
  500,
  0,
  0,
  0,
];
a[85] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  4000,
  8500,
  14500,
  22500,
  32500,
  47500,
  51000,
  53000,
  55000,
  56000,
  56000,
  55000,
  53500,
  52000,
  50500,
  45000,
  33000,
  14000,
  2500,
  0,
  0,
  0,
  0,
  0,
];
a[84] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  4000,
  9500,
  15500,
  22500,
  31000,
  45000,
  50500,
  52500,
  54000,
  55500,
  55500,
  54000,
  52500,
  51000,
  50000,
  39000,
  27500,
  11500,
  3500,
  0,
  0,
  0,
  0,
  0,
];
a[83] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  4500,
  10000,
  16000,
  22500,
  30000,
  41500,
  48500,
  51500,
  53500,
  55000,
  54500,
  52000,
  51000,
  50000,
  42000,
  32000,
  23000,
  10000,
  3500,
  0,
  0,
  0,
  0,
  0,
];
a[82] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  6000,
  11000,
  17000,
  23000,
  30000,
  41500,
  50000,
  51500,
  52500,
  54000,
  53000,
  50000,
  46500,
  39000,
  32000,
  25000,
  18000,
  8000,
  3000,
  0,
  0,
  0,
  0,
  0,
];
a[81] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  4000,
  7500,
  12500,
  18000,
  24000,
  31000,
  42500,
  50000,
  51000,
  52000,
  52500,
  52000,
  50000,
  43000,
  35500,
  28500,
  21500,
  14500,
  6000,
  2000,
  0,
  0,
  0,
  0,
  0,
];
a[80] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  5500,
  9000,
  14000,
  19000,
  24500,
  31000,
  41000,
  48500,
  50500,
  51000,
  51000,
  51000,
  50000,
  41000,
  33000,
  25500,
  18000,
  11500,
  3500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[79] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  3500,
  6500,
  10500,
  14500,
  19500,
  25000,
  31000,
  39500,
  46000,
  50000,
  50500,
  50500,
  50500,
  47000,
  39000,
  31000,
  23000,
  15500,
  8500,
  2000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[78] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  4500,
  7500,
  11000,
  15000,
  19500,
  24500,
  30000,
  38500,
  44000,
  49000,
  50000,
  50000,
  50000,
  43500,
  36000,
  29000,
  22000,
  15000,
  9000,
  2500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[77] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  5000,
  8000,
  11000,
  15000,
  19000,
  23500,
  28500,
  35500,
  40500,
  44500,
  47000,
  47000,
  47000,
  39500,
  33000,
  27000,
  20500,
  14500,
  9500,
  3500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[76] = [
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  5000,
  7500,
  10500,
  13500,
  17000,
  21000,
  24500,
  31000,
  35000,
  37500,
  39000,
  39000,
  38500,
  33500,
  29500,
  25000,
  19500,
  14500,
  10000,
  5000,
  2000,
  0,
  0,
  0,
  0,
  0,
];
a[75] = [
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  4500,
  7000,
  9500,
  12500,
  15500,
  19000,
  22500,
  28000,
  31000,
  33000,
  34000,
  34000,
  33500,
  30000,
  26000,
  22500,
  18500,
  14000,
  10000,
  5000,
  2500,
  500,
  0,
  0,
  0,
  0,
];
a[74] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  4000,
  6000,
  8500,
  11500,
  14000,
  17500,
  20500,
  25000,
  27500,
  29000,
  30000,
  30000,
  29500,
  27000,
  23500,
  20500,
  17000,
  13500,
  10000,
  5500,
  3000,
  1000,
  0,
  0,
  0,
  0,
];
a[73] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  3000,
  5000,
  7500,
  10000,
  12500,
  15500,
  18500,
  22500,
  24500,
  25500,
  26000,
  26000,
  26000,
  24000,
  21000,
  18000,
  15500,
  12500,
  9500,
  5500,
  3000,
  1500,
  0,
  0,
  0,
  0,
];
a[72] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  4000,
  6500,
  9000,
  12000,
  14500,
  16500,
  20000,
  21500,
  22500,
  23000,
  23000,
  22500,
  21000,
  19000,
  16000,
  14000,
  11500,
  9000,
  5500,
  3000,
  1500,
  0,
  0,
  0,
  0,
];
a[71] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  3500,
  6000,
  8500,
  11000,
  13000,
  15500,
  17500,
  19000,
  20000,
  20500,
  20500,
  20000,
  19000,
  17000,
  15000,
  13000,
  10500,
  8500,
  5000,
  3000,
  1500,
  0,
  0,
  0,
  0,
];
a[70] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  5000,
  7500,
  9500,
  11500,
  13500,
  15500,
  17000,
  17500,
  18000,
  18000,
  17500,
  16500,
  15000,
  13500,
  11500,
  9500,
  7500,
  5000,
  3000,
  1500,
  0,
  0,
  0,
  0,
];
a[69] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  4000,
  6000,
  7500,
  9500,
  11000,
  13000,
  14000,
  14500,
  15000,
  15000,
  14500,
  14000,
  12500,
  11000,
  10000,
  8500,
  7000,
  4500,
  3000,
  1500,
  500,
  0,
  0,
  0,
];
a[68] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  4000,
  5500,
  7000,
  8500,
  10000,
  11500,
  12500,
  13000,
  13000,
  13000,
  13000,
  12500,
  11500,
  10000,
  8500,
  7500,
  6000,
  4000,
  3000,
  1500,
  500,
  0,
  0,
  0,
];
a[67] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  4000,
  5000,
  6000,
  7500,
  9000,
  10500,
  11000,
  11500,
  11500,
  11500,
  11500,
  11000,
  10000,
  9000,
  7500,
  6500,
  5500,
  4000,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[66] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2000,
  3000,
  4000,
  5000,
  6000,
  7000,
  8000,
  9500,
  10000,
  10500,
  10500,
  10500,
  10500,
  10000,
  9000,
  8000,
  7000,
  6000,
  4500,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
];
a[65] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  4000,
  5000,
  6000,
  6500,
  7500,
  8500,
  9000,
  9500,
  9500,
  9500,
  9500,
  9000,
  8000,
  7500,
  6500,
  5000,
  4500,
  3000,
  2000,
  1500,
  500,
  0,
  0,
  0,
];
a[64] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  3500,
  4500,
  5500,
  6000,
  7000,
  8000,
  8000,
  8500,
  8500,
  8500,
  8500,
  8000,
  7500,
  6500,
  6000,
  5000,
  4000,
  3000,
  2000,
  1500,
  500,
  0,
  0,
  0,
];
a[63] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3500,
  4000,
  5000,
  5500,
  6000,
  7000,
  7500,
  7500,
  7500,
  7500,
  7500,
  7000,
  6500,
  6000,
  5500,
  4500,
  4000,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
];
a[62] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3500,
  4000,
  4500,
  5000,
  5500,
  6500,
  7000,
  7000,
  7000,
  7000,
  7000,
  6500,
  6500,
  6000,
  5000,
  4500,
  3500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[61] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  5500,
  6000,
  6500,
  6500,
  6500,
  6500,
  6500,
  6500,
  6000,
  5500,
  5000,
  4000,
  3500,
  2000,
  1500,
  1000,
  0,
  0,
  0,
  0,
];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  5500,
  5500,
  6000,
  6500,
  6500,
  6500,
  6500,
  6000,
  6000,
  5500,
  5000,
  4000,
  3500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5500,
  6000,
  6000,
  6000,
  6000,
  6000,
  6000,
  5500,
  5500,
  5000,
  4000,
  3000,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5500,
  5500,
  6000,
  6000,
  6000,
  6000,
  6000,
  5500,
  5000,
  5000,
  4000,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5500,
  5500,
  6000,
  6000,
  6000,
  5500,
  5500,
  5000,
  4500,
  4000,
  3000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5500,
  5000,
  5000,
  4500,
  4000,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5500,
  5000,
  5000,
  4500,
  3500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5500,
  5000,
  4500,
  4500,
  3500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5000,
  5000,
  4500,
  4500,
  4000,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5500,
  5500,
  5500,
  5000,
  5000,
  5000,
  4500,
  4000,
  3000,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5500,
  5500,
  5500,
  5000,
  5000,
  5000,
  4500,
  4000,
  3000,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  3500,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  4000,
  4000,
  3500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  3500,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  2000,
  2500,
  2500,
  3000,
  3500,
  4000,
  4500,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  3000,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3000,
  3500,
  4000,
  4500,
  4500,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  1500,
  2000,
  2500,
  3000,
  3000,
  3500,
  4000,
  4500,
  4500,
  4500,
  4500,
  4000,
  4000,
  3500,
  3000,
  2500,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  3500,
  4000,
  4000,
  4000,
  4000,
  4000,
  3500,
  3000,
  3000,
  2500,
  2000,
  2000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  2500,
  3000,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3000,
  3000,
  2500,
  2000,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3000,
  3000,
  3500,
  3500,
  3500,
  3000,
  3000,
  2500,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas770 = new DataMapNumeric(
  'Gas 770',
  'Gas Content at 770 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  74,
  46,
  33,
  113,
);

a = [];
a[105] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[104] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[103] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[102] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[101] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[100] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  4000,
  3500,
  3500,
  4000,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[99] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  6500,
  11500,
  16500,
  16500,
  11000,
  4500,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[98] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  6000,
  16500,
  24000,
  34000,
  33000,
  23500,
  12000,
  6000,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[97] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  5500,
  16500,
  31000,
  43500,
  50500,
  50500,
  40000,
  26500,
  14500,
  5000,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[96] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  10000,
  24500,
  48000,
  53000,
  55000,
  54500,
  51500,
  44000,
  26000,
  11000,
  2500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[95] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  14000,
  34500,
  51500,
  57500,
  60500,
  58000,
  53500,
  50500,
  30000,
  11500,
  2500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[94] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  5500,
  25000,
  51000,
  56000,
  62500,
  66000,
  62500,
  57000,
  51500,
  33000,
  16500,
  4500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[93] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  12500,
  39500,
  53500,
  60000,
  68000,
  73000,
  66500,
  61000,
  54000,
  44000,
  23500,
  10000,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[92] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  17500,
  45000,
  56000,
  64000,
  72500,
  79500,
  72500,
  64000,
  55000,
  50500,
  33500,
  17500,
  5500,
  2000,
  0,
  0,
  0,
  0,
  0,
];
a[91] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  23000,
  50000,
  57500,
  67000,
  77500,
  81500,
  74000,
  64000,
  56500,
  51500,
  40000,
  21000,
  8500,
  2500,
  0,
  0,
  0,
  0,
  0,
];
a[90] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  6500,
  35500,
  53000,
  60000,
  68000,
  76000,
  78000,
  74000,
  65500,
  58500,
  53500,
  50000,
  29500,
  9500,
  3000,
  0,
  0,
  0,
  0,
  0,
];
a[89] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  10000,
  46500,
  54500,
  61500,
  68500,
  74000,
  76000,
  72500,
  66000,
  60500,
  55500,
  51500,
  35000,
  10500,
  2500,
  0,
  0,
  0,
  0,
  0,
];
a[88] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3000,
  9500,
  21500,
  50500,
  55500,
  62500,
  69500,
  74000,
  75500,
  71500,
  65500,
  60500,
  55500,
  51500,
  34500,
  8000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[87] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  4000,
  10000,
  20500,
  36000,
  52500,
  57500,
  63000,
  68500,
  72500,
  74000,
  70000,
  64500,
  59500,
  54500,
  50500,
  27500,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[86] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  7500,
  15000,
  28000,
  48500,
  54500,
  59000,
  63500,
  67500,
  71000,
  72000,
  68000,
  63500,
  58500,
  53500,
  46000,
  19000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[85] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  4500,
  10500,
  20500,
  36500,
  50500,
  55500,
  60000,
  63500,
  67500,
  70500,
  70500,
  66500,
  62500,
  57500,
  51500,
  39500,
  20000,
  6000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[84] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  5500,
  12500,
  23500,
  40000,
  51000,
  56000,
  60000,
  63500,
  67000,
  70000,
  70000,
  66000,
  62500,
  57500,
  53000,
  50000,
  29000,
  11000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[83] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  3500,
  9000,
  18000,
  32000,
  50000,
  54500,
  58500,
  62000,
  65000,
  68000,
  68000,
  65500,
  62000,
  58500,
  55500,
  52500,
  50000,
  24000,
  11000,
  500,
  0,
  0,
  0,
  0,
];
a[82] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  6000,
  13000,
  25000,
  40500,
  53500,
  57500,
  61000,
  63500,
  66500,
  66500,
  64500,
  62000,
  58500,
  56000,
  53000,
  51000,
  31500,
  16500,
  3000,
  0,
  0,
  0,
  0,
];
a[81] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3000,
  8500,
  21000,
  40500,
  53500,
  57000,
  60500,
  62500,
  64500,
  65000,
  63500,
  61500,
  58500,
  56000,
  53500,
  51500,
  36500,
  21500,
  9000,
  0,
  0,
  0,
  0,
];
a[80] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  4000,
  19500,
  41500,
  53500,
  56500,
  59500,
  62500,
  63500,
  64000,
  63000,
  61000,
  58500,
  56000,
  53500,
  51500,
  40000,
  25500,
  13000,
  4000,
  0,
  0,
  0,
];
a[79] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  6000,
  19500,
  44000,
  53500,
  56500,
  59000,
  62000,
  63500,
  64000,
  62500,
  60500,
  58000,
  56000,
  53500,
  51500,
  41000,
  27000,
  15500,
  6500,
  0,
  0,
  0,
];
a[78] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  6000,
  14500,
  27000,
  48000,
  53500,
  56500,
  59000,
  61500,
  62500,
  63000,
  61500,
  59500,
  57500,
  55500,
  53500,
  51500,
  41000,
  27000,
  15500,
  6500,
  0,
  0,
  0,
];
a[77] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  3500,
  6500,
  11500,
  19500,
  33500,
  50000,
  53500,
  55500,
  57500,
  59500,
  61000,
  61000,
  60000,
  58500,
  56500,
  54500,
  53000,
  51000,
  39500,
  27000,
  16000,
  7500,
  500,
  0,
  0,
];
a[76] = [
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  5000,
  9000,
  15000,
  24000,
  37500,
  50000,
  53000,
  55000,
  57000,
  58500,
  60000,
  60000,
  58500,
  57000,
  55000,
  53500,
  52000,
  50500,
  36000,
  24500,
  15000,
  7000,
  500,
  0,
  0,
];
a[75] = [
  0,
  0,
  0,
  0,
  0,
  500,
  3500,
  6500,
  11000,
  17500,
  26000,
  36500,
  49000,
  52000,
  54000,
  56000,
  57500,
  59000,
  59000,
  57500,
  55500,
  53500,
  52000,
  50500,
  44500,
  28500,
  19500,
  12000,
  5500,
  0,
  0,
  0,
];
a[74] = [
  0,
  0,
  0,
  0,
  0,
  1000,
  4500,
  8000,
  12500,
  18000,
  25000,
  33500,
  43000,
  51000,
  53000,
  55000,
  56500,
  58500,
  58500,
  56000,
  53500,
  52000,
  50500,
  43500,
  33000,
  21500,
  13500,
  7500,
  3000,
  0,
  0,
  0,
];
a[73] = [
  0,
  0,
  0,
  0,
  0,
  1000,
  4500,
  8000,
  12000,
  17000,
  23000,
  30000,
  38000,
  50500,
  52000,
  53500,
  55500,
  57000,
  56500,
  54000,
  52000,
  50500,
  44000,
  32500,
  22500,
  15000,
  8500,
  3500,
  0,
  0,
  0,
  0,
];
a[72] = [
  0,
  0,
  0,
  0,
  0,
  1000,
  4500,
  8000,
  12000,
  17000,
  23000,
  30000,
  37500,
  48500,
  51000,
  52500,
  54000,
  55000,
  54500,
  52500,
  50000,
  43500,
  33000,
  24000,
  15000,
  8000,
  4500,
  1000,
  0,
  0,
  0,
  0,
];
a[71] = [
  0,
  0,
  0,
  0,
  0,
  500,
  4000,
  7500,
  11500,
  16000,
  21000,
  27500,
  34500,
  47500,
  51000,
  52000,
  53000,
  53000,
  53000,
  51500,
  50000,
  38000,
  28500,
  19500,
  9500,
  3000,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[70] = [
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  5000,
  8500,
  12500,
  17000,
  23000,
  29500,
  41500,
  50000,
  51000,
  51500,
  51500,
  51500,
  50500,
  46000,
  34500,
  25500,
  16500,
  9000,
  2500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[69] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  4000,
  6500,
  10500,
  14500,
  20500,
  27000,
  38000,
  45500,
  50000,
  50500,
  50500,
  50500,
  50000,
  42000,
  32500,
  23500,
  16000,
  9500,
  3000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[68] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  5000,
  8500,
  12000,
  17500,
  23500,
  35000,
  42000,
  49000,
  50000,
  50000,
  50000,
  46500,
  39000,
  30500,
  22500,
  15500,
  9500,
  3500,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[67] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  3500,
  6000,
  9500,
  14000,
  20000,
  31500,
  38500,
  45000,
  50000,
  50000,
  49500,
  42500,
  36000,
  28500,
  21500,
  15500,
  9500,
  4000,
  1500,
  0,
  0,
  0,
  0,
  0,
];
a[66] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  4000,
  6000,
  13000,
  20000,
  29000,
  36500,
  43500,
  49500,
  49500,
  46000,
  39000,
  33000,
  26500,
  20000,
  14500,
  9500,
  4000,
  1500,
  0,
  0,
  0,
  0,
  0,
];
a[65] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  4000,
  9500,
  17000,
  27500,
  35000,
  41000,
  46000,
  46000,
  43500,
  36000,
  30000,
  24000,
  18000,
  13000,
  8500,
  3500,
  1500,
  0,
  0,
  0,
  0,
  0,
];
a[64] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  5000,
  9500,
  14000,
  22000,
  28000,
  33000,
  35500,
  35500,
  34500,
  29500,
  25000,
  20500,
  15500,
  11000,
  7000,
  2500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[63] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  3000,
  5500,
  9500,
  13000,
  19500,
  24500,
  28500,
  30000,
  30000,
  29500,
  26000,
  21500,
  17500,
  13500,
  9000,
  4500,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[62] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  3500,
  6000,
  9000,
  12000,
  17000,
  21500,
  24000,
  25500,
  25500,
  25000,
  22500,
  18500,
  15000,
  11000,
  6500,
  4000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[61] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  3500,
  5500,
  8000,
  10500,
  15000,
  18500,
  20500,
  21500,
  21500,
  21000,
  19000,
  16000,
  13000,
  9500,
  6500,
  4000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  3500,
  5500,
  8000,
  10500,
  13000,
  15500,
  17500,
  18000,
  18000,
  18000,
  16500,
  14000,
  11500,
  9000,
  6000,
  4000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  3500,
  5000,
  7000,
  9500,
  12000,
  13500,
  15000,
  15500,
  15500,
  15500,
  14000,
  12500,
  10000,
  8000,
  6000,
  4000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  4500,
  6500,
  8000,
  10500,
  12000,
  13000,
  13500,
  13500,
  13000,
  12000,
  10500,
  9000,
  7000,
  5500,
  4000,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2000,
  3500,
  5000,
  6500,
  8500,
  9500,
  10500,
  11000,
  11000,
  10500,
  10000,
  8500,
  7500,
  6500,
  5000,
  3500,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  4500,
  5500,
  7500,
  8500,
  9000,
  9500,
  9500,
  9500,
  9000,
  7500,
  6500,
  5500,
  4500,
  3500,
  2000,
  1000,
  500,
  500,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  4000,
  5500,
  7000,
  8000,
  8500,
  8500,
  8500,
  8500,
  8000,
  7000,
  6000,
  5000,
  4000,
  3000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  4000,
  5000,
  6500,
  7000,
  7500,
  7500,
  7500,
  7500,
  7000,
  6000,
  5500,
  4500,
  3500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  4000,
  5000,
  6000,
  6500,
  7000,
  7000,
  7000,
  6500,
  6000,
  5500,
  4500,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  3000,
  4000,
  5000,
  6000,
  6000,
  6500,
  6500,
  6500,
  6000,
  5500,
  5000,
  4000,
  3000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  2500,
  3500,
  4500,
  5500,
  5500,
  6000,
  6000,
  5500,
  5500,
  4500,
  4000,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3500,
  4000,
  5000,
  5500,
  5500,
  5500,
  5500,
  5000,
  4500,
  3500,
  3000,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  3000,
  4000,
  5000,
  5500,
  5500,
  5500,
  5000,
  5000,
  4000,
  3500,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2500,
  3500,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2500,
  3500,
  4500,
  5000,
  5000,
  5000,
  4500,
  4500,
  3500,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2500,
  3500,
  4500,
  4500,
  5000,
  5000,
  4500,
  4500,
  3500,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2500,
  3000,
  4000,
  4500,
  5000,
  5000,
  4500,
  4500,
  3500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  4000,
  3000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  4000,
  3000,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  5000,
  5000,
  4500,
  4000,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  4500,
  3500,
  3000,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  4500,
  3500,
  3000,
  2000,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  4500,
  4000,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3000,
  3000,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas780 = new DataMapNumeric(
  'Gas 780',
  'Gas Content at 780 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  75,
  58,
  32,
  106,
);

a = [];
a[80] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[79] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[78] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[77] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[76] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[75] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[74] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  3000,
  5000,
  3000,
  2000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[73] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3500,
  10000,
  15500,
  19000,
  13000,
  4000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[72] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  7500,
  20500,
  29500,
  40000,
  29500,
  14500,
  5000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[71] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  6000,
  20000,
  36500,
  50000,
  51500,
  50000,
  30500,
  13500,
  3500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[70] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  8500,
  15500,
  25000,
  40000,
  50500,
  55500,
  58000,
  55000,
  50000,
  29000,
  12000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[69] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  5000,
  17000,
  29500,
  46000,
  51500,
  57500,
  61500,
  64500,
  60500,
  54000,
  44000,
  21000,
  4000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[68] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3000,
  9000,
  26500,
  46500,
  52500,
  56500,
  63000,
  69500,
  74000,
  66000,
  59000,
  51000,
  24000,
  5000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[67] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  5000,
  13000,
  34500,
  50500,
  54500,
  60000,
  68000,
  81000,
  90500,
  76000,
  64000,
  53000,
  32000,
  12000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[66] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3500,
  12000,
  39500,
  52000,
  56500,
  61500,
  73500,
  86000,
  91500,
  80000,
  68000,
  58000,
  44500,
  20000,
  3500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[65] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  11000,
  33500,
  52500,
  58000,
  65500,
  76500,
  86000,
  89000,
  80000,
  68000,
  58000,
  51000,
  24500,
  5000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[64] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  21500,
  47500,
  57000,
  65500,
  75000,
  81500,
  84500,
  79000,
  70000,
  62000,
  54500,
  34000,
  4500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[63] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  21500,
  44500,
  57000,
  65000,
  73000,
  79500,
  82000,
  77000,
  69500,
  62000,
  55500,
  50000,
  10500,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[62] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3000,
  26000,
  51000,
  57500,
  65000,
  73000,
  78000,
  79500,
  75000,
  68000,
  62000,
  55500,
  50000,
  21000,
  6500,
  1500,
  0,
  0,
  0,
  0,
];
a[61] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  6000,
  30500,
  51000,
  56500,
  63000,
  70000,
  74500,
  76000,
  72500,
  67000,
  61500,
  55500,
  51500,
  37000,
  12000,
  4500,
  500,
  0,
  0,
  0,
];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  5000,
  10500,
  30500,
  46500,
  55500,
  62500,
  68500,
  74000,
  74500,
  70500,
  65000,
  60000,
  55000,
  51500,
  37000,
  12000,
  4500,
  500,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  1000,
  4500,
  11000,
  18500,
  34500,
  50000,
  55500,
  62500,
  68500,
  72500,
  72500,
  68000,
  63000,
  58000,
  53000,
  50000,
  32500,
  12000,
  4500,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  2500,
  5500,
  10500,
  17500,
  27500,
  50000,
  52500,
  57000,
  62500,
  67000,
  70000,
  70000,
  65500,
  60500,
  55500,
  47500,
  35500,
  24000,
  9500,
  3500,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  1000,
  3500,
  8000,
  14000,
  22500,
  35000,
  51000,
  54000,
  58500,
  62500,
  66500,
  70000,
  68500,
  63500,
  58500,
  52500,
  46000,
  29500,
  19000,
  7000,
  2000,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  2000,
  5500,
  10500,
  18000,
  28500,
  43500,
  52500,
  55500,
  59000,
  62500,
  66500,
  68000,
  67000,
  62500,
  57500,
  52500,
  46000,
  27500,
  16000,
  5500,
  1000,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  2000,
  6000,
  12000,
  20000,
  31500,
  47500,
  52500,
  55500,
  58500,
  62000,
  64000,
  66000,
  64500,
  61500,
  57000,
  53000,
  49500,
  28500,
  15000,
  4000,
  0,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  1500,
  5000,
  10000,
  17000,
  27000,
  42000,
  52000,
  54500,
  57500,
  60500,
  62500,
  65000,
  63500,
  60500,
  56500,
  52500,
  48000,
  26500,
  12500,
  1500,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  500,
  4000,
  8500,
  15000,
  25000,
  39000,
  51000,
  54000,
  57000,
  60000,
  62000,
  63500,
  62000,
  58500,
  55000,
  51500,
  40500,
  20500,
  4500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  1500,
  5000,
  9000,
  15500,
  23500,
  49000,
  52000,
  54500,
  57500,
  60000,
  61000,
  59500,
  56500,
  53000,
  46500,
  31000,
  13500,
  4500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  2000,
  3500,
  6500,
  10500,
  33000,
  50000,
  53000,
  55500,
  58000,
  60000,
  58500,
  55000,
  51000,
  42500,
  26500,
  16000,
  8000,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  4000,
  22000,
  41000,
  51000,
  53500,
  55500,
  58000,
  57000,
  54500,
  51000,
  42500,
  26500,
  16000,
  8500,
  3000,
  500,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3000,
  15000,
  27500,
  45000,
  50500,
  53000,
  55500,
  55500,
  53500,
  51500,
  45000,
  30500,
  20500,
  13000,
  5000,
  1500,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3000,
  13000,
  21500,
  32500,
  46000,
  51500,
  54000,
  54500,
  52500,
  51000,
  44500,
  30500,
  20500,
  13500,
  5500,
  1500,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3000,
  12000,
  21000,
  32500,
  46000,
  51500,
  52500,
  53500,
  51500,
  49500,
  39000,
  29000,
  20500,
  13500,
  5500,
  1500,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  9500,
  16500,
  25500,
  36000,
  49000,
  50500,
  51000,
  50000,
  41500,
  33500,
  26500,
  19000,
  13000,
  5500,
  2000,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  7000,
  13500,
  21500,
  30500,
  41000,
  49500,
  50000,
  43000,
  35500,
  29000,
  22500,
  17000,
  12000,
  5000,
  1500,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  5000,
  12500,
  20000,
  28000,
  34500,
  41500,
  44000,
  37500,
  30000,
  23500,
  18500,
  13500,
  10000,
  4500,
  1500,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  4500,
  9000,
  14500,
  21000,
  28000,
  30500,
  30500,
  28500,
  23000,
  18000,
  14000,
  10000,
  7000,
  3500,
  500,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  5000,
  8000,
  12000,
  17000,
  22000,
  24000,
  24000,
  22500,
  18000,
  13500,
  10000,
  7000,
  4500,
  2000,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  5000,
  8000,
  11000,
  14000,
  17500,
  18500,
  18500,
  17500,
  13500,
  9500,
  7000,
  4500,
  3000,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  4500,
  6500,
  8500,
  11500,
  12500,
  13000,
  13000,
  11500,
  8500,
  6000,
  4000,
  2500,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  4000,
  5500,
  7500,
  9000,
  10500,
  10500,
  10500,
  9000,
  6500,
  5000,
  3000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  2500,
  4000,
  5000,
  6500,
  7500,
  8500,
  8500,
  8500,
  7500,
  5500,
  4000,
  2500,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  3500,
  4500,
  5500,
  6500,
  7000,
  7000,
  7000,
  6000,
  5000,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  4000,
  5000,
  5500,
  6000,
  6000,
  6000,
  5500,
  4500,
  3500,
  2500,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  3500,
  4500,
  5000,
  5500,
  5500,
  5500,
  5000,
  4000,
  3000,
  2500,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3500,
  4000,
  4500,
  5000,
  5000,
  5000,
  4500,
  4000,
  3000,
  2000,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  4000,
  3500,
  3000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  3000,
  3500,
  4000,
  4500,
  5000,
  4500,
  4000,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4000,
  3500,
  3000,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  2500,
  3000,
  3500,
  3500,
  3500,
  3000,
  2500,
  2000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3000,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas790 = new DataMapNumeric(
  'Gas 790',
  'Gas Content at 790 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  78,
  90,
  28,
  81,
);

a = [];
a[63] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[62] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[61] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[60] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  2500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  4500,
  13500,
  17500,
  16000,
  8500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  13500,
  29000,
  42500,
  42000,
  20500,
  6500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  8000,
  33000,
  51500,
  54500,
  54500,
  45000,
  23000,
  3500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  5500,
  17000,
  51500,
  58500,
  63000,
  63500,
  57000,
  51000,
  15000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  8000,
  16500,
  28000,
  43000,
  65500,
  78500,
  86000,
  83000,
  74500,
  58500,
  51000,
  22000,
  3500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  4500,
  20500,
  41500,
  52000,
  58000,
  77500,
  90000,
  96000,
  95000,
  83500,
  62500,
  54000,
  37000,
  11000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  6500,
  21500,
  48000,
  54000,
  61000,
  77500,
  91500,
  95000,
  95000,
  85000,
  64000,
  54500,
  36000,
  10500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  5500,
  31000,
  51500,
  56500,
  64000,
  81500,
  91000,
  95000,
  94500,
  85000,
  64500,
  54500,
  36000,
  10500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  27000,
  51500,
  58500,
  66500,
  82500,
  90000,
  94000,
  92000,
  83500,
  66500,
  57000,
  41000,
  14500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  21500,
  46000,
  58000,
  67000,
  81500,
  89000,
  95000,
  91000,
  83500,
  69500,
  60500,
  53000,
  25500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3000,
  23000,
  50500,
  59500,
  67500,
  80500,
  86500,
  90500,
  89000,
  82500,
  71000,
  63000,
  56000,
  50000,
  5500,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  2000,
  4500,
  12500,
  41500,
  53000,
  59500,
  67500,
  79000,
  84000,
  87500,
  86500,
  82500,
  72000,
  64500,
  58500,
  53000,
  21000,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  1500,
  5500,
  11500,
  23000,
  50500,
  55000,
  61500,
  68000,
  78000,
  82500,
  85500,
  85000,
  81500,
  72000,
  65500,
  60000,
  55000,
  36500,
  3500,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  500,
  3000,
  8000,
  16500,
  32000,
  52000,
  56500,
  62500,
  67500,
  76500,
  81500,
  85000,
  84000,
  80500,
  72000,
  65500,
  61000,
  56000,
  50000,
  19500,
  3000,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  1000,
  4500,
  10500,
  21000,
  37500,
  52500,
  57000,
  62000,
  66500,
  75000,
  79000,
  81500,
  80500,
  77500,
  71000,
  65500,
  61000,
  56500,
  51000,
  34000,
  16000,
  3000,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  1000,
  3500,
  8500,
  17500,
  31500,
  51500,
  56000,
  61000,
  65500,
  73500,
  77000,
  79000,
  79000,
  76000,
  70500,
  64500,
  60500,
  56500,
  51000,
  38500,
  19500,
  4000,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  500,
  2000,
  6000,
  12500,
  23500,
  50000,
  54500,
  59500,
  64000,
  71500,
  75000,
  77500,
  76500,
  75000,
  69500,
  64500,
  60500,
  56500,
  51000,
  38500,
  20000,
  6000,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  500,
  3500,
  8000,
  20500,
  48500,
  54000,
  58500,
  62500,
  70000,
  73500,
  76000,
  75500,
  72500,
  66500,
  62500,
  59000,
  55500,
  51000,
  38000,
  20000,
  6000,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  3500,
  18000,
  50500,
  54000,
  58000,
  62000,
  67000,
  70500,
  71500,
  70500,
  67000,
  62000,
  58000,
  54500,
  52000,
  42000,
  26500,
  14000,
  3500,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  500,
  5000,
  21000,
  50000,
  53500,
  57000,
  60500,
  65000,
  67500,
  68500,
  68000,
  65500,
  60500,
  56500,
  53000,
  50500,
  36000,
  23500,
  11000,
  500,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  1500,
  7500,
  21000,
  49000,
  52500,
  55500,
  59000,
  63500,
  66000,
  66500,
  65500,
  63500,
  58000,
  53000,
  50000,
  37500,
  24500,
  14000,
  6500,
  500,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  3000,
  10000,
  19500,
  41000,
  51000,
  54000,
  57500,
  62500,
  64500,
  65500,
  64500,
  62500,
  55500,
  51000,
  41500,
  28000,
  15000,
  7000,
  1500,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  3000,
  8500,
  16500,
  33000,
  50000,
  52500,
  56000,
  61000,
  63000,
  65000,
  63500,
  61000,
  54500,
  51000,
  36000,
  22000,
  8000,
  2500,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  2000,
  7000,
  14000,
  30000,
  48000,
  52000,
  55000,
  59000,
  61000,
  62000,
  60500,
  58000,
  53000,
  50000,
  29500,
  11000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  500,
  4500,
  11500,
  27500,
  45500,
  51500,
  54000,
  57500,
  59000,
  59500,
  59000,
  56500,
  52500,
  48000,
  26000,
  12500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  7500,
  23500,
  40500,
  50500,
  52500,
  56000,
  57000,
  57500,
  56500,
  55000,
  51500,
  43500,
  26000,
  13000,
  2500,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  4500,
  19000,
  35000,
  50000,
  51500,
  54500,
  56000,
  56000,
  55500,
  54000,
  50000,
  36500,
  23500,
  13500,
  4000,
  500,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  3500,
  17500,
  30000,
  43000,
  50500,
  53500,
  54500,
  55500,
  55000,
  53000,
  50000,
  35000,
  23000,
  14000,
  4500,
  500,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  2000,
  6500,
  16500,
  26000,
  36500,
  50000,
  51500,
  52500,
  53000,
  52500,
  51000,
  45500,
  31000,
  21000,
  13500,
  5500,
  2000,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  6500,
  15000,
  22500,
  31000,
  41000,
  50500,
  51000,
  51000,
  51000,
  49500,
  38500,
  30000,
  21000,
  13500,
  5500,
  2500,
  500,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  3500,
  6000,
  12500,
  19000,
  27000,
  35500,
  50000,
  50500,
  50500,
  49000,
  42000,
  31500,
  24500,
  18500,
  12500,
  5500,
  2500,
  1000,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  5000,
  10500,
  16000,
  23000,
  31000,
  44000,
  50000,
  49000,
  42000,
  35500,
  26000,
  19000,
  14000,
  9500,
  5000,
  2500,
  1000,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  6500,
  10000,
  16000,
  23000,
  33000,
  36500,
  35500,
  31000,
  25500,
  16500,
  11000,
  7500,
  5000,
  2500,
  1000,
  500,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3500,
  5000,
  12500,
  19500,
  25500,
  28000,
  28000,
  26000,
  22000,
  14500,
  8500,
  5000,
  3500,
  2000,
  1000,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2500,
  4000,
  8000,
  13500,
  19500,
  21500,
  21500,
  20500,
  16500,
  11000,
  6000,
  4000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  4000,
  6500,
  10000,
  14500,
  16000,
  16000,
  16000,
  12500,
  8500,
  5000,
  2500,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  3500,
  5000,
  8000,
  11000,
  12500,
  12500,
  12000,
  9500,
  6500,
  4500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  4000,
  5500,
  7500,
  8000,
  8000,
  7500,
  6500,
  4500,
  3000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  3500,
  5000,
  6000,
  6500,
  6500,
  6500,
  5500,
  4000,
  3000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  3000,
  4000,
  5000,
  5500,
  5500,
  5500,
  4500,
  3500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3500,
  4500,
  5000,
  5000,
  4500,
  4000,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  4000,
  4500,
  4500,
  4000,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2500,
  3000,
  3500,
  3500,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  2500,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.gas800 = new DataMapNumeric(
  'Gas 800',
  'Gas Content at 800 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  79,
  113,
  27,
  64,
);

a = [];
a[14] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[13] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[12] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[11] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[10] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[9] = [0, 0, 0, 0, 0, 0, 0, 0, 500, 500, 1000, 500, 0, 0, 0, 0, 0, 0, 0];
a[8] = [0, 0, 0, 0, 0, 0, 500, 500, 500, 1000, 1000, 1000, 0, 0, 0, 0, 0, 0, 0];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [0, 0, 0, 0, 0, 500, 500, 1000, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0];
a[5] = [0, 0, 0, 0, 0, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[4] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[3] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.tritium650 = new DataMapNumeric(
  'Tritium 650',
  'Tritium Content at 650 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  93,
  41,
  19,
  15,
);

a = [];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  1500,
  1500,
  1500,
  2000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  2000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  2000,
  2500,
  4000,
  4000,
  4000,
  4000,
  3500,
  3500,
  3000,
  3000,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  3000,
  4000,
  11200,
  11200,
  11200,
  5000,
  4000,
  4000,
  4000,
  3500,
  3000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  3500,
  4500,
  11200,
  7000,
  7000,
  7000,
  6000,
  5000,
  5000,
  4500,
  3500,
  3000,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  4000,
  11200,
  6500,
  11400,
  9000,
  11600,
  11600,
  9000,
  8000,
  6500,
  6000,
  5000,
  4500,
  3500,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2500,
  3500,
  11200,
  7000,
  8500,
  11600,
  11700,
  11700,
  11700,
  11600,
  9000,
  7000,
  6500,
  11200,
  4500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  3000,
  4500,
  6000,
  8000,
  11700,
  11900,
  12000,
  11900,
  11900,
  11800,
  11600,
  11400,
  6500,
  11200,
  4500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  3500,
  11200,
  7000,
  9000,
  11800,
  12100,
  12200,
  12100,
  12000,
  11800,
  11700,
  8000,
  6500,
  11200,
  4500,
  3500,
  2500,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  4500,
  6000,
  11400,
  11600,
  11900,
  12100,
  12300,
  12200,
  12000,
  11800,
  11700,
  11400,
  6500,
  5000,
  4000,
  3000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  2500,
  3000,
  4500,
  6000,
  8000,
  11600,
  11800,
  12000,
  12100,
  12000,
  11900,
  11700,
  11600,
  7000,
  6000,
  4500,
  3500,
  2500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3500,
  4500,
  6000,
  11400,
  9000,
  11700,
  11800,
  11900,
  11800,
  11800,
  11700,
  9000,
  6000,
  5000,
  4000,
  2500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  5000,
  6000,
  7000,
  8000,
  8500,
  9000,
  8500,
  8500,
  8000,
  6500,
  5000,
  4000,
  3000,
  1500,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3500,
  4500,
  5000,
  6000,
  6500,
  6500,
  6500,
  6500,
  6500,
  6500,
  11200,
  4000,
  3000,
  2500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  4500,
  4500,
  4500,
  4500,
  4500,
  4500,
  4500,
  3000,
  2500,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  1500,
  2000,
  2500,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  1500,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.tritium660 = new DataMapNumeric(
  'Tritium 660',
  'Tritium Content at 660 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  79,
  29,
  49,
  38,
);

a = [];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  2500,
  3000,
  3000,
  3500,
  3000,
  3000,
  3000,
  2500,
  2500,
  2500,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  2500,
  3000,
  3500,
  4000,
  4000,
  4000,
  4000,
  3500,
  3500,
  3500,
  3000,
  3000,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5000,
  4500,
  4500,
  4000,
  4000,
  3500,
  3000,
  3000,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4500,
  5000,
  11200,
  6000,
  6000,
  6000,
  11200,
  5000,
  4500,
  4500,
  4000,
  3500,
  3500,
  3000,
  3000,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  3500,
  4500,
  5000,
  6000,
  7000,
  11400,
  8000,
  8000,
  11400,
  7000,
  6500,
  11200,
  5000,
  5000,
  4000,
  4000,
  3500,
  3000,
  3000,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  6500,
  11400,
  8500,
  11600,
  11600,
  11600,
  9000,
  8500,
  7000,
  6500,
  6000,
  11200,
  4500,
  4000,
  3500,
  3500,
  3000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  3500,
  4500,
  5000,
  6000,
  6500,
  7000,
  8000,
  11600,
  11700,
  11800,
  11800,
  11800,
  11700,
  11600,
  8000,
  7000,
  6500,
  6000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  4500,
  6000,
  7000,
  8000,
  9000,
  11600,
  11700,
  11800,
  12000,
  12100,
  12100,
  12000,
  11900,
  11800,
  11600,
  8500,
  11400,
  6500,
  11200,
  5000,
  4000,
  3500,
  3000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3500,
  4000,
  5000,
  11200,
  6000,
  6500,
  11400,
  11600,
  11700,
  11900,
  12000,
  12100,
  12200,
  12400,
  12400,
  12300,
  12200,
  12100,
  11900,
  11700,
  9000,
  11400,
  7000,
  11200,
  5000,
  4000,
  3500,
  3000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  4000,
  5000,
  6000,
  7000,
  8000,
  11600,
  11700,
  11800,
  12100,
  12300,
  12500,
  12600,
  12800,
  12900,
  13000,
  12900,
  12800,
  12500,
  12300,
  12200,
  11800,
  11600,
  8500,
  11400,
  11200,
  5000,
  4500,
  3500,
  3000,
  2500,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  6500,
  8000,
  11600,
  11700,
  11800,
  12000,
  12200,
  12500,
  12700,
  12900,
  13100,
  13200,
  13300,
  13300,
  13300,
  13000,
  12800,
  12500,
  12300,
  11900,
  11700,
  8500,
  11400,
  11200,
  5000,
  4000,
  3500,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  11200,
  11400,
  11600,
  11800,
  12000,
  12200,
  12400,
  12700,
  12900,
  13100,
  13300,
  13500,
  13600,
  13600,
  13600,
  13600,
  13300,
  13000,
  12600,
  12300,
  11900,
  11700,
  8500,
  7000,
  11200,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  11200,
  6000,
  8500,
  11700,
  12000,
  12300,
  12500,
  12800,
  13100,
  13300,
  13600,
  13700,
  13800,
  13800,
  13800,
  13700,
  13700,
  13400,
  13000,
  12600,
  12300,
  11800,
  11600,
  8000,
  6500,
  5000,
  4500,
  3500,
  3000,
  3000,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  5000,
  6000,
  11400,
  11600,
  11900,
  12200,
  12600,
  12800,
  13300,
  13600,
  13800,
  13900,
  14000,
  14000,
  13900,
  13900,
  13800,
  13500,
  13200,
  12700,
  12400,
  12000,
  11700,
  8500,
  6500,
  11200,
  4500,
  4000,
  3000,
  2500,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  5000,
  6000,
  7000,
  8500,
  11800,
  12000,
  12300,
  12700,
  13000,
  13500,
  13800,
  13900,
  14000,
  14000,
  13900,
  13900,
  13800,
  13700,
  13200,
  12900,
  12600,
  12200,
  12000,
  9000,
  7000,
  6000,
  5000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2500,
  2500,
  3000,
  4000,
  4500,
  11200,
  6500,
  11400,
  11600,
  11900,
  12200,
  12500,
  12800,
  13200,
  13700,
  13900,
  13900,
  14000,
  13900,
  13800,
  13700,
  13600,
  13300,
  12900,
  12500,
  12200,
  11900,
  11800,
  11400,
  6000,
  5000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  5000,
  6000,
  7000,
  8500,
  11600,
  12000,
  12200,
  12500,
  12800,
  13200,
  13700,
  13800,
  13800,
  13800,
  13800,
  13600,
  13500,
  13200,
  12900,
  12500,
  12200,
  11900,
  11600,
  9000,
  6000,
  5000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  6500,
  11400,
  9000,
  11700,
  12000,
  12300,
  12500,
  12800,
  13100,
  13500,
  13600,
  13600,
  13500,
  13500,
  13300,
  13100,
  12800,
  12500,
  12200,
  11800,
  11600,
  8000,
  7000,
  5000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  11200,
  7000,
  8000,
  9000,
  11700,
  11900,
  12100,
  12300,
  12600,
  12700,
  12900,
  13000,
  13000,
  12900,
  12800,
  12600,
  12400,
  12200,
  12000,
  11700,
  8000,
  6000,
  5000,
  4500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  5000,
  11200,
  7000,
  8000,
  9000,
  11600,
  11800,
  12000,
  12200,
  12300,
  12500,
  12500,
  12500,
  12500,
  12400,
  12300,
  12100,
  12000,
  11900,
  11700,
  8000,
  6000,
  5000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  5000,
  11200,
  6500,
  11400,
  8500,
  11600,
  11700,
  11800,
  12000,
  12000,
  12100,
  12100,
  12100,
  12100,
  12000,
  11800,
  11600,
  11600,
  9000,
  8000,
  6500,
  5000,
  4000,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  5000,
  11200,
  6500,
  11400,
  8000,
  8500,
  11600,
  11700,
  11700,
  11800,
  11800,
  11800,
  11800,
  11800,
  11600,
  8500,
  6500,
  6500,
  6500,
  6000,
  5000,
  4000,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  6000,
  6500,
  7000,
  11400,
  8000,
  8000,
  8500,
  8500,
  8000,
  8000,
  8000,
  11400,
  6500,
  11200,
  4500,
  4500,
  4000,
  4000,
  3500,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3000,
  3500,
  4000,
  4500,
  11200,
  11200,
  6000,
  6500,
  6500,
  7000,
  7000,
  6500,
  6500,
  6000,
  6000,
  11200,
  5000,
  4500,
  3500,
  3500,
  3000,
  2500,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  11200,
  11200,
  11200,
  11200,
  11200,
  11200,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  3000,
  2500,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3000,
  3500,
  3500,
  4000,
  4500,
  4500,
  4500,
  4500,
  4500,
  4500,
  4500,
  4500,
  4000,
  3500,
  3500,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2500,
  2500,
  3000,
  3000,
  3500,
  3500,
  3500,
  4000,
  4000,
  4000,
  4000,
  4000,
  3500,
  3500,
  3000,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.tritium670 = new DataMapNumeric(
  'Tritium 670',
  'Tritium Content at 670 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  75,
  27,
  66,
  50,
);

a = [];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1500,
  2500,
  3000,
  3000,
  3500,
  4000,
  4500,
  4500,
  4000,
  4000,
  3500,
  3500,
  3000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2000,
  2000,
  2000,
  2000,
  2000,
  3000,
  4000,
  4000,
  4500,
  5000,
  11200,
  11200,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  3500,
  3500,
  3000,
  3000,
  3000,
  4000,
  5000,
  11200,
  6000,
  6500,
  7000,
  7000,
  6000,
  6000,
  11200,
  5000,
  4000,
  3500,
  3000,
  3000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  2500,
  3000,
  3500,
  4000,
  4500,
  4500,
  4500,
  4500,
  4500,
  4500,
  11200,
  6500,
  6500,
  11400,
  8500,
  9000,
  8000,
  11400,
  11400,
  6500,
  11200,
  5000,
  4000,
  3500,
  3500,
  3000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  3000,
  3500,
  4000,
  4500,
  11200,
  6000,
  6000,
  6000,
  6000,
  11200,
  11200,
  6500,
  8000,
  8500,
  11600,
  11700,
  11700,
  11600,
  9000,
  9000,
  11400,
  6500,
  11200,
  4500,
  4000,
  4000,
  3500,
  3000,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  3000,
  4000,
  4500,
  5000,
  6000,
  6500,
  8000,
  8000,
  8000,
  8000,
  11400,
  6500,
  8500,
  11700,
  11700,
  11800,
  11900,
  12000,
  11800,
  11700,
  11700,
  9000,
  11400,
  6500,
  11200,
  4500,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  2000,
  2500,
  4000,
  11200,
  6000,
  7000,
  8500,
  11600,
  11700,
  11800,
  11800,
  11800,
  11800,
  11800,
  12000,
  12100,
  12100,
  12300,
  12400,
  12400,
  12200,
  12000,
  12000,
  11800,
  9000,
  8000,
  6500,
  11200,
  5000,
  4500,
  3500,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2500,
  3500,
  5000,
  6500,
  11400,
  9000,
  11600,
  11800,
  12000,
  12100,
  12100,
  12100,
  12200,
  12200,
  12400,
  12500,
  12500,
  12600,
  12700,
  12700,
  12500,
  12300,
  12200,
  11900,
  11700,
  9000,
  11400,
  6000,
  11200,
  4500,
  4000,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  2500,
  3000,
  3500,
  4000,
  11200,
  11400,
  8500,
  11700,
  11900,
  12000,
  12300,
  12400,
  12400,
  12500,
  12500,
  12600,
  12800,
  12900,
  12900,
  13000,
  13000,
  13000,
  12800,
  12600,
  12400,
  12100,
  11900,
  11700,
  8000,
  6500,
  11200,
  4500,
  4000,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  3000,
  3500,
  3500,
  4000,
  4500,
  5000,
  6500,
  8500,
  11600,
  11900,
  12100,
  12300,
  12600,
  12700,
  12700,
  12800,
  12900,
  13000,
  13200,
  13300,
  13300,
  13300,
  13400,
  13400,
  13100,
  12800,
  12600,
  12300,
  12000,
  11700,
  8000,
  6500,
  11200,
  4500,
  4000,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  4500,
  5000,
  11200,
  6000,
  7000,
  11600,
  11800,
  12100,
  12300,
  12600,
  12900,
  13000,
  13000,
  13100,
  13200,
  13300,
  13600,
  13600,
  13600,
  13600,
  13600,
  13600,
  13400,
  13100,
  12800,
  12400,
  12000,
  11700,
  11400,
  6000,
  5000,
  4500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  5000,
  6000,
  6000,
  7000,
  11400,
  8000,
  11600,
  11900,
  12100,
  12400,
  12600,
  12900,
  13200,
  13400,
  13400,
  13500,
  13500,
  13600,
  13800,
  13800,
  13800,
  13800,
  13800,
  13700,
  13700,
  13200,
  12800,
  12400,
  12000,
  11700,
  7000,
  6000,
  5000,
  4000,
  3500,
  3000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3500,
  4000,
  5000,
  7000,
  8000,
  8500,
  11600,
  11700,
  11800,
  12100,
  12400,
  12500,
  12800,
  13100,
  13300,
  13700,
  13800,
  13800,
  13900,
  13900,
  13900,
  14000,
  14000,
  14000,
  13900,
  13900,
  13800,
  13400,
  13000,
  12700,
  12300,
  11900,
  11600,
  7000,
  11200,
  4500,
  4000,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  5000,
  6000,
  8000,
  11600,
  11700,
  11800,
  12000,
  12100,
  12500,
  12700,
  12800,
  13100,
  13400,
  13600,
  13900,
  14000,
  14000,
  14100,
  14100,
  14100,
  14000,
  14000,
  14000,
  13900,
  13900,
  13700,
  13200,
  12800,
  12600,
  12200,
  11900,
  11600,
  6500,
  5000,
  4500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  2000,
  2500,
  3000,
  3500,
  4500,
  11200,
  6500,
  11600,
  11800,
  11900,
  12100,
  12200,
  12400,
  12800,
  13100,
  13200,
  13400,
  13600,
  13900,
  14100,
  14200,
  14200,
  14200,
  14100,
  14100,
  14000,
  14000,
  13900,
  13900,
  13800,
  13600,
  13000,
  12600,
  12300,
  11900,
  11600,
  8000,
  11200,
  4500,
  4000,
  3500,
  2500,
  2500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  2500,
  3000,
  3500,
  4000,
  5000,
  6000,
  11400,
  11700,
  11900,
  12100,
  12300,
  12500,
  12700,
  13100,
  13400,
  13400,
  13600,
  13800,
  14000,
  14300,
  14300,
  14300,
  14300,
  14200,
  14100,
  13900,
  13800,
  13800,
  13700,
  13600,
  13300,
  12700,
  12300,
  12000,
  11600,
  11400,
  6500,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  3000,
  3500,
  4500,
  5000,
  11200,
  6500,
  8500,
  11800,
  12100,
  12300,
  12500,
  12800,
  13000,
  13400,
  13600,
  13700,
  13900,
  14000,
  14200,
  14400,
  14400,
  14400,
  14300,
  14200,
  14000,
  13800,
  13600,
  13600,
  13500,
  13300,
  13000,
  12400,
  12100,
  11800,
  8000,
  6500,
  5000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3500,
  4000,
  5000,
  11200,
  6500,
  11400,
  11600,
  12000,
  12300,
  12500,
  12700,
  13000,
  13200,
  13600,
  13800,
  13900,
  14000,
  14100,
  14200,
  14400,
  14400,
  14400,
  14200,
  14100,
  13900,
  13600,
  13400,
  13400,
  13200,
  12900,
  12600,
  12200,
  11800,
  11600,
  11400,
  11200,
  4500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  5000,
  6000,
  7000,
  8000,
  11600,
  11800,
  12200,
  12500,
  12700,
  12900,
  13200,
  13400,
  13800,
  13900,
  14000,
  14100,
  14100,
  14200,
  14200,
  14200,
  14200,
  14000,
  13900,
  13700,
  13300,
  13000,
  12900,
  12600,
  12400,
  12100,
  11700,
  9000,
  8000,
  6500,
  5000,
  4000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  2500,
  3000,
  4000,
  5000,
  6000,
  7000,
  11400,
  9000,
  11700,
  11900,
  12300,
  12600,
  12800,
  13100,
  13300,
  13600,
  13800,
  13900,
  14000,
  14000,
  14000,
  14000,
  14000,
  13900,
  13900,
  13800,
  13600,
  13400,
  13000,
  12700,
  12600,
  12300,
  12000,
  11800,
  8500,
  7000,
  6500,
  5000,
  4000,
  3000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  11200,
  6500,
  11400,
  8500,
  11600,
  11800,
  12000,
  12400,
  12700,
  12900,
  13200,
  13500,
  13700,
  13800,
  13900,
  13900,
  13900,
  13900,
  13900,
  13800,
  13700,
  13700,
  13500,
  13400,
  13100,
  12700,
  12400,
  12300,
  11900,
  11600,
  8000,
  6500,
  11200,
  5000,
  4000,
  3000,
  2500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  6000,
  7000,
  8000,
  9000,
  11700,
  11900,
  12100,
  12400,
  12700,
  13000,
  13300,
  13600,
  13700,
  13700,
  13800,
  13800,
  13800,
  13800,
  13700,
  13500,
  13400,
  13400,
  13300,
  13100,
  12900,
  12500,
  12200,
  12000,
  11700,
  8000,
  6500,
  5000,
  4000,
  4000,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  5000,
  6000,
  7000,
  8500,
  11600,
  11700,
  11900,
  12100,
  12400,
  12700,
  12900,
  13200,
  13500,
  13500,
  13500,
  13500,
  13500,
  13500,
  13500,
  13400,
  13200,
  13100,
  13100,
  12900,
  12800,
  12600,
  12200,
  12000,
  11800,
  9000,
  7000,
  11200,
  4000,
  3000,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2500,
  3000,
  3500,
  4000,
  4500,
  11200,
  6500,
  11400,
  8500,
  11600,
  11700,
  11900,
  12100,
  12400,
  12600,
  12800,
  13000,
  13200,
  13300,
  13200,
  13200,
  13200,
  13200,
  13100,
  13000,
  12800,
  12700,
  12700,
  12600,
  12500,
  12300,
  12000,
  11800,
  11600,
  8000,
  6000,
  4500,
  3000,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  5000,
  11200,
  6500,
  11400,
  8500,
  11600,
  11700,
  11800,
  11900,
  12200,
  12400,
  12500,
  12600,
  12700,
  12700,
  12700,
  12700,
  12700,
  12600,
  12500,
  12400,
  12300,
  12200,
  12200,
  12200,
  12100,
  12000,
  11700,
  9000,
  8000,
  6500,
  5000,
  4000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  5000,
  11200,
  7000,
  11400,
  8500,
  9000,
  11600,
  11700,
  11800,
  12000,
  12200,
  12200,
  12300,
  12400,
  12400,
  12400,
  12300,
  12300,
  12200,
  12000,
  11900,
  11900,
  11900,
  11900,
  11900,
  11800,
  11700,
  9000,
  11400,
  7000,
  11200,
  4000,
  3000,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  5000,
  11200,
  7000,
  11400,
  8500,
  8500,
  11600,
  11600,
  11700,
  11900,
  12000,
  12000,
  12000,
  12100,
  12100,
  12100,
  12000,
  12000,
  11800,
  11700,
  11600,
  11600,
  11600,
  11600,
  11600,
  11600,
  9000,
  11400,
  6500,
  11200,
  4500,
  3500,
  2500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  5000,
  11200,
  6500,
  11400,
  8000,
  8000,
  8500,
  9000,
  11600,
  11700,
  11700,
  11700,
  11800,
  11800,
  11800,
  11800,
  11700,
  11700,
  9000,
  7000,
  7000,
  11400,
  8000,
  8000,
  8000,
  11400,
  11400,
  6000,
  5000,
  4500,
  3500,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  6500,
  7000,
  11400,
  11400,
  11400,
  8000,
  8000,
  8500,
  8500,
  8500,
  9000,
  11600,
  11600,
  9000,
  8500,
  8000,
  7000,
  6000,
  11200,
  6000,
  6000,
  6000,
  6000,
  6000,
  11200,
  4500,
  4000,
  3500,
  3000,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  3500,
  4000,
  4500,
  11200,
  6000,
  6500,
  6500,
  6500,
  6500,
  7000,
  7000,
  7000,
  7000,
  7000,
  11400,
  11400,
  7000,
  6500,
  6500,
  11200,
  4500,
  4000,
  4500,
  4500,
  4500,
  4500,
  4500,
  4500,
  3500,
  3000,
  3000,
  2000,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  2500,
  3000,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  3500,
  3000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2500,
  2500,
  3000,
  3000,
  3500,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  3500,
  3500,
  3500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  3000,
  3000,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2500,
  2000,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  1500,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.tritium680 = new DataMapNumeric(
  'Tritium 680',
  'Tritium Content at 680 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  70,
  26,
  83,
  59,
);

a = [];
a[59] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[58] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[57] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[56] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[55] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  2000,
  2500,
  2500,
  2500,
  3000,
  3000,
  3500,
  3500,
  3500,
  3000,
  3000,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2500,
  2500,
  3000,
  3500,
  3500,
  3500,
  3500,
  3500,
  4000,
  4500,
  4500,
  4500,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2000,
  2000,
  2500,
  3000,
  4500,
  4500,
  5000,
  11200,
  5000,
  4500,
  4500,
  5000,
  6000,
  6500,
  6000,
  6000,
  11200,
  5000,
  4000,
  3500,
  3000,
  2500,
  2000,
  2000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  2500,
  3000,
  3000,
  3000,
  3500,
  4500,
  6500,
  6500,
  8000,
  9000,
  8000,
  6500,
  6500,
  11400,
  8500,
  8500,
  7000,
  7000,
  6500,
  11200,
  5000,
  4000,
  3500,
  2500,
  2000,
  2000,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  2000,
  3000,
  3500,
  4500,
  11200,
  11200,
  11200,
  11200,
  6500,
  11700,
  11800,
  12000,
  12200,
  12100,
  12000,
  12000,
  12000,
  11900,
  11800,
  11600,
  9000,
  8000,
  7000,
  6000,
  4500,
  3500,
  3000,
  2500,
  2000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2500,
  3000,
  4500,
  11200,
  6500,
  8000,
  8000,
  11400,
  7000,
  8500,
  12100,
  12200,
  12500,
  12700,
  12800,
  12500,
  12500,
  12400,
  12200,
  12000,
  11700,
  11600,
  9000,
  11400,
  6000,
  4500,
  3500,
  3000,
  2000,
  2000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2500,
  4000,
  5000,
  6500,
  11400,
  9000,
  11700,
  11700,
  11800,
  11800,
  11900,
  12600,
  12700,
  13000,
  13200,
  13300,
  13100,
  13100,
  12800,
  12500,
  12200,
  11900,
  11700,
  9000,
  11400,
  6000,
  4500,
  3500,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  2500,
  3000,
  3000,
  3500,
  6000,
  7000,
  9000,
  11700,
  11800,
  12100,
  12100,
  12200,
  12200,
  12400,
  13100,
  13200,
  13500,
  13600,
  13800,
  13600,
  13500,
  13100,
  12800,
  12500,
  12000,
  11700,
  9000,
  11400,
  6000,
  4000,
  3500,
  2500,
  2000,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  3500,
  4000,
  4000,
  5000,
  11400,
  9000,
  11800,
  12000,
  12200,
  12500,
  12500,
  12600,
  12700,
  12900,
  13500,
  13800,
  13800,
  13900,
  14000,
  13900,
  13800,
  13400,
  12900,
  12600,
  12000,
  11700,
  8500,
  7000,
  11200,
  3500,
  3000,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  2000,
  2500,
  3000,
  4000,
  4500,
  11200,
  11200,
  6000,
  6500,
  7000,
  11700,
  11900,
  12200,
  12500,
  12800,
  13200,
  13200,
  13300,
  13400,
  13500,
  13800,
  13900,
  14000,
  14100,
  14100,
  13900,
  13800,
  13400,
  13000,
  12600,
  12100,
  11700,
  8500,
  6500,
  5000,
  3000,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  3000,
  3500,
  4000,
  5000,
  11200,
  11400,
  11400,
  8000,
  9000,
  11600,
  12100,
  12200,
  12600,
  12900,
  13200,
  13600,
  13600,
  13600,
  13700,
  13700,
  13900,
  14000,
  14000,
  14000,
  14000,
  13800,
  13700,
  13400,
  13000,
  12600,
  12100,
  11700,
  8500,
  6500,
  5000,
  2500,
  2000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  1500,
  1500,
  2500,
  3500,
  4500,
  5000,
  6000,
  7000,
  9000,
  9000,
  11700,
  11800,
  11900,
  12500,
  12600,
  12900,
  13200,
  13500,
  13800,
  13800,
  13900,
  13900,
  13900,
  14000,
  14000,
  14000,
  13900,
  13900,
  13600,
  13500,
  13100,
  12800,
  12500,
  12000,
  11700,
  8500,
  6500,
  4500,
  2500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  2000,
  2500,
  3000,
  4500,
  5000,
  6500,
  11400,
  8500,
  11700,
  11800,
  11900,
  12100,
  12400,
  12900,
  13000,
  13300,
  13500,
  13700,
  14000,
  14000,
  14000,
  14000,
  14000,
  13900,
  13900,
  13900,
  13800,
  13600,
  13300,
  13200,
  12900,
  12600,
  12300,
  11900,
  11700,
  8500,
  6500,
  4500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  2500,
  3000,
  3500,
  4500,
  11200,
  6500,
  11400,
  9000,
  11700,
  11900,
  12000,
  12200,
  12400,
  12700,
  13200,
  13400,
  13600,
  13800,
  13900,
  14000,
  14000,
  14000,
  14000,
  14000,
  13900,
  13800,
  13600,
  13500,
  13300,
  12900,
  12900,
  12600,
  12400,
  12100,
  11800,
  11600,
  11400,
  6000,
  4500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  11200,
  7000,
  8000,
  9000,
  11700,
  11800,
  12100,
  12300,
  12500,
  12700,
  13000,
  13500,
  13700,
  13900,
  14000,
  14000,
  14100,
  14100,
  14000,
  14000,
  13900,
  13800,
  13500,
  13200,
  12900,
  12700,
  12300,
  12300,
  12200,
  12000,
  11800,
  9000,
  8000,
  6500,
  11200,
  4000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  2000,
  2500,
  3000,
  3500,
  4500,
  4500,
  11200,
  6000,
  6500,
  8000,
  9000,
  11600,
  11800,
  11900,
  12200,
  12400,
  12600,
  12900,
  13200,
  13700,
  13800,
  14000,
  14000,
  14000,
  14000,
  14000,
  13900,
  13800,
  13700,
  13400,
  13200,
  12800,
  12400,
  12200,
  11900,
  11900,
  11800,
  11700,
  11600,
  11400,
  7000,
  11200,
  4500,
  3500,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  11200,
  11200,
  6000,
  7000,
  11400,
  9000,
  11600,
  11700,
  11800,
  12000,
  12300,
  12500,
  12700,
  13000,
  13300,
  13700,
  13800,
  13900,
  14000,
  14000,
  14000,
  13900,
  13800,
  13600,
  13400,
  13000,
  12800,
  12300,
  11900,
  11600,
  11600,
  11600,
  9000,
  8500,
  8000,
  6000,
  11200,
  4500,
  3500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  3000,
  3500,
  4000,
  4500,
  11200,
  6500,
  6500,
  7000,
  11400,
  8500,
  11600,
  11700,
  11800,
  11900,
  12100,
  12300,
  12500,
  12800,
  13000,
  13200,
  13700,
  13700,
  13800,
  13800,
  13800,
  13800,
  13800,
  13600,
  13400,
  13100,
  12600,
  12400,
  11900,
  8500,
  7000,
  6500,
  6500,
  6500,
  6000,
  11200,
  4500,
  4500,
  3500,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  2000,
  2000,
  2000,
  2500,
  3000,
  3500,
  4500,
  4500,
  11200,
  6000,
  7000,
  7000,
  11400,
  8500,
  9000,
  11600,
  11700,
  11800,
  12000,
  12100,
  12400,
  12500,
  12700,
  12900,
  13100,
  13500,
  13500,
  13600,
  13600,
  13600,
  13500,
  13500,
  13300,
  13100,
  12800,
  12300,
  12100,
  11700,
  11400,
  11200,
  4500,
  4500,
  4000,
  4000,
  4000,
  3000,
  3000,
  2500,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3000,
  3500,
  4000,
  5000,
  11200,
  6000,
  6500,
  7000,
  8000,
  8000,
  8500,
  9000,
  11600,
  11700,
  11800,
  11900,
  12000,
  12100,
  12300,
  12400,
  12600,
  12700,
  12900,
  13000,
  13000,
  13000,
  13000,
  13000,
  12900,
  12900,
  12800,
  12600,
  12300,
  11900,
  11800,
  9000,
  6500,
  5000,
  2500,
  2500,
  1500,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  3000,
  3500,
  3500,
  4000,
  4500,
  11200,
  6000,
  6500,
  7000,
  11400,
  8500,
  8500,
  9000,
  11600,
  11600,
  11700,
  11800,
  11800,
  11900,
  12000,
  12200,
  12300,
  12400,
  12500,
  12600,
  12700,
  12700,
  12700,
  12600,
  12600,
  12400,
  12400,
  12400,
  12200,
  12100,
  11700,
  11600,
  7000,
  11200,
  4000,
  2000,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3500,
  4000,
  4500,
  5000,
  11200,
  6000,
  6500,
  7000,
  11400,
  8000,
  8500,
  9000,
  9000,
  11600,
  11600,
  11700,
  11700,
  11800,
  11900,
  12000,
  12100,
  12200,
  12300,
  12300,
  12400,
  12400,
  12400,
  12300,
  12300,
  12200,
  12000,
  12000,
  12000,
  11900,
  11800,
  9000,
  8000,
  6000,
  4500,
  3000,
  1500,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  3000,
  3500,
  4500,
  5000,
  11200,
  6000,
  7000,
  7000,
  11400,
  8000,
  8000,
  8500,
  9000,
  11600,
  11600,
  11600,
  11700,
  11700,
  11800,
  11800,
  11900,
  12000,
  12000,
  12100,
  12100,
  12100,
  12100,
  12100,
  12000,
  11900,
  11800,
  11600,
  11600,
  11600,
  11600,
  9000,
  7000,
  6500,
  5000,
  3500,
  2500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  4000,
  5000,
  11200,
  6000,
  6500,
  11400,
  11400,
  11400,
  8000,
  8500,
  9000,
  9000,
  11600,
  11600,
  11600,
  11700,
  11700,
  11700,
  11800,
  11800,
  11900,
  11900,
  11900,
  11900,
  11900,
  11900,
  11900,
  11800,
  11600,
  8000,
  11400,
  11400,
  11400,
  7000,
  7000,
  11200,
  5000,
  4000,
  3000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  11200,
  11200,
  6500,
  7000,
  11400,
  8000,
  8000,
  8000,
  8500,
  9000,
  9000,
  9000,
  11600,
  11600,
  11600,
  11600,
  11600,
  11700,
  11700,
  11700,
  11700,
  11700,
  11700,
  11700,
  11600,
  11600,
  8000,
  6500,
  11200,
  4500,
  4500,
  4500,
  4500,
  4000,
  3500,
  3500,
  2500,
  2000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  2500,
  3000,
  4000,
  5000,
  11200,
  6000,
  6500,
  7000,
  11400,
  8000,
  8000,
  8500,
  8500,
  9000,
  9000,
  9000,
  9000,
  9000,
  11600,
  11600,
  11600,
  11600,
  11600,
  11600,
  11600,
  11600,
  11600,
  9000,
  8000,
  8000,
  6500,
  11200,
  4500,
  3500,
  3500,
  3000,
  3000,
  3000,
  2500,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  5000,
  6000,
  6500,
  7000,
  11400,
  8000,
  8000,
  8000,
  8500,
  8500,
  8500,
  8500,
  9000,
  9000,
  9000,
  9000,
  9000,
  9000,
  9000,
  8500,
  8500,
  8500,
  8500,
  8000,
  8000,
  6500,
  6500,
  11200,
  4500,
  3500,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2500,
  3000,
  3000,
  3500,
  4500,
  5000,
  6000,
  6500,
  7000,
  11400,
  8000,
  8000,
  8000,
  8000,
  8500,
  8500,
  8500,
  8500,
  8500,
  8500,
  8000,
  8000,
  8000,
  8000,
  8000,
  11400,
  11400,
  11400,
  7000,
  6500,
  11200,
  5000,
  4500,
  3500,
  2500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  11200,
  6000,
  6500,
  7000,
  11400,
  11400,
  8000,
  8000,
  8000,
  8000,
  8000,
  8000,
  8000,
  8000,
  8000,
  11400,
  11400,
  11400,
  7000,
  7000,
  6500,
  6500,
  6500,
  6000,
  11200,
  4500,
  4500,
  3500,
  3000,
  2000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  11200,
  6000,
  6500,
  7000,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  6500,
  6500,
  6500,
  6000,
  11200,
  5000,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  5000,
  6000,
  6000,
  6500,
  7000,
  7000,
  7000,
  7000,
  7000,
  7000,
  7000,
  7000,
  11400,
  7000,
  7000,
  6000,
  6000,
  11200,
  5000,
  4500,
  4000,
  4000,
  4000,
  3500,
  3500,
  2500,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  3500,
  4000,
  5000,
  11200,
  11200,
  6000,
  6000,
  6000,
  6000,
  6000,
  6000,
  6500,
  6500,
  6500,
  6500,
  6500,
  6000,
  5000,
  5000,
  4500,
  4000,
  4000,
  3500,
  3500,
  3000,
  3000,
  2500,
  2000,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3000,
  3500,
  4000,
  4500,
  5000,
  5000,
  11200,
  11200,
  11200,
  11200,
  11200,
  11200,
  11200,
  11200,
  11200,
  11200,
  11200,
  11200,
  4500,
  4000,
  3500,
  3500,
  3000,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  3000,
  3500,
  3500,
  4000,
  4500,
  4500,
  4500,
  5000,
  5000,
  5000,
  5000,
  4500,
  4500,
  5000,
  5000,
  5000,
  4500,
  4500,
  3500,
  3500,
  3000,
  2500,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  3000,
  3000,
  3500,
  3500,
  3500,
  3500,
  4000,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3000,
  2500,
  2500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.tritium690 = new DataMapNumeric(
  'Tritium 690',
  'Tritium Content at 690 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  69,
  24,
  86,
  60,
);

a = [];
a[54] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[53] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[52] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[51] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[50] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[49] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[48] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[47] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[46] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[45] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
];
a[44] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[43] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  1500,
  1500,
  1500,
  1000,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  2000,
  2500,
  2500,
  2500,
  2500,
  3000,
  3000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[42] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  3000,
  2500,
  1500,
  500,
  500,
  1500,
  2500,
  2500,
  2500,
  2500,
  3500,
  4500,
  3500,
  3500,
  4000,
  4500,
  4000,
  3000,
  3000,
  2500,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[41] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  2000,
  3000,
  3500,
  4500,
  11200,
  6000,
  6500,
  7000,
  6500,
  6500,
  6500,
  11400,
  7000,
  11200,
  11200,
  6000,
  9000,
  11800,
  7000,
  11400,
  8500,
  7000,
  6000,
  4000,
  3500,
  2500,
  2000,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[40] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3000,
  4000,
  5000,
  6000,
  7000,
  8000,
  9000,
  11600,
  11700,
  11700,
  11800,
  11900,
  11900,
  11700,
  7000,
  9000,
  12200,
  12600,
  12800,
  12300,
  11900,
  11600,
  11400,
  4500,
  3500,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[39] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  2500,
  4000,
  5000,
  6000,
  11400,
  8500,
  11700,
  11800,
  12000,
  12100,
  12200,
  12400,
  12500,
  12600,
  12500,
  12500,
  12600,
  13300,
  13500,
  13700,
  12900,
  12200,
  11700,
  11400,
  4500,
  3500,
  2500,
  2000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[38] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  2500,
  3000,
  4500,
  11200,
  7000,
  9000,
  11600,
  11900,
  12100,
  12300,
  12500,
  12600,
  12900,
  13100,
  13400,
  13400,
  13500,
  14000,
  14300,
  13900,
  13500,
  12800,
  12100,
  11700,
  11400,
  4000,
  2500,
  2000,
  1500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[37] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  2000,
  2500,
  3000,
  3500,
  5000,
  6500,
  8000,
  11600,
  11800,
  12200,
  12500,
  12800,
  13000,
  13200,
  13500,
  13700,
  13900,
  14000,
  14400,
  14800,
  14900,
  14300,
  13200,
  12200,
  8000,
  6000,
  4500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[36] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  4000,
  11200,
  7000,
  8500,
  11700,
  12000,
  12400,
  12700,
  13000,
  13200,
  13500,
  13600,
  13800,
  13900,
  14100,
  14400,
  14400,
  14200,
  13900,
  12700,
  11700,
  6500,
  4500,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[35] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2500,
  3500,
  4000,
  4500,
  4500,
  6000,
  7000,
  9000,
  11800,
  12100,
  12600,
  12900,
  13200,
  13500,
  13600,
  13600,
  13700,
  13800,
  13900,
  14000,
  14000,
  13700,
  13400,
  12400,
  11700,
  6000,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[34] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  3500,
  4000,
  4500,
  5000,
  11200,
  6500,
  11400,
  9000,
  11800,
  12200,
  12700,
  13100,
  13400,
  13600,
  13500,
  13400,
  13400,
  13500,
  13600,
  13600,
  13500,
  13200,
  13000,
  12100,
  11600,
  5000,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[33] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  2500,
  3000,
  3000,
  3500,
  3500,
  4000,
  4000,
  4000,
  4500,
  4500,
  4500,
  5000,
  11200,
  6000,
  7000,
  8000,
  11600,
  11900,
  12200,
  12600,
  12900,
  13200,
  13400,
  13200,
  13100,
  13100,
  13100,
  13100,
  13100,
  13100,
  12800,
  12600,
  11900,
  8000,
  3500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[32] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3000,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  11200,
  6000,
  6000,
  6000,
  6000,
  6000,
  6500,
  6500,
  11400,
  9000,
  11700,
  11800,
  12000,
  12400,
  12500,
  12600,
  12600,
  12400,
  12300,
  12400,
  12500,
  12500,
  12500,
  12500,
  12200,
  12100,
  11600,
  6500,
  3000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[31] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  3500,
  4000,
  4500,
  5000,
  5000,
  11200,
  6000,
  6500,
  6500,
  6500,
  6500,
  6500,
  6500,
  7000,
  7000,
  8000,
  9000,
  11600,
  11700,
  11900,
  12100,
  12100,
  12100,
  12100,
  11900,
  11800,
  12000,
  12100,
  12100,
  12100,
  12100,
  11900,
  11800,
  8000,
  11200,
  3000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  3000,
  3500,
  4000,
  4500,
  4500,
  5000,
  11200,
  6000,
  6000,
  7000,
  7000,
  7000,
  7000,
  7000,
  7000,
  7000,
  11400,
  11400,
  8000,
  8500,
  11600,
  11600,
  11800,
  11800,
  11800,
  11800,
  11700,
  11400,
  8000,
  11600,
  11800,
  11800,
  11800,
  11800,
  11700,
  9000,
  6000,
  4000,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3500,
  4000,
  4500,
  5000,
  5000,
  11200,
  6000,
  6500,
  6500,
  7000,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  8000,
  8500,
  9000,
  11600,
  11600,
  11600,
  11600,
  11600,
  8500,
  6500,
  6500,
  11400,
  8500,
  9000,
  9000,
  9000,
  8000,
  7000,
  4500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  4000,
  4500,
  5000,
  11200,
  6000,
  6500,
  6500,
  7000,
  7000,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  7000,
  6500,
  6000,
  5000,
  5000,
  11200,
  6000,
  6000,
  6000,
  6000,
  11200,
  4500,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3000,
  3500,
  4500,
  5000,
  11200,
  6000,
  6500,
  7000,
  7000,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  7000,
  7000,
  6500,
  6000,
  11200,
  5000,
  4500,
  4000,
  4000,
  4000,
  4500,
  4500,
  4500,
  4500,
  4000,
  3000,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  5000,
  11200,
  6500,
  6500,
  7000,
  7000,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  7000,
  11400,
  11400,
  7000,
  7000,
  6500,
  6000,
  11200,
  5000,
  4500,
  4000,
  3500,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3500,
  4000,
  4500,
  11200,
  6000,
  7000,
  7000,
  7000,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  7000,
  7000,
  7000,
  7000,
  7000,
  6500,
  6000,
  11200,
  5000,
  4500,
  3500,
  3000,
  2500,
  2500,
  2500,
  2000,
  2000,
  2500,
  2500,
  2000,
  2000,
  1500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  3500,
  4000,
  4500,
  5000,
  6000,
  6500,
  7000,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  7000,
  7000,
  7000,
  6500,
  6500,
  6500,
  6000,
  6000,
  5000,
  4500,
  4000,
  3500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  3000,
  3500,
  4000,
  4500,
  11200,
  6000,
  7000,
  7000,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  11400,
  7000,
  6500,
  6500,
  6000,
  11200,
  11200,
  11200,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2500,
  3000,
  3000,
  4000,
  4500,
  5000,
  11200,
  6500,
  7000,
  11400,
  11400,
  11400,
  11400,
  11400,
  7000,
  7000,
  7000,
  6500,
  6000,
  11200,
  11200,
  5000,
  5000,
  4500,
  4500,
  4000,
  3500,
  2500,
  2000,
  2000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  3000,
  3000,
  4000,
  4500,
  4500,
  11200,
  6000,
  6500,
  7000,
  7000,
  7000,
  7000,
  7000,
  6500,
  6500,
  6000,
  6000,
  11200,
  5000,
  4500,
  4500,
  4000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2500,
  2500,
  3000,
  3000,
  4000,
  4000,
  4500,
  5000,
  6000,
  6500,
  6500,
  6500,
  6500,
  6500,
  6000,
  6000,
  11200,
  11200,
  5000,
  4500,
  4000,
  3500,
  3500,
  3500,
  3000,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2500,
  2500,
  3000,
  3000,
  3500,
  4000,
  4500,
  4500,
  5000,
  11200,
  11200,
  11200,
  11200,
  11200,
  5000,
  5000,
  4500,
  4000,
  3500,
  3000,
  2500,
  2500,
  2500,
  2500,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2500,
  2500,
  3000,
  3500,
  3500,
  4000,
  4000,
  4500,
  5000,
  5000,
  5000,
  5000,
  5000,
  4500,
  4000,
  4000,
  3000,
  2500,
  2000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2500,
  2500,
  2500,
  3000,
  3500,
  3500,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2500,
  2500,
  2500,
  3000,
  3000,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2500,
  2500,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  3000,
  2500,
  2500,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2500,
  2500,
  2500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.tritium700 = new DataMapNumeric(
  'Tritium 700',
  'Tritium Content at 700 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  69,
  38,
  97,
  55,
);

a = [];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1500,
  1500,
  1500,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  4000,
  4000,
  4000,
  4000,
  3500,
  3000,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1000,
  2000,
  3000,
  3000,
  4000,
  11200,
  11200,
  11200,
  5000,
  4500,
  3500,
  3000,
  2000,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  3000,
  3000,
  5000,
  11200,
  11200,
  7000,
  11400,
  11400,
  7000,
  6500,
  11200,
  4000,
  3000,
  2000,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2500,
  8000,
  11600,
  11900,
  12100,
  12100,
  12000,
  11700,
  11600,
  8000,
  11400,
  11200,
  4500,
  3500,
  2500,
  1500,
  1500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  3500,
  11200,
  12100,
  12300,
  12800,
  12700,
  12700,
  12400,
  11900,
  11800,
  9000,
  11400,
  11200,
  4500,
  3500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  11200,
  9000,
  11900,
  13000,
  13200,
  13900,
  13500,
  13400,
  12900,
  12100,
  11800,
  9000,
  7000,
  5000,
  4000,
  3000,
  2000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  6000,
  12000,
  12500,
  13000,
  14500,
  14600,
  15300,
  14500,
  13800,
  13100,
  12200,
  11800,
  8000,
  6000,
  4500,
  3500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3500,
  6000,
  11700,
  13000,
  14200,
  15400,
  16500,
  16500,
  16400,
  14500,
  13800,
  13000,
  12000,
  11700,
  11400,
  5000,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2000,
  3500,
  5000,
  11400,
  12100,
  13600,
  14800,
  16000,
  17300,
  16600,
  15400,
  13600,
  13200,
  12400,
  11700,
  8000,
  5000,
  3500,
  2500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  4500,
  11400,
  11800,
  12500,
  13900,
  14900,
  16000,
  15900,
  15600,
  14200,
  12300,
  12300,
  11900,
  6500,
  11200,
  3500,
  2500,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  3000,
  4500,
  6000,
  11600,
  11900,
  12300,
  13200,
  13500,
  13700,
  13600,
  13600,
  12500,
  6000,
  6000,
  4500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  3500,
  5000,
  6500,
  8500,
  11700,
  12100,
  12400,
  12400,
  12400,
  12300,
  12300,
  11800,
  4500,
  3000,
  2000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2000,
  3500,
  5000,
  6500,
  8000,
  11600,
  11700,
  11800,
  11800,
  9000,
  8500,
  8500,
  11400,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1000,
  1500,
  2000,
  3000,
  4000,
  4500,
  5000,
  11200,
  6000,
  6000,
  5000,
  3500,
  2000,
  2000,
  2000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  3500,
  3500,
  4000,
  4000,
  3500,
  2500,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.tritium710 = new DataMapNumeric(
  'Tritium 710',
  'Tritium Content at 710 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  132,
  64,
  43,
  30,
);

a = [];
a[30] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[29] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[28] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[27] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[26] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  2000,
  3000,
  3000,
  2500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[25] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1500,
  2500,
  3500,
  4500,
  4500,
  3500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[24] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  2500,
  4500,
  11200,
  7000,
  7000,
  5000,
  2500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[23] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  2000,
  2500,
  2500,
  2500,
  4000,
  6000,
  8500,
  11600,
  11600,
  11400,
  3500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[22] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1000,
  2000,
  3000,
  4500,
  4500,
  11200,
  6000,
  6500,
  8500,
  11800,
  12100,
  12300,
  12200,
  11800,
  6000,
  4000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2000,
  3000,
  4500,
  6500,
  6500,
  8000,
  11600,
  11800,
  11900,
  12300,
  12600,
  12900,
  12700,
  12200,
  7000,
  4500,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  3500,
  11200,
  8500,
  11600,
  11700,
  11900,
  12400,
  12500,
  12900,
  13200,
  13400,
  13400,
  12600,
  11400,
  11200,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  3000,
  4500,
  6500,
  11800,
  12000,
  12300,
  12600,
  13200,
  13300,
  13600,
  13800,
  13900,
  13700,
  12900,
  11700,
  11200,
  3000,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  3500,
  11200,
  8000,
  11900,
  12200,
  12500,
  12900,
  13600,
  13600,
  13800,
  13900,
  13900,
  13500,
  12800,
  8000,
  11200,
  3000,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  3500,
  4500,
  6500,
  9000,
  12000,
  12300,
  12700,
  13100,
  13800,
  13800,
  13800,
  13800,
  13800,
  13300,
  12600,
  11400,
  4000,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  2500,
  4000,
  11200,
  7000,
  11600,
  12100,
  12400,
  12800,
  13300,
  13800,
  13800,
  13700,
  13500,
  13400,
  12900,
  12200,
  11400,
  4000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2500,
  3000,
  11200,
  6500,
  8000,
  11700,
  12100,
  12300,
  12600,
  13000,
  13200,
  13200,
  13000,
  12700,
  12400,
  12200,
  11700,
  11200,
  4000,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  2000,
  2500,
  3500,
  6000,
  7000,
  8500,
  11700,
  12000,
  12200,
  12400,
  12500,
  12600,
  12600,
  12400,
  12000,
  11600,
  11600,
  11400,
  4000,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2000,
  3000,
  4000,
  6000,
  11400,
  8500,
  11600,
  11900,
  11900,
  12100,
  12100,
  12100,
  12100,
  11800,
  7000,
  6000,
  5000,
  3500,
  2000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2500,
  3000,
  4500,
  6000,
  11400,
  8000,
  9000,
  11700,
  11700,
  11800,
  11800,
  11600,
  11600,
  8500,
  11200,
  3000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  2000,
  2500,
  3000,
  3500,
  11200,
  6000,
  6500,
  7000,
  8000,
  8000,
  8000,
  11400,
  11200,
  11200,
  4000,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  2000,
  2500,
  3000,
  4500,
  5000,
  11200,
  11200,
  6000,
  6000,
  6000,
  11200,
  4000,
  4000,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1500,
  1500,
  2000,
  2500,
  3500,
  3500,
  4000,
  4000,
  4500,
  4500,
  4500,
  4000,
  2500,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  1000,
  1500,
  1500,
  1500,
  2000,
  2000,
  2000,
  2500,
  3000,
  3000,
  3000,
  3000,
  3000,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1000,
  1500,
  1500,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  1000,
  1000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.tritium720 = new DataMapNumeric(
  'Tritium 720',
  'Tritium Content at 720 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  143,
  69,
  40,
  31,
);

a = [];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  1500,
  2000,
  2500,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  3000,
  4000,
  4000,
  5000,
  4000,
  3000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2000,
  2500,
  3000,
  5000,
  7000,
  7000,
  11400,
  11600,
  11400,
  5000,
  3000,
  2000,
  500,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  4000,
  11200,
  6500,
  11600,
  12000,
  12300,
  12400,
  12100,
  11700,
  7000,
  5000,
  3000,
  1000,
  500,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  4500,
  11400,
  11700,
  12100,
  12600,
  13200,
  13400,
  13400,
  12600,
  12100,
  11600,
  11200,
  3500,
  1000,
  500,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  11400,
  12100,
  13000,
  14100,
  15400,
  15100,
  14500,
  13800,
  12600,
  11900,
  8000,
  5000,
  3000,
  1000,
  500,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  3500,
  7000,
  12300,
  13400,
  14700,
  16400,
  15300,
  14300,
  13500,
  12600,
  11800,
  6500,
  4000,
  2000,
  1000,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  1000,
  2000,
  3500,
  11400,
  12300,
  13400,
  14300,
  15300,
  14700,
  13600,
  12900,
  12000,
  8500,
  5000,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  4000,
  9000,
  12100,
  12800,
  13600,
  13600,
  13400,
  12700,
  12000,
  9000,
  5000,
  3000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  4000,
  7000,
  11600,
  11900,
  11900,
  11400,
  8500,
  11400,
  11200,
  3000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  11200,
  7000,
  8000,
  8000,
  11200,
  4500,
  4000,
  3000,
  2000,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  2500,
  4000,
  4500,
  5000,
  5000,
  3500,
  2500,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1500,
  2500,
  3000,
  3000,
  3000,
  2000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1000,
  1000,
  1000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.tritium730 = new DataMapNumeric(
  'Tritium 730',
  'Tritium Content at 730 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  159,
  78,
  26,
  22,
);

a = [];
a[21] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[20] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  1500,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  4000,
  3500,
  2500,
  2000,
  1500,
  1000,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  3000,
  6000,
  9000,
  11700,
  11400,
  6500,
  4500,
  3500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  7000,
  11900,
  12300,
  12500,
  12200,
  11800,
  6500,
  11200,
  3000,
  2000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  3000,
  4500,
  11700,
  12900,
  13400,
  13400,
  13300,
  12500,
  11800,
  8500,
  4500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  6000,
  11600,
  12000,
  13500,
  15300,
  16800,
  16800,
  14900,
  13400,
  12600,
  11900,
  6000,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2000,
  3500,
  11600,
  12200,
  12900,
  14500,
  17100,
  17700,
  16700,
  15400,
  13600,
  12600,
  11900,
  6000,
  3000,
  1000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  5000,
  11900,
  12700,
  13800,
  17000,
  17000,
  17700,
  14800,
  13900,
  12900,
  12200,
  11800,
  6000,
  3000,
  1500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2500,
  4500,
  7000,
  12300,
  13200,
  14000,
  14700,
  14100,
  14100,
  12400,
  11700,
  11700,
  9000,
  6500,
  3500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  5000,
  8000,
  11900,
  12500,
  13100,
  13100,
  12800,
  12600,
  11600,
  11200,
  5000,
  5000,
  3000,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  3500,
  5000,
  7000,
  11700,
  12000,
  12000,
  11900,
  11900,
  11700,
  5000,
  3500,
  2500,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  500,
  1000,
  1500,
  3000,
  4000,
  5000,
  11200,
  11200,
  11200,
  4500,
  4500,
  4000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  2500,
  3000,
  3500,
  3500,
  3000,
  2500,
  2000,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  1500,
  1500,
  2000,
  2000,
  2000,
  1500,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.tritium740 = new DataMapNumeric(
  'Tritium 740',
  'Tritium Content at 740 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  166,
  82,
  30,
  22,
);

a = [];
a[19] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[18] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[17] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[16] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  1000,
  1500,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[15] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  2500,
  2500,
  3500,
  2500,
  1500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[14] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  4000,
  11200,
  11200,
  6500,
  4500,
  2500,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3000,
  4000,
  11200,
  11600,
  11800,
  11900,
  11700,
  7000,
  3500,
  1500,
  500,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  1000,
  2000,
  4000,
  7000,
  11700,
  12100,
  12800,
  12900,
  12900,
  12200,
  11700,
  4500,
  2000,
  500,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1500,
  3000,
  11200,
  11700,
  12800,
  13900,
  15300,
  16200,
  16200,
  14500,
  13500,
  12000,
  4500,
  1500,
  0,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  3000,
  6000,
  11600,
  12900,
  14200,
  16300,
  17900,
  17200,
  17200,
  15400,
  13600,
  12000,
  3500,
  1500,
  0,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  4500,
  9000,
  12300,
  13700,
  15400,
  17600,
  18200,
  16900,
  15300,
  14000,
  12600,
  11800,
  3500,
  1000,
  0,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  6000,
  11800,
  12700,
  13800,
  15300,
  16000,
  15300,
  13700,
  13200,
  12700,
  11800,
  11200,
  2000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  11200,
  11600,
  12400,
  13200,
  13800,
  13800,
  13200,
  12900,
  12300,
  11600,
  11200,
  3000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  4000,
  6500,
  11800,
  12100,
  12200,
  12200,
  12100,
  11900,
  8500,
  4500,
  2000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  3000,
  4500,
  5000,
  5000,
  5000,
  5000,
  4000,
  2500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  1500,
  2000,
  2000,
  2000,
  2000,
  2000,
  1000,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  500,
  500,
  500,
  500,
  500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[0] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];

dataMaps.tritium750 = new DataMapNumeric(
  'Tritium 750',
  'Tritium Content at 750 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  175,
  88,
  26,
  20,
);

a = [];
a[16] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[15] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[14] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[13] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 500, 500, 0, 0, 0, 0];
a[12] = [0, 0, 0, 0, 0, 0, 0, 0, 500, 500, 2000, 4000, 4000, 2000, 500, 0, 0];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1000,
  2500,
  5000,
  11200,
  11400,
  11800,
  11600,
  4500,
  2500,
  500,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  8000,
  11800,
  12500,
  12700,
  13100,
  12200,
  11600,
  5000,
  2500,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  1500,
  5000,
  11800,
  13200,
  14100,
  15300,
  14700,
  13400,
  11900,
  5000,
  2500,
  0,
];
a[8] = [
  0,
  0,
  0,
  500,
  2000,
  4500,
  11600,
  12500,
  14400,
  17200,
  19300,
  16800,
  14400,
  12400,
  11400,
  3000,
  0,
];
a[7] = [
  0,
  0,
  0,
  1000,
  3000,
  6500,
  12000,
  13200,
  15800,
  17800,
  100000,
  17600,
  14400,
  12400,
  6500,
  2500,
  0,
];
a[6] = [
  0,
  0,
  0,
  1000,
  3000,
  7000,
  12000,
  13300,
  14800,
  17100,
  17300,
  16100,
  13300,
  11900,
  4500,
  1500,
  0,
];
a[5] = [
  0,
  0,
  0,
  500,
  2000,
  5000,
  11600,
  12600,
  14000,
  14800,
  14800,
  13200,
  12100,
  11200,
  2500,
  1000,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  1000,
  2500,
  5000,
  11600,
  12400,
  12400,
  12300,
  6500,
  4500,
  2500,
  1000,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  500,
  2000,
  11200,
  7000,
  7000,
  4000,
  2500,
  1000,
  500,
  0,
  0,
  0,
];
a[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 500, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.tritium760 = new DataMapNumeric(
  'Tritium 760',
  'Tritium Content at 760 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  186,
  94,
  17,
  17,
);

a = [];
a[15] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[14] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[13] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[12] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 500, 0, 0, 0, 0, 0, 0, 0];
a[11] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2500, 5000, 1500, 500, 500, 0, 0, 0, 0];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  500,
  2500,
  4500,
  11600,
  12300,
  11200,
  11200,
  3500,
  1000,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  4000,
  11600,
  12400,
  13000,
  14400,
  13100,
  12700,
  7000,
  3000,
  500,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  0,
  2000,
  7000,
  12600,
  14700,
  16400,
  18200,
  18700,
  16500,
  14400,
  12900,
  6500,
  1500,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  500,
  6000,
  12300,
  14300,
  17500,
  120000,
  19900,
  19500,
  17100,
  14900,
  12900,
  11600,
  1500,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  1500,
  6500,
  13100,
  15300,
  18900,
  160000,
  19900,
  19200,
  16700,
  14700,
  12900,
  6000,
  500,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  1500,
  6500,
  12500,
  14200,
  17600,
  18000,
  17900,
  16900,
  15300,
  13700,
  11800,
  3500,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  1000,
  3500,
  11600,
  12700,
  14400,
  14400,
  14400,
  12900,
  11800,
  11600,
  2500,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  500,
  2000,
  4500,
  11600,
  12100,
  12500,
  12500,
  8000,
  4500,
  500,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [
  0,
  0,
  0,
  0,
  0,
  500,
  1500,
  3500,
  3500,
  6500,
  6500,
  2500,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[1] = [0, 0, 0, 0, 0, 0, 0, 500, 500, 500, 500, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.tritium770 = new DataMapNumeric(
  'Tritium 770',
  'Tritium Content at 770 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  192,
  99,
  19,
  16,
);

a = [];
a[13] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[12] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[11] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[10] = [0, 0, 0, 0, 0, 0, 1000, 2500, 500, 0, 500, 0, 0, 0, 0];
a[9] = [0, 0, 0, 0, 0, 4500, 12000, 12500, 11900, 11600, 7000, 2500, 0, 0, 0];
a[8] = [
  0,
  0,
  0,
  0,
  500,
  5000,
  12300,
  14600,
  16300,
  14800,
  11700,
  1500,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  2000,
  12100,
  14400,
  18600,
  180000,
  160000,
  12400,
  1500,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  500,
  5000,
  13100,
  16200,
  18600,
  120000,
  19100,
  12500,
  4500,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  1000,
  3000,
  12100,
  14500,
  15500,
  15500,
  13200,
  11800,
  4500,
  0,
  0,
  0,
];
a[4] = [0, 0, 0, 0, 1000, 4000, 11600, 11600, 11400, 2500, 1500, 500, 0, 0, 0];
a[3] = [0, 0, 0, 0, 0, 1000, 2000, 2500, 1500, 0, 0, 0, 0, 0, 0];
a[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.tritium780 = new DataMapNumeric(
  'Tritium 780',
  'Tritium Content at 780 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  199,
  102,
  15,
  14,
);

a = [];
a[16] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[15] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[14] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1490000,
  1490000,
  1490000,
  1490000,
  1490000,
  1490000,
  0,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1480000,
  12200,
  2000,
  7500,
  7000,
  1500,
  370000,
  0,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  1490000,
  17200,
  2000,
  12500,
  12600,
  12600,
  4000,
  13100,
  1480000,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  1490000,
  16300,
  4000,
  13000,
  12900,
  12900,
  13000,
  12700,
  5500,
  12300,
  670000,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  630000,
  12300,
  13100,
  17100,
  370000,
  370000,
  16700,
  13100,
  12700,
  3000,
  16400,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  0,
  1110000,
  4000,
  13000,
  140000,
  110000,
  370000,
  220000,
  17200,
  13100,
  2500,
  11900,
  1490000,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  0,
  770000,
  4000,
  13100,
  16400,
  370000,
  180000,
  220000,
  16700,
  13100,
  2500,
  150000,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  0,
  1480000,
  12800,
  4000,
  13500,
  13900,
  13900,
  13500,
  13400,
  12700,
  12700,
  1110000,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  770000,
  11900,
  12300,
  12800,
  13200,
  13200,
  13200,
  12600,
  12700,
  150000,
  1490000,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  770000,
  150000,
  13100,
  2500,
  12300,
  11900,
  12300,
  2500,
  16800,
  0,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1490000,
  370000,
  190000,
  190000,
  370000,
  670000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.tritium790 = new DataMapNumeric(
  'Tritium 790',
  'Tritium Content at 790 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  205,
  104,
  18,
  17,
);

a = [];
a[17] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[16] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[15] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[14] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[13] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  270000,
  1110000,
  1480000,
  1490000,
  1490000,
  0,
  0,
  0,
  0,
];
a[12] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1490000,
  400000,
  13100,
  3500,
  4000,
  12200,
  11700,
  370000,
  0,
  0,
  0,
  0,
];
a[11] = [
  0,
  0,
  0,
  0,
  0,
  770000,
  12600,
  5000,
  12600,
  16800,
  13100,
  4000,
  2000,
  640000,
  0,
  0,
  0,
  0,
];
a[10] = [
  0,
  0,
  0,
  0,
  0,
  13000,
  4000,
  12600,
  17200,
  160000,
  16800,
  13100,
  4000,
  150000,
  0,
  0,
  0,
  0,
];
a[9] = [
  0,
  0,
  0,
  0,
  670000,
  2000,
  12300,
  13900,
  17600,
  160000,
  150000,
  16800,
  4000,
  270000,
  0,
  0,
  0,
  0,
];
a[8] = [
  0,
  0,
  0,
  1110000,
  12300,
  3000,
  13100,
  17200,
  220000,
  220000,
  150000,
  16900,
  12600,
  190000,
  0,
  0,
  0,
  0,
];
a[7] = [
  0,
  0,
  0,
  400000,
  12400,
  12800,
  13800,
  17600,
  220000,
  220000,
  160000,
  16800,
  13000,
  16300,
  0,
  0,
  0,
  0,
];
a[6] = [
  0,
  0,
  0,
  1490000,
  150000,
  16900,
  2000,
  13800,
  16800,
  370000,
  16800,
  13900,
  12700,
  190000,
  0,
  0,
  0,
  0,
];
a[5] = [
  0,
  0,
  0,
  0,
  0,
  1490000,
  16800,
  2000,
  4000,
  13500,
  13500,
  13000,
  12200,
  230000,
  0,
  0,
  0,
  0,
];
a[4] = [
  0,
  0,
  0,
  0,
  0,
  0,
  1490000,
  1490000,
  190000,
  12700,
  12700,
  12300,
  16700,
  770000,
  0,
  0,
  0,
  0,
];
a[3] = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1490000,
  1490000,
  1490000,
  1490000,
  0,
  0,
  0,
  0,
  0,
  0,
];
a[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
a[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

dataMaps.tritium800 = new DataMapNumeric(
  'Tritium 800',
  'Tritium Content at 800 ft above sea level',
  'ft',
  a,
  320,
  200,
  0,
  212,
  107,
  18,
  18,
);

export default dataMaps;
